(function () {
  'use strict';

  angular.module('GoCloudCast.core', [
    'ui.router'
  ])
  .config(routeConfig)
  //.run(logUiRoute)

  /** @ngInject */
  function routeConfig($stateProvider) {

    $stateProvider.state('main', {
      abstract : true,
      templateUrl : 'app/core/main.core.html'
    })
  }

  function logUiRoute($rootScope){
      $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams){
        console.log('$stateChangeStart to '+toState.to+'- fired when the transition begins. toState,toParams : \n',toState, toParams);
      });

      $rootScope.$on('$stateChangeError',function(event, toState, toParams, fromState, fromParams){
        console.log('$stateChangeError - fired when an error occurs during transition.');
        console.log(arguments);
      });

      $rootScope.$on('$stateChangeSuccess',function(event, toState, toParams, fromState, fromParams){
        console.log('$stateChangeSuccess to '+toState.name+'- fired once the state transition is complete.');
      });

      $rootScope.$on('$viewContentLoaded',function(event){
        console.log('$viewContentLoaded - fired after dom rendered',event);
      });

      $rootScope.$on('$stateNotFound',function(event, unfoundState, fromState, fromParams){
        console.log('$stateNotFound '+unfoundState.to+'  - fired when a state cannot be found by its name.');
        console.log(unfoundState, fromState, fromParams);
      });
    }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.modules', [
    'ui.router',
    'LocalStorageModule',
    'GoCloudCast.modules.properties',
    'GoCloudCast.modules.users',
    'GoCloudCast.modules.cities',
    'GoCloudCast.modules.areas',
    'GoCloudCast.modules.iptv',
    'GoCloudCast.modules.cast',
    'GoCloudCast.modules.templates',
    'GoCloudCast.modules.reports',
    'GoCloudCast.modules.services',
    'GoCloudCast.modules.configs',
    'GoCloudCast.modules.errors'
    //'BlurAdmin.pages.dashboard',
    //'BlurAdmin.pages.ui',
    //'BlurAdmin.pages.components'
  ])           
      .run(startFunction)
      .config(routeConfig)

  function startFunction($location, UsersService, SessionService, editableOptions){
    UsersService.getLoggedUser().then(function(data){
      SessionService.setLoggedUser(data.data);
    }, function(data){
      $location.path('/login');
    });

    editableOptions.theme = 'bs3'; // bootstrap3 theme. Can be also 'bs4', 'bs2', 'default'
  }

  function routeConfig($urlRouterProvider, $stateProvider, baSidebarServiceProvider) {
    //$urlRouterProvider.otherwise('/dashboard');
//    baSidebarServiceProvider.addStaticItem({
//      title: 'Menu Level 1',
//      icon: 'ion-ios-more',
//      subMenu: [{
//        title: 'Menu Level 1.1',
//        disabled: true
//      }, {
//        title: 'Menu Level 1.2',
//        subMenu: [{
//          title: 'Menu Level 1.2.1',
//          disabled: true
//        }]
//      }]
//    });
    
      
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages', [
    'ui.router',

    'GoCloudCast.pages.dashboard',
    //'GoCloudCast.pages.ui',
    //'GoCloudCast.pages.components',
    'GoCloudCast.pages.form',
    //'GoCloudCast.pages.tables',
    //'GoCloudCast.pages.charts',
    //'GoCloudCast.pages.maps',
    //'GoCloudCast.pages.profile',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/dashboard');

/*
    baSidebarServiceProvider.addStaticItem({
      title: 'Pages',
      icon: 'ion-document',
      subMenu: [
        { title: 'amCharts', fixedHref: '#/charts/amCharts' }, 
        { title: 'Chart.js', fixedHref: '#/charts/chartJs' }, 
        { title: 'Chartist', fixedHref: '#/charts/chartist' }, 
        { title: 'Morris', fixedHref: '#/charts/morris' }, 
        { title: 'Dashboard', fixedHref: '#/dashboard' }, 
        { title: 'Mail', fixedHref: '#/components/mail' }, 
        { title: 'Timeline', fixedHref: '#/components/timeline' }, 
        { title: 'Tree', fixedHref: '#/components/tree' },
        { title: 'Form Inputs', fixedHref: '#/form/inputs' }, 
        { title: 'Form Layouts', fixedHref: '#/form/layouts' }, 
        { title: 'Form Wizard', fixedHref: '#/form/wizard' }, 
        { title: 'Google Maps', fixedHref: '#/maps/gmap' }, 
        { title: 'Leaflet Maps', fixedHref: '#/maps/leaflet' }, 
        { title: 'Bubble Maps', fixedHref: '#/maps/bubble' }, 
        { title: 'Line Maps', fixedHref: '#/maps/line' }, 
        { title: 'Profile', fixedHref: '#/profile' }, 
        { title: 'Basic Tables', fixedHref: '#/tables/basic' }, 
        { title: 'Smart Tables', fixedHref: '#/tables/smart' }, 

        { title: 'Alerts', fixedHref: '#/ui/alerts' }, 
        { title: 'Buttons', fixedHref: '#/ui/buttons' }, 
        { title: 'Grid', fixedHref: '#/ui/grid' }, 
        { title: 'Icons', fixedHref: '#/ui/icons' }, 
        { title: 'Modals', fixedHref: '#/ui/modals' }, 
        { title: 'Notifications', fixedHref: '#/ui/notifications' },
        { title: 'Panels', fixedHref: '#/ui/panels' }, 
        { title: 'ProgressBars', fixedHref: '#/ui/progressBars' }, 
        { title: 'Slider', fixedHref: '#/ui/slider' }, 
        { title: 'Tabs', fixedHref: '#/ui/tabs' }, 
        { title: 'Typography', fixedHref: '#/ui/typography' },

        { title: 'Sign In', fixedHref: 'auth.html', blank: true }, 
        { title: 'Sign Up', fixedHref: 'reg.html', blank: true }, 
//        { title: 'User Profile', stateRef: 'profile' }, 
        { title: '404 Page', fixedHref: '404.html', blank: true }
      ]
    });

//    baSidebarServiceProvider.addStaticItem({
//      title: 'Menu Level 1',
//      icon: 'ion-ios-more',
//      subMenu: [{
//        title: 'Menu Level 1.1',
//        disabled: true
//      }, {
//        title: 'Menu Level 1.2',
//        subMenu: [{
//          title: 'Menu Level 1.2.1',
//          disabled: true
//        }]
//      }]
//    });
*/
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'GoCloudCast.theme.components',
      'GoCloudCast.theme.inputs'
  ]);

})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.areas', [
    'GoCloudCast.modules.areas.areaLists',
    'GoCloudCast.modules.areas.areaTypes'
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('areas', {
      url: '/areas',
      parent: 'main',
      template : '<ui-view  autoscroll="false" autoscroll-body-top></ui-view>',
      abstract: true,
      title: 'Areas',
      sidebarMeta: {
        propertyErrorMessage: 'There must be at least one property before you can see this section',
        disabledWithoutProperty: true,
        icon: 'fa fa-bed'
      },
    });
  }
})();
(function () {
  'use strict';

  angular.module('GoCloudCast.auth', [
    'ui.router',

    'GoCloudCast.auth.login',
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider) {
  }

})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.cast', [
    'GoCloudCast.modules.cast.receivers',
    'GoCloudCast.modules.cast.senders',
    'GoCloudCast.modules.cast.news'
//    'GoCloudCast.modules.cast.notifications'
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('cast', {
      url: '/cast',
      parent: 'main',
      template : '<ui-view  autoscroll="false" autoscroll-body-top></ui-view>',
      abstract: true,
      title: 'CAST',
      sidebarMeta: {
        permissions: [
          'receivers--index',
          'notification-emails--index',
          'news--index',
          'senders--index'
        ],
        propertyErrorMessage: 'There must be at least one property before you can see this section',
        disabledWithoutProperty: true,
        icon: 'fa fa-tv'
      },
    });
  }
})();

(function () {
	'use strict';
  
	angular.module('GoCloudCast.modules.cities', []).config(routeConfig);
  
	/** @ngInject */
	function routeConfig($stateProvider) {
	  $stateProvider
		.state('cities-list', {
		  url: '/cities',  
		  parent : 'main',
		  templateUrl: 'app/modules/cities/cities.html',
		  title: 'Cities',
		  sidebarMeta: {
			permissions: [
			  'cities--index'
			],
			propertyErrorMessage: 'There must be at least one property before you can see this section',
			disabledWithoutProperty: true,
			icon: 'fa fa-institution'
		  },
		  controller : 'CitiesController',
		  controllerAs : 'vm'
		})
		.state('cities-edit', {
		  url: '/cities-edit/:id',
		  templateUrl: 'app/modules/cities/citiesAddEdit.html',
		  parent : 'main',
		  title: 'City Edition',
		  controller : 'CitiesAddEditController',
		  controllerAs : 'vm',
		  contentTopParent : 'cities-list',
		  resolve : {
			city: function($stateParams, CitiesService){
			  	return CitiesService.get($stateParams.id);  
			},
			countries : function (CountriesService) {
			  	return CountriesService.getAll();
			},
			timezones: function (TimezonesService) {
				return TimezonesService.getAllWithoutPagination();
			}
		  }
		})
  
		.state('cities-new', {
		  url: '/cities-new',  
		  templateUrl: 'app/modules/cities/citiesAddEdit.html',
		  parent : 'main',
		  title: 'City Creation',
		  controller : 'CitiesAddEditController',
		  controllerAs : 'vm',
		  contentTopParent : 'cities-list',
		  resolve : {
			city : function(CitiesService){
			  return CitiesService.getEmptyCity();
			},
			countries : function (CountriesService) {
			  return CountriesService.getAll();
			},
			timezones: function (TimezonesService) {
				return TimezonesService.getAllWithoutPagination();
			}
		  }
		})
  
	}
  })();
  
(function () {
  'use strict';

  angular.module('GoCloudCast.modules.configs', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('configs-list', {
        url: '/configs',  
        templateUrl: 'app/modules/configs/configs.html',
        title: 'Configs',
        parent : 'main',
        sidebarMeta: {
          permissions: [
             'configs--get-cast-router-types',
             'configs--get-guest-router-types',
             'configs--get-interfaces',
             'configs--get-protocol-types',
             'configs--get-security-levels',
             'configs--get-splash-image',
             'configs--index',
             'configs--indication-templates',
             'configs--update',
             'configs--upload-splash-image',
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-cog'
        }, 
        resolve : {
          configs: function($stateParams,ConfigsService){
            return ConfigsService.get();  
          },
          templates: function(ApiService,StorageService){
            return ApiService.get('/indications-templates/'+StorageService.getProperty().id);
          },
          guestRouterTypes: function($stateParams,ConfigsService){
            return ConfigsService.getGuestRouterTypes();  
          },
          castRouterTypes: function($stateParams,ConfigsService){
            return ConfigsService.getCastRouterTypes();  
          },
          protocolTypes: function($stateParams,ConfigsService){
            return ConfigsService.getProtocolTypes();  
          },
          securityLevels: function($stateParams,ConfigsService){
            return ConfigsService.getSecurityLevels();  
          },
          interfaces: function($stateParams, ConfigsService){
            return ConfigsService.getInterfaces();
          },
          splashPages: function($stateParams, ConfigsService){
            return ConfigsService.getSplashpages();
          },
          splashImage: function($stateParams, ConfigsService){
            return ConfigsService.getSplashImage();
          }
        },
        controller : 'ConfigsController',
        controllerAs : 'vm'
      })

  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv', [
    'GoCloudCast.modules.iptv.channels',
    'GoCloudCast.modules.iptv.tvs',
    'GoCloudCast.modules.iptv.tvModels',
    'GoCloudCast.modules.iptv.tlx',
    'GoCloudCast.modules.iptv.hotelInfos',
    'GoCloudCast.modules.iptv.tvApplications',
    'GoCloudCast.modules.iptv.tvApplicationsProperty',
    'GoCloudCast.modules.iptv.tvApplicationVersions',
    'GoCloudCast.modules.iptv.experiences'
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('iptv', {
      url: '/iptv',
      parent: 'main',
      template : '<ui-view  autoscroll="false" autoscroll-body-top></ui-view>',
      abstract: true,
      title: 'IPTV',
      sidebarMeta: {
        permissions: [
           'tlx--add-tlx',
           'tv-models--index',
           'tvs--index',
           'channels--index',
           'hotel-info--index',
           'hotel-info-categories--index',
           'tv-applications--index',
           'tv-applications-properties--index',
	   'experiences--index'
        ],
        propertyErrorMessage: 'There must be at least one property before you can see this section',
        disabledWithoutProperty: true,
        icon: 'fa fa-tv'
      },
    });
  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.properties', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('properties-list', {
        url: '/properties',  
        templateUrl: 'app/modules/properties/properties.html',
        title: 'Properties',
        parent : 'main',
        sidebarMeta: {
          permissions: [
            'properties--store',
            'properties--update',
            'properties--destroy'
          ],
          icon: 'fa fa fa-building-o'
        },
        controller : 'PropertiesController',
        controllerAs : 'vm'
      })
      .state('properties-edit', {
        url: '/properties-edit/:id',
        templateUrl: 'app/modules/properties/propertiesAddEdit.html',
        title: 'Properties Edition',
        parent : 'main',
        controller : 'PropertiesAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'properties-list',
        resolve : {
          /*
          driver : function($stateParams, ApiService){
            return ApiService.get('repository/drif/get-by-id/' + $stateParams.id)
          } 
          */
          property: function($stateParams,PropertiesService){
            // Adhiere la informacion del pais de la ciudad creada al objeto.
            var modifiedWhatever = PropertiesService.get($stateParams.id).then(function(data) {
              if (data.data.city) {
                data.data.country = data.data.city.country_code;
              }
              console.log(data);
              return data;
            });
            
            return modifiedWhatever;
          },
          templates : function (TemplatesService) {
            return TemplatesService.getAll();
          },
          properties : function (PropertiesService) {
            return PropertiesService.getAllWithoutPagination();
          },
          countries : function (CountriesService) {
            return CountriesService.getAll();
          },
          cities : function (CitiesService) {
            return CitiesService.getAll();
          },
          layouts : function (PropertiesService){
            return PropertiesService.getAllLayouts();
          },
          /*,
          states: function(ApiService){
            return ApiService.get('/states');
          }*/
        }
      })

      .state('properties-new', {
        url: '/properties-new',  
        templateUrl: 'app/modules/properties/propertiesAddEdit.html',
        title: 'Properties Creation',
        parent : 'main',
        controller : 'PropertiesAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'properties-list',
        resolve : {
          property : function(PropertiesService){
            return PropertiesService.getEmptyProperty();
          },
          templates : function (TemplatesService) {
            return TemplatesService.getAll();
          },
          properties : function (PropertiesService) {
            return PropertiesService.getAll();
          },
          countries : function (CountriesService) {
            return CountriesService.getAll();
          },
          cities : function (CitiesService) {
            return CitiesService.getAll();
          },
          layouts : function (PropertiesService){
            return PropertiesService.getAllLayouts();
          },
          /*,
          states: function(ApiService){
            return ApiService.get('/states');
          } */    
        }
      })

  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.reports', [
    'GoCloudCast.modules.reports.general-use',
    'GoCloudCast.modules.reports.signal-strength'
    //'GoCloudCast.modules.reports.infrastructure-monitor'
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('reports', {
      url: '/reports',
      parent: 'main',
      template : '<ui-view  autoscroll="false" autoscroll-body-top></ui-view>',
      abstract: true,
      title: 'Reports',
      sidebarMeta: {
        all_permissions: true,
        permissions: [
          //TODO: permisos de reportes de ES que no permite darse de alta
          /*
          'sender-uptime--top-mac-address',
          'report--report',
          'sender-uptime--statistics',
          'receiver-state--statistics',
          'receiver-uptime--index-filtering-by-date',
          'signal-strength--get-signal-strength-graph-data',
          */
          'receivers--index'
        ],
        propertyErrorMessage: 'There must be at least one property before you can see this section',
        disabledWithoutProperty: true,
        icon: 'ion-stats-bars'
      },
    });
  }
})();
(function () {
  'use strict';

  angular.module('GoCloudCast.modules.services', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('services-list', {
        url: '/services',  
        templateUrl: 'app/modules/services/services.html',
        title: 'Services',
        parent : 'main',
        sidebarMeta: {
          permissions: [
            'services--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-wrench'
        }, 
        controller : 'ServicesController',
        controllerAs : 'vm',
        resolve : {
          backdropCount: function(ReceiversService){
            return ReceiversService.getBackdropCount();
          },
          onCount: function(ReceiversService){
            return ReceiversService.getOnCount();
          }
        }
      })

  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.templates', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('templates-edit', {
        url: '/templates-edit/:id',  
        templateUrl: 'app/modules/templates/templatesEdit.html',
        controller : 'TemplatesEditController',
        parent : 'main',
        title: 'Templates',
        controllerAs : 'vm',
        resolve: {
          template: function($stateParams, TemplatesService) {
            return TemplatesService.get($stateParams.id);  
          }
        }
      })
    }
  })();
(function () {
  'use strict';

  angular.module('GoCloudCast.modules.users', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('users-list', {
        url: '/users',  
        parent : 'main',
        templateUrl: 'app/modules/users/users.html',
        title: 'Users',
        sidebarMeta: {
          permissions: [
            'customers--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-user'
        },
        controller : 'UsersController',
        controllerAs : 'vm'
      })
      .state('users-edit', {
        url: '/users-edit/:id',
        templateUrl: 'app/modules/users/usersAddEdit.html',
        parent : 'main',
        title: 'User Edition',
        controller : 'UsersAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'users-list',
        resolve : {
          /*
          driver : function($stateParams, ApiService){
            return ApiService.get('repository/drif/get-by-id/' + $stateParams.id)
          } 
          */
          user: function($stateParams,UsersService){
            return UsersService.get($stateParams.id);  
          },
          properties: function(PropertiesService){
            return PropertiesService.getAllWithoutPagination();
          },
          roles: function(ApiService){
            return ApiService.get('/roles?pagination=disabled');
          }
        }
      })

      .state('users-new', {
        url: '/users-new',  
        templateUrl: 'app/modules/users/usersAddEdit.html',
        parent : 'main',
        title: 'User Creation',
        controller : 'UsersAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'users-list',
        resolve : {
          user : function(UsersService){
            return UsersService.getEmptyUser();
          },
          properties: function(PropertiesService){
            return PropertiesService.getAllWithoutPagination();
          },
          roles: function(ApiService){
            return ApiService.get('/roles?pagination=disabled');
          }
        }
      })

  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts', [
      'GoCloudCast.pages.charts.amCharts',
      'GoCloudCast.pages.charts.chartJs',
      'GoCloudCast.pages.charts.chartist',
      'GoCloudCast.pages.charts.morris'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts', {
          url: '/charts',
          parent : 'main',
          abstract: true,
          template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
          title: 'Charts',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 150,
          },
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components', [
    'GoCloudCast.pages.components.mail',
    'GoCloudCast.pages.components.timeline',
    'GoCloudCast.pages.components.tree',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components', {
          url: '/components',
          parent : 'main',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Components',
          sidebarMeta: {
            icon: 'ion-gear-a',
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard', [])


      .config(routeConfig);

  /** @ngInject */
 function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard', {
          url: '/dashboard',
          parent : 'main',
          templateUrl: 'app/pages/dashboard/dashboard.html',
          title: 'Dashboard',
          controller : 'DashboardController',
          controllerAs : 'vm',
          sidebarMeta: {
            propertyErrorMessage: 'There must be at least one property before you can see this section',
            disabledWithoutProperty: true,
            icon: 'ion-android-home',
            order: 0,
          },
          resolve: {
            areas: function(AreasService){
              return AreasService.getAllWithoutPagination();
            }
          },
        });
  }



})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.form', ['ui.select', 'ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.maps', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('maps', {
          url: '/maps',
          parent : 'main',
          templateUrl: 'app/pages/maps/maps.html',
          abstract: true,
          title: 'Maps',
          sidebarMeta: {
            icon: 'ion-ios-location-outline',
            order: 500,
          },
        })
        .state('maps.gmap', {
          url: '/gmap',
          templateUrl: 'app/pages/maps/google-maps/google-maps.html',
          controller: 'GmapPageCtrl',
          title: 'Google Maps'
//          sidebarMeta: {
//            order: 0,
//          },
        })
        .state('maps.leaflet', {
          url: '/leaflet',
          templateUrl: 'app/pages/maps/leaflet/leaflet.html',
          controller: 'LeafletPageCtrl',
          title: 'Leaflet Maps'
//          sidebarMeta: {
//            order: 100,
//          },
        })
        .state('maps.bubble', {
          url: '/bubble',
          templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
          controller: 'MapBubblePageCtrl',
          title: 'Bubble Maps'
//          sidebarMeta: {
//            order: 200,
//          },
        })
        .state('maps.line', {
          url: '/line',
          templateUrl: 'app/pages/maps/map-lines/map-lines.html',
          controller: 'MapLinesPageCtrl',
          title: 'Line Maps'
//          sidebarMeta: {
//            order: 300,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('profile', {
          url: '/profile',
          parent : 'main',
          title: 'Profile',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          parent : 'main',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables'
//          sidebarMeta: {
//            order: 0,
//          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables'
//          sidebarMeta: {
//            order: 100,
//          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui', [
    'GoCloudCast.pages.ui.typography',
    'GoCloudCast.pages.ui.buttons',
    'GoCloudCast.pages.ui.icons',
    'GoCloudCast.pages.ui.modals',
    'GoCloudCast.pages.ui.grid',
    'GoCloudCast.pages.ui.alerts',
    'GoCloudCast.pages.ui.progressBars',
    'GoCloudCast.pages.ui.notifications',
    'GoCloudCast.pages.ui.tabs',
    'GoCloudCast.pages.ui.slider',
    'GoCloudCast.pages.ui.panels',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui', {
          url: '/ui',
          parent : 'main',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'UI Features',
          sidebarMeta: {
            icon: 'ion-android-laptop',
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.inputs', []);

})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.areas.areaLists', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('areas.area-lists-list', {
        url: '/area-lists',  
        templateUrl: 'app/modules/areas/area-lists/areaLists.html',
        title: 'Area Lists',
        parent : 'main',
        sidebarMeta: {
          permissions: [
            'areas--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-bed',
        },
        controller : 'AreaListsController',
        controllerAs : 'vm',
        resolve : {
          areaCodes : function(AreasService){
            return AreasService.getAreaCodes();
          },
          expirationTime: function (AreasService) {
            return AreasService.getExpirationTime();
          }
        }
      })
      .state('areas.area-lists-edit', {
        url: '/area-lists-edit/:id',
        templateUrl: 'app/modules/areas/area-lists/areaListsAddEdit.html',
        title: 'Area Edition',
        parent : 'main',
        controller : 'AreaListsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'areas.area-lists-list',
        resolve : {
          /*
          driver : function($stateParams, ApiService){
            return ApiService.get('repository/drif/get-by-id/' + $stateParams.id)
          } 
          */
          area: function($stateParams,AreasService){
            return AreasService.get($stateParams.id);  
          },
          areaTypes: function (AreaTypesService) {
            return AreaTypesService.getAllWithoutPagination();
          }
        }
      })

      .state('areas.area-lists-new', {
        url: '/area-lists-new',  
        templateUrl: 'app/modules/areas/area-lists/areaListsAddEdit.html',
        parent : 'main',
        title: 'Area Creation',
        controller : 'AreaListsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'areas.area-lists-list',
        resolve : {
          area : function(AreasService){
            return AreasService.getEmptyArea();
          },
          areaTypes: function (AreaTypesService) {
            return AreaTypesService.getAllWithoutPagination();
          }
        }
      })

  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.areas.areaTypes', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('areas.area-types-list', {
        url: '/area-types',  
        templateUrl: 'app/modules/areas/area-types/areaTypes.html',
        title: 'Area Types',
        parent : 'main',
        sidebarMeta: {
          permissions: [
            'area-types--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-bed',
        },
        controller : 'AreaTypesController',
        controllerAs : 'vm'
      })
      .state('areas.area-types-new', {
        url: '/area-types-new',  
        templateUrl: 'app/modules/areas/area-types/areaTypesAddEdit.html',
        parent : 'main',
        title: 'Area Type Creation',
        controller : 'AreaTypesAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'areas.area-types-list',
        resolve : {
          areaType : function(AreaTypesService){
            return AreaTypesService.getEmptyAreaType();
          }
        }
      })
      .state('areas.area-types-edit', {
        url: '/area-types-edit/:id',
        templateUrl: 'app/modules/areas/area-types/areaTypesAddEdit.html',
        title: 'Area Type Edition',
        parent : 'main',
        controller : 'AreaTypesAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'areas.area-types-list',
        resolve : {
          areaType : function($stateParams,AreaTypesService){
            return AreaTypesService.get($stateParams.id);
          }
        }
      })

  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.auth.login', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider

    .state('login', {
      url : '/login',
      title : 'Login',
      templateUrl : 'app/modules/auth/login/login.html',
      controller : 'LoginController',
      controllerAs : 'vm'
    });
        
  }
})();
(function () {
  'use strict';

  angular.module('GoCloudCast.modules.cast.news', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('cast.news-list', {
        url: '/news',  
        templateUrl: 'app/modules/cast/news/news.html',
        title: 'News',
        parent : 'main',
        order: 2,
        sidebarMeta: {
          permissions: [
           'news--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-newspaper-o'
        },
        resolve: {
          categories: function(ApiService) {
            return ApiService.get('/news/categories').then(function(response) {
              return response.data;
            });
          }
        },
        controller : 'NewsController',
        controllerAs : 'vm'
      })
      .state('cast.news-edit', {
        url: '/news-edit/:id',
        templateUrl: 'app/modules/cast/news/newsAddEdit.html',
        title: 'News Edition',
        parent : 'main',
        controller : 'NewsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'cast.news-list',
        resolve : {
          news: function($stateParams,NewsService){
            return NewsService.get($stateParams.id);  
          },
          areas: function(AreasService){
            return AreasService.getAllWithoutPagination();
          },
          categories: function(NewsService){
            return NewsService.getCategories();
          }
        }
      })

      .state('cast.news-new', {
        url: '/news-new',  
        templateUrl: 'app/modules/cast/news/newsAddEdit.html',
        parent : 'main',
        title: 'News Creation',
        controller : 'NewsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'cast.news-list',
        resolve : {
          news : function(NewsService){
            return NewsService.getEmptyNews();
          },
          areas: function(AreasService){
            return AreasService.getAllWithoutPagination();
          },
          categories: function(NewsService){
            return NewsService.getCategories();
          }
        }
      })

  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.cast.notifications', [
    'GoCloudCast.modules.cast.notifications.notificationEmails'
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider.state('cast.notifications', {
      url: '/notifications',
      parent: 'main',
      template : '<ui-view  autoscroll="false" autoscroll-body-top></ui-view>',
      abstract: true,
      title: 'Notifications',
      sidebarMeta: {
        icon: 'fa fa-bell',
      },
    });
  }
})();
(function () {
  'use strict';

  angular.module('GoCloudCast.modules.cast.receivers', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('cast.receivers-list', {
        url: '/receivers',  
        templateUrl: 'app/modules/cast/receivers/receivers.html',
        parent : 'main',
        title: 'Receivers',
        order: 2,
        sidebarMeta: {
          permissions: [
            'receivers--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-wifi'
        },
        controller : 'ReceiversController',
        controllerAs : 'vm',
        resolve : {
          types: function(ReceiversService){
            return ReceiversService.getReceiversTypes();
          },
          apps: function(ReceiversService){
            return ReceiversService.getApps();
          },
          websocketUrl: function(ApiService) {
            return ApiService.get('/websocket-url').then(function(response) {
              return response.data.websocket_url;
            });
          }
        }
      })
      .state('cast.receivers-edit', {
        url: '/receivers-edit/:id',
        templateUrl: 'app/modules/cast/receivers/receiversAddEdit.html',
        parent : 'main',
        title: 'Receiver Edition',
        controller : 'ReceiversAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'cast.receivers-list',
        resolve : {
          /*
          driver : function($stateParams, ApiService){
            return ApiService.get('repository/drif/get-by-id/' + $stateParams.id)
          } 
          */
          receiver: function($stateParams,ReceiversService){
            return ReceiversService.get($stateParams.id);  
          },
          types: function(ReceiversService){
            return ReceiversService.getReceiversTypes();
          },
          areas: function(AreasService){
            return AreasService.getAllWithoutPagination();
          },
          areaTypes: function (AreaTypesService) {
            return AreaTypesService.getAllWithoutPagination();
          }
        }
      })

      .state('cast.receivers-new', {
        url: '/receivers-new',  
        templateUrl: 'app/modules/cast/receivers/receiversAddEdit.html',
        parent : 'main',
        title: 'Receiver Creation',
        controller : 'ReceiversAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'cast.receivers-list',
        resolve : {
          receiver : function(ReceiversService){
            return ReceiversService.getEmptyReceiver();
          },
          types: function(ReceiversService){
            return ReceiversService.getReceiversTypes();
          },
          areas: function(AreasService){
            return AreasService.getAllWithoutPagination();
          },
          areaTypes: function (AreaTypesService) {
            return AreaTypesService.getAllWithoutPagination();
          }  
        }
      })

  }
})();



(function () {
  'use strict';

  angular.module('GoCloudCast.modules.cast.senders', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('cast.senders-list', {
        url: '/senders',  
        templateUrl: 'app/modules/cast/senders/senders.html',
        title: 'Senders',
        parent : 'main',
        sidebarMeta: {
          permissions: [
            'senders--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-mobile'
        },
        controller : 'SendersController',
        controllerAs : 'vm',
        resolve: {
          areas: function(AreasService){
            return AreasService.getAllWithoutPagination();
          },
          configs: function($stateParams,ConfigsService){
            return ConfigsService.get();  
          }
        }
      })

  }
})();

(function () {
	'use strict';
  
	angular.module('GoCloudCast.modules.iptv.channels', [
	  'GoCloudCast.modules.iptv.channels.lists',
	  'GoCloudCast.modules.iptv.channels.types'
	]).config(routeConfig);
  
	/** @ngInject */
	function routeConfig($stateProvider) {
	  $stateProvider.state('iptv.channels', {
		url: '/channels',
		parent: 'main',
		template : '<ui-view  autoscroll="false" autoscroll-body-top></ui-view>',
		abstract: true,
		title: 'Channels',
		sidebarMeta: {
		  icon: 'fa fa-tv',
		  permissions: [
           	    'channels--index'
		  ]
		}
	  });
	}
  })();

(function () {
    'use strict';
  
    angular.module('GoCloudCast.modules.iptv.experiences', []).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('iptv.experiences-list', {
          url: '/experiences',  
          templateUrl: 'app/modules/iptv/experiences/experiences.html',
          title: 'Experiences',
          parent : 'main',
          sidebarMeta: {
            propertyErrorMessage: 'There must be at least one property before you can see this section',
            disabledWithoutProperty: true,
            icon: 'fa fa-glass',
          },
          controller : 'ExperiencesController',
          controllerAs : 'vm',
        })


        .state('iptv.experiences-edit', {
          url: '/experiences-edit/:id',  
          templateUrl: 'app/modules/iptv/experiences/experiencesAddEdit.html',
          parent : 'main',
          title: 'Experiences Edition',
          controller : 'ExperiencesAddEditController',
          controllerAs : 'vm',
          contentTopParent : 'iptv.experiences-list',
          resolve: {
            areas: function(AreasService){
              return AreasService.getAllWithoutPagination();  
            },
            experience : function($stateParams,ExperiencesService){
              return ExperiencesService.get($stateParams.id);
            },
             languages : function(ExperiencesService){
              return ExperiencesService.getLanguages();
            }
          }
        })


        .state('iptv.experiences-add', {
          url: '/experiences-add',  
          templateUrl: 'app/modules/iptv/experiences/experiencesAddEdit.html',
          parent : 'main',
          title: 'Experiences Add',
          controller : 'ExperiencesAddEditController',
          controllerAs : 'vm',
          contentTopParent : 'iptv.experiences-list',
          resolve: {
            areas: function(AreasService){
              return AreasService.getAllWithoutPagination();  
            },
            experience : function(ExperiencesService){
              
              return ExperiencesService.getEmptyExperience();
            },
            languages : function(ExperiencesService){
              return ExperiencesService.getLanguages();
            }
          }
        })
  
    }
  })();


(function () {
	'use strict';
  
	angular.module('GoCloudCast.modules.iptv.hotelInfos', [
	  'GoCloudCast.modules.iptv.hotelInfos.lists',
	  'GoCloudCast.modules.iptv.hotelInfos.categories'
	]).config(routeConfig);
  
	/** @ngInject */
	function routeConfig($stateProvider) {
	  $stateProvider.state('iptv.hotel-infos', {
		url: '/hotelInfos',
		parent: 'main',
		template : '<ui-view  autoscroll="false" autoscroll-body-top></ui-view>',
		abstract: true,
		title: 'Hotel Infos',
		sidebarMeta: {
		  icon: 'fa fa-building',
        	  permissions: [
           	      'hotel-info--index'
		  ]
      		}
	  });
	}
  })();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.tlx', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('iptv.tlx-add', {
        url: '/tlx',  
        templateUrl: 'app/modules/iptv/tlx/tlx.html',
        title: 'Tlx',
        parent : 'main',
        sidebarMeta: {
          permissions: [
             'tlx--add-tlx'
          ],
          disabledWithoutProperty: false,
          icon: 'fa fa-th-large',
        },
        controller : 'TlxController',
        controllerAs : 'vm',
        resolve: {
          tvModels: function(TvModelsService){
            return TvModelsService.getAllWithoutPagination();
          }
        }
      })


  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvApplicationVersions', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {

    function getQueryParams(endpoint){
      var str = window.location.href;
      var queryParams = str.substr(str.indexOf(endpoint)+endpoint.length);
      var values = queryParams.split("/")
      var params = [];
      var keys = ['application_id', 'name'];

      values.forEach(function(elem,index) {
        params[keys[index]] = elem;
      });

      return params;
    }

    $stateProvider
      .state('iptv.tv-application-version-list', {
        url: '/tv-applications/:application_id/:name/versions',  
        templateUrl: 'app/modules/iptv/tvApplicationVersions/tvApplicationVersions.html',
        title: function(){
          var queryParams = getQueryParams('tv-applications/');
          return queryParams.name + " versions";
        },
        contentTopParent : 'iptv.tv-applications-list',
        parent : 'main',
        controller : 'TvApplicationVersionsController',
        controllerAs : 'vm',
        resolve: {
          application_resolve : function($stateParams){
            return $stateParams;
          },
          application : function(TvApplicationsService, $stateParams) {
            return TvApplicationsService.get($stateParams.application_id).then(function(callback){
              return callback.data;
            });
          }
        }
      })
 
      .state('iptv.tv-application-version-new', {
        url: '/tv-applications/:application_id/:name/versions-new',  
        templateUrl: 'app/modules/iptv/tvApplicationVersions/tvApplicationVersionAddEdit.html',
        contentTopParent : 'iptv.tv-applications-list',
        parent : 'main',
        title: function(){
          var queryParams = getQueryParams('tv-applications/');
          return queryParams.name + " version creation";
        },
        controller : 'TvApplicationVersionAddEditController',
        controllerAs : 'vm',
        resolve: {
          application_resolve : function($stateParams){
            return $stateParams;
          },
          tv_application_version : function($stateParams, TvApplicationVersionsService){
            return TvApplicationVersionsService.getEmptyTvApplicationVersion($stateParams.application_id);
          },
          tv_models: function(TvModelsService){
            return TvModelsService.getAllWithoutPagination().then(function(callback){
              return callback.data.map(function(object) { 
                return {text: object.model};
              });
            });
          },
          application : function(TvApplicationsService, $stateParams) {
            return TvApplicationsService.get($stateParams.application_id).then(function(callback){
              return callback.data;
            });
          }
        }
      })
 
      .state('iptv.tv-application-version-edit', {
        url: '/tv-applications/:application_id/:name/versions-edit/:id',  
        templateUrl: 'app/modules/iptv/tvApplicationVersions/tvApplicationVersionAddEdit.html',
        contentTopParent : 'iptv.tv-applications-list',
        parent : 'main',
        title: function(){
          var queryParams = getQueryParams('tv-applications/');
          return queryParams.name + " version edition";
        },
        controller : 'TvApplicationVersionAddEditController',
        controllerAs : 'vm',
        resolve: {
          application_resolve : function($stateParams){
            return $stateParams;
          },
          tv_application_version : function($stateParams, TvApplicationVersionsService){
            return TvApplicationVersionsService.get($stateParams.id).then(function(callback){
              var data = callback.data;
              data.tv_application_version_models.map(function(model){
                model['text'] = model.tv_model;
              })

              return data; 
            });
          },
          tv_models: function(TvModelsService){
            return TvModelsService.getAllWithoutPagination().then(function(callback){
              return callback.data.map(function(object) { 
                return {text: object.model};
              });
            });
          },
          application : function(TvApplicationsService, $stateParams) {
            return TvApplicationsService.get($stateParams.application_id).then(function(callback){
              return callback.data;
            });
          }
        }
      })
  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvApplications', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('iptv.tv-applications-list', {
        url: '/tv-applications',  
        templateUrl: 'app/modules/iptv/tvApplications/tvApplications.html',
        title: 'Tv Applications',
        parent : 'main',
        sidebarMeta: {
           permissions: [
             'tv-applications--destroy',
             'tv-applications--new',
             'tv-applications--edit'
           ],
          icon: 'fa fa-television',
        },
        resolve: {
          brands: function(ApiService) {
            return ApiService.get('/tv-models/brands').then(function(response) {
              return response.data;
            });
          }
        },
        controller : 'TvApplicationsController',
        controllerAs : 'vm'
      })
      .state('iptv.tv-applications-new', {
        url: '/tv-applications-new',  
        templateUrl: 'app/modules/iptv/tvApplications/tvApplicationsAddEdit.html',
        parent : 'main',
        title: 'Tv Applications New',
        controller : 'TvApplicationsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.tv-applications-list',
        resolve : {
          brands: function(ApiService) {
            return ApiService.get('/tv-models/brands').then(function(response) {
              return response.data;
            });
          },
          tvApplication: function($stateParams, TvApplicationsService) {
              return TvApplicationsService.getEmptyTvApplication();
          },
          languages : function(TvApplicationsService){
            return TvApplicationsService.getLanguages();
          }
        }
      })
      .state('iptv.tv-applications-edit', {
        url: '/tv-applications-edit/:id',  
        templateUrl: 'app/modules/iptv/tvApplications/tvApplicationsAddEdit.html',
        parent : 'main',
        title: 'Tv Applications Edition',
        controller : 'TvApplicationsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.tv-applications-list',
        resolve : {
          brands: function(ApiService) {
            return ApiService.get('/tv-models/brands').then(function(response) {
              return response.data;
            });
          },
          tvApplication: function($stateParams, TvApplicationsService) {
              return TvApplicationsService.get($stateParams.id);
          },
          languages : function(TvApplicationsService){
            return TvApplicationsService.getLanguages();
          }
        }
      })
  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvApplicationsProperty', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('iptv.tv-applications-property-list', {
        url: '/tv-applications-property',  
        templateUrl: 'app/modules/iptv/tvApplicationsProperty/tvApplicationsProperty.html',
        title: 'Tv Apps Property',
        parent : 'main',
        sidebarMeta: {
          permissions: [
             'tv-applications-properties--index'
          ],
          icon: 'fa fa-television',
        },
        controller : 'TvApplicationsPropertyController',
        controllerAs : 'vm',
        resolve: {
          tvApplicationsProperty: function(TvApplicationsPropertyService){
            return TvApplicationsPropertyService.getAll();
          },
          tvApplications: function(TvApplicationsService){
            return TvApplicationsService.getAll();
          },
          brands: function(ApiService) {
            return ApiService.get('/tv-models/brands').then(function(response) {
              return response.data;
            });
          },
          tvApplicationVersions: function(TvApplicationVersionsService){
            return TvApplicationVersionsService.getAll();
          }
        }
      })
  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvModels', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('iptv.tv-models-list', {
        url: '/tv-models',  
        templateUrl: 'app/modules/iptv/tvModels/tvModels.html',
        title: 'Tv Models',
        parent : 'main',
        sidebarMeta: {
          permissions: [
             'tv-models--index'
          ],
          icon: 'fa fa-television',
        },
        controller : 'TvModelsController',
        controllerAs : 'vm',
        resolve : {
          brands: function(ApiService) {
            return ApiService.get('/tv-models/brands').then(function(response) {
              return response.data;
            });
          },
          resolutions: function(ApiService) {
            return ApiService.get('/tv-models/resolutions').then(function(response) {
              return response.data;
            });
          }
        }
      })
      .state('iptv.tv-models-new', {
        url: '/tv-models-new',  
        templateUrl: 'app/modules/iptv/tvModels/tvModelsAddEdit.html',
        parent : 'main',
        title: 'Tv Models New',
        controller : 'TvModelsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.tv-models-list',
        resolve : {
          brands: function(ApiService) {
            return ApiService.get('/tv-models/brands').then(function(response) {
              return response.data;
            });
          },
          resolutions: function(ApiService) {
            return ApiService.get('/tv-models/resolutions').then(function(response) {
              return response.data;
            });
          },
          tvModel: function($stateParams, TvModelsService) {
              return TvModelsService.getEmptyTvModel();
          }
        }
      })
      .state('iptv.tv-models-edit', {
        url: '/tv-models-edit/:id',  
        templateUrl: 'app/modules/iptv/tvModels/tvModelsAddEdit.html',
        parent : 'main',
        title: 'Tv Models Edition',
        controller : 'TvModelsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.tv-models-list',
        resolve : {
          brands: function(ApiService) {
            return ApiService.get('/tv-models/brands').then(function(response) {
              return response.data;
            });
          },
          resolutions: function(ApiService) {
            return ApiService.get('/tv-models/resolutions').then(function(response) {
              return response.data;
            });
          },
          tvModel: function($stateParams, TvModelsService) {
              return TvModelsService.get($stateParams.id);
          }
        }
      })
  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvs', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('iptv.tvs-list', {
        url: '/tvs',  
        templateUrl: 'app/modules/iptv/tvs/tvs.html',
        title: 'Tvs',
        parent : 'main',
        sidebarMeta: {
          permissions: [
             'tvs--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-television',
        },
        controller : 'TvsController',
        controllerAs : 'vm'
      })
      .state('iptv.tvs-edit', {
        url: '/tvs-edit/:id',
        templateUrl: 'app/modules/iptv/tvs/tvsAddEdit.html',
        parent : 'main',
        title: 'Tv Edition',
        controller : 'TvsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.tvs-list',
        resolve : {
          tv: function($stateParams,TvsService){
            return TvsService.get($stateParams.id);  
          },
          areas: function(AreasService){
            return AreasService.getAllWithoutPagination();
          },
          tvModels: function(TvModelsService){
            return TvModelsService.getAllWithoutPagination();
          }
        }
      })
      .state('iptv.tvs-new', {
        url: '/tvs-new',  
        templateUrl: 'app/modules/iptv/tvs/tvsAddEdit.html',
        parent : 'main',
        title: 'Tv Creation',
        controller : 'TvsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.tvs-list',
        resolve : {
          tv: function(TvsService){
            return TvsService.getEmptyTv();
          },
          areas: function(AreasService){
            return AreasService.getAllWithoutPagination();
          },
          tvModels: function(TvModelsService){
            return TvModelsService.getAllWithoutPagination();
          }  
        }
      })
  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.reports.general-use', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var format = 'YYYY-MM-DD HH:mm:ss';
    var today = moment().format(format); 
    var lastMonth = moment().subtract(1, 'months').format(format);
    var startDate = new Date(lastMonth);
    var endDate = new Date(today);

    $stateProvider
      .state('reports.general-use', {  
        url: '/reports/general-use',
        parent: 'main',
        title: 'General use',
        sidebarMeta: {
          all_permissions: true,
          permissions: [
            //TODO: permisos de reportes de ES que no permite darse de alta
            /*
            'sender-uptime--top-mac-address',
            'report--report',
            'sender-uptime--statistics',
            'receiver-state--statistics',
            'receiver-uptime--index-filtering-by-date'
            */
            //POR EL MOMENTO DEJO ESTE PERMISO PERO EL DIA DE MAÑANA HAY QUE PONER LOS ADECUADOS
            'receivers--index'
          ],
        },
        views: {
          '': {
            templateUrl: 'app/modules/reports/general-use/general-use-reports.html',
            controller : 'GeneralUseReportsController',
            controllerAs : 'vm'
          },
          'validation@main': {
            templateUrl: 'app/modules/reports/general-use/validations/validation-reports.html',
            controller : 'ValidationReportsController',
            controllerAs : 'vm',
            resolve: {
              top_macs: function(GeneralUseService){
                return GeneralUseService.getTopMacAddresses(moment(startDate).format(format), moment(endDate).format(format));
              }
            }
          },
          'state@main': {
            templateUrl: 'app/modules/reports/general-use/states/state-reports.html',
            controller : 'StateReportsController',
            controllerAs : 'vm'
          },    
          'section@main': {
            templateUrl: 'app/modules/reports/general-use/sections/section-reports.html',
            controller : 'SectionReportsController',
            controllerAs : 'vm'
          }
        },
        resolve: {
          date_format_resolve: function(){
            return format;
          },
          start_date_resolve: function(){
            return startDate;
          },
          end_date_resolve: function(){
            return endDate;
          }
        }  
      });
  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.reports.infrastructure-monitor', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var format = 'YYYY-MM-DD HH:mm:ss';
    var today = moment().format(format); 
    var lastMonth = moment().subtract(1, 'months').format(format);
    var startDate = new Date(lastMonth);
    var endDate = new Date(today);

    $stateProvider
      .state('reports.infrastructure-monitor', {  
        url: '/reports/infrastructure-monitor',
        parent: 'main',
        title: 'Infrastructure Monitor',
        templateUrl: 'app/modules/reports/infrastructure-monitor/infrastructure-monitor-reports.html',
        controller : 'InfrastructureMonitorReportsController',
        controllerAs : 'vm',
        sidebarMeta: {},
        resolve: {
          date_format_resolve: function(){
            return format;
          },
          start_date_resolve: function(){
            return startDate;
          },
          end_date_resolve: function(){
            return endDate;
          },
          data_resolve: function(InfrastructureMonitorService, ReceiversService){
            return InfrastructureMonitorService.getGraphData(moment(startDate).format(format), moment(endDate).format(format))/*.then(function(monitorData){
              return ReceiversService.getAll(true).then(function(receiversData){
                return InfrastructureMonitorService.groupAndFormatData(receiversData.data, monitorData.data)
              });
            })*/;
          },
          receivers_data: function(ReceiversService){
            return ReceiversService.getAll(true);
          },
          frecs_resolve: function(){
            return [
              'A','B','C','D','E','F'
            ]
          }
        } 
      });
  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.reports.signal-strength', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    var format = 'YYYY-MM-DD HH:mm:ss';
    var today = moment().format(format); 
    var lastMonth = moment().subtract(1, 'months').format(format);
    var startDate = new Date(lastMonth);
    var endDate = new Date(today);

    $stateProvider
      .state('reports.signal-strength', {  
        url: '/reports/signal-strength',
        parent: 'main',
        title: 'Signal Strength',
        templateUrl: 'app/modules/reports/signal-strength/signal-strength-reports.html',
        controller : 'SignalStrengthReportsController',
        controllerAs : 'vm',
        sidebarMeta: {
          all_permissions: true,
          permissions: [
            //TODO: permisos de reportes de ES que no permite darse de alta
            /*
            'signal-strength--get-signal-strength-graph-data',
            */
            'receivers--index'
          ]
        },
        resolve: {
          date_format_resolve: function(){
            return format;
          },
          start_date_resolve: function(){
            return startDate;
          },
          end_date_resolve: function(){
            return endDate;
          },
          data_resolve: function(SignalStrengthService, ReceiversService){
            return SignalStrengthService.getGraphData(moment(startDate).format(format), moment(endDate).format(format)).then(function(signalData){
              return ReceiversService.getAll(true).then(function(receiversData){
                return SignalStrengthService.groupAndFormatData(receiversData.data, signalData.data)
              });
            });
          },
          receivers_data: function(ReceiversService){
            return ReceiversService.getAll(true);
          },
          frecs_resolve: function(){
            return [
              'A','B','C','D','E','F'
            ]
          }
        } 
      });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.amCharts', [])
      .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.amCharts', {
          url: '/amCharts',
          templateUrl: 'app/pages/charts/amCharts/charts.html',
          title: 'amCharts'
//          sidebarMeta: {
//            order: 0,
//          },
        });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
    'use strict';

    angular.module('GoCloudCast.pages.charts.chartJs', [])
        .config(routeConfig).config(chartJsConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('charts.chartJs', {
                url: '/chartJs',
                templateUrl: 'app/pages/charts/chartJs/chartJs.html',
                title: 'Chart.js'
//                sidebarMeta: {
//                    order: 200
//                }
            });
    }

    function chartJsConfig(ChartJsProvider, baConfigProvider) {
        var layoutColors = baConfigProvider.colors;
        // Configure all charts
        ChartJsProvider.setOptions({
            chartColors: [
                layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2500
            },
            scale: {
                gridLines: {
                    color: layoutColors.border
                },
                scaleLabel: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    fontColor: layoutColors.defaultText,
                    showLabelBackdrop: false
                }
            }
        });
        // Configure all line charts
        ChartJsProvider.setOptions('Line', {
            datasetFill: false
        });
        // Configure all radar charts
        ChartJsProvider.setOptions('radar', {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });
        // Configure all bar charts
        ChartJsProvider.setOptions('bar', {
            tooltips: {
                enabled: false
            }
        });
    }

})();
/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartist', {
          url: '/chartist',
          templateUrl: 'app/pages/charts/chartist/chartist.html',
          title: 'Chartist'
//          sidebarMeta: {
//            order: 100,
//          },
        });
  }

})();
/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider){
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.morris', {
          url: '/morris',
          templateUrl: 'app/pages/charts/morris/morris.html',
          title: 'Morris'
//          sidebarMeta: {
//            order: 300,
//          }
        });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('components.mail', {
          url: '/mail',
          abstract: true,
          templateUrl: 'app/pages/components/mail/mail.html',
          controller: "MailTabCtrl",
          controllerAs: "tabCtrl",
          title: 'Mail'
//          sidebarMeta: {
//            order: 0,
//          },
        }).state('components.mail.label', {
          url: '/:label',
          templateUrl: 'app/pages/components/mail/list/mailList.html',
          title: 'Mail',
          controller: "MailListCtrl",
          controllerAs: "listCtrl"
        }).state('components.mail.detail', {
          url: '/:label/:id',
          templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
          title: 'Mail',
          controller: "MailDetailCtrl",
          controllerAs: "detailCtrl"
        });
    $urlRouterProvider.when('/components/mail','/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('components.timeline', {
        url: '/timeline',
	    templateUrl: 'app/pages/components/timeline/timeline.html',
		title: 'Timeline'
//          sidebarMeta: {
//            icon: 'ion-ios-pulse',
//            order: 100,
//          },
      });
  }
})();
/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.tree', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components.tree', {
          url: '/tree',
          templateUrl: 'app/pages/components/tree/tree.html',
          title: 'Tree View'
//          sidebarMeta: {
//            order: 200,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts'
//          sidebarMeta: {
//            order: 500,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons'
//          sidebarMeta: {
//            order: 100,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid'
//          sidebarMeta: {
//            order: 400,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons'
//          sidebarMeta: {
//            order: 200,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals'
//          sidebarMeta: {
//            order: 300,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications'
//          sidebarMeta: {
//            order: 700,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels'
//          sidebarMeta: {
//            order: 1100,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars'
//          sidebarMeta: {
//            order: 600,
//          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders'
//          sidebarMeta: {
//            order: 1000,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions'
//          sidebarMeta: {
//            order: 800,
//          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography'
//          sidebarMeta: {
//            order: 0,
//          },
        });
  }

})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.cast.notifications.notificationEmails', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('cast.notifications.notification-emails-list', {
        url: '/notification-emails',  
        templateUrl: 'app/modules/cast/notifications/notificationEmails/notificationEmails.html',
        title: 'Notification Emails',
        parent : 'main',
        sidebarMeta: {
          permissions: [
            'notification-emails--index'
          ],
          icon: 'fa fa-envelope',
        },
        controller : 'NotificationEmailsController',
        controllerAs : 'vm'
      })

      .state('cast.notifications.notification-emails-new', {
        url: '/notification-emails-new',  
        templateUrl: 'app/modules/cast/notifications/notificationEmails/notificationEmailsAddEdit.html',
        parent : 'main',
        title: 'Notification Email Creation',
        controller : 'NotificationEmailsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'cast.notifications.notification-emails-list',
        resolve: {
          notificationEmail : function(NotificationEmailsService){
            return NotificationEmailsService.getEmptyNotificationEmail();
          }
        }
      })

      .state('cast.notifications.notification-emails-edit', {
        url: '/notification-emails-edit/:id',  
        templateUrl: 'app/modules/cast/notifications/notificationEmails/notificationEmailsAddEdit.html',
        parent : 'main',
        title: 'Notification Email Edition',
        controller : 'NotificationEmailsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'cast.notifications.notification-emails-list',
        resolve: {
          notificationEmail : function($stateParams,NotificationEmailsService){
            return NotificationEmailsService.get($stateParams.id);
          }
        }
      })
  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.channels.lists', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('iptv.channels.lists-list', {
        url: '/channel-lists',  
        templateUrl: 'app/modules/iptv/channels/lists/lists.html',
        title: 'List',
        parent : 'main',
        sidebarMeta: {
          permissions: [
             'channels--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
        //  icon: 'fa fa-th-large',
        },
        controller : 'ChannelListsController',
        controllerAs : 'vm',
        resolve: {
          types: function(ChannelListsService){
            return ChannelListsService.getTypes();  
          },
          states: function(ChannelListsService){
            return ChannelListsService.getStates();  
          }
        }
      })

      .state('iptv.channels.lists-new', {
        url: '/channels-lists-new',  
        templateUrl: 'app/modules/iptv/channels/lists/listsAddEdit.html',
        parent : 'main',
        title: 'Channel Creation',
        controller : 'ChannelListsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.channels.lists-list',
        resolve: {
          types: function(ChannelListsService){
            return ChannelListsService.getTypes();  
          },
          states: function(ChannelListsService){
            return ChannelListsService.getStates();  
          },
          channel : function(ChannelListsService){
            return ChannelListsService.getEmptyChannel();
          },
          languages : function(ChannelListsService){
            return ChannelListsService.getLanguages();
          },
          channelTypes : function(ChannelTypesService){
            return ChannelTypesService.getAllWithoutPagination();
          }
        }
      })

      .state('iptv.channels.lists-edit', {
        url: '/channels-lists-edit/:id',  
        templateUrl: 'app/modules/iptv/channels/lists/listsAddEdit.html',
        parent : 'main',
        title: 'Channel Edition',
        controller : 'ChannelListsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.channels.lists-list',
        resolve: {
          types: function(ChannelListsService){
            return ChannelListsService.getTypes();  
          },
          states: function(ChannelListsService){
            return ChannelListsService.getStates();  
          },
          channel : function($stateParams,ChannelListsService){
            return ChannelListsService.get($stateParams.id);
          },
          languages : function(ChannelListsService){
            return ChannelListsService.getLanguages();
          },
          channelTypes : function(ChannelTypesService){
            return ChannelTypesService.getAllWithoutPagination();
          }
        }
      })

  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.channels.types', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('iptv.channels.types-list', {
        url: '/channel-types',  
        templateUrl: 'app/modules/iptv/channels/types/types.html',
        title: 'Types',
        parent : 'main',
        sidebarMeta: {
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-th-large',
        },
        controller : 'ChannelTypesController',
        controllerAs : 'vm',
        resolve: {
        }
      })

      .state('iptv.channels.types-new', {
        url: '/channel-types-new',  
        templateUrl: 'app/modules/iptv/channels/types/typesAddEdit.html',
        parent : 'main',
        title: 'Types Creation',
        controller : 'ChannelTypesAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.channels.types-list',
        resolve: {
          languages : function(ChannelTypesService){
            return ChannelTypesService.getLanguages();
          },
          channelType : function(ChannelTypesService){
            return ChannelTypesService.getEmptyChannelTypes();
          }
        }
      })

      .state('iptv.channels.types-edit', {
        url: '/channel-types-edit/:id',  
        templateUrl: 'app/modules/iptv/channels/types/typesAddEdit.html',
        parent : 'main',
        title: 'Types Edition',
        controller : 'ChannelTypesAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.channels.types-list',
        resolve: {
          languages : function(ChannelTypesService){
            return ChannelTypesService.getLanguages();
          },
          channelType : function($stateParams,ChannelTypesService){
            return ChannelTypesService.get($stateParams.id);
          }
        }
      })

  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.hotelInfos.categories', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('iptv.hotel-infos.categories-list', {
        url: '/hotel-info-categories',  
        templateUrl: 'app/modules/iptv/hotelInfos/categories/categories.html',
        title: 'Categories',
        parent : 'main',
        sidebarMeta: {
          permissions: [
             'hotel-info-categories--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-info-circle',
        },
        controller : 'HotelInfoCategoriesController',
        controllerAs : 'vm'
      })
      .state('iptv.hotel-infos.categories-new', {
        url: '/hotel-info-categories-new',  
        templateUrl: 'app/modules/iptv/hotelInfos/categories/categoriesAddEdit.html',
        parent : 'main',
        title: 'Hotel Info Category Creation',
        controller : 'HotelInfoCategoriesAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.hotel-infos.categories-list',
        resolve: {
          hotelInfoCategory : function(HotelInfoCategoriesService){
            return HotelInfoCategoriesService.getEmptyHotelInfoCategory();
          }
        }
      })
      .state('iptv.hotel-infos.categories-edit', {
        url: '/categories-edit/:id',  
        templateUrl: 'app/modules/iptv/hotelInfos/categories/categoriesAddEdit.html',
        parent : 'main',
        title: 'Hotel Info Category Edition',
        controller : 'HotelInfoCategoriesAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.hotel-infos.categories-list',
        resolve: {
          hotelInfoCategory : function($stateParams,HotelInfoCategoriesService){
            return HotelInfoCategoriesService.get($stateParams.id);
          }
        }
      })
    }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules.iptv.hotelInfos.lists', []).config(routeConfig).config(textAngular);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('iptv.hotel-infos.lists-list', {
        url: '/hotel-info-lists',  
        templateUrl: 'app/modules/iptv/hotelInfos/lists/lists.html',
        title: 'List',
        parent : 'main',
        sidebarMeta: {
          permissions: [
             'hotel-info--index'
          ],
          propertyErrorMessage: 'There must be at least one property before you can see this section',
          disabledWithoutProperty: true,
          icon: 'fa fa-info-circle',
        },
        controller : 'HotelInfoListsController',
        controllerAs : 'vm'
      })

      .state('iptv.hotel-infos.lists-new', {
        url: '/hotel-info-lists-new',  
        templateUrl: 'app/modules/iptv/hotelInfos/lists/listsAddEdit.html',
        parent : 'main',
        title: 'Hotel Info Creation',
        controller : 'HotelInfoListsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.hotel-infos.lists-list',
        resolve: {
          hotelInfo : function(HotelInfoListsService){
            return HotelInfoListsService.getEmptyHotelInfo();
          },
          languages : function(HotelInfoListsService){
            return HotelInfoListsService.getLanguages();
          },
          hotelInfoCategories : function(HotelInfoCategoriesService){
            return HotelInfoCategoriesService.getAllWithoutPagination();
          },
          hotelInfosMenu: function(HotelInfoListsService){
            return HotelInfoListsService.getAllWithoutPagination();
          }
        }
      })

      .state('iptv.hotel-infos.lists-edit', {
        url: '/hotel-info-lists-edit/:id',  
        templateUrl: 'app/modules/iptv/hotelInfos/lists/listsAddEdit.html',
        parent : 'main',
        title: 'Hotel Info Edition',
        controller : 'HotelInfoListsAddEditController',
        controllerAs : 'vm',
        contentTopParent : 'iptv.hotel-infos.lists-list',
        resolve: {
          hotelInfo : function($stateParams,HotelInfoListsService){
            return HotelInfoListsService.get($stateParams.id);
          },
          languages : function(HotelInfoListsService){
            return HotelInfoListsService.getLanguages();
          },
          hotelInfoCategories : function(HotelInfoCategoriesService){
            return HotelInfoCategoriesService.getAllWithoutPagination();
          },
          hotelInfosMenu: function(HotelInfoListsService){
            return HotelInfoListsService.getAllWithoutPagination();
          }
      }
    })
  }

  function textAngular($provide){
      // this demonstrates how to register a new tool and add it to the default toolbar
      $provide.decorator('taOptions', ['taRegisterTool', '$delegate', function(taRegisterTool, taOptions) { // $delegate is the taOptions we are decorating
          taOptions.toolbar = [
              ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
              ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
              ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
              ['html', 'wordcount', 'charcount']
          ];
          return taOptions;
      }]);
  }   
})();

'use strict';

angular.module('GoCloudCast', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'ngTable',
  'ngSweetAlert2',
  'pascalprecht.translate', 
  'angular-translate-loader-pluggable',
  'angular-progress-button-styles',
  'LocalStorageModule',
  'ngDialog',
  'highcharts-ng',
  'ngPassword',
  'ngMessages',
  'colorpicker.module',
  'ngCropper',
  'angular-loading-bar',
  'ngAnimate',
  'timer',
  'gridster',
  'angular-advanced-searchbox',
  'textAngular',
  'ckeditor',
  'angularFileUpload',
  'ngTagsInput',

  'GoCloudCast.theme',
  'GoCloudCast.pages',
  'GoCloudCast.core',
  'GoCloudCast.auth',
  'GoCloudCast.modules'
]);
(function(){
  'use strict';

  angular.module('GoCloudCast.core').controller('abstractAddEdit', abstractAddEdit);
  
  function abstractAddEdit($state, $uibModal, childProperties, NotificationService, scope, service) {

    var vm = this;

    vm.cancel                     = cancel;
    vm.save                       = save;
    vm.saveAsync                  = saveAsync;
    vm.cleanSvError               = cleanSvError;
    vm.showServerError            = showServerError;
    vm.haveServerError            = haveServerError;
    vm.errorsSv                   = {};
    vm.basicValidationWithSvError = basicValidationWithSvError;
    vm.basicValidation            = basicValidation;
    vm.clickOpenFile              = clickOpenFile;
    
    function basicValidationWithSvError(form, field, fieldName) {
      return (field && field.$invalid && (field.$dirty || form.$submitted) ) || (vm.errorsSv[fieldName]? vm.errorsSv[fieldName].length : false)
    }

    function basicValidation(form, field) {
      return field && field.$invalid && (field.$dirty || form.$submitted)
    }

    function clickOpenFile(){
      var fileInput = document.getElementById('image');
      fileInput.click();
    }

    function cleanSvError(fieldName) {
      vm.errorsSv[fieldName] = [];
    }

    function haveServerError(field) {
      return vm.errorsSv[field] !== undefined;
    }

    function showServerError(field){
      var message = vm.errorsSv[field]? vm.errorsSv[field][0] : "";
      return message;
    }

    function save(form,data) {

      var promise = new Promise(function(resolve, reject) {
      
        if (form.$valid) {
          var dataToSend = angular.copy(data)
          if (childProperties.formatData){
            childProperties.formatData(dataToSend)
          }  
    
          service.save(dataToSend).then(function(data){
            if (!childProperties.noRedirect){
              $state.go(childProperties.stateUrl,childProperties.stateParams);
            } 
            NotificationService.success('Element saved', 'Success');
            if (childProperties.postSave){
              childProperties.postSave(data)
            } 
            resolve('.');
          }, function(data){
            vm.errorsSv = data.data.data.errors? data.data.data.errors : {}
            NotificationService.error('Element cannot be saved', 'Error');
            reject(new Error("error updating entity")); 
          });
        } else {
          resolve('.');
        }

      })

      return promise
    }

    function saveAsync(form,data) {
      if (form.$valid) {
        var dataToSend = angular.copy(data)
        if (childProperties.formatData){
          childProperties.formatData(dataToSend)
        }  
        service.save(dataToSend).then(function(data){
          NotificationService.success('Element saved', 'Success');
          if (childProperties.postSave){
            childProperties.postSave(data)
          }

        }, function(data){
          vm.errorsSv = data.data.data.errors? data.data.data.errors : {}
          NotificationService.error('Element cannot be saved', 'Error');
        });

        NotificationService.info('The element is being saved', 'Success');
        if (!childProperties.noRedirect){
          $state.go(childProperties.stateUrl,childProperties.stateParams);
        } 
      }
    }

    function cancel() {
      $state.go(childProperties.stateUrl,childProperties.stateParams);
    }    

    scope.setFile = function(element) {
      scope.currentFile  = element.files[0];
      var reader         = new FileReader();
      
      reader.onload = function(event) {
          if (element.files && element.files[0]) {
            childProperties.onLoad(element.files[0], openModal(element.files[0]))
          }
          element.value = "";
          scope.$apply();
      }
      // when the file is read it triggers the onload event above.
      reader.readAsDataURL(element.files[0]);
    }

    function openModal(image){

      var modalInstance = $uibModal.open({
        animation: true,
        windowClass: 'modal',
        title: 'Edit Image',
        templateUrl: 'app/modules/templates/editImage.html',
        controller: 'EditImageController',
        controllerAs: 'vm',
        backdrop: false,
        resolve: {
          image: function(){
            return image;
          },
          resolutions: function(){
            return {
              minWidth: childProperties.resolutions.minWidth,
              minHeight: childProperties.resolutions.minHeight,
              maxWidth: childProperties.resolutions.maxWidth,
              maxHeight: childProperties.resolutions.maxHeight
            }
          },
          aspectRatio: function(){
            return childProperties.resolutions.ratio;
          }
        }
      });

      modalInstance.result.then(function(data){
        if(data){
          childProperties.promise(data)
        }
      });
    }
  }
})();
(function(){
  'use strict';

  angular.module('GoCloudCast.core').controller('abstractTable', abstractConfigurationTable);
  
  function abstractConfigurationTable(NgTableParams, childProperties, scope, ApiService, NotificationService, StorageService) {

    var vm = this;

    vm.deleteRow = deleteRow;

    vm.applyGlobalSearch = applyGlobalSearch;

    vm.generateParams = generateParams;

    vm.parameters = [
    ];

    vm.table  =  new NgTableParams(
      { page: 1,
        count: 10,
        sorting: childProperties.sorting
      }, 
      {
        getData: function(params){
          return ApiService.get('/'+ getUrl() +
                                '?page='+params.page()+
                                '&per_page='+params.count() +
                                (addStaticFilters()) +
                                (addSorts(params)) +
                                (addFilters(params))
            ).then(function(response){
              var dataRoot = response.data;
              if(childProperties.dataRoot){
                var way = response;
                childProperties.dataRoot.forEach(function(point){way = way[point]})
                dataRoot = way;
              }
              params.total(dataRoot.total);
              
              var responseData = response.data.data? response.data.data: response.data
              if(childProperties.preProcessData){
                return childProperties.preProcessData(responseData);
              } else {
                return responseData;
              }
            }, function(data){
            });
        }
      });

    vm.refreshTable = refreshTable;

    scope.$on('advanced-searchbox:modelUpdated', function (event, model) {
      if (!model.query) {
        vm.applyGlobalSearch(model);
      }
    });

    vm.search = {}

    scope.$on('advanced-searchbox:addedSearchParam', function (event, searchParameter) {
      vm.search[searchParameter.key] = ""
    });

    function getUrl(){
      return (typeof childProperties.url === 'function') ? childProperties.url() : childProperties.url;
    }

    function addStaticFilters(params){
      var filters = ''; 
      if (childProperties.staticFilters){
        angular.forEach(childProperties.staticFilters, function(funcValue, key) {
          var value = funcValue();
          if(value){
            filters = filters + '&' + key + '=' + value;
          }
        });
      }
      return filters;
    }

    function addFilters(params){
      var filters = '';
      var filter = angular.copy(params.filter());
      if (!(!filter || angular.equals(filter, {}))){
        filters = childProperties.staticFilters ? '&filter_condition=and' : '&filter_condition=or';
        childProperties.fieldsToFilter.forEach(function(field) {
          var fieldElement = filter[field];
          if(fieldElement != '' && fieldElement) {
            filters = filters + '&' + field + '=' + fieldElement
          }
        });
      }
      return filters;
    }

    function addSorts(params){
      var sortParam = '';
      var sorting = params.sorting();
      var sortBy  = Object.keys(params.sorting())[0];
      if (sortBy){
        var sortDir = sorting[sortBy];
        sortParam = '&sort_by=' + sortBy + '&sort_dir=' + sortDir ; 
      }
      return sortParam;
    }

    function applyGlobalSearch(value){
        vm.table.filter(value).reload();
    }

    function deleteRow(id){
      ApiService.delete('/' + childProperties.url + '/' + id).then(function(data){
        NotificationService.success('Element deleted', 'Success');
        vm.table.reload();
        if (childProperties.postDelete){
          childProperties.postDelete(id);
        }
      }, function(data){
          NotificationService.error('Element cannot be deleted', 'Error');
      })
    }
    
    function generateParams(fields, suggestedValues) {
      var arrayLength = fields.length;
      var result = [];
      for (var i = 0; i < arrayLength; i++) {
        var arrayIndex = fields[i];
        var obj = {key:arrayIndex, name: formatValuesForName(arrayIndex)};
        if ((typeof(suggestedValues) != "undefined") && !!suggestedValues[arrayIndex]){
          obj.suggestedValues = suggestedValues[arrayIndex];
        }
        result.push(obj);
      }
      return result;
    }
    function formatValuesForName(string) {
      var result = string;
      result = result.replace(/_/g, ' ');
      return result.capitalize();
    }
    String.prototype.capitalize = function() {
      return this.charAt(0).toUpperCase() + this.slice(1);
    };
    
    function refreshTable(){
      vm.table.reload();
    }

  }

})();
(function(){
  
  'use strict';

  angular.module('GoCloudCast.core')

    .config(localstorageConfig)
    .config(localeSetup)
    .config(configLoadingBar)
    
    function configLoadingBar(cfpLoadingBarProvider){

      //#209e91
      //cfpLoadingBarProvider.latencyThreshold = 50000000;
      cfpLoadingBarProvider.parentSelector = '#loading-bar-container';
      cfpLoadingBarProvider.loadingBarTemplate = '<div id="loading-bar" class="" style=""><div class="gc-bar"><div class="peg"></div></div></div>'
      cfpLoadingBarProvider.spinnerTemplate = '<div id="loading-bar-spinner" class="" style=""><div class="gc-spinner-icon"></div></div>';
    }

    function localstorageConfig(localStorageServiceProvider){
      localStorageServiceProvider.setPrefix('GoCloudCastApp');
    }
    function localeSetup($translateProvider) {
      $translateProvider.useLoader('translatePluggableLoader');
      $translateProvider.useSanitizeValueStrategy('sanitize');
      $translateProvider.preferredLanguage('EN');
    }

})();
(function(){
  
  'use strict';
  angular.module('GoCloudCast.core')

    .constant('GoCloudCast_Constants', constants())
    ;

    function constants(){

      return angular.merge( {
        apiUrl : 'guestcast.localhost.com:8000/api'
        
      }, window ? window.__env : {})

    }
    
})();
(function(){
  
  'use strict';

  angular.module('GoCloudCast.modules')

    .config(intercept);

    function checkIfIsExceptionOfHandleError(apiUrl){
      return apiUrl.includes('/configs/splash-image');
    }
    
    /** @ngInject */
    function intercept($httpProvider) {
      var interceptor = function($q, $location, $timeout, $injector, $translate,cfpLoadingBar) {
        return {
          success: function(response) { 
            return response;  
          },
          response: function(response) {
            if(response.config.url.includes('http://posadas_tenant.cast.gocloud1.com:8000')){
              //cfpLoadingBar.complete();
            }
            // do something on success
            return response;
          },
          responseError: function(response) {
            var apiUrl = response.config.url;
            if(!(apiUrl.includes('api/v1/total-rooms') || apiUrl.includes('/api/v1/public/es') || apiUrl.includes('/receivers/discovery'))){
              if(response.config.method == 'GET'){

                if(checkIfIsExceptionOfHandleError(apiUrl)){
                  return response;
                }else{
                  $location.path('/error')
                }

                if (response.status === 400) {
                  $location.path('/error-400')
                }
                if (response.status === 401) {
                  $location.path('/error-401')
                  //$timeout(function() { $location.path('/login'); }, 0);
                }
                if (response.status === 503) {
                  $location.path('/error-503')
                }
              }
            }

            return $q.reject(response);
          }
        }
      };

      $httpProvider.interceptors.push(interceptor);

    }

})();
(function(){
  'use strict';
  
  angular.module('GoCloudCast.pages.dashboard').provider('dashboard', dashboard); 

  function dashboard(){
    var widgets = {};
    var structures = {};
    var messageTemplate = '<div class="alert alert-danger">{}</div>';
    var loadingTemplate = '\
      <div class="progress progress-striped active">\n\
        <div class="progress-bar" role="progressbar" style="width: 100%">\n\
          <span class="sr-only">loading ...</span>\n\
        </div>\n\
      </div>';

    this.widget = function(name, widget){
        var w = angular.extend({reload: false}, widget)
        if ( w.edit ){
            var edit = {reload: true};
            angular.extend(edit, w.edit);
            w.edit = edit;
        }
        widgets[name] = w;
        return this;
    };

    this.structure = function(name, structure){
        structures[name] = structure;
        return this;
    };

    this.messageTemplate = function(template){
        messageTemplate = template;
        return this;
    };

    this.loadingTemplate = function(template){
        loadingTemplate = template;
        return this;
    };

    this.$get = function(){
        return {
            widgets: widgets,
            structures: structures,
            messageTemplate: messageTemplate,
            loadingTemplate: loadingTemplate
        };
    };
  }

})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('GoCloudCast.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('GoCloudCast.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.core').factory('ApiService',ApiService);

  function ApiService($http, $location, localStorageService, StorageService, GoCloudCast_Constants, cfpLoadingBar, CurrentTenantService) {

    var service = {};

    service.get               = http
    service.getOutsideCastApi = getOutsideCastApi
    service.post              = post
    service.delete            = _delete
    service.put               = put
    service.getApiUrl         = getApiUrl

    function getApiUrl(){
      //return $location.protocol() + '://' + $location.host() + '/backend/api/v1';
      //return $location.protocol() + '://dev.guestcast.localhost.com/backend/api/v1';
      var tenant = CurrentTenantService();
      return $location.protocol() + '://' + tenant + '.' + 'api.guestcast.com/api/v1';
    }

    function http(url,options, extras){
      var apiUrl = getApiUrl();
      var bearerAuth = (url.includes('/es/') ? false : true);
      var config = angular.merge({ auth : bearerAuth, clean : false }, ( extras || {}));
      var params = angular.merge({
        method : 'GET',
        url : apiUrl + url,
        headers : ( config.auth ? {  Authorization : 'bearer ' + StorageService.getToken() } : {} )
      }, ( options || {} ));
      cfpLoadingBar.start();
      return $http(params).then(function(response){ 
        cfpLoadingBar.complete();
        return config.clean ?  response : response.data
      },function(response){
        cfpLoadingBar.complete();
        throw response
      })
    }

    function post(url, postdata, options, extras){
      return http(url, angular.merge({data : postdata, method : 'POST' }, options), extras);
    }

    function _delete(url, options, extras){
      return http(url,angular.merge({method:'DELETE'}, options), extras)
    }

    function put(url, putdata, options, extras){
      return http(url,angular.merge({data : putdata, method:'PUT'}, options), extras)
    }

    function getOutsideCastApi(url,options, extras){
      var params = angular.merge({
        method : 'GET',
        url : url,
        headers : {} 
      }, ( options || {} ));
      cfpLoadingBar.start();
      return $http(params).then(function(response){ 
        cfpLoadingBar.complete();
        return response 
      },function(response){
        cfpLoadingBar.complete();
        throw response
      })
    }

    return service;
  }


})();

(function(){
  'use strict';
  angular.module('GoCloudCast.core').factory('CurrentTenantService',CurrentTenantService) 

  function CurrentTenantService($location) {
    function getCompanyName(){
      var host = $location.host();
      if (host.indexOf('.') >= 0) {
        var company = host.split('.')[0];
      }
      return company
    }
    
    return getCompanyName

  }

})();

(function(){
  'use strict';
  angular.module('GoCloudCast.core').factory('DeviceService',DeviceService);

  function DeviceService(toastr) {

    var service = {};

    service.onLandscape = onLandscape    
    service.onPortrait = onPortrait    
    service.isMobile = isMobile    
    service.isTablet = isTablet    
    service.isShortDesktop = isShortDesktop
    service.isMediumDesktop = isMediumDesktop
    service.isLongDesktop = isLongDesktop

    function onLandscape(){
      return window.innerWidth > window.innerHeight;
    }

    function onPortrait(){
      return window.innerWidth > window.innerHeight;
    }

    function isMobile(){
      return window.innerWidth <= 500
    }

    function isTablet(){
      return window.innerWidth > 500 && window.innerWidth <= 900
    }

    function isShortDesktop(){
      return window.innerWidth > 900 && window.innerWidth <= 1024
    }

    function isMediumDesktop(){
      return window.innerWidth > 1024 && window.innerWidth <= 1440
    }

    function isLongDesktop(){
      return window.innerWidth > 1440
    }

    return service;
  }


})();
(function(){
  'use strict';
  angular.module('GoCloudCast.core').factory('EasingService',EasingService);

  function EasingService() {

    var service = {};

    /**
     * Easing function from https://github.com/danro/easing-js/blob/master/easing.js
     */
    //API
    service.easeInQuad = easeInQuad;
    service.easeOutQuad = easeOutQuad;
    service.easeInOutQuad = easeInOutQuad;
    service.easeInCubic = easeInCubic;
    service.easeOutCubic = easeOutCubic;
    service.easeInOutCubic = easeInOutCubic;
    service.easeInQuart = easeInQuart;
    service.easeOutQuart = easeOutQuart;
    service.easeInOutQuart = easeInOutQuart;
    service.easeInQuint = easeInQuint;
    service.easeOutQuint = easeOutQuint;
    service.easeInOutQuint = easeInOutQuint;
    service.easeInSine = easeInSine;
    service.easeOutSine = easeOutSine;
    service.easeInOutSine = easeInOutSine;
    service.easeInExpo = easeInExpo;
    service.easeOutExpo = easeOutExpo;
    service.easeInOutExpo = easeInOutExpo;
    service.easeInCirc = easeInCirc;
    service.easeOutCirc = easeOutCirc;
    service.easeInOutCirc = easeInOutCirc;
    service.easeOutBounce = easeOutBounce;
    service.easeInBack = easeInBack;
    service.easeOutBack = easeOutBack;
    service.easeInOutBack = easeInOutBack;
    service.elastic = elastic;
    service.swingFromTo = swingFromTo;
    service.swingFrom = swingFrom;
    service.swingTo = swingTo;
    service.bounce = bounce;
    service.bouncePast = bouncePast;
    service.easeFromTo = easeFromTo;
    service.easeFrom = easeFrom;
    service.easeTo = easeTo;


    function easeInQuad(pos) {
      return Math.pow(pos, 2);
    }

    function easeOutQuad(pos) {
      return -(Math.pow((pos-1), 2) -1);
    }

    function easeInOutQuad(pos) {
      if ((pos/=0.5) < 1) return 0.5*Math.pow(pos,2);
      return -0.5 * ((pos-=2)*pos - 2);
    }

    function easeInCubic(pos) {
      return Math.pow(pos, 3);
    }

    function easeOutCubic(pos) {
      return (Math.pow((pos-1), 3) +1);
    }

    function easeInOutCubic(pos) {
      if ((pos/=0.5) < 1) return 0.5*Math.pow(pos,3);
      return 0.5 * (Math.pow((pos-2),3) + 2);
    }

    function easeInQuart(pos) {
      return Math.pow(pos, 4);
    }

    function easeOutQuart(pos) {
      return -(Math.pow((pos-1), 4) -1);
    }

    function easeInOutQuart(pos) {
      if ((pos/=0.5) < 1) return 0.5*Math.pow(pos,4);
      return -0.5 * ((pos-=2)*Math.pow(pos,3) - 2);
    }

    function easeInQuint(pos) {
      return Math.pow(pos, 5);
    }

    function easeOutQuint(pos) {
      return (Math.pow((pos-1), 5) +1);
    }

    function easeInOutQuint(pos) {
      if ((pos/=0.5) < 1) return 0.5*Math.pow(pos,5);
      return 0.5 * (Math.pow((pos-2),5) + 2);
    }

    function easeInSine(pos) {
      return -Math.cos(pos * (Math.PI/2)) + 1;
    }

    function easeOutSine(pos) {
      return Math.sin(pos * (Math.PI/2));
    }

    function easeInOutSine(pos) {
      return (-0.5 * (Math.cos(Math.PI*pos) -1));
    }

    function easeInExpo(pos) {
      return (pos===0) ? 0 : Math.pow(2, 10 * (pos - 1));
    }

    function easeOutExpo(pos) {
      return (pos===1) ? 1 : -Math.pow(2, -10 * pos) + 1;
    }

    function easeInOutExpo(pos) {
      if(pos===0) return 0;
      if(pos===1) return 1;
      if((pos/=0.5) < 1) return 0.5 * Math.pow(2,10 * (pos-1));
      return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
    }

    function easeInCirc(pos) {
      return -(Math.sqrt(1 - (pos*pos)) - 1);
    }

    function easeOutCirc(pos) {
      return Math.sqrt(1 - Math.pow((pos-1), 2));
    }

    function easeInOutCirc(pos) {
      if((pos/=0.5) < 1) return -0.5 * (Math.sqrt(1 - pos*pos) - 1);
      return 0.5 * (Math.sqrt(1 - (pos-=2)*pos) + 1);
    }

    function easeOutBounce(pos) {
      if ((pos) < (1/2.75)) {
        return (7.5625*pos*pos);
      } else if (pos < (2/2.75)) {
        return (7.5625*(pos-=(1.5/2.75))*pos + 0.75);
      } else if (pos < (2.5/2.75)) {
        return (7.5625*(pos-=(2.25/2.75))*pos + 0.9375);
      } else {
        return (7.5625*(pos-=(2.625/2.75))*pos + 0.984375);
      }
    }

    function easeInBack(pos) {
      var s = 1.70158;
      return (pos)*pos*((s+1)*pos - s);
    }

    function easeOutBack(pos) {
      var s = 1.70158;
      return (pos=pos-1)*pos*((s+1)*pos + s) + 1;
    }

    function easeInOutBack(pos) {
      var s = 1.70158;
      if((pos/=0.5) < 1) return 0.5*(pos*pos*(((s*=(1.525))+1)*pos -s));
      return 0.5*((pos-=2)*pos*(((s*=(1.525))+1)*pos +s) +2);
    }

    function elastic(pos) {
      return -1 * Math.pow(4,-8*pos) * Math.sin((pos*6-1)*(2*Math.PI)/2) + 1;
    }

    function swingFromTo(pos) {
      var s = 1.70158;
      return ((pos/=0.5) < 1) ? 0.5*(pos*pos*(((s*=(1.525))+1)*pos - s)) :
      0.5*((pos-=2)*pos*(((s*=(1.525))+1)*pos + s) + 2);
    }

    function swingFrom(pos) {
      var s = 1.70158;
      return pos*pos*((s+1)*pos - s);
    }

    function swingTo(pos) {
      var s = 1.70158;
      return (pos-=1)*pos*((s+1)*pos + s) + 1;
    }

    function bounce(pos) {
      if (pos < (1/2.75)) {
        return (7.5625*pos*pos);
      } else if (pos < (2/2.75)) {
        return (7.5625*(pos-=(1.5/2.75))*pos + 0.75);
      } else if (pos < (2.5/2.75)) {
        return (7.5625*(pos-=(2.25/2.75))*pos + 0.9375);
      } else {
        return (7.5625*(pos-=(2.625/2.75))*pos + 0.984375);
      }
    }

    function bouncePast(pos) {
      if (pos < (1/2.75)) {
        return (7.5625*pos*pos);
      } else if (pos < (2/2.75)) {
        return 2 - (7.5625*(pos-=(1.5/2.75))*pos + 0.75);
      } else if (pos < (2.5/2.75)) {
        return 2 - (7.5625*(pos-=(2.25/2.75))*pos + 0.9375);
      } else {
        return 2 - (7.5625*(pos-=(2.625/2.75))*pos + 0.984375);
      }
    }

    function easeFromTo(pos) {
      if ((pos/=0.5) < 1) return 0.5*Math.pow(pos,4);
      return -0.5 * ((pos-=2)*Math.pow(pos,3) - 2);
    }

    function easeFrom(pos) {
      return Math.pow(pos,4);
    }

    function easeTo(pos) {
      return Math.pow(pos,0.25);
    }

    return service;
  }


})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('FormValidates',FormValidates);

  function FormValidates() {
    var service = {};

    service.validateEmail = _validateEmail;
    service.validateTextSize = _validateTextSize;
    service.validateIfIsUndefined = _validateIfIsUndefined;
    service.validatePasswordMatch = _validatePasswordMatch;
    service.validateEmpty = _validateEmpty;
    service.setPristine = _setPristine;
    service.setDirty = _setDirty;
    service.validateDomain = _validateDomain;
    service.alreadyExist = _alreadyExist;
    service.alreadyExistAux = _alreadyExistAux;
    service.matchRegex = _matchRegex;
    service.customValidation = _customValidation;

    function _validateEmail(form,fieldName,email) {
      var regExp = /\S+@\S+\.\S+/;
      var hasEmailFormat = regExp.test(email);

      form[fieldName].$setValidity('emailBadFormat',hasEmailFormat);
    }

    function _validateTextSize(form,fieldName,text,minSize,maxSize) {
      if(maxSize != undefined){
        form[fieldName].$setValidity('textExceedsSize',text? text.length <= maxSize: true);
      }
      form[fieldName].$setValidity('textUnderSize',text? text.length >= minSize: true);
    }

    function _validateIfIsUndefined(form,fieldName,posibleUndefined){
      form[fieldName].$setValidity('undefined',posibleUndefined !== undefined);
    }

    function _validatePasswordMatch(form,fieldName,field,match){
      var fieldValue = field || '';
      var matchValue = match || '';
      form[fieldName].$setValidity('passMatch',fieldValue == matchValue);
    }

    function _validateEmpty(form,fieldName,condition){
      form[fieldName].$setValidity('empty',!condition);
    }

    function _validateDomain(form,fieldName,field){
      var regExp = /(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/;
      form[fieldName].$setValidity('domain', regExp.test(field));
    }

    function _alreadyExist(form,fieldName,condition){
      form[fieldName].$setValidity('alreadyExist', !condition);
    }

    function _matchRegex(form,fieldName,regExp,field){
      form[fieldName].$setValidity("matchRegex", regExp.test(field));
    }

    function _customValidation(form,fieldName,condition,validationName){
      form[fieldName].$setValidity(validationName, condition);
    }

    function _alreadyExistAux(elem){
      elem.$setValidity("alreadyExist", true);
    }

    function _setPristine(form) {
      var dirtyFormControls = [];
      angular.forEach(form, function(value, key) {
        if (typeof value === 'object' && value.hasOwnProperty('$dirty') && value.$dirty){
          dirtyFormControls.push(value);
        }
      });
      if(dirtyFormControls.length == 0){
        form.$setPristine();
      }
    }

    function _setDirty(form) {
      angular.forEach(form, function(value, key) {
        if (typeof value === 'object' && value.hasOwnProperty('$dirty')){
          value.$setDirty();
        }
      });
      form.$setDirty();
    }

    return service;
  }

})();

(function(){
  'use strict';
  angular.module('GoCloudCast.core').factory('NotificationService',NotificationService);

  function NotificationService(toastr) {

    var service = {};

    var defaults = {
      positionClass:         "toast-top-right",
      timeOut:               "5000",
      extendedTimeOut:       "2000",
      allowHtml:             false,
      closeButton:           true,
      tapToDismiss:          true,
      progressBar:           true,
      newestOnTop:           true,
      maxOpened:             0,
      preventDuplicates:     false,
      preventOpenDuplicates: false
    };

    service.info    = toast('info')
    service.error   = toast('error')
    service.warning = toast('warning')
    service.success = toast('success')

    function toast(type){
      return (function(message, title, options){
        toastr[type](message, title, angular.merge({}, defaults, options, {type : type}));
      })
    }

    return service;
  }


})();
(function(){
  
  'use strict';

  angular.module('GoCloudCast.auth')

    .config(intercept);

    /** @ngInject */
    function intercept ($httpProvider) {

      var interceptor = function($q, $location, $timeout, StorageService, $injector, $translate) {
        return {
          success: function(response) { 
            return response;  
          },
          responseError: function(response) {
            //var NotificationService = $injector.get('NotificationService');           

            if (response.status === 401) {
              //NotificationService.info($translate.instant('NOTIFICATIONS.TOKEN_EXPIRED'))
              StorageService.removeToken();
              $timeout(function() { $location.path('/login'); }, 0);
            }
            return $q.reject(response);
          }
        }
      };

      $httpProvider.interceptors.push(interceptor);

    }

})();
(function(){
  
  'use strict';

  angular.module('GoCloudCast.auth')

    .run(accessControl);

    function accessControl($rootScope, $location, StorageService, $state){
      
      $rootScope.$on('$stateChangeStart', function(event, to, toParams, from, fromParams){

        if(!StorageService.hasToken()){
          return $location.path('login');
        }

      });

    }
    
})();
(function(){
  'use strict';
  angular.module('GoCloudCast.auth').factory('SessionService',SessionService);

  function SessionService($rootScope, $http, ApiService, NotificationService, StorageService, PropertiesService, $state){  //ApiService) {

    var instance = {};

    var loggedUser;

    instance.login  = login;
    instance.logout = logout;
    instance.getLoggedUser = getLoggedUser;
    instance.setLoggedUser = setLoggedUser;

    function login(credentials){
      return ApiService.post('/login', credentials, {}, {clean : true, auth : false} ).then(
        function(response){
          if (response.status === 401){
            console.log('log: ','TODO::NOTIFY BAD CREDENTIALS');
          } else if (response.status === 200 && response.data.data.token ) {
            setLoggedUser(response.data.data);

            StorageService.setPermissions(response.data.data.customer_permissions);
            
            StorageService.setToken(response.data.data.token);
            PropertiesService.getAllWithoutPagination().then(function(data) {
              var properties = data.data;
              StorageService.setProperties(properties);
              if(properties.length == 0) $state.go('properties-list');
              else {
                StorageService.setActualProperty(properties[0]);
                $rootScope.$broadcast('appVariablesSetted');
                $state.go('dashboard');
              }
            },function(data){
              console.log("ERROR");
              console.log(data);
            });
          }
          return response;
        }, function(data){
          return data;
        }
      );

      //StorageService.setProperty(properties[0]);
    }

    function setLoggedUser(user){
      loggedUser = user;
    }

    function getLoggedUser(){
      return loggedUser;
    }

    function logout(){
      return ApiService.get('/logout').finally(function(){
        StorageService.removeAll();
        console.log("borrando user")
        loggedUser = null;
        $state.go('login');
      });
    }

    return instance;
  }
})();
(function() {

	'use strict';
  
	angular.module('GoCloudCast.modules.cities').controller('CitiesController', CitiesController);
	
	function CitiesController($controller, $scope) {
	  var vm    =  this;
	  var fields = [
		'name',
		'timezone_code'
	];
  
	  angular.extend(vm, $controller('abstractTable',{
		childProperties : {
		  url            : 'cities',
		  fieldsToFilter : fields,
		},scope : $scope
	  }));
	  vm.availableSearchParams = vm.generateParams(fields);
	}
  
  })();
(function() {

  'use strict';
  
  angular.module('GoCloudCast.modules').factory('CitiesService',CitiesService);

  function CitiesService(ApiService) {

    var instance = {};

    instance.getAll          = getAll;
    instance.get             = get;
    instance.getCountries    = getCountries;
    instance.getAllCountries = getAllCountries;
    instance.getEmptyCity    = getEmptyCity;
    instance.save            = save;

    function getAll() {
      return ApiService.get('/cities?pagination="disabled"');
    }

    function get(id) {
      return ApiService.get('/cities/'+id);
    }

    function getCountries(countryCode) {
      if (countryCode) {
        return ApiService.get('/cities/from-country/'+countryCode);
      }
    }

    function getAllCountries() {
      return ApiService.get('/countries');
    }

    function getEmptyCity() {
      return {
        "id": "",
        "name": "",
        "country": "",
        "timezone_code": "",
      }
    }

    function save(city){
      if (city.id) {
        return ApiService.put('/cities/'+city.id, city);
      } else {
        return ApiService.post('/cities', city);
      }
    }

    return instance;
  }

})();
(function() {

	'use strict';
  
	angular.module('GoCloudCast.modules.cities').controller('CitiesAddEditController', CitiesAddEditController);
	
	function CitiesAddEditController($scope, $controller, city, countries, timezones, CitiesService) {
	  var vm = this;
  
	  	vm.data 	 = city.data;
		vm.countries = countries.data;
		vm.timezones = timezones.data;
	
		angular.extend(vm, $controller('abstractAddEdit',{
			childProperties : {
				stateUrl   : 'cities-list', 
			}, service : CitiesService,
			scope: $scope
		}))
  
	}
  
  })();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.services').controller('ConfigsController', ConfigsController);
  
  function ConfigsController($rootScope, $state, $timeout, $controller, $scope, $uibModal, ApiService, StorageService, NotificationService, ConfigsService, 
    splashPages, templates, configs, splashImage, guestRouterTypes, castRouterTypes, protocolTypes, securityLevels, interfaces) {
    var vm = this;

    vm.data = configs.data;
    
    vm.save                       = save;
    vm.templates                  = templates.data;
    vm.guestRouterTypes           = guestRouterTypes.data;
    vm.castRouterTypes            = castRouterTypes.data;
    vm.protocolTypes              = protocolTypes.data;
    vm.securityLevels             = securityLevels.data;
    vm.interfaces                 = interfaces.data;
    vm.splashPages                = splashPages.data;
    vm.addGuestInterface          = addGuestInterface;
    vm.removeGuestInterface       = removeGuestInterface;
    vm.getErrorMessages           = getErrorMessages;
    vm.getField                   = getField;
    vm.updateGuestInterface       = updateGuestInterface;
    vm.getInterfaces              = getInterfaces;
    vm.isTheImageLarge            = false;
    vm.maxAllowedSize             = 8; //8MB
    vm.availableImageTypes        = '".jpg, .jpeg"';
    vm.splashImage                = splashImage.data.splashImage != "" ? splashImage.data.splashImage+'?random='+Date.now() : "/iptv/assets/img/theme/no-image.png"; 
    vm.getSplashImage             = getSplashImage;
    vm.guestInterfaces            = parseInterfacesApiToFront(vm.data.general);
    
    vm.interfacesIpAddresses      = vm.interfaces.map(function(interfaz){
      return 'http://' + interfaz.ip_address + '/'
    });
    vm.configs                    = {
      //launcher: ['DEBUG'],
      general: ['AIRBRAKE_ENABLED'],
      //web: ['APP_DEBUG','CODEBASE_ENABLED'] 
    };

    $scope.$on("propertyChanged", function(){
      reloadData()
    });

    parseFieldsToJs(vm.data)

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl     : 'iptv.channels.lists-list',
        resolutions  : {
                minWidth: 64,
                minHeight: 64,
                maxWidth: 1920,
                maxHeight: 1080,
                ratio: null
        },
        promise : function(data){
          vm.flagChannelImage = false;
          vm.imageToUpload    = {"image":data.image};
          vm.splashImage      = data.croppedImage;
          ConfigsService.uploadSplashImage(vm.imageToUpload).then(function(data){
            NotificationService.success('Image uploaded', 'Success');
          },function(error){
            vm.splashImage = splashImage.data.splashImage+'?random='+Date.now();
            NotificationService.error('Error cant upload image', 'Error');
          });
        },
        onLoad : function(data, openModal){
          var maxSize = vm.maxAllowedSize * 1024 * 1024;
          if (data.size > maxSize) {
            vm.isTheImageLarge = true;
          } else {
            vm.isTheImageLarge = false;
            openModal();
          }
        },
        formatData   : function(data){
          if(data.type == "IPTV"){
            delete data.frequency;
          }
          if(data.type == "RF"){
            delete data.url;
          }
          if(!data.id){
            data.image_base64 = vm.channelImage;
          }
        } 
      },
      service : ConfigsService,
      scope : $scope
    }));

    function getInterfaces(usedInterface){
       var usedInterfaces = vm.guestInterfaces.map(function(interfaz){
         return interfaz.name
       })
       usedInterfaces.push(vm.data.general.CAST_INTERFACE);
       return vm.interfaces.filter(function(interfaz){return interfaz.name==usedInterface||!usedInterfaces.includes(interfaz.name)});
   }

    function getSplashImage(){
      return vm.splashImage
    }

    function updateGuestInterface(guestInterfaz){
       var interfaz = vm.interfaces.filter(function(interfaz){return interfaz.name == guestInterfaz.name})[0]
       guestInterfaz.ip_address = interfaz.ip_address
       guestInterfaz.netmask = interfaz.mask    
    }      

    function addGuestInterface(){
      vm.guestInterfaces.push({'name':'','netmask':'','ip_address':''})
    }

    function removeGuestInterface(index){
      vm.guestInterfaces.splice(index,1)
    }

    function parseFieldsToJs(data) { 
      for(var key in vm.configs) {
        vm.configs[key].forEach(function(name){
          if(data[key][name] == '1'){
            data[key][name] = true;
          } else {
            data[key][name] = false;
          }
        })
      }
    }

    function parseFieldsToPython(data) { 
      for(var key in vm.configs) {
        vm.configs[key].forEach(function(name){
          if(data[key][name]){
            data[key][name] = 'True';
          } else {
            data[key][name] = 'False';
          }
        })
      }
    }

    function save(form,data) {
 
      if (form.$valid) {
        var dataToSend = angular.copy(data)
        //if(vm.data.web.GUEST_ROUTER_TYPE == "mikrotik"){
        //	dataToSend.orchestation.UNMANAGED_GUEST_ROUTER = 'false';
        //} else {
        //	dataToSend.orchestation.UNMANAGED_GUEST_ROUTER = 'True';
        //}
        //console.log(dataToSend.orchestation.UNMANAGED_GUEST_ROUTER);
        parseFieldsToPython(dataToSend);
        parseInterfacesFrontToApi(dataToSend);
        ConfigsService.save(dataToSend).then(function(data){
          //$state.go(childProperties.stateUrl);
          NotificationService.success('Element saved', 'Success');
        }, function(data){
          vm.errorsSv = data.data.data.errors? data.data.data.errors : {}
          console.log(vm.errorsSv);
          NotificationService.error('Element cannot be saved', 'Error');
        });
      }
    }

    function reloadData(){
      $state.reload();
    }

    function parseInterfacesApiToFront(general){
      var interfaces = []
      var guestInterfaces            = general.GUEST_INTERFACES.split(',')
      var guestNetmasks              = general.GUEST_NETMASKS.split(',')
      var guestIpAddresses           = general.GUEST_IP_ADDRESSES.split(',')
      for (var i = 0; i < guestInterfaces.length; i++) {
        interfaces.push({'name':guestInterfaces[i],'netmask':guestNetmasks[i],'ip_address':guestIpAddresses[i]})
      }
      return interfaces
    }

    function parseInterfacesFrontToApi(dataToSend){
      var guestInterfaces            = vm.guestInterfaces.map(function(interfaz){return interfaz.name});
      var guestNetmasks              = vm.guestInterfaces.map(function(interfaz){return interfaz.netmask});
      var guestIpAddresses           = vm.guestInterfaces.map(function(interfaz){return interfaz.ip_address});
      dataToSend.general.GUEST_INTERFACES   = guestInterfaces.join(',')
      dataToSend.general.GUEST_NETMASKS     = guestNetmasks.join(',')
      dataToSend.general.GUEST_IP_ADDRESSES = guestIpAddresses.join(',')
    }

    function getErrorMessages(form,name,index){
      if(form[name+index] ) {
         return form[name+index].$error;
      } 
      
    }

    function getField(form,name,index){
      return form[name+index]
    }
  }
})();

(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('ConfigsService',ConfigsService);

  function ConfigsService(StorageService, ApiService) {

    var instance = {};

    instance.get                 = get;
    instance.save                = save;
    instance.getCastRouterTypes  = getCastRouterTypes;
    instance.getGuestRouterTypes = getGuestRouterTypes;
    instance.getProtocolTypes    = getProtocolTypes;
    instance.getSecurityLevels   = getSecurityLevels;
    instance.getInterfaces       = getInterfaces;
    instance.getSplashpages      = getSplashpages;
    instance.uploadSplashImage   = uploadSplashImage;
    instance.getSplashImage      = getSplashImage;

    function get(){
      return ApiService.get("/configs/"+StorageService.getProperty().id);
    }

    function getCastRouterTypes(){
      return ApiService.get("/cast-router-types");
    }

    function getGuestRouterTypes(){
      return ApiService.get("/guest-router-types");
    }

    function getProtocolTypes(){
      return ApiService.get("/email-protocol-types");
    }

    function getSecurityLevels(){
      return ApiService.get("/email-security-levels");
    }

    function getSplashpages(){
      return ApiService.get("/chromecast-splashpages");
    }

    function getInterfaces(){
      return ApiService.get("/interfaces/"+StorageService.getProperty().id);
    }

    function save(data){
      return ApiService.post("/configs/"+StorageService.getProperty().id,data);
    }

    function uploadSplashImage(imageToUpload){
      return ApiService.post("/configs/upload-splash-image?property_id="+StorageService.getProperty().id, imageToUpload);
    }

    function getSplashImage(){
      return ApiService.get("/configs/splash-image/"+StorageService.getProperty().id).then(function(data){
        return data
      },function(error){
        return {'data':{'splashImage':''}}
      });
    }

    return instance;
  }

})();


(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('ConfigurationVariablesService',ConfigurationVariablesService);

  function ConfigurationVariablesService($location, CurrentTenantService) {

    var instance = {};

    instance.getPathImage = getPathImage;

    function getPathImage(){
//      return $location.protocol() +'://'+ $location.host() +'/backend/iptv/';
      var tenant = CurrentTenantService();
      return $location.protocol() + '://' + tenant + '.' + 'api.guestcast.com/iptv/';
    }

    return instance;
  }

})();

(function() {

  'use strict';
  
  angular.module('GoCloudCast.modules').factory('CountriesService',CountriesService);

  function CountriesService(ApiService) {

    var instance = {};

    instance.getAll = getAll;
    instance.get    = get;

    function getAll() {
      return ApiService.get('/countries?pagination="disabled"');
    }

    function get(propertyId) {
      return ApiService.get('/countries/'+id);
    }

    return instance;
  }

})();
(function() {

'use strict';

angular.module('GoCloudCast.modules')
    .directive('trinomioSearchBoxes', function() {
        return {
            restrict: 'E',
            scope: {
                model: '=ngModel',
                parameters: '=',
                parametersLabel: '@',
                parametersDisplayLimit: '=?',
                placeholder: '@',
                searchThrottleTime: '=?'
            },
            replace: true,
            templateUrl: function(element, attr) {
                return attr.templateUrl || 'app/modules/directives/advancedSearchBox.html';
            },
            controller: [
                '$scope', '$attrs', '$element', '$timeout', '$filter',
                function ($scope, $attrs, $element, $timeout, $filter) {

                    $scope.parametersLabel = '';
                    $scope.parametersDisplayLimit = $scope.parametersDisplayLimit || 8;
                    $scope.placeholder = $scope.placeholder || 'Search ...';
                    $scope.searchThrottleTime = 100;
                    $scope.searchParams = [];
                    $scope.searchQuery = '';
                    $scope.setSearchFocus = false;
                    var searchThrottleTimer;
                    var changeBuffer = [];

                    $scope.$watch('model', function (newValue, oldValue) {

                        if(angular.equals(newValue, oldValue))
                            return;

                        angular.forEach($scope.model, function (value, key) {
                            if (key === 'query' && $scope.searchQuery !== value) {
                                $scope.searchQuery = value;
                            }
                        });
                    }, true);

                    $scope.searchQueryChanged = function (query) {
                        updateModel('change', 'query', query);
                    };

                    $scope.removeAll = function() {
                        $scope.searchParams.length = 0;
                        $scope.searchQuery = '';

                        $scope.model = {};

                        $scope.$emit('advanced-searchbox:modelUpdated', $scope.model);
                    };

                    $scope.model = {};

                    function updateModel(command, key, value) {
                        if (searchThrottleTimer)
                            $timeout.cancel(searchThrottleTimer);

                        // remove all previous entries to the same search key that was not handled yet
                        changeBuffer = $filter('filter')(changeBuffer, function (change) { return change.key !== key; });
                        // add new change to list
                        changeBuffer.push({
                            command: command,
                            key: key,
                            value: value
                        });

                        searchThrottleTimer = $timeout(function () {
                            angular.forEach(changeBuffer, function (change) {
                                if(change.command === 'delete')
                                    delete $scope.model[change.key];
                                else
                                    $scope.model[change.key] = change.value;
                            });

                            changeBuffer.length = 0;

                            $scope.$emit('advanced-searchbox:modelUpdated', $scope.model);

                        }, $scope.searchThrottleTime);
                    }
                }
            ]
        };
    })
    .directive('trinomioSetFocus', [
        '$timeout', '$parse',
        function($timeout, $parse) {
            return {
                restrict: 'A',
                link: function($scope, $element, $attrs) {
                    var model = $parse($attrs.trinomioSetFocus);
                    $scope.$watch(model, function(value) {
                        if (value === true) {
                            $timeout(function() {
                                $element[0].focus();
                            });
                        }
                    });
                    /*$element.bind('blur', function() {
                        $scope.$apply(model.assign($scope, false));
                    });*/
                }
            };
        }
    ])
    .directive('trinomioAutoSizeInput', [
        '$timeout',
        function($timeout) {
            return {
                restrict: 'A',
                scope: {
                    model: '=ngModel'
                },
                link: function($scope, $element, $attrs) {
                    var supportedInputTypes = ['text', 'search', 'tel', 'url', 'email', 'password', 'number'];


                    var container = angular.element('<div style="position: fixed; top: -9999px; left: 0px;"></div>');
                    var shadow = angular.element('<span style="white-space:pre;"></span>');

                    var maxWidth = $element.css('maxWidth') === 'none' ? $element.parent().innerWidth() : $element.css('maxWidth');
                    $element.css('maxWidth', maxWidth);

                    angular.forEach([
                        'fontSize', 'fontFamily', 'fontWeight', 'fontStyle',
                        'letterSpacing', 'textTransform', 'wordSpacing', 'textIndent',
                        'boxSizing', 'borderLeftWidth', 'borderRightWidth', 'borderLeftStyle', 'borderRightStyle',
                        'paddingLeft', 'paddingRight', 'marginLeft', 'marginRight'
                    ], function(css) {
                        shadow.css(css, $element.css(css));
                    });

                    angular.element('body').append(container.append(shadow));

                    function resize() {
                        $timeout(function() {
                            if(supportedInputTypes.indexOf($element[0].type || 'text') === -1)
                                return;

                            shadow.text($element.val() || $element.attr('placeholder'));
                            $element.css('width', maxWidth-100);
                        });
                    }

                    resize();

                    if ($scope.model) {
                        $scope.$watch('model', function() { resize(); });
                    } else {
                        $element.on('keypress keyup keydown focus input propertychange change', function() { resize(); });
                    }
                }
            };
        }
    ]);
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules').directive('ipAddressFormat', ipAddressFormat);

  /** @ngInject */
  function ipAddressFormat(){
    return {
            restrict: 'A',
            require: '?ngModel',
            scope: {
                config: '=?ngIpConfig'
            },
            link: function(scope, element, attrs, ngModelCtrl) {
                if (!ngModelCtrl) {
                    return;
                }

                // Initialize configuration
                var allowPort = false;
                var requirePort = false;

                // Initialize regex...
                // Match leading zero
                var regexLeadingZero = new RegExp('^0', 'g');
                // Match leading period
                var regexLeadingPeriod = new RegExp('^\\.', 'g');
                // Match duplicate period
                var regexDupePeriods = new RegExp('\\.\\.+', 'g');
                // Match colons
                var regexColon = new RegExp(':', 'g');
                // Match leading colon
                var regexLeadingColon = new RegExp('^:', 'g');

                // Initialize caret position tracker
                var curPos = 0;

                // Initialize ctrl/cmd tracker
                var ctrlDown = false;

                // Shallow watch the members of the config object and evaluate changes
                scope.$watchCollection('config', evalConfiguration);

                // Attach key evaluators to the element keydown and keyup events to check
                // for when ctrl/cmd is being held down
                element.bind('keydown', evalIfCtrlDown);
                element.bind('keyup', evalIfCtrlUp);

                // Attach key evaluator to the element keypress event
                element.bind('keypress', evalKeyPress);

                // Attach input evaluator to the input model parsers
                ngModelCtrl.$parsers.push(evalInput);

                function evalConfiguration(newConfig) {
                    // If configuration is truthy...
                    if (newConfig) {
                        // Require port if it is set
                        requirePort = typeof(newConfig.requirePort) === 'boolean' && newConfig.requirePort;
                        // If port is either required or optional, allow port
                        allowPort = requirePort || ((typeof(newConfig.allowPort) === 'boolean') && newConfig.allowPort);
                    } else {
                        // Otherwise, reset the options to false
                        allowPort = false;
                        requirePort = false;
                    }
                    // If port is allowed or the value is falsey...
                    if (allowPort || !ngModelCtrl.$viewValue) {
                        // Trigger parser to check validity
                        ngModelCtrl.$parsers[0](ngModelCtrl.$viewValue);
                    } else {
                        // Otherwise, remove colons and replace view value
                        ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue.replace(regexColon, ''));
                    }
                }

                function evalIfCtrlDown(event) {
                    // If the character code represents ctrl/cmd...
                    if (event.which === 17 || event.which === 91) {
                        // Toggle the tracker
                        ctrlDown = true;
                    }
                }

                function evalIfCtrlUp(event) {
                    // If the character code represents ctrl/cmd...
                    if (event.which === 17 || event.which === 91) {
                        // Toggle the tracker
                        ctrlDown = false;
                    }
                }

                function evalKeyPress(event) {
                    // If the character code is not allowed...
                    if ((event.which < 46 && event.which !== 0 && event.which !== 8 && event.which !== 13)
                        || event.which === 47
                        || (event.which === 58 && !allowPort)
                        || event.which > 58 && !(ctrlDown && (event.which === 99 || event.which === 118 || event.which === 120))) {
                        // Stop key press from propagating
                        event.preventDefault();
                    }
                }

                function evalInput(val) {
                    // If val is falsey (undefined, empty string, etc)...
                    if (!val) {
                        // Set the field validity to true since it should be the responsibility of 'required' to stop blank entries
                        ngModelCtrl.$setValidity('ipAddress', true);
                        // Return value
                        return val;
                    }

                    // Set caret position tracker
                    curPos = element[0].selectionStart;

                    // Initialize validation result tracker
                    var validationResult = true;

                    // Initialize port holder
                    var port = null;

                    // Remove leading period
                    val = val.replace(regexLeadingPeriod, '');

                    // Remove any duplicate periods
                    val = val.replace(regexDupePeriods, '.');

                    // Break the IP address into segments
                    var valArray = val.split('.');
                    // Eval length to be used later
                    var valArrayLength = valArray.length;

                    // If there are less than four IP segments...
                    if (valArrayLength < 4) {
                        // Set validity tracker to false
                        validationResult = false;
                    }
                    // Otherwise, if there are more than four IP segments...
                    else if (valArrayLength > 4) {
                        // Enforce 4 segment limit
                        valArray.length = 4;
                        // Update array length
                        valArrayLength = 4;
                    }

                    // For each segment...
                    for (var i = 0; i < valArrayLength; i++) {
                        // Eval array value to be used later so the array isn't getting accessed so often
                        var arrayVal = valArray[i];
                        // If the user configured options to allow ports...
                        if (allowPort) {
                            // If the current section is not the fourth...
                            if (i < 3) {
                                // Delete any colons
                                arrayVal = arrayVal.replace(regexColon, '');
                            } else {
                                // Delete colon if it is leading (ex. 1.1.1.:)
                                arrayVal = arrayVal.replace(regexLeadingColon, '');
                                // If there is a port...
                                if (arrayVal.indexOf(':') !== -1) {
                                    // Break the segment into ip segment and ports
                                    var segmentArray = arrayVal.split(':');
                                    // Set the ip segment
                                    arrayVal = segmentArray[0];
                                    // Set the port, delete leading zeroes and remove any number after the fifth
                                    port = segmentArray[1].replace(regexLeadingZero, '').substring(0, 5);
                                    // If the port is empty, isn't a number, or the value is greater than max
                                    if (!port || !isNumeric(arrayVal) || port > 65535) {
                                        // Set validity tracker to false
                                        validationResult = false;
                                    }
                                }
                                // Otherwise, if port is required...
                                else if (requirePort) {
                                    // Set validity tracker to false
                                    validationResult = false;
                                }
                            }
                        }
                        // If the ip segment value is longer than one digit...
                        if (arrayVal.length > 1) {
                            // Delete leading zeroes and any number after the third
                            arrayVal = arrayVal.replace(regexLeadingZero, '').substring(0, 3);
                            // If the value isn't a number or is greater than 255...
                            if (!isNumeric(arrayVal) || arrayVal > 255) {
                                // Set validity tracker to false
                                validationResult = false;
                            }
                        }
                        // Otherwise, check if the value is empty...
                        else if (!arrayVal) {
                            // Set validity tracker to false
                            validationResult = false;
                        }
                        // Set the final value back to the segment
                        valArray[i] = arrayVal;
                    }

                    // Reassemble the segments
                    val = valArray.join('.');

                    // If the port is not null...
                    if (port !== null) {
                        // Attach it to the final value
                        val += ':' + port
                    }

                    // Set validity of field (will be displayed as class 'ng-valid-ip-address' or 'ng-invalid-ip-address')
                    ngModelCtrl.$setValidity('ipAddress', validationResult);

                    // Replace the input value with the cleaned value in the view
                    ngModelCtrl.$setViewValue(val);
                    ngModelCtrl.$render();

                    // Set the caret position back to where it was prior to re-render
                    element[0].setSelectionRange(curPos, curPos);

                    // Return value
                    return val;
                }

                // Determines if a passed value is numeric
                function isNumeric(n) {
                    return !isNaN(parseFloat(n)) && isFinite(n);
                }
            }
        };
    
  }
}());
(function(){
  'use strict';
  
  angular.module('GoCloudCast.modules').directive('permissionDisable',permissionDisable);
  
  function permissionDisable(StorageService) {

    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var hasPermission = StorageService.getPermissions().includes(attrs.permissionDisable);
        if (!hasPermission) {
          element.attr('disabled', 'true');
        }
      }

    }

  }
})();

(function(){
  'use strict';
  
  angular.module('GoCloudCast.modules').directive('permissionHide',permissionHide);
  
  function permissionHide(StorageService) {

    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var hasPermission = StorageService.getPermissions().includes(attrs.permissionHide);
        if (!hasPermission) {
          element.hide();
        }
      }

    }

  }
})();

(function(){
  'use strict';
  
  angular.module('GoCloudCast.modules').directive('permissionReadonly',permissionReadonly);
  
  function permissionReadonly(StorageService) {

    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        var hasPermission = StorageService.getPermissions().includes(attrs.permissionReadonly);
        if (!hasPermission) {
          element.attr('readonly', 'true');
        }
      }

    }

  }
})();

(function () {
  'use strict';

  angular.module('GoCloudCast.modules').directive('stringToNumber', stringToNumber);

  /** @ngInject */
  function stringToNumber($compile) {
    return {
      require: 'ngModel',
      link: function(scope, element, attrs, ngModel) {
        ngModel.$parsers.push(function(value) {
          return parseInt(value);
        });
        ngModel.$formatters.push(function(value) {
          return parseInt(value);
        });
      }
    }
  }

}());
(function () {
  'use strict';

  angular.module('GoCloudCast.modules').directive('templatePreview', templatePreview);

  /** @ngInject */
  function templatePreview($compile) {
    return {
            restrict: 'E',
            replace: true,
            scope: {
                template: '='
            },
            link: function(scope, element) {
                var iframe = document.createElement('iframe');
                $(iframe).css('width', '100%');
                $(iframe).css('height', $(window).height() + 'px');
                //$(iframe).css('height', '100%');
                $(iframe).css('border', '1px solid lightgrey');
                element[0].appendChild(iframe);

                scope.$watch('template.parameters',function(oldValue, newValue, scope) {
                  var html = '' + scope.template.html;                  
                  scope.template.parameters.forEach(function(it) {
                    var parameter = it.parameter.toLowerCase().replace(/\s/g, '-');
                    html = html.replace(new RegExp('\\$' + parameter, 'g'), it.value);
                  });                  

                  $(iframe).fadeOut(250, function(){
                      iframe.src = "data:text/html;charset=utf-8," + escape(html);
                      $(iframe).fadeIn(250);
                  });

                }, true);
              }
            }
          }

}());
(function () {
  'use strict';

  angular.module('GoCloudCast.modules').directive('uiSelectFreeText', uiSelectFreeText);

  /** @ngInject */
  function uiSelectFreeText($compile) {
    return {
            restrict: "A",
            require: "uiSelect",
            link: function (scope, element, attrs, $select) {
                var searchInput = element.querySelectorAll("input.ui-select-search");

                if (searchInput.length !== 1) {
                    console.log("Error! Input not found.");
                    return;
                }
                console.log('link')
                searchInput.on("keyup", function () {
                    var valueProp = attrs["valueProp"];
                    var addNewObjOption = function () {
                        // add new item represent free text option
                        var newOption = { isFreeText: true };
                        newOption[valueProp] = $select.search;
                        $select.items.unshift(newOption);
                    };

                    if ($select.items.length > 0) {
                        var firstItem = $select.items[0];

                        if (valueProp) {
                            // items is list of Object
                            if (firstItem.isFreeText) {
                                firstItem[valueProp] = $select.search;
                            } else {
                                addNewObjOption();
                            }
                        } else {
                            // items is list of string
                            if (firstItem === $select.search) {
                                return;
                            } else {
                                $select.items.push($select.search);
                            }
                        }
                    } else {
                        if (valueProp) {
                            addNewObjOption();
                        } else {
                            // items is list of string
                            $select.items.push($select.search);
                        }
                    }
                });
            }
        }
    }

}());
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.areas').controller('ErrorsController', ErrorsController);
  
  function ErrorsController($stateParams, $rootScope, status, $controller, $scope) {
    var vm = this;

    vm.status = status;

  }

})();


(function () {
  'use strict';

  angular.module('GoCloudCast.modules.errors', []).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('error-template', {
        url: '/error',  
        templateUrl: 'app/modules/errors/errorTemplate.html',
        title: 'Error',
        parent : 'main',
        controller : 'ErrorsController',
        controllerAs : 'vm',
        resolve : {
          status : function(){
            return undefined;
          }
        }
      })
      .state('error-400', {
        url: '/error-400',  
        templateUrl: 'app/modules/errors/errorTemplate.html',
        title: 'Error',
        parent : 'main',
        controller : 'ErrorsController',
        controllerAs : 'vm',
        resolve : {
          status : function(){
            return 400;
          }
        }
      })
      .state('error-401', {
        url: '/error-401',  
        templateUrl: 'app/modules/errors/errorTemplate.html',
        title: 'Error',
        parent : 'main',
        controller : 'ErrorsController',
        controllerAs : 'vm',
        resolve : {
          status : function(){
            return 401;
          }
        }
      })
      .state('error-503', {
        url: '/error-503',  
        templateUrl: 'app/modules/errors/errorTemplate.html',
        title: 'Error',
        parent : 'main',
        controller : 'ErrorsController',
        controllerAs : 'vm',
        resolve : {
          status : function(){
            return 503;
          }
        }
      })

  }
})();

(function() {

  'use strict';

  angular.module('GoCloudCast.modules.properties').controller('PropertiesController', PropertiesController);
  
  function PropertiesController($rootScope, $controller, $scope, StorageService) {
    var vm = this;
    var fields = ['name','acronym','token','instance_token','instance_url'];
    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'properties',
        fieldsToFilter : fields,
        postDelete     : function(idDeleted){
          if (StorageService.getProperty().id == idDeleted) {
            StorageService.removeProperty();
          }
          $rootScope.$broadcast("propertiesUpdated");

        },  
      }, 
      scope : $scope 
    }));
    vm.availableSearchParams = vm.generateParams(fields);
  }

})();


(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('PropertiesService',PropertiesService);

  function PropertiesService(ApiService) {

    var instance = {};

    instance.getAll                  = getAll;
    instance.getAllWithoutPagination = getAllWithoutPagination;
    instance.get                     = get;
    instance.save                    = save;
    instance.delete                  = deleteProperty;
    instance.getEmptyProperty        = getEmptyProperty;
    instance.getAllLayouts           = getAllLayouts;

    function getAll(){
     return ApiService.get('/properties?pagination=disabled');     
    }

    function getAllWithoutPagination(){
     return ApiService.get('/properties?pagination=disabled');     
    }

    function get(id){
     return ApiService.get('/properties/'+id);
    }

    function getAllLayouts(){
      return ApiService.get('/layouts?pagination=disabled');
    }

    function save(property){
      property.city_id = property.city.id;
      if (property.id) {
        return ApiService.put('/properties/'+property.id, property);
      } else {
        return ApiService.post('/properties', property);
      }
    }

    function getEmptyProperty(){
      return {"data":{
                  "id":"",
                  "name":"",
                  "acronym":"",
                  "token":"",
                  "state_id":"2",
                  "instance_token":"",
                  "instance_url":""
                }
              };
    }

    function deleteProperty(id){
      return ApiService.delete('/properties/'+id);
    }

    return instance;
  }

})();
   (function() {

  'use strict';

  angular.module('GoCloudCast.modules.properties').controller('PropertiesAddEditController', PropertiesAddEditController);
  
  function PropertiesAddEditController($state, $scope, $rootScope, $controller, property, properties, countries, layouts, cities, CitiesService, templates, ApiService, StorageService, PropertiesService, NotificationService) {
    var vm = this;

    vm.properties                    = properties.data;
    
    vm.data                          = property.data;

    vm.layouts                       = layouts.data;

    vm.templates                     = templates.data;

    vm.countries                     = countries.data;

    vm.cities                        = [];

    vm.generateToken                 = generateToken;

    vm.onSelected                    = onSelected;

    vm.createCity                    = createCity;

    vm.stateCopyTv                   = false;

    vm.stateCopyReceiver             = false;
  
    vm.propertyTvNotSelected         = true;

    vm.propertyReceiverNotSelected   = true;

    vm.templatesTv                   = filterTemplates('tv');

    vm.templatesReceiver             = filterTemplates('receiver');

    vm.layoutsTv                     = filterLayouts(vm.templatesTv);

    vm.layoutsReceiver               = filterLayouts(vm.templatesReceiver);

    vm.layoutsFromProperty           = filterLayoutsFromProperty;

    vm.propertiesFromTv              = filterPropertiesFromType(vm.layoutsTv);

    vm.propertiesFromReceiver        = filterPropertiesFromType(vm.layoutsReceiver);

    vm.notExistsProperties           = notExistsProperties;

    vm.tvTitle                       = '"tv"';

    vm.receiverTitle                 = '"receiver"';

    vm.modifyDefaultLayoutTv         = false;

    vm.modifyDefaultLayoutReceiver   = false;

    vm.setLayoutName                 = setLayoutName;

    vm.isUpdate                      = typeof vm.data.id == "number";

    if(vm.isUpdate){
      vm.defaultLayoutTV       = getDefaultLayoutName(vm.layoutsTv, vm.data.default_layout_tv_id);
      vm.defaultLayoutReceiver = getDefaultLayoutName(vm.layoutsReceiver, vm.data.default_layout_receiver_id);
      vm.tv_name               = vm.stateCopyTv ? "" : vm.defaultLayoutTV;
      vm.receiver_name         = vm.stateCopyReceiver ? "" : vm.defaultLayoutReceiver;
    }
    
    if (vm.data.city) {
      //si estas en edicion poneme el codigo en un formato que onSelected() entienda y ejecuta esa funcion
      //para poder ver la city que elegiste
      vm.data.country = vm.data.city.country;
      var formattedData = {};
      formattedData.code = vm.data.city.country;
      onSelected(formattedData);
    }
    
    vm.data.property_tv_id ? vm.propertyTvNotSelected = false : vm.propertyTvNotSelected = true;
    vm.data.property_receiver_id ? vm.propertyReceiverNotSelected = false : vm.propertyReceiverNotSelected = true;
    vm.data.city ? vm.countryNotSelected = false : vm.countryNotSelected = true;

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl     : 'properties-list',
        formatData   : function(data){
          if(data.instance_token == ""){
            delete data.instance_token;
          }
          if(data.instance_url == ""){
            delete data.instance_url;
          }
          if(!data.layout_tv_name){
            data.layout_tv_name = vm.tv_name;
          }
          if(!data.layout_receiver_name){
            data.layout_receiver_name = vm.receiver_name;
          }
          if(vm.isUpdate && !vm.modifyDefaultLayoutTv){
            delete data.property_tv_id;
            delete data.template_tv_id;
            delete data.id_copy_parameters_tv_from;
          }
          if(vm.isUpdate && !vm.modifyDefaultLayoutReceiver){
            delete data.property_receiver_id;
            delete data.template_receiver_id;
            delete data.id_copy_parameters_receiver_from;
          }
          if(vm.stateCopyTv){
            delete data.template_tv_id;
          } else {
            delete data.property_tv_id;
            delete data.id_copy_parameters_tv_from;
          }
          if(vm.stateCopyReceiver){
            delete data.template_receiver_id;
          } else {
            delete data.property_receiver_id;
            delete data.id_copy_parameters_receiver_from;
          }
        },
        postSave     : function(data){
          $rootScope.$broadcast("propertiesUpdated");
        }  
      }, service : PropertiesService,
      scope: $scope
    }));

    function getDefaultLayoutName(layouts, defaultLayoutId){
      var layoutName = layouts.find(function(layout){
        return layout.id == defaultLayoutId
      });
      return layoutName ? layoutName.name : '';
    }

    function filterLayouts(templates){
      return vm.layouts.filter(function(layout){
        return templates.some(function(template){
          return template.id == layout.template_id;
        });
      });      
    }

    function filterPropertiesFromType(layouts){
      return vm.properties.filter(function(property){
        return layouts.some(function(layout){
          return layout.property_id == property.id;
        });
      });
    }

    function filterLayoutsFromProperty(layouts, propertyId){
      var layoutsFilter = layouts.filter(function(layout){
        return layout.property_id == propertyId
      });
      return layoutsFilter;
    }

    function notExistsProperties(tvOrReceiver){
      if(tvOrReceiver == 'tv'){
        return vm.propertiesFromTv.length == 0;
      } else {
        return vm.propertiesFromReceiver.length == 0;
      }
    }

    function setLayoutName(layoutName, stateCopy, defaultLayout){
      if(vm.isUpdate){
        layoutName = stateCopy ? "" : defaultLayout;
      }
    }

    function onSelected(item){
      CitiesService.getCountries(item.code).then(function(data){
        vm.cities = data.data;
        vm.countryNotSelected = false;
      });
    }

    function filterTemplates(tvOrReceiver){
      return vm.templates.filter(function(template){
          return template.type == tvOrReceiver;
        });
    }

	  function generateToken() {
	  	var MD5 = new Hashes.MD5;
      var token = MD5.hex(new Date().toString()) + MD5.hex(new Date().toString());
	  	vm.data.token = token.substr(1,60).toString();
	  }

    function createCity() {
      CitiesService.save({"name":vm.data.city.name,"country_code":vm.data.country}).then(function(data){
          vm.data.city.isFreeText = false;
          vm.data.city.name = vm.data.city.name;
          vm.data.city.id = data.data.id;
          NotificationService.success('City "' + vm.data.city.name + '" added', 'Success');
        },function(error){
          NotificationService.error('City "' + vm.data.city.name + '" cannot be added', 'Error');
        });
    }
 }
})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.services').controller('ServicesController', ServicesController);
  
  function ServicesController($rootScope,$controller,$scope, ApiService, backdropCount, onCount, ReceiversService, StorageService, NotificationService) {
    var vm = this;

    vm.backdropCount = backdropCount.data
    vm.onCount = onCount.data

    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url : function(){
          return 'services/'+ StorageService.getProperty().id;
        }
      }, scope : $scope
    }))

    $scope.$on("propertyChanged", function(){
       refreshServices()
    });

    vm.restart         = restart;
    vm.getClass        = getClass;
    vm.getStatus       = getStatus;
    vm.refreshServices = refreshServices;

    function getClass(service){
      if(service.service == 'launcher_page_dash_cast' && vm.backdropCount > 0){
        return 'badge badge-warning'
      } else {   
        if(service.status == 'RUNNING'){
          return 'badge badge-success'
        } else {
          return 'badge badge-danger'
        }
      }
    }

    function getStatus(service){
      if(service.service == 'launcher_page_dash_cast' && service.status == 'RUNNING' && vm.backdropCount > 0){
        return service.status + ' - BACKDROP: ' + vm.backdropCount + ' - ON: ' + vm.onCount
      } else {
        return service.status
      }
    }

    function restart(service){
      ApiService.post('/services/restart/'+ StorageService.getProperty().id + '/' + service.service).then(function(data){
          NotificationService.success('Service restarted', 'Success');
          vm.table.reload();
      }, function(data){
          NotificationService.error('Service cannot be restarted', 'Error');
          vm.table.reload();
      });
    }

    function refreshServices(){
      ReceiversService.getBackdropCount().then(function(data){
        vm.backdropCount = data.data;
        ReceiversService.getOnCount().then(function(onData){
          vm.onCount = onData.data
          vm.refreshTable()
        });
      });
          
    }
  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('StorageService',StorageService);

  function StorageService(localStorageService) {

    var instance = {};
    var tokenName = 'token';
    var propertyName = 'property';
    var propertiesName = 'properties';
    var widgetsName = 'widgets';
    var permissionsName = 'permissions';

    instance.removeProperty    = removeProperty
    instance.removeProperties  = removeProperties
    instance.getPermissions    = getPermissions
    instance.setPermissions    = setPermissions
    instance.setActualProperty = setActualProperty
    instance.getProperty       = getProperty
    instance.hasProperty       = hasProperty
    instance.setProperties     = setProperties
    instance.getProperties     = getProperties
    instance.hasProperties     = hasProperties   
    instance.hasToken          = hasToken
    instance.removeToken       = removeToken
    instance.setToken          = setToken
    instance.getToken          = getToken
    instance.removeAll         = removeAll
    instance.setWidgets        = setWidgets
    instance.hasWidgets        = hasWidgets
    instance.getWidgets        = getWidgets
    instance.removeWidgets     = removeWidgets

    function set(key,value){
      localStorageService.set(key, value);
    }

    function get(key){
      return localStorageService.get(key);
    }

    function remove(key){
      localStorageService.remove(key);
    }

    function has(key){
      return !!localStorageService.get(key);
    }

    function setActualProperty(property){
      set(propertyName,property)
    }

    function setProperties(properties){
      set(propertiesName,properties)
    }

    function getProperty(){
      return get(propertyName);
    }

    function getProperties(){
      return get(propertiesName);
    }

    function removeProperties(){
      remove(propertiesName);
    }

    function removeProperty(){
      remove(propertyName);
    }

    function setToken(token){
      set(tokenName,token)
    }

    function getToken(){
      return get(tokenName);
    }

    function removeToken(){
      remove(tokenName);
    }

    function hasToken(){
      return has(tokenName);
    }

    function setWidgets(widgets){
      set(widgetsName,widgets)
    }

    function getWidgets(){
      return get(widgetsName);
    }

    function removeWidgets(){
      remove(widgetsName);
    }

    function hasWidgets(){
      return has(widgetsName);
    }


    function hasProperty(){
      return has(propertyName);
    }

    function hasProperties(){
      return has(propertiesName);
    }

    function removeAll(){
      localStorageService.clearAll();
    }

    function setPermissions(permissions){
      set(permissionsName,permissions);
    }

    function getPermissions() {
      return get(permissionsName);
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.templates').controller('EditImageController', EditImageController);
  
  function EditImageController($scope, $timeout, $uibModalInstance, $stateParams, $state, image, resolutions, aspectRatio, Cropper) {
    var vm = this;

    vm.save      = save;
    vm.cancel    = cancel;
    vm.saveImage = true;

    // Crop config
    vm.minWidth    = resolutions.minWidth;
    vm.minHeight   = resolutions.minHeight;
    vm.maxWidth    = resolutions.maxWidth;
    vm.maxHeight   = resolutions.maxHeight;
    vm.aspectRatio = aspectRatio;

    $scope.supportedDimensions = {
      minWidth: vm.minWidth,
      minHeight: vm.minHeight,
      maxWidth: vm.maxWidth,
      maxHeight: vm.maxHeight,      
    };

    var file, data;

    $scope.image = image;

    var croppedImage

    $scope.onFile = function(blob) {
      Cropper.encode((file = blob)).then(function(dataUrl) {
        $scope.image = dataUrl;
        $timeout(showCropper);  // wait for $digest to set image's src
      });
    };

    $scope.onFile(image);
    //Cropper.background(false)

    $scope.cropper = {};
    $scope.cropperProxy = 'cropper.first';

    $scope.preview = function() {
      return Cropper.crop(file, data).then(Cropper.encode).then(function(dataUrl) {
        croppedImage = dataUrl;
        //($scope.preview || ($scope.preview = {})).dataUrl = dataUrl;
      });
    };

    $scope.options = {
      aspectRatio: vm.aspectRatio,
      crop: function(dataNew) {
        vm.saveImage = verifyCrop(dataNew);
        $scope.dimensions = {
          width: Math.trunc(dataNew.width),
          height: Math.trunc(dataNew.height),
        };
        data = dataNew;
        $scope.$apply();
      }
    };

    $scope.showEvent = 'show';
    $scope.hideEvent = 'hide';

    function verifyCrop(imageCrop){
      if (!vm.maxHeight && !vm.maxWidth) {
        return verifyMinCrop(imageCrop);  
      }
      else if (!vm.minHeight && !vm.minWidth) {
        return verifyMaxCrop(imageCrop);  
      }
      else {
        return verifyMinCrop(imageCrop) && verifyMaxCrop(imageCrop);
      }
    }

    function verifyMinCrop(imageCrop){
      return imageCrop.width >= vm.minWidth && imageCrop.height >= vm.minHeight;
    }

    function verifyMaxCrop(imageCrop){
      return imageCrop.width <= vm.maxWidth && imageCrop.height <= vm.maxHeight;
    }

    function showCropper() { $scope.$broadcast($scope.showEvent); }

    function save(){
      $scope.preview().then(function (argument) {
        //var image  = croppedImage.slice(croppedImage.lastIndexOf("base64,") + 7) //croppedImage es un string croppedImage:image/jpeg;base64,/etc.. a mi lo que me interesa es lo que esta despues de base64,
        var image  = croppedImage;
        $uibModalInstance.close({image: image, croppedImage: croppedImage});
      })
    }

    function cancel() {
      $uibModalInstance.close();
    }
    
  }

})();
(function() {

  'use strict';
  
  angular.module('GoCloudCast.modules').factory('TemplatesService',TemplatesService);

  function TemplatesService(ApiService, GoCloudCast_Constants) {

    var instance = {};

    instance.getAll = getAll;
    instance.get    = get;
    instance.save   = save;

    function getAll() {
      return ApiService.get('/templates');
    }

    function get(propertyId) {
      
      return ApiService.get('/properties-template-parameters/'  + propertyId).then(function(response) {
        return ApiService.get('/template-html?property_id='  + propertyId)
            .then(function(html) {
                return {
                    parameters: response.data,
                    html: html
                }; 
            });
      });

    }
    function save(propertyId, parameters) {
      return ApiService.put('/properties-template-parameters/' + propertyId, parameters);
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.templates').controller('TemplatesEditController', TemplatesEditController);
  
  function TemplatesEditController($scope, $uibModal, $stateParams, NotificationService, TemplatesService, $state, template) {
    var vm = this;

    vm.template = template; 
    vm.save     = save;

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        promise : function(data){
          vm.currentParameter.value = data.slice(data.lastIndexOf("base64,") + 7) //data es un string data:image/jpeg;base64,/etc.. a mi lo que me interesa es lo que esta despues de base64,
        },
        onLoad : function(data, openModal){
          openModal();
        },
        noRedirect: true,  
      }, 
      service : TemplatesService,
      scope : $scope
    })); 

    function save(parameters){
      TemplatesService.save($stateParams.id, parameters).then(function(data){
          NotificationService.success('changes saved', 'Success');
          $state.go('properties-list');
        }, function(data){
          NotificationService.error('changes cannot be saved', 'Error');
        });
    }
  }
})();
(function() {

	'use strict';
	
	angular.module('GoCloudCast.modules').factory('TimezonesService',TimezonesService);
  
	function TimezonesService(ApiService) {
  
	  var instance = {};
  
	  instance.getAllWithoutPagination = getAllWithoutPagination;
  
	  function getAllWithoutPagination() {
		return ApiService.get('/timezones?pagination="disabled"');
	  }
  
	  return instance;
	}
  
  })();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.users').controller('UsersController', UsersController);
  
  function UsersController($controller, $scope) {
    var vm    =  this;
    var fields = [
      'first_name',
      'last_name',
      'username',
      'email'];

    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'customers',
        fieldsToFilter : fields,
      },scope : $scope
    }));
    vm.availableSearchParams = vm.generateParams(fields);
  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('UsersService',UsersService);

  function UsersService(StorageService, ApiService, SessionService) {

    var instance = {};

    instance.getAll        = getAll;
    instance.get           = get;
    instance.save          = save;
    instance.getEmptyUser  = getEmptyUser;
    instance.getLoggedUser = getLoggedUser;

    function getAll(){
      return ApiService.get("/customers?property_id=" + StorageService.getProperty().id);
    }

    function get(id){
      return ApiService.get('/customers/' + id);
    }

    function getLoggedUser(id){
      return ApiService.get('/customers/loggedCustomer');
    }

    function getEmptyUser(){
      console.log("falta ver que onda el campo enabled y properties")

     return {"data": {
              "id":"",
              "first_name":"",
              "last_name":"",
              "email":"",
              "username":"",
              "password":"",
              "all_properties":false,
              "notifications_activated":true,
              "properties":[]
              } 
            };
    }

    function save(user){
      if (user.id) {
        var loggedCustomer = SessionService.getLoggedUser();
        if (loggedCustomer.id == user.id) {
          return ApiService.put('/customers/self', user);  
        } else {
          return ApiService.put('/customers/'+user.id, user);
        }
      } else {
        return ApiService.post('/customers', user);
      }
    }

    return instance;
  }

})();

(function() {

  'use strict';

  angular.module('GoCloudCast.modules.users').controller('UsersAddEditController', UsersAddEditController);
  
  function UsersAddEditController($state, $scope, $controller, NgTableParams, NotificationService, user, roles, properties, UsersService) {
    var vm = this;

    vm.data = user.data;

    vm.data.all_properties = (vm.data.all_properties == 1); 
    vm.data.notifications_activated = (vm.data.notifications_activated == 1); 

    if(vm.data.roles){
        vm.data.role_id = vm.data.roles[0].id
    }

    vm.roles = roles.data;
    vm.addProperty                = addProperty;
    vm.deletePropertySelected     = deletePropertySelected;
    vm.passwordValidation         = passwordValidation;
    vm.updatePropertiesList       = updatePropertiesList;
    vm.properties = properties.data.map(function(x) {
      return {"id":x.id,"name":x.name};
    });

    vm.table = new NgTableParams({}, {dataset: vm.data.properties});

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl            : 'users-list', 
        formatData     : function(data){
          data.properties = data.properties.map(function(property) {return property.id});
          if(data.password == ""){
            delete data.password
          }
        }   
      }, service : UsersService,
      scope: $scope
    }))

    function updatePropertiesList() {
      if(vm.data.all_properties){
        vm.propertySelected = undefined;
        vm.data.properties = [];
        vm.table = new NgTableParams({}, {dataset: vm.data.properties});
      }
    }

    function passwordValidation(){
      return vm.data.password != vm.passwordConfirm;
    }

    function addProperty(){
      vm.data.properties.push(vm.propertySelected);
      vm.propertySelected = undefined;
      //$scope.$digest();
      vm.table = new NgTableParams({}, {dataset: vm.data.properties});
    }

    function deletePropertySelected(property){
      vm.data.properties = vm.data.properties.filter(function(item) { 
        return item.id !== property.id;
      })
      vm.table = new NgTableParams({}, {dataset: vm.data.properties});
      vm.table.reload();
    }

  }

})();
(function(){
  'use strict';

  angular.module('GoCloudCast.pages.dashboard').factory('chartHelperService', chartHelperService);
  
  function chartHelperService($translate, $rootScope, $timeout, EasingService, DeviceService) {//, PolygraphService

    var instancia = {};

    var defaultNoData = {
      lang: {
        noData: '<div class="text-center">'+
                  '<h2>No data to display</h2>'+
                  '<i class="fa fa-frown-o fa-3x"></i>'+
                '<div>'
      },
      noData: {
        useHTML: true,
        style: {
          fontWeight: 'bold'
        }
      }
    }

    function generateInfoLabel(chart,attr,css,text,x,y) {
      return chart.renderer.label(text, x, y).attr(attr).css(css).add();
    }

    ////////////////////////////////////////  Start Resize  ///////////////////////////////////////

    //Observacion: Solo actua sobre los charts
    function resizeCharts(charts) {
      $timeout(function(){
        charts.forEach(function(current){ if (current) private_resize(current) });
      },500)
    }

    function private_resize(chart) {
      var elem = chart.container;
      var parent = $(elem).parent();
      chart.setSize(parent.width()+1, parent.height()+1);
    }

    /* ----------------------------------------------------------------------------------------- */

    //Observacion: Funciona sobre widgets que tienen charts dentro
    function resize(chart) {
      var elem = chart.container;
      var item = $(elem).parents('li').scope().gridsterItem;
      chart.setSize(item.getElementSizeX()-10, item.getElementSizeY()-10);
    }

    function resizeMethod() {
      return function(chart) {
        $timeout(function(){
          resize(chart);
        },600);
      }
    }

    /////////////////////////////////////////  End Resize  ////////////////////////////////////////

    function getChartData(array,yColumn){
      return array.map(function(row){
        var formated = {}
        Object.keys(row).forEach(function(key){
          if(yColumn == key) formated.y = row[key]
          else formated[key] = row[key]
        });

        return formated;
      });
    }

    function updateChart(chart, options, redraw){
      if(redraw == undefined) redraw = true;

      if(Array.isArray(options)){
        options.map(function(data, index){
          if(!data.animation) Object.assign(data, instancia.defaultAnimation);
          return data;
        })

      }else{
        if(!options.animation) Object.assign(options, instancia.defaultAnimation);
      }

      chart.series.forEach(function(serie){
        serie.update(options, redraw);   
      });
    }

    function generalSerieFormat(data, name){
      if(data.length > 0 && data[0].data != undefined){
        return data;
      }

      if(!Array.isArray(data)){
        if(data['series']){
          return [Object.assign(data.series[0], instancia.defaultAnimation)];
        }
        return [Object.assign(data, instancia.defaultAnimation)];
      }

      var serie = {
        name : name,
        data : data 
      };

      return [Object.assign(serie, instancia.defaultAnimation)];
    }

    function calculateChartHeight(data){
      var dataLength = data.length;
      return DeviceService.isMobile() ? (dataLength * 52) + 350
             : DeviceService.isTablet() ? (dataLength * 39) + 250
             : DeviceService.isShortDesktop() ? (dataLength * 21) + 250
             : (dataLength * 13) + 250
    }

    var optionSet = {
      doughnut : {
        settings: Object.assign({
          chart : {
            type : 'pie' ,
            renderTo: 'container',
            events : {
              load: function(event) {
                this.extras_ = { 
                  totalText : this.renderer.text(
                    'Total: ??' ,
                    this.plotLeft,
                    this.plotTop - 20
                  ).attr({ zIndex: 5 }).add()
                }
              },
              redraw: function(event) {
                var total = 0;
                for(var i=0, len=this.series[0].yData.length; i<len; i++) if (this.series[0].points[i].visible) total += this.series[0].yData[i];
                this.extras_.totalText.element.innerHTML = 'Total: ' + total;
              }
            }
          },
          plotOptions : {
            series : {
              tooltip : {
                pointFormatter : function(){
                  return this.y
                }
              }
            },
            pie: {
              showInLegend: true,
              allowPointSelect: true,
              innerSize: '50%',
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y}',
              }
            } 
          }
        }, defaultNoData),
        serie : function(data, name){
          return generalSerieFormat(data, name)
        }
      },

      ///////////////////////////////////////////////////////////////////////////////////////////////////

      pie: {
        settings: Object.assign({
          chart: { 
            type: 'pie'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y} uses',
                style: {
                  color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
                }
              }
            }
          },
          tooltip: {
            pointFormat: 'Count: <b>{point.y}</b>'
          }
        }, defaultNoData),
        serie : function(data, name){
          return generalSerieFormat(data, name)
        }
      },

      ///////////////////////////////////////////////////////////////////////////////////////////////////

      column: {
        settings: Object.assign({
          chart: { type: 'column' },
          legend: { enabled: false },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: { 
                enabled: true, 
                format: '<b>{point.name}</b>' 
              }
            }
          },
          tooltip: { 
            pointFormat:  'Count: <b>{point.y}</b>' //+
                          //'<br>' +
                          //'Average: <b>{point.avg}%</b>'

          }
        }, defaultNoData),
        serie : function(data, name){
          var generalSerie = generalSerieFormat(data, name)
          Object.assign(generalSerie[0], {colorByPoint: true})
          return generalSerie;
        }
      },

      ///////////////////////////////////////////////////////////////////////////////////////////////////

      zoomtype: {
        settings: Object.assign({
          chart: { 
            zoomType: 'x'
          },
          yAxis: { title: { text: 'Quantity' } },
          xAxis: { title: { text: 'Hour' }, type: 'hour' },
          legend: {
              align: 'center',
              layout: 'horizontal',
              verticalAlign: 'bottom',
          },
          tooltip: {
            pointFormat: 'Quantity: <b>{point.y}</b>'
          },
          plotOptions: {
            area: {
              fillColor: {
                linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
                stops: [
                  [0, Highcharts.getOptions().colors[0]],
                  [1, Highcharts.Color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
                ]
              },
              marker: { radius: 2 },
              lineWidth: 1,
              states: { hover: { lineWidth: 1 } },
              threshold: null
            },

          }
        }, defaultNoData),
        serie : function(data, name){
          return generalSerieFormat(data, name)
        }
      },

      ///////////////////////////////////////////////////////////////////////////////////////////////////

      splitLines: {
        settings: Object.assign({
          chart: {
              scrollablePlotArea: {
                  minWidth: 700
              }
          },

          xAxis: { title: { text: 'Hour' }, type: 'hour' },

          yAxis: { title: { text: 'Quantity' } },

          legend: {
              align: 'left',
              verticalAlign: 'top',
              borderWidth: 0
          },

          tooltip: {
              shared: true,
              crosshairs: true,
          },

          plotOptions: {
              series: {
                  step: 'center',
                  lineWidth: 3,
                  marker: {
                      radius: 5
                  },
              }
          }
        }, defaultNoData),
        serie : function(data, name){
          this.settings.plotOptions.series.events = data.events;
          return generalSerieFormat(data.data, name);
        }
      },

      ///////////////////////////////////////////////////////////////////////////////////////////////////

      heatmap: {
        settings: Object.assign({

          chart: {
              type: 'heatmap',
              height: 300,
              plotBorderWidth: 5
          },

          xAxis: {
              visible: false,
              categories: []
          },

          yAxis: {
              visible: false,
              categories: [],
              title: null,
              reversed: true
          }

        }, defaultNoData),

        serie : function(data, name){
          var generalSerie = generalSerieFormat(data, name)
          this.settings.chart.height = calculateChartHeight(data.data) + 300;
          Object.assign(generalSerie[0], {
            borderWidth: 1
          })

          return generalSerie;
        }
      },

      ///////////////////////////////////////////////////////////////////////////////////////////////////

      treemap: {
        settings: Object.assign({
          chart: {
              type: 'treemap',
          }
        }, defaultNoData),

        serie : function(data, name){
          var generalSerie = generalSerieFormat(data, name);
          this.settings.chart.height = calculateChartHeight(data.series[0].data);

          return generalSerie;
        }
      }
    }

    function simpleChart(type, data, options){
      var contextButtonsTranslations = {
        SWITCH_LEGENDS : function(){ return $translate.instant('DASHBOARD.WIDGET.SWITCH_LEGENDS'); },
        EXPORT_PNG     : function(){ return $translate.instant('DASHBOARD.WIDGET.EXPORT_PNG'    ); }
      }

      return function(callback){
        callback = callback || function(){}
        options = angular.merge({
          title : 'DASHBOAD.WIDGET.DEFAULT.TITLE',
          serieName : 'DASHBOAD.WIDGET.DEFAULT.SERIE'
        }, options || {})

        var core = {
          __title : options.title,
          options : {
            extra: options.extra,
            legend : {
              itemWidth: 200,
            },
            exporting : {
              buttons : {
                contextButton : {
                  menuItems: [
                    {
                      id : 'SWITCH_LEGENDS',
                      text: contextButtonsTranslations.SWITCH_LEGENDS(),
                      onclick: function() {
                        if (this.legend.display) {
                          this.legend.group.hide();
                          this.legend.display = false
                        } else {  
                          this.legend.group.show();
                          this.legend.display = true
                        }
                      },
                    }, {
                      separator : true
                    }, {
                      id : 'EXPORT_PNG',
                      text: contextButtonsTranslations.EXPORT_PNG(),
                      onclick: function () { this.exportChart(); }
                    }
                  ]
                }
              }
            },
            drilldown : options.drilldown ? { series : options.drilldown } : {}
          },
          title : {
            text : $translate.instant(options.title)
          },
          series : optionSet[type].serie(data, options.serieName),
          func: function(chart) {
            callback(chart)
          }
        }


        var settingTypesSelector = Object.assign(optionSet[type].settings, options.typeCallbackParameters)
        core.options = angular.merge(core.options, settingTypesSelector)

        if(type === 'map')
          core.chartType = 'map';

        function updateTranslations(core){
          core.title.text = $translate.instant(options.title);
          // core.series[0].name = $translate.instant(options.serieName);
          core.options.exporting.buttons.contextButton.menuItems.forEach(function(current){ contextButtonsTranslations[current.id] ? current.text = contextButtonsTranslations[current.id]() : core })
        }

        $rootScope.$on('$translateChangeEnd', function(){
          updateTranslations(core);
        });

        return core
      }
    }

    instancia.resizeMethod = resizeMethod;
    instancia.resizeCharts = resizeCharts;
    instancia.simpleChart  = simpleChart;
    instancia.getChartData  = getChartData;
    instancia.updateChart  = updateChart;
    instancia.calculateChartHeight = calculateChartHeight;
    instancia.generateInfoLabel  = generateInfoLabel;
    instancia.defaultAnimation = { animation: { duration: 1500, easing: EasingService.easeOutBounce } }
    return instancia;
  }
})();




(function() {

  'use strict'

  //**************//
  //*** CHARTS ***//
  //**************//
  angular.module('GoCloudCast.pages.dashboard').controller('mockPieController',  mockPieController);

  function mockPieController($scope, $rootScope, $translate, chartHelperService, data) {
    var apps = data? data.data.map(function(app){
      return {name: app.key, y: app.doc_count}
    }) : [];
    var myScope   = $scope;
    var destroyer = $rootScope.$on('cDashboard-config-changed', function(event, args) {
      myScope.chartConfig.getHighcharts().destroy();
      destroyer();
      $scope.$emit('widgetReload');
    });
    $scope.$on("$destroy", function() {
      if (destroyer) destroyer();
    })

    $scope.data = data? true : undefined;

    $scope.chartConfig = chartHelperService.simpleChart('doughnut', apps, {
      title : "Apps Streamed"//$translate.instant('TICKETS_STATUS.CHARTS.TITLES.TICKETS_PER_STATUS')
    })(chartHelperService.resizeMethod());
  }


  //***************//
  //*** WIDGETS ***//
  //***************//
  angular.module('GoCloudCast.pages.dashboard').controller('abstractSimpleChartsController', abstractSimpleChartsController);
  angular.module('GoCloudCast.pages.dashboard').controller('infoController',  infoController);
  angular.module('GoCloudCast.pages.dashboard').controller('avgDurationController',  avgDurationController);
  angular.module('GoCloudCast.pages.dashboard').controller('avgUsesController',  avgUsesController)

  function infoController($controller, $scope, stats, data) {
    angular.extend(this, $controller('abstractSimpleChartsController', {
      data: data,
      statsValue: stats? stats.data : undefined,
      myScope: $scope
    }));
  }

  function avgDurationController($controller, $scope, stats, data) {
    angular.extend(this, $controller('abstractSimpleChartsController', {
      data: data,
      statsValue: stats? convertMS(stats.data.value) : undefined,
      myScope: $scope
    }));
  }

  function avgUsesController($controller, $scope, stats, data) {
    angular.extend(this, $controller('abstractSimpleChartsController', {
      data: data,
      statsValue: stats? Number(Math.round(stats.data.value+'e2')+'e-2') : undefined,
      myScope: $scope
    }));
  }

  function abstractSimpleChartsController($rootScope, myScope, data, statsValue) {
    var destroyer = $rootScope.$on('cDashboard-config-changed', function(event, args) {
      destroyer();
      myScope.$emit('widgetReload');
    });
    data.stats = statsValue;
    myScope.info = data;
    myScope.$on("$destroy", function() {
      if (destroyer) destroyer();
    })
  }


  function convertMS(ms){
      var d, h, m, s;
      s = Math.floor(ms / 1000);
      m = Math.floor(s / 60);
      s = s % 60;
      h = Math.floor(m / 60);
      m = m % 60;
      d = Math.floor(h / 24);
      h = h % 24;
      h += d * 24;
      return addZero(h) + ':' + addZero(m) + ':' + addZero(s);
  }

  function addZero(n){
    return (n>9? n.toString() : '0' + n)
  }

})( );

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
  	.config(function (dashboardProvider) {
      dashboardProvider.widget('Mock Chart Pie', /*@ngInject*/ {
        title: 'Mock Chart Pie',
        reload: true,
        templateUrl: 'app/pages/dashboard/widgets/chart.html',
        controller: 'mockPieController',
        resolve: {
          data: function(DashboardConfigurationInstance){
            return DashboardConfigurationInstance.getWithFilter('receiver-state/apps-streamed');
          },
        }
      });
    })

    .config(function (dashboardProvider) {
      dashboardProvider.widget('Total Rooms', /*@ngInject*/ {
        title: 'Total Rooms',
        reload: true,
        templateUrl: 'app/pages/dashboard/widgets/usage.html',
        controller: 'infoController',
        resolve: {
          data : function(){
            return {description: 'Total Rooms', stats: undefined, icon: 'bed'}
          },
          stats: function(DashboardConfigurationInstance) {
            return DashboardConfigurationInstance.totalRooms();
          }
        }
      });
    })

    .config(function (dashboardProvider) {
      dashboardProvider.widget('Uses', /*@ngInject*/ {
        title: 'Uses',
        reload: true,
        templateUrl: 'app/pages/dashboard/widgets/usage.html',
        controller: 'infoController',
        resolve: {
          data : function(){
            return {description: 'Uses', stats: undefined, icon: 'play'}
          },
          stats: function(DashboardConfigurationInstance) {
            return DashboardConfigurationInstance.getWithFilter('receiver-state/uses');
          }
        }
      });
    })

    .config(function (dashboardProvider) {
      dashboardProvider.widget('Guest Streamed', /*@ngInject*/ {
        title: 'Guest Streamed',
        reload: true,
        templateUrl: 'app/pages/dashboard/widgets/usage.html',
        controller: 'infoController',
        resolve: {
          data : function(){
            return {description: 'Guest Streamed', stats: undefined, icon: 'television'}
          },
          stats: function(DashboardConfigurationInstance) {
            return DashboardConfigurationInstance.getWithFilter('sender-uptime/guests-streamed');
          }
        }
      });
    })

    .config(function (dashboardProvider) {
      dashboardProvider.widget('Avg. Duration of One Use', /*@ngInject*/ {
        title: 'Avg. Duration of One Use',
        reload: true,
        templateUrl: 'app/pages/dashboard/widgets/usage.html',
        controller: 'avgDurationController',
        resolve: {
          data : function(){
            return {description: 'Avg. Duration of One Use', stats: undefined, icon: 'clock-o'}
          },
          stats: function(DashboardConfigurationInstance) {
            return DashboardConfigurationInstance.getWithFilter('receiver-uptime/avg-duration');
          }
        }
      });
    })

    .config(function (dashboardProvider) {
      dashboardProvider.widget('Avg. Total Duration Per Stay', /*@ngInject*/ {
        title: 'Avg. Total Duration Per Stay',
        reload: true,
        templateUrl: 'app/pages/dashboard/widgets/usage.html',
        controller: 'infoController',
        resolve: {
          data : function(){
            return {description: 'Avg. Duration of One Use', stats: undefined, icon: 'clock-o'}
          },
          stats: function(DashboardConfigurationInstance) {
            return DashboardConfigurationInstance.getWithFilter('sender-uptime/guests-streamed');
          }
        }
      });
    })

    .config(function (dashboardProvider) {
      dashboardProvider.widget('Avg. GoCloud StreamCast Uses Per Stay', /*@ngInject*/ {
        title: 'Avg. GoCloud StreamCast Uses Per Stay',
        reload: true,
        templateUrl: 'app/pages/dashboard/widgets/usage.html',
        controller: 'avgUsesController',
        resolve: {
          data : function(){
            return {description: 'Avg. GoCloud StreamCast Uses Per Stay', stats: undefined, icon: 'play'}
          },
          stats: function(DashboardConfigurationInstance) {
            return DashboardConfigurationInstance.getWithFilter('receiver-state/avg-uses');
          }
        }
      });
    })

})();
 


(function() {

  'use strict';

  angular.module('GoCloudCast.pages.dashboard').controller('DashboardController', DashboardController);
  
  function DashboardController($scope, ApiService, StorageService, areas, DashboardConfigurationInstance) {
    var vm = this;

    vm.chartsName = ['Total Rooms','Uses','Avg. Duration of One Use',
      'Guest Streamed'];//,'Avg. GoCloud StreamCast Uses Per Stay', 'Avg. Total Duration Per Stay', 

    vm.areas = areas.data.map(function(x){
      return x.name;
    }); 

    function createWidgets(data) {
      var widgets = []; 
      var col = 0, row = 0, chartSizeX = 24, chartSizeY = 7, infoSizeX = 12, infoSizeY = 3;
      var chart;
 
      for (chart in vm.chartsName) {
        widgets.push({ col: col, row: row, sizeX: infoSizeX, sizeY: infoSizeY, type: vm.chartsName[chart], data: []});
        if((col + infoSizeX) > 15){
          col = 0
          row += infoSizeX
        } else {
          col += infoSizeX
        }
      }

      col = 0;
      row += chartSizeY+1;

      widgets.push({ col: col, row: row, sizeX: chartSizeX, sizeY: chartSizeY, type: "Mock Chart Pie", data:  vm.apps});//vm.appsStreamedChart

      return widgets;
    }
    
    getWidgets(); 

    function getWidgets() {
      if(StorageService.hasWidgets()){
        vm.widgets = StorageService.getWidgets();
      } else {
        vm.widgets = createWidgets();
        StorageService.setWidgets(vm.widgets); 
      }
    }

    $scope.$on("resize", function() {
      StorageService.setWidgets(vm.widgets);
    })

    $scope.$on("$destroy", function(){
      DashboardConfigurationInstance.cleanFilters();
    })
          
  }
    

    

})();



(function(){
  'use strict';

  angular.module('GoCloudCast.pages.dashboard').factory('DashboardConfigurationInstance', DashboardConfigurationInstance);
  
  function DashboardConfigurationInstance(ApiService, StorageService) {
    var instance = {};
    
    instance.start_date = undefined;
    instance.end_date = undefined;
    instance.area_name = undefined;

    instance.getAppsStreamed = getAppsStreamed;
    instance.totalRooms      = totalRooms;
    instance.getWithFilter   = getWithFilter;
    instance.cleanFilters    = cleanFilters;

    function cleanFilters() {
      instance.start_date = undefined;
      instance.end_date = undefined;
      instance.area_name = undefined;
    }

    function getAppsStreamed() {
      return ApiService.get("/public/es/receiver-state/apps-streamed?property_id=" + StorageService.getProperty().id + '&token=' + StorageService.getProperty().token + dateFilter());
    }

    function totalRooms(){
      return ApiService.get("/total-rooms?property_id=" + StorageService.getProperty().id).then(
        function(data){return data}, function(){return undefined});
    }

    function getWithFilter(url) {
      return ApiService.get("/public/es/" + url + "?property_id=" + StorageService.getProperty().id + '&token=' + StorageService.getProperty().token + dateFilter() + areaFilter()).then(
        function(data){return data}, function(){return undefined});
    }

    function dateFilter() {
      var dateFilter = instance.start_date? '&from='+formatDate(instance.start_date) : '' 
      dateFilter = dateFilter + (instance.end_date? '&to='+formatDate(instance.end_date) : '')
      return dateFilter;
    }

    function areaFilter() {
      var areaFilter = instance.area_name? '&area=' + instance.area_name : '' 
      return areaFilter;
    }

    function formatDate(date){
      var month = (date.getMonth()+1);
      var day = (date.getDate());
      if(month<10){
        month = '0' + month
      }
      if(day<10){
        day = '0' + day
      }
      return date.getFullYear()+'-'+ month + '-' + day + ' 00:00:00'
    }

    return instance;
  }

})();
/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal) {
    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

(function(){
  'use strict'

  angular.module('GoCloudCast.modules').directive('ngReallyClick',ngReallyClick);
  
  // function ngReallyClick($modal){
  //   var ModalInstanceCtrl = function($scope, $modalInstance) {
  //     $scope.ok     = function() { $modalInstance.close(); };
  //     $scope.cancel = function() { $modalInstance.dismiss('cancel'); };
  //   };
  //   return {
  //     restrict: 'A',
  //     scope:{
  //       ngReallyClick:"&",
  //       item:"="
  //     },
  //     link: function(scope, element, attrs) {
  //       element.bind('click', function() {
  //         var message = attrs.ngReallyMessage || '{{"ALERTAS.ELIMINACION" | translate}}';
  //         var modalHtml =
  //           '<div class="modal-header"><button type="button" class="close" ng-click="cancel()" aria-hidden="true">&times;</button>' +
  //           '<h4 class="modal-title">{{"ALERTAS.CONFIRMAR" | translate}}</h4></div>' +
  //           '<div class="modal-body modal-message">'+
  //           '<p>' + message + '</p>' +
  //           '</div>' +
  //           '<div class="modal-footer">' +
  //           '<button type="button" class="btn btn-sm btn-success" ng-click="ok()" data-dismiss="modal"><i class="fa fa-check"></i> {{"BOTONES.CONTINUAR" | translate}}</button>' +
  //           '<button type="button" class="btn btn-sm btn-danger" ng-click="cancel()"><i class="fa fa-times"></i> {{"BOTONES.CANCELAR" | translate}}</button>' +
  //           '</div>';

  //         var modalInstance = $modal.open({
  //           template: modalHtml,
  //           controller: ModalInstanceCtrl,
  //           size:'sm'
  //         });

  //         modalInstance.result.then(function() {
  //           scope.ngReallyClick({item:scope.item}); //raise an error : $digest already in progress
  //         }, function() {
  //           //Modal dismissed
  //         });
  //       });
  //     }
  //   }
  // }

  function ngReallyClick(SweetAlert2, $translate){
    return {
      restrict: 'A',
      scope: {
        ngReallyClick:"&",
        item:"="
      },
      link: function(scope, element, attrs) {
        element.bind('click', function() {
          SweetAlert2.swal({
            title: $translate.instant('ALERTS.CONFIRM'),
            text: attrs.ngReallyMessage || $translate.instant('ALERTS.DELETE'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#F44336",
            confirmButtonText: $translate.instant('BUTTONS.CONTINUE'),
            cancelButtonText: $translate.instant('BUTTONS.CANCEL'),
            closeOnConfirm: true,
            closeOnCancel: true
          },
          function() {
            scope.ngReallyClick({ item:scope.item });
          },
          function() {
            //Modal dismissed
          });
        });
      }
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
'use strict';

(function(root, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['angular', 'jquery-minicolors'], factory);
    } else if (typeof exports === 'object') {
        module.exports = 'minicolors';
    } else {
        root.angularMinicolors = factory(root.angular);
    }
})(this, function(angular) {

    angular.module('GoCloudCast.theme').provider('minicolors', function() {
        this.defaults = {
            theme: 'bootstrap',
            position: 'top left',
            defaultValue: '',
            animationSpeed: 50,
            animationEasing: 'swing',
            change: null,
            changeDelay: 0,
            control: 'hue',
            hide: null,
            hideSpeed: 100,
            inline: false,
            letterCase: 'lowercase',
            opacity: false,
            show: null,
            showSpeed: 100
        };

        this.$get = function() {
            return this;
        };

    });

    angular.module('GoCloudCast.theme').directive('minicolors', ['minicolors', '$timeout', '$parse', function(minicolors, $timeout, $parse) {
        return {
            require: '?ngModel',
            restrict: 'A',
            priority: 1, //since we bind on an input element, we have to set a higher priority than angular-default input
            link: function(scope, element, attrs, ngModel) {

                var inititalized = false;

                //gets the settings object
                var getSettings = function() {
                    var config = angular.extend({}, minicolors.defaults, scope.$eval(attrs.minicolors));
                    return config;
                };

                //what to do if the value changed
                ngModel.$render = function() {

                    //we are in digest or apply, and therefore call a timeout function
                    $timeout(function() {
                        var color = ngModel.$viewValue;
                        
                        var opacity = scope.$eval(attrs.minicolorsOpacity) || '1.0';
                        element.minicolors('opacity', opacity);
                        element.minicolors('value', color);
                    }, 0, false);
                };

                //init method
                var initMinicolors = function() {

                    if (!ngModel) {
                        return;
                    }
                    var settings = getSettings();
                    settings.change = function(hex, opacity) {
                        scope.$apply(function() {
                            ngModel.$setViewValue(hex);
                            if (attrs.minicolorsRgba) {
                                var rgba = element.minicolors('rgbaString');
                                $parse(attrs.minicolorsRgba).assign(scope, rgba);
                            }
                            if (attrs.minicolorsOpacity) {
                                var opacity = element.minicolors('opacity');
                                $parse(attrs.minicolorsOpacity).assign(scope, opacity);
                            }
                        });
                    };

                    //destroy the old colorpicker if one already exists
                    if (element.hasClass('minicolors')) {
                        element.minicolors('destroy');
                    }

                    // Create the new minicolors widget
                    element.minicolors(settings);

                    // are we inititalized yet ?
                    //needs to be wrapped in $timeout, to prevent $apply / $digest errors
                    //$scope.$apply will be called by $timeout, so we don't have to handle that case
                    if (!inititalized) {
                        $timeout(function() {
                            var color = ngModel.$viewValue;
                            var opacity = scope.$eval(attrs.minicolorsOpacity);
                            var rgba = scope.$eval(attrs.minicolorsRgba);
                            element.minicolors('value', color);
                            element.minicolors('opacity', opacity);
                            element.minicolors('rgbaString', rgba);
                        }, 0);
                        inititalized = true;
                        return;
                    }
                };

                initMinicolors();
                //initital call

                // Watch for changes to the directives options and then call init method again
                scope.$watch(getSettings, initMinicolors, true);
            }
        };
    }]);
});

(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('GoCloudCast.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.areas.areaLists').controller('AreaListsController', AreaListsController);
  
  function AreaListsController($rootScope,$controller,$scope, StorageService, ApiService, NotificationService, AreasService, areaCodes, expirationTime) {
    var vm = this;

    vm.expirationTime    = expirationTime.data ;
    vm.verificationCodes = areaCodes.data;
    vm.refreshCode       = refreshCode;
    vm.autoRefreshCodes  = false;
    vm.autoRefresh       = autoRefresh;
    var fields = ['name'];
    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'areas-with-receiver-quantity',
        preProcessData : function(data){
          data.map(function(area){
            area["code"] = getCode(area.name);
            return area;
          })
          return data;
        },
        fieldsToFilter : fields,
        staticFilters  : {'property_id': function(){
          return StorageService.getProperty().id;
        }}  
      }, scope : $scope
    }))
    vm.availableSearchParams = vm.generateParams(fields);
    vm.deleteRow         = deleteRow;
    vm.refreshTable = refreshTable;

    $scope.$on("propertyChanged", function(){
      refreshTable();
    });

    function getCode(areaName){
      var area = vm.verificationCodes.find(function(area){
        return area.name == areaName;
      });

      if (!area) {
        console.log("Error: Area Code not found");
        area = { code: "Error"}
      }

      return area.code;
    }

    function autoRefresh(){
      if (vm.expirationTime == 0) {
        refreshCode();
      }
    }

    function updateExpirationTime() {
      AreasService.getExpirationTime().then(function(data){
          vm.expirationTime = data.data 
          $scope.$broadcast('timer-add-cd-seconds', vm.expirationTime);
        });
    }

    function updateAreaCodes(argument) {
      AreasService.getAreaCodes().then(function(data){
          vm.verificationCodes = data.data
          vm.table.reload();
        });
    }

    function refreshCode(){
      vm.expirationTime = 0;
      if (vm.autoRefreshCodes) {
        updateExpirationTime()
        updateAreaCodes()
      }
    }

    function refreshTable(){            
      vm.table.reload();
      vm.expirationTime = 0;        
      AreasService.getExpirationTime().then(function(data){
        vm.expirationTime = data.data   
        $scope.$broadcast('timer-set-countdown', vm.expirationTime);
        $scope.$broadcast('timer-start');       
      });
      updateAreaCodes();          
    }

    function deleteRow(id){
      ApiService.delete('/areas/' + id).then(function(data){
        NotificationService.success('Element deleted', 'Success');
        vm.table.reload();
      }, function(data){
          NotificationService.error('Element cannot be deleted', 'Error');
      })
    }


  
  }

})();            
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.areas.areaLists').controller('AreaListsAddEditController', AreaListsAddEditController);
  
  function AreaListsAddEditController($state, $scope, $controller, area, areaTypes, AreasService, StorageService, AreaTypesService, NotificationService) {
    var vm = this;

    
    vm.data = area.data;
    vm.areaTypes = areaTypes.data;
    vm.createAreaType = createAreaType;

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl            : 'areas.area-lists-list',
        formatData     : function(data){
          data.area_type_id = data.area_type.id
          if($state.params.id){
            data.id = $state.params.id;
          }
        }  
      }, service : AreasService,
      scope: $scope
    }))

    function createAreaType() {
      AreaTypesService.save({"name":vm.data.area_type.name,"property_id":StorageService.getProperty().id}).then(function(data){
          vm.areaTypes.push(data.data)
          vm.data.area_type.isFreeText = false;
          vm.data.area_type.name = vm.data.area_type.name;
          vm.data.area_type.id = data.data.id;
          NotificationService.success('Area Type added', 'Success');
        },function(error){
          NotificationService.error('Area Type cannot be added', 'Error')
        })
    }

  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('AreasService',AreasService);

  function AreasService(StorageService, ApiService) {

    var instance = {};

    instance.getAll                  = getAll;
    instance.get                     = get;
    instance.save                    = save;
    instance.getEmptyArea            = getEmptyArea;
    instance.delete                  = deleteArea;
    instance.getAreaCodes            = getAreaCodes;
    instance.getExpirationTime       = getExpirationTime;
    instance.getAllWithoutPagination = getAllWithoutPagination;

    function getAll(){
      return ApiService.get("/areas?property_id=" + StorageService.getProperty().id);
    }

    function getAllWithoutPagination(){
      return ApiService.get("/areas?property_id=" + StorageService.getProperty().id + '&pagination=disabled');
    }

    function get(id){
      return ApiService.get("/areas/"+id);
    }

    function getEmptyArea(){
     return {"data": {
                "property_id":StorageService.getProperty().id,
                "name":""}
              };
    }

    function getAreaCodes(){
      return ApiService.get("/codes/" + StorageService.getProperty().id);
    }

    function getExpirationTime(){
      return ApiService.get("/code-expiration-time/" + StorageService.getProperty().id);
    }

    function save(area){
      if (area.id) {
        return ApiService.put('/areas/'+area.id, area);
      } else {
        return ApiService.post('/areas', area);
      }
    }

    function deleteArea(name){
      return ApiService.delete('/areas/'+name);
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.areas.areaTypes').controller('AreaTypesController', AreaTypesController);
  
  function AreaTypesController($rootScope,$controller,$scope, StorageService) {
    var vm     = this;
    var fields = ['name'];
    
    vm.tvTitle       = '"tv"';
    vm.receiverTitle = '"receiver"';

    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'area-types',
        fieldsToFilter : fields,
        staticFilters  : {'property_id': function(){
          return StorageService.getProperty().id;
        }}  
      }, scope : $scope
    }))
    vm.availableSearchParams = vm.generateParams(fields);
    vm.refreshTable          = refreshTable;

    $scope.$on("propertyChanged", function(){
      refreshTable();
    });

    function refreshTable(){            
      vm.table.reload();        
    }
  }
})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.areas.areaTypes').controller('AreaTypesAddEditController', AreaTypesAddEditController);
  
  function AreaTypesAddEditController($state, $scope, $controller, areaType, AreaTypesService , NotificationService) {
    var vm = this;
    
    vm.data              = areaType.data;
    vm.tvTitle           = '"tv"';
    vm.receiverTitle     = '"receiver"';
    vm.clear             = clear;

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl            : 'areas.area-types-list' 
      }, service : AreaTypesService,
      scope: $scope
    }))

    function clear($event, $select){ 
      //stops click event bubbling
      $event.stopPropagation(); 
      //to allow empty field, in order to force a selection remove the following line
      $select.selected = undefined;
      //reset search query
      $select.search = undefined;
    }

  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('AreaTypesService',AreaTypesService);

  function AreaTypesService(StorageService, ApiService) {

    var instance = {};

    instance.getAllWithoutPagination = getAllWithoutPagination;
    instance.getEmptyAreaType        = getEmptyAreaType;
    instance.save                    = save;
    instance.get                     = get;
    instance.getAllLayouts           = getAllLayouts;


    function getAllWithoutPagination(){
      return ApiService.get("/area-types?property_id=" + StorageService.getProperty().id + '&pagination=disabled');
    }

    function getEmptyAreaType(){
     return {"data": {
                "property_id":StorageService.getProperty().id,
                "name":""}
              };
    }

    function getAllLayouts(){
      return ApiService.get("/layouts");
    }

    function get(id){
      return ApiService.get("/area-types/"+id); 
    }

    function save(areaType){
      if (areaType.id) {
        return ApiService.put('/area-types/'+areaType.id, areaType);
      } else {
        return ApiService.post('/area-types', areaType);
      }
    }

    return instance;
  }

})();
(function () {
  'use strict';

  angular.module('GoCloudCast.auth.login').controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($scope, SessionService) {
    var vm = this;

    vm.login = login;
    vm.errorMessage;
    vm.cleanErrorMessage = cleanErrorMessage;
    vm.credentials = {
      username : '',
      password : ''
    }

    function login(){
      SessionService.login(vm.credentials).then(function(data) {
        if(data.status != 200){
          vm.errorMessage = data.data? data.data.data.message : "Could not login";
        }
      });
    }

    function cleanErrorMessage() {
      vm.errorMessage = undefined;
    }



  }

})();


(function() {

  'use strict';

  angular.module('GoCloudCast.modules.cast.news').controller('NewsController', NewsController);
  
  function NewsController($rootScope,$controller,$scope, categories, StorageService) {
    var vm = this;
    vm.categories = categories.map( function(data){
      return data.name;
    });
    var fields = ['title', 'category'];
    var suggestedValues = {  category : vm.categories};
    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'news',
        fieldsToFilter : fields,
        staticFilters  : {'property_id': function(){
          return StorageService.getProperty().id;
        }}  
      }, scope : $scope
    }));

    $scope.$on("propertyChanged", function(){
      vm.table.reload();
    });
    vm.availableSearchParams = vm.generateParams(fields, suggestedValues);
  
  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('NewsService',NewsService);

  function NewsService(StorageService, ApiService) {

    var instance = {};

    instance.getAll        = getAll;
    instance.get           = get;
    instance.save          = save;
    instance.getEmptyNews  = getEmptyNews;
    instance.delete        = deleteNews;
    instance.getCategories = getCategories;

    function getAll(){
      return ApiService.get("/news?property_id=" + StorageService.getProperty().id);
    }

    function get(id){
      return ApiService.get("/news/"+id);
    }

    function getEmptyNews(){
     return {"data": {
                "property_id":StorageService.getProperty().id,
                "title":"",
                "areas":[],
                "all_areas":false,
                "category_id":"",
                "publication_date": new Date(),
                "expiration_date":new Date()}
              };
    }

    function getCategories(){
      return ApiService.get("/news/categories");
    }

    function save(news){
      if (news.id) {
        return ApiService.put('/news/'+news.id, news);
      } else {
        return ApiService.post('/news', news);
      }
    }

    function deleteNews(id){
      return ApiService.delete('/news/'+id);
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.cast.news').controller('NewsAddEditController', NewsAddEditController);
  
  function NewsAddEditController($state, $scope, $controller, news, categories, NgTableParams, NewsService, areas, NotificationService) {
    var vm = this;

    vm.data = news.data;
    vm.categories = categories.data;
    vm.data.all_areas = (vm.data.all_areas == 1); 
    vm.addArea = addArea;
    vm.deleteAreaSelected = deleteAreaSelected
    vm.areas = areas.data.map(function(area) {
      return {"name":area.name};
    });
    vm.publication_date = new Date(vm.data.publication_date);
    vm.expiration_date = new Date(vm.data.expiration_date);
    vm.publication_date.setHours(vm.publication_date.getHours() - (new Date().getTimezoneOffset() / -60));
    vm.expiration_date.setHours(vm.expiration_date.getHours() - (new Date().getTimezoneOffset() / -60));


    vm.table = new NgTableParams({}, {dataset: vm.data.areas});

    vm.openPicker = openPicker;
    vm.format = 'yyyy-MM-dd';
    vm.options = {
      showWeeks: false
    };

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl            : 'cast.news-list', 
        formatData     : function(data){
          data.areas = data.areas.map(function(area) {return area.name});
          data.publication_date = formatDate(vm.publication_date);
          data.expiration_date = formatDate(vm.expiration_date);
        },   
      }, service : NewsService,
      scope: $scope
    }))

    function openPicker(e,picker) {
      vm[picker] = true;
    }

    function addArea(){

      if(!(areaSelected(vm.areaSelected))){
        vm.data.areas.push(vm.areaSelected);
        vm.areaSelected = undefined;
        vm.table = new NgTableParams({}, {dataset: vm.data.areas});
      }
    }

    function areaSelected(area){
      var areaSelected = false;
      vm.data.areas.forEach(function(item) {
        if(item.name == area.name){
          areaSelected = true
        }
      });
      return areaSelected
    }

    function formatDate(date){
      var month = (date.getMonth()+1);
      if(month<10){
        month = '0' + month
      }
      return date.getFullYear()+'-'+ month + '-' + date.getDate()
    }


    function deleteAreaSelected(area){
      vm.data.areas = vm.data.areas.filter(function(item) { 
        return item.name !== area.name;
      })
      vm.table = new NgTableParams({}, {dataset: vm.data.areas});
      vm.table.reload();
    }

  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.cast.receivers').controller('AddReceiverController', AddReceiverController);
  
  function AddReceiverController($state, $uibModalInstance, $uibModal, ReceiversService, ApiService,
    AreasService, AreaTypesService, StorageService, dataAreas, areaTypes, NotificationService, receiver, types) {

    var vm = this;

    vm.receiver                   = receiver;
    vm.areaTypes                  = areaTypes.data;
    vm.types                      = types.data;   
    vm.basicValidation            = basicValidation;
    vm.basicValidationWithSvError = basicValidationWithSvError;
    vm.cleanSvError               = cleanSvError;
    vm.showServerError            = showServerError;
    vm.haveServerError            = haveServerError;
    vm.errorsSv                   = {};
    vm.assign                     = assign;
    vm.cancel                     = cancel;
    vm.inputs                     = ['hdmi1', 'hdmi2', 'hdmi3', 'hdmi4'];
    vm.changeType                 = changeType;
    vm.isChromecastInputRequired  = isChromecastInputRequired;
    vm.isSmartTVIPAddressRequired = isSmartTVIPAddressRequired;
    vm.areaExist                  = areaExist;
    vm.areaTypeExist              = areaTypeExist;
    vm.createArea                 = createArea;
    vm.createAreaType             = createAreaType;
    vm.areas                      = dataAreas.data;
    vm.areaTypeChanged            = areaTypeChanged;
    vm.shouldCreateAreaTypeButton = shouldCreateAreaTypeButton;

    checkIfIShouldArea();

    function changeType() {
      if (vm.receiver.type != 'Google Chromecast v1.0 + Smart TV') {
        vm.receiver.chromecast_input = null;
        vm.receiver.smart_tv_ip_address = null;
      }
    }

    function areaTypeChanged(areaType){ 
      if(areaType.id){
        vm.receiver.area_type.id = areaType.id
      }
    }

    function shouldCreateAreaTypeButton() {
      return vm.areaTypeExist()||vm.receiver.area_type.name=="";
    }

    function createArea() {
      AreasService.save(
        {
          "name":vm.receiver.area_name.name,
          "property_id":StorageService.getProperty().id,
          "area_type_id":vm.receiver.area_type.id
        }
      ).then(function(data){
          vm.areas.push({"name":vm.receiver.area_name.name})
          vm.receiver.area_name.isFreeText = false;
          NotificationService.success('Area added', 'Success');
        },function(error){
          NotificationService.error('Area cannot be added', 'Error')
        })
    }

    function createAreaType() {
      AreaTypesService.save({"name":vm.receiver.area_type.name,"property_id":StorageService.getProperty().id}).then(function(data){
          vm.areaTypes.push(data.data)
          vm.receiver.area_type.isFreeText = false;
          vm.receiver.area_type.name = vm.receiver.area_type.name;
          vm.receiver.area_type.id = data.data.id;
          NotificationService.success('Area Type added', 'Success');
        },function(error){
          NotificationService.error('Area Type cannot be added', 'Error')
        })
    }


    function areaExist() {
      return vm.areas.some(function(area){return vm.receiver.area_name && area.name==vm.receiver.area_name.name.toUpperCase()});
    }

    function areaTypeExist() {
      return vm.areaTypes.some(function(areaType){return vm.receiver.area_type && areaType.name==vm.receiver.area_type.name.toLowerCase()});
    }

    function checkIfIShouldArea() {
      if(vm.areas.some(function(area){return area.name==vm.receiver.name.toUpperCase()})){
        vm.receiver.area_name = {"name" : vm.receiver.name.toUpperCase()}
      } 
    }

    function basicValidation(form, field) {
      return field && field.$invalid && (field.$dirty || form.$submitted)
    }

    function basicValidationWithSvError(form, field, fieldName) {
      return (field.$invalid && (field.$dirty || form.$submitted) ) || (vm.errorsSv[fieldName]? vm.errorsSv[fieldName].length : false)
    }

     function cleanSvError(fieldName) {
      vm.errorsSv[fieldName] = [];
    }

    function haveServerError(field) {
      return vm.errorsSv[field] !== undefined;
    }

    function showServerError(field){
      var message = vm.errorsSv[field]? vm.errorsSv[field][0] : "";
      return message;
    }

    function isChromecastInputRequired() {
      return (vm.receiver.type == 'Google Chromecast v1.0 + Smart TV');
    }

    function isSmartTVIPAddressRequired() {
      return (vm.receiver.type == 'Google Chromecast v1.0 + Smart TV');
    }

    function assign(form) { 
      if (form.$valid) {
        var dataToSend = angular.copy(vm.receiver);
        dataToSend.property_id = StorageService.getProperty().id;
        dataToSend.area_name = dataToSend.area_name.name;
        ReceiversService.save(dataToSend).then(function(data){
          NotificationService.success('Receiver added', 'Success');
          $uibModalInstance.close();
        }, function(data){
          vm.errorsSv = data.data.data.errors? data.data.data.errors : {}
          NotificationService.error('Receiver cannot be added', 'Error');
        });
      }
    }

    function cancel() {
      $uibModalInstance.close();
    }

  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.cast.receivers').controller('ReceiversController', ReceiversController);

  function ReceiversController($controller, $rootScope, $scope, $uibModal, $timeout, NgTableParams, ApiService,
    NotificationService, StorageService, ReceiversService, types, apps, websocketUrl, $location, $window) {
    var fields = ['name', 'area_name', 'type', 'ip_address', 'smart_tv_ip_address', 'mac_address', 'smart_tv_mac_address', "uuid", "state"];
    var vm = this;
    vm.types              = types.data;
    vm.refreshTokens      = refreshTokens;
    vm.restart            = restart;
    vm.reboot             = reboot;
    vm.getState           = getState;
    vm.goToIndications    = goToIndications;
    vm.apps               = apps.data
    vm.receiverIsOn       = receiverIsOn;
    vm.add                = add;
    var suggestedValues   = { type : vm.types, state : vm.apps};
    vm.receiverStates     = [];
    vm.discoveryDisable   = true;	  

    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'receivers',
        fieldsToFilter : fields,
        postDelete : function(id){
          refreshDiscovery();
        },
        preProcessData : function(data){
          var uuids = data.map(function(x){return x.uuid});
          ReceiversService.getCurrentStates(uuids).then(function(states){
              vm.receiverStates = states.data;
              //for test

              data.map(function(receiver){
                receiver["isOn"]  = receiverIsOn(receiver.uuid);
                receiver["state"] = getState(receiver.uuid);
                return receiver;
              });
          });
          ReceiversService.getLastApp(uuids).then(function(states){
              vm.lastApps = states.data;

              data.map(function(receiver){
                receiver["last_date"]  = receiverLastDate(receiver.uuid);
                return receiver;
              });
          });
          return data;
        },
        staticFilters  : {'property_id': function(){
          return StorageService.getProperty().id;
        }}
      }, scope : $scope
    }));
    vm.availableSearchParams = vm.generateParams(fields, suggestedValues);
    vm.refreshTable = refreshTable;

    //*****************//
    //*** WEBSOCKET ***//
    //*****************//
    var socket = io(websocketUrl+'/'+getSubdomain());

    socket.on('connect', function() {
      socket.emit('subscribe-to-property', StorageService.getProperty().id);
    });
    socket.on('disconnect', function() {
    });

    socket.on('new-cast-status', function(data) {
      $scope.$evalAsync(function($scope) { // Esta función actualiza la vista
          vm.table.data = updateState(vm.table.data,data)
        })
    });

    $scope.$on('$destroy', function(event) {
      socket.close();
    });


    ReceiversService.discovery().then(function(data){
      vm.discoveryReceivers = data.data.casts;
      vm.discoveryTable     = new NgTableParams({}, { dataset: vm.discoveryReceivers});
      vm.discoveryDisable   = false;
    },function(error){
      vm.discoveryTable     = new NgTableParams({}, { dataset: []})
      NotificationService.error('Receivers cannot be loaded', 'Error');
    });

    function refreshTokens() {
      ApiService.post('/receivers/token-refresh', { property_id: StorageService.getProperty().id }).then(function(data){
        NotificationService.success('Token refresh request sent', 'Success');
      }, function(data){
        NotificationService.error('The token refresh request could not be made', 'Error');
      });
    }

    function restart(receiver){
      ApiService.post('/receivers/restart-app', receiver).then(function(data){
          NotificationService.success('Element restarted', 'Success');
      }, function(data){
          NotificationService.error('Element cannot be restarted', 'Error');
      });
    }

    function updateState(data,newState){
      data = data.map(function(receiver){
        if(receiver.id==newState.receiver_id){
          if(newState.to){
            receiver.state     = 'Off';
            receiver.isOn      = false;
          } else {
            receiver.state     = newState.app;
            receiver.isOn      = true;
            receiver.last_date = newState.from
            NotificationService.info('Receiver ' + receiver.name + ' has new state: ' + receiver.state, 'New State');          
          }        }
        return receiver
      })
      return data
    }

    function reboot(receiver){
      ApiService.post('/receivers/reboot', receiver).then(function(data){
          NotificationService.success('Element rebooted', 'Success');
      }, function(data){
          NotificationService.error('Element cannot be rebooted', 'Error');
      });
    }

    $scope.$on("propertyChanged", function(){
      vm.refreshTable()
    });

    function getState(uuid){
      var receiver = vm.receiverStates.find(receiverOn(uuid))

      if(receiver == undefined){
        return "Off"
      }
      return receiver.app
    }

    function refreshTable(){
      vm.table.reload();
      refreshDiscovery();
    }

    function refreshDiscovery(){
      ReceiversService.discovery().then(function(data){
        vm.discoveryReceivers = data.data.casts;
      })
    }

    function getSubdomain(){
       var host = $location.host();
        if (host.indexOf('.') < 0) 
            return null;
        else
            return host.split('.')[0];
    }

    function receiverIsOn(uuid){
      return vm.receiverStates.some(receiverOn(uuid))
    }

    function receiverLastDate(uuid) {
      var lastApp = vm.lastApps.find(function(app){
        return app.uuid == uuid;
      })
      if(lastApp){
        return lastApp.to? lastApp.to : lastApp.from; 
      } else {
        return ''
      }
    }

    function receiverOn(uuid){
      function receiverHasSameUUIDAndToIsEmpty(receiver) {
        return receiver.uuid == uuid;
      }

      return receiverHasSameUUIDAndToIsEmpty;
    }

    function add(receiver){
      openModal(receiver);
    }

    function goToIndications(uuid){
      var property = StorageService.getProperty();
      $window.open(property.instance_url + '/indications/to-chromecast?uuid=' + uuid);
    }

    function openModal(receiver){

      var modalInstance = $uibModal.open({
        animation: true,
        windowClass: 'modal',
        title: 'Add Receiver',
        templateUrl: 'app/modules/cast/receivers/addReceiverModal.html',
        controller: 'AddReceiverController',
        controllerAs: 'vm',
        resolve: {
          dataAreas: function(AreasService){
            return AreasService.getAllWithoutPagination();
          },
          receiver: function(){
            return angular.copy(receiver);
          },
          types: function(ReceiversService){
            return ReceiversService.getReceiversTypes();
          },
          areaTypes: function (AreaTypesService) {
            return AreaTypesService.getAllWithoutPagination();
          }
        }
      });

      modalInstance.result.then(function(){
          vm.refreshTable();
        });
    }

  }

})();

(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('ReceiversService',ReceiversService);

  function ReceiversService(StorageService, ApiService) {

    var instance = {};

    instance.getAll            = getAll;
    instance.get               = get;
    instance.save              = save;
    instance.getEmptyReceiver  = getEmptyReceiver;
    instance.getApps           = getApps;
    instance.getReceiversTypes = getReceiversTypes;
    instance.delete            = deleteReceiver;
    instance.getStates         = getStates;
    instance.getCurrentStates  = getCurrentStates;
    instance.getBackdropCount  = getBackdropCount;
    instance.getOnCount        = getOnCount;
    instance.discovery         = discovery;
    instance.getLastApp        = getLastApp;

    function getAll(all){
      var uri = "/receivers?property_id=" + StorageService.getProperty().id;
      if (all) {
        uri = uri + "&pagination=disable";
      }
      return ApiService.get(uri);
    }

    function get(id){
      return ApiService.get("/receivers/" + id);
    }

    function getLastApp(uuids) {
      return ApiService.get('/public/es/receiver-state/last-apps?property_id=' + StorageService.getProperty().id + '&uuids=' + uuids + '&token=' + StorageService.getProperty().token).then(function(data){return data},function(error){return {data:[]}});
    }

    function getEmptyReceiver(){
     return { "data":{ 
                "property_id":StorageService.getProperty().id,
                "name":"",
                "area_name":"",
                "type":"",
                "uuid":""
              }
            };
    }

    function getApps(){
     return ApiService.get('/public/es/receiver-state/apps?property_id=' + StorageService.getProperty().id + '&token=' + StorageService.getProperty().token).then(function(data){return data},function(error){return {data:[]}});
    } 

    function save(receiver){
      if (receiver.id) {
        return ApiService.put('/receivers/'+receiver.id, receiver);
      } else {
        return ApiService.post('/receivers', receiver);
      }
    }

    function getReceiversTypes(){
      return ApiService.get("/receivers/types");
    }

    function getStates(){
      return ApiService.get("/public/es/receiver-state?property_id=" + StorageService.getProperty().id + '&token=' + StorageService.getProperty().token).then(function(data){return data},function(error){return {data:[]}});
    }

    function getCurrentStates(uuids){
      return ApiService.get('/public/es/receiver-state/current-apps?property_id=' + StorageService.getProperty().id + '&uuids=' + uuids + '&token=' + StorageService.getProperty().token).then(function(data){return data},function(error){return {data:[]}});
    }

    function getBackdropCount(uuids){
      return ApiService.get('/public/es/receiver-state/backdrop-count?property_id=' + StorageService.getProperty().id + '&token=' + StorageService.getProperty().token).then(function(data){return data});
    }

    function getOnCount(uuids){
      return ApiService.get('/public/es/receiver-state/on-count?property_id=' + StorageService.getProperty().id + '&token=' + StorageService.getProperty().token).then(function(data){return data});
    }

    function deleteReceiver(id){
      return ApiService.delete('/receivers/'+id);
    }

    function discovery() {
      return ApiService.get('/receivers/discovery/'+StorageService.getProperty().id);
    }


    return instance;
  }

})();

(function() {

  'use strict';

  angular.module('GoCloudCast.modules.cast.receivers').controller('ReceiversAddEditController', ReceiversAddEditController);
  
  function ReceiversAddEditController($state, $scope, receiver, $controller, $uibModal, areas, types, areaTypes,
    ReceiversService, AreasService, AreaTypesService, StorageService, NotificationService) {
    var vm = this;

    vm.areaTypes                  = areaTypes.data;
    vm.areaTypesNames             = vm.areaTypes.map(function(areaType){return areaType.name})  
    vm.data                       = receiver.data;
    vm.data.area_name             = {"name":vm.data.area_name};
    vm.data.area_type             = {"name":""};
    vm.areas                      = areas.data;
    vm.types                      = types.data;
    vm.inputs                     = ['hdmi1', 'hdmi2', 'hdmi3', 'hdmi4'];
    vm.changeType                 = changeType;
    vm.isTVType                   = isTVType;
    vm.refreshAreas               = refreshAreas;
    vm.areaExist                  = areaExist;
    vm.areaTypeExist              = areaTypeExist;
    vm.createArea                 = createArea;
    vm.createAreaType             = createAreaType;
    vm.shouldCreateAreaButton     = shouldCreateAreaButton;
    vm.shouldCreateAreaTypeButton = shouldCreateAreaTypeButton;
    vm.areaTypeChanged            = areaTypeChanged;

    function changeType() {
      if (vm.data.type != 'Google Chromecast v1.0 + Smart TV') {
        vm.data.chromecast_input = null;
        vm.data.smart_tv_ip_address = null;
      }
    }

    function areaTypeChanged(areaType){ 
      if(areaType.id){
        vm.data.area_type.id = areaType.id
      }
    }

    function shouldCreateAreaButton() {
      return vm.areaExist()||vm.data.area_name.name==""||!vm.data.area_type.id;
    }

    function shouldCreateAreaTypeButton() {
      return vm.areaTypeExist()||vm.data.area_type.name=="";
    }

    function createArea() {
      AreasService.save({
        "name":vm.data.area_name.name,
        "property_id":StorageService.getProperty().id,
        "area_type_id":vm.data.area_type.id}).then(function(data){
          vm.areas.push(data.data)
          vm.data.area_name.isFreeText = false;
          NotificationService.success('Area added', 'Success');
        },function(error){
          NotificationService.error('Area cannot be added', 'Error')
        })
    }

    function createAreaType() {
      AreaTypesService.save({"name":vm.data.area_type.name,"property_id":StorageService.getProperty().id}).then(function(data){
          vm.areaTypes.push(data.data)
          vm.data.area_type.isFreeText = false;
          vm.data.area_type.name = vm.data.area_type.name;
          vm.data.area_type.id = data.data.id;
          NotificationService.success('Area Type added', 'Success');
        },function(error){
          NotificationService.error('Area Type cannot be added', 'Error')
        })
    }

    function areaExist() {
      return vm.areas.some(function(area){return vm.data.area_name && area.name==vm.data.area_name.name.replace(/ /g,"_").toUpperCase()});
    }

    function areaTypeExist() {
      return vm.areaTypes.some(function(areaType){return vm.data.area_type && areaType.name==vm.data.area_type.name.replace(/ /g,"_").toLowerCase()});
    }

    function areaTypeExist() {
      return vm.areaTypes.some(function(areaType){return vm.data.area_type && areaType.name==vm.data.area_type.name.toLowerCase()});
    }

    function isTVType() {
      return (vm.data.type == 'Google Chromecast v1.0 + Smart TV');
    }

    function refreshAreas() {
      AreasService.getAllWithoutPagination().then(function(data){
        vm.areas = data.data
      })
    }

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl : 'cast.receivers-list',
        formatData   : function(data){        
          data.area_name = data.area_name.name.replace(/ /g,"_").toUpperCase();
        } 
      }, service : ReceiversService,
      scope: $scope
    }))

  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.cast.senders').controller('SendersController', SendersController);
  
  function SendersController(ngDialog, $uibModal, $controller, $scope, $rootScope, areas, configs, StorageService, SendersService, AreasService, NotificationService) {
    var vm = this;

    var fields = [
      'ip_address',
      'mac_address',
      'area_name',
      'name'
    ];

    vm.changeArea = changeArea;

    vm.openModal = openModal;

    vm.configs = configs.data;
    vm.areas = areas.data.map(function(x){
      return x.name;
    });

    vm.revoke     = revoke;
    vm.enableMDNS = enableMDNS;
    vm.getPlatformIcon = getPlatformIcon;
    vm.getBrowserIcon  = getBrowserIcon;
    vm.isUnmanaged = isUnmanaged;

    vm.revokePressed = false;
    vm.mdnsPressed   = false;

    vm.areaselected = '';

    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'senders',
        fieldsToFilter : fields,
        staticFilters: {'property_id': function(){
                          return StorageService.getProperty().id;
                        },
                        'area_name': function(){
                            return vm.areaselected;
                        }}
      },scope : $scope
    }));
    vm.availableSearchParams = vm.generateParams(fields);
    $scope.$on("propertyChanged", function(){
      vm.table.reload();
      vm.areaselected = undefined;
    });
    
    function getPlatformIcon(platform){
      switch (platform) {
        case 'androidos':
          return "fa-android";
        case 'ios':
          return "fa-apple";
        default:
          return 'fa-' + platform;
      }
    }
    
    function getBrowserIcon(browser){
      switch (browser) {
        case 'mozilla':
          return "fa-firefox";
        case '0':
          return "fa-globe";
        case null:
          return "fa-globe";
        default:
          return 'fa-' + browser;
      }
    }

    function isUnmanaged(){
      return vm.configs.web.GUEST_ROUTER_TYPE.toLowerCase() == "unmanaged"
    }

    function openModal(){
      var modalInstance = $uibModal.open({
        animation: true,
        windowClass: 'modal',
        title: 'Sender Manual Assignment',
        templateUrl: 'app/modules/cast/senders/sendersManualAssignment.html',
        controller: 'SendersManualAssignmentController',
        controllerAs: 'vm',
        resolve: {
          dataAreas: function(AreasService){
            return AreasService.getAllWithoutPagination();
          },
          platforms: function(SendersService){
            return SendersService.getSenderPlatforms();
          }
        }
      });

      modalInstance.result.then(function(){
          vm.table.reload();
        });
    }

    function revoke(senderId){
      vm.revokePressed = true;
      SendersService.manualRevoke(senderId).then(function(data){
        NotificationService.success('Device revoked', 'Success');
        vm.table.reload();
        vm.revokePressed = false;
      }, function(data){
        NotificationService.error('Device cannot be revoked', 'Error');
        vm.revokePressed = false;
      });
    }

    function changeArea() {
      vm.table.reload();
    }

    function enableMDNS(senderId) {
      vm.mdnsPressed = true;
      SendersService.enableMDNS(senderId).then(function(data){
        NotificationService.success('MDNS Enabled', 'Success');
        vm.table.reload();
        vm.mdnsPressed = false;
      }, function(data){
        NotificationService.error('MDNS cannot be revoked', 'Error');
        vm.mdnsPressed = false;
      });
    }
  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('SendersService',SendersService);

  function SendersService(StorageService, ApiService) {

    var instance = {};

    instance.getSenders             = getSenders;

    instance.getSender              = getSender;

    instance.getEmptyAssignmentData = getEmptyAssignmentData;

    instance.getSenderPlatforms    = getSenderPlatforms;

    instance.manualAssignment       = manualAssignment;

    instance.manualRevoke           = manualRevoke;

    instance.enableMDNS             = enableMDNS;

    function getSenders(){
      return ApiService.get('/senders?property_id=' + StorageService.getProperty().id);
    }

    function getSender(id){
      return ApiService.get('/senders/' + id);
    }

    function getEmptyAssignmentData(){
     return {
              "ip_address":"",
              "area_name":"",
              "platform": ""
            };
    }

    function getSenderPlatforms(){
      return ApiService.get("/senders/platforms");
    }

    function manualAssignment(assignmentData){
      assignmentData.property_id = StorageService.getProperty().id;
      return ApiService.post('/senders/manualAssignment', assignmentData);
    }

    function manualRevoke(senderId){
      var revokeData = {
        "property_id" : StorageService.getProperty().id,
        "id" : senderId
      }
      return ApiService.post('/senders/manualRevoke', revokeData);
    }

    function enableMDNS(senderId){
      var data = {
        "property_id" : StorageService.getProperty().id,
        "id" : senderId
      }
      return ApiService.post('/senders/enable-mdns', data);
    }


    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.cast.senders').controller('SendersManualAssignmentController', SendersManualAssignmentController);
  
  function SendersManualAssignmentController($state, $uibModalInstance, $uibModal, dataAreas, platforms, SendersService, NotificationService) {
    var vm = this;

    vm.basicValidation = basicValidation;
    vm.assign          = assign;
    vm.cancel          = cancel;
    vm.assignmentData  = SendersService.getEmptyAssignmentData();
    vm.areas           = dataAreas.data.map(function(x){
                                  return x.name;
                         });
    vm.platforms       = platforms.data; 

    function basicValidation(form, field) {
      return field && field.$invalid && (field.$dirty || form.$submitted)
    }

    function assign(form) {
      if (form.$valid) {
        SendersService.manualAssignment(vm.assignmentData).then(function(data){
          NotificationService.success('Device assigned', 'Success');
          $uibModalInstance.close();
        }, function(data){
          NotificationService.error('Device cannot be assigned', 'Error');
        });
      }
    }

    function cancel() {
      $uibModalInstance.close();
    }

  }

})();
(function () {
	'use strict';
  
	var translations = {
		"CITIES": {
			"NEW"  				 : "Add City",
			"NAME" 				 : "Name",
			"COUNTRY"			 : "Country",
			"TIMEZONE"			 : "Timezone",
			"COUNTRY_NOT_EXIST"  : "The country doesn't exist.",
			"TIMEZONE_NOT_EXIST" : "The timezone doesn't exist.",
	  } 
  
	}
  
	angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
	  translatePluggableLoaderProvider.translations('EN', translations)
	})
  
  })();
(function () {
  'use strict';

  var translations = {
  	"CONFIGS": {
      "ORCHESTATION_GUEST_INTERFACE"          : "guest interface",
      "ORCHESTATION_CAST_INTERFACE"           : "cast interface",
      "ORCHESTATION_LOG_IP_ADDRESS"           : "log ip address",
      "ORCHESTATION_UNMANAGED_GUEST_ROUTER"   : "unmanaged guest router", 
      "LAUNCHER_APP_GOCLOUDCAST"              : "splashpage",
      "LAUNCHER_LOAD_URL"                     : "load url",
      "LAUNCHER_CAST_API_TOKEN"               : "Cast api token",                 
      "LAUNCHER_CAST_API_URL"                 : "Cast api url",                                     
      "WEB_GUEST_ROUTER_TYPE"                 : "Guest router type",
      "WEB_GUEST_ROUTER_HOST"                 : "Guest router host",                
      "WEB_GUEST_ROUTER_USERNAME"             : "Guest router username",
      "WEB_GUEST_ROUTER_PASSWORD"             : "Guest router password",
      "WEB_INDICATIONS_TEMPLATE"              : "Indications template",                          
      "WEB_CODE_EXPIRATION_TIME"              : "Code expiration time",                                    
      "WEB_TRANSPORT_EMAIL"                   : "Transport email",                                    
      "WEB_TRANSPORT_EMAIL_USERNAME"          : "Username",                                    
      "WEB_TRANSPORT_EMAIL_PASSWORD"          : "Password",                                    
      "WEB_TRANSPORT_EMAIL_DOMAIN"            : "Domain",                                    
      "WEB_TRANSPORT_EMAIL_PROTOCOL"          : "Protocol",                                    
      "WEB_TRANSPORT_EMAIL_PORT"              : "Port",                                    
      "WEB_TRANSPORT_EMAIL_SECURITY"          : "Security",                                    
      "GENERAL_MIKROTIK_HOST"                 : "Mikrotik host",                              
      "GENERAL_MIKROTIK_TYPE"                 : "Mikrotik type",                             
      "GENERAL_MIKROTIK_USERNAME"             : "Mikrotik username",                            
      "GENERAL_MIKROTIK_PASSWORD"             : "Mikrotik password",
      "GENERAL_CAST_INTERFACE"                : "Interface",
      "GENERAL_CAST_IP_ADDRESS"               : "Ip Address",
      "GENERAL_CAST_NETMASK"                  : "Netmask",
      "GENERAL_CAST_SSID"                     : "SSID",
      "IPTV_IMAGE"                            : "Choose Image",
      "UPLOAD_IMAGE"                          : "Upload Image",
      "IMAGE_FORMAT_ACCEPTED"                 : "Please choose an accepted format: {{availableImageTypes}}.",
      "THE_IMAGE_IS_BIG"                      : "Please choose a smaller image. Less than {{maxAllowedSize}}MB.",           
      "SPLASH_IMAGE"                          : "Splash Image: ",
      "CHANGE_SPLASH_IMAGE"                   : "Change Splash Image"
    }

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
      
(function () {
  'use strict';
  angular.module('GoCloudCast.modules')
      .directive('basicFileInput', basicFileInput);
  function basicFileInput($timeout, FormValidates) {
    return {
      restrict: 'E',
      require: '^form',
      transclude: true,
      scope: {
        fileId: '@',
        label: '@',
        extensions: '@',
        model: '=',
        maxFile: '=?',
        widthInput: '@',
        disabled: '@?'
      },
      templateUrl: 'app/modules/directives/basicFileInput/basicFileInput.html',
      link: function(scope, element, attrs, controller) {
        $timeout(function() {
          scope.idform         = controller[scope.fileId];
          scope.form           = controller;
          scope.add            = add;
          scope.formValidates  = FormValidates;
          scope.extensionsList = scope.extensions.split(',');
          scope.accept         = scope.extensionsList.map(function(extension) {
            return '.' + extension;
          }).join();
        });

        function add() {
          scope.formValidates.customValidation(scope.form, scope.fileId, true, 'wrongExtension');

          var file       = document.getElementById(scope.fileId).files[0];
          var fileReader = new FileReader();
          var extn       = file.name.split(".").pop();
          
          if(scope.extensionsList.includes(extn)) {
            fileReader.onloadend = function(e) {
              scope.$apply(function() {
                scope.model = e.target.result;
              });
            }
          } else {
            scope.formValidates.customValidation(scope.form, scope.fileId, false, 'wrongExtension');
          }

          fileReader.readAsDataURL(file);
        }
      }
    };
  }
})();

(function(){
  'use strict';

  angular.module('GoCloudCast.modules').directive('adfWidget', adfWidget);
  
  function adfWidget(dashboard) {// 
    
    function preLink($scope, $element, $attr){
      var w = dashboard.widgets[$scope.definition.type];
      $scope.widget = angular.copy(w);
    }

    return {
      replace: true,
      restrict: 'E',
      template: ''+
      '<div class="widget">' +
        '<adf-widget-content model="definition" content="widget" start="start" end="end" type="type"></adf-widget-content>' +
      '</div>',
      scope: {
        definition: '=',
        start: '=',
        end: '=',
        type: '='
      },
      compile: function($element, $attr, transclude) {
        return {
          pre: preLink
        };
      }
    };

  }
})();


(function(){
  'use strict';

      /*
     * The MIT License
     *
     * Copyright (c) 2013, Sebastian Sdorra
     *
     * Permission is hereby granted, free of charge, to any person obtaining a copy
     * of this software and associated documentation files (the "Software"), to deal
     * in the Software without restriction, including without limitation the rights
     * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
     * copies of the Software, and to permit persons to whom the Software is
     * furnished to do so, subject to the following conditions:
     *
     * The above copyright notice and this permission notice shall be included in
     * all copies or substantial portions of the Software.
     *
     * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
     * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
     * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
     * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
     * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
     * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
     * SOFTWARE.
     */

  angular.module('GoCloudCast.modules').directive('adfWidgetContent', adfWidgetContent)

  function adfWidgetContent($log, $q, $sce, $http, dashboard, $templateCache, $compile, $controller, $injector) {//

    function getTemplate(widget){
        var deferred = $q.defer();

        if ( widget.template ){
            deferred.resolve(widget.template);
        } else if (widget.templateUrl) {
            var url = $sce.getTrustedResourceUrl(widget.templateUrl);
            $http.get(url, {cache: $templateCache})
                .success(function(response){
                    deferred.resolve(response);
                })
                .error(function(){
                    deferred.reject('could not load template');
                });
        }

        return deferred.promise;
    }

    function compileWidget($scope, $element) {
        var model = $scope.model;
        var content = $scope.content;

        // display loading template
        $element.html(dashboard.loadingTemplate);

        // create new scope
        var templateScope = $scope.$new();

        // pass config object to scope
        if (!model.config) {
            model.config = {};
        }

        templateScope.config = model.config;

        // local injections
        var base = {
            $scope: templateScope,
            widget: model,
            config: model.config
        };

        // get resolve promises from content object
        var resolvers = {};
        resolvers['$tpl'] = getTemplate(content);
        if (content.resolve) {
            angular.forEach(content.resolve, function(promise, key) {
                if (angular.isString(promise)) {
                    resolvers[key] = $injector.get(promise);
                } else {
                    resolvers[key] = $injector.invoke(promise, promise, base);
                }
            });
        }

        // resolve all resolvers
        $q.all(resolvers).then(function(locals) {
            angular.extend(locals, base);

            // compile & render template
            var template = locals['$tpl'];
            $element.html(template);
            if (content.controller) {
                var templateCtrl = $controller(content.controller, locals);
                $element.children().data('$ngControllerController', templateCtrl);
            }
            $compile($element.contents())(templateScope);
        }, function(reason) {
            // handle promise rejection
            var msg = 'Could not resolve all promises';
            if (reason) {
                msg += ': ' + reason;
            }
            $log.warn(msg);
            $element.html(dashboard.messageTemplate.replace(/{}/g, msg));
        });
    }

    return {
        replace: true,
        restrict: 'EA',
        transclude: false,
        scope: {
          model: '=',
          content: '=',
          start: '=',
          end: '=',
          type: '='
        },
        link: function($scope, $element, $attr) {
          $scope.$watchGroup(['start', 'end', 'type'], function() {
            Highcharts.charts.forEach(function(chart){
              if (chart) {
                chart.destroy();
              }
            });
            compileWidget($scope, $element);
          }, true);
          
          $scope.$on('widgetConfigChanged', function(){
            compileWidget($scope, $element);
          });
          $scope.$on('widgetReload', function(){
            compileWidget($scope, $element);
          });
        }
    };

  }
})(); 
(function(){
  'use strict';

  angular.module('GoCloudCast.modules').directive('dashboard', dashboard);
 
  function dashboard($rootScope, $timeout, $window){




    function resize(chart) {
      var elem = chart.container;
      var $elem = $(elem);
      var item = $elem.parents('li').scope().gridsterItem;
      chart.setSize(item.getElementSizeX()-10, item.getElementSizeY()-10)
    }

    function resizeChartsNext(){
      var f = function(){Highcharts.charts.forEach(function(current){ if (current) resize(current)});} 
      $timeout(function(){
        f();
        $timeout(function() {f()}, 2000);
      },600)
    }

    var template = '' +
      '<div >' +        
        '<div class="row" style="margin-left: 5px; margin-bottom: 15px">'+

          '<p class="col-md-2 input-group">' +
            '<input type="text" class="form-control" uib-datepicker-popup="{{dashboard.format}}" datepicker-options="dashboard.options" ng-model="dashboard.start_date" id="start_date" name="start_date" is-open="dashboard.start_date_open" ng-required="true" placeholder="Start Date Filter"  close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" />' +
            '<span class="input-group-btn">' +
              '<button type="button" class="btn btn-default" ng-click="dashboard.openPicker($event,' + "'start_date_open'" + ')"><i class="glyphicon glyphicon-calendar"></i></button>' +
            '</span>' +
          '</p>' +

          '<p class="col-md-2 input-group" style="margin-left: 25px">' +
            '<input type="text" class="form-control" popup-placement="bottom" uib-datepicker-popup="{{dashboard.format}}" datepicker-options="dashboard.options" ng-model="dashboard.end_date" id="end_date" name="end_date" is-open="dashboard.end_date_open" ng-required="true" placeholder="End Date Filter" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" />' +
            '<span class="input-group-btn">' +
              '<button type="button" class="btn btn-default" ng-click="dashboard.openPicker($event,' + "'end_date_open'" + ')"><i class="glyphicon glyphicon-calendar"></i></button>' +
            '</span>' +
          '</p>' +

          '<div class="col-md-3 ">' +
            '<ui-select ng-model="dashboard.areaselected"' +
              'name="type"' +
              'class="btn-group bootstrap-select form-control"' +
              'append-to-body="true"' +
              'search-enabled="false"' +
              'required>' +
              '<ui-select-match allow-clear="true" placeholder="Select Area Filter">' +
                '<span> {{$select.selected}}</span>' +
              '</ui-select-match>' +
              '<ui-select-choices repeat="area in dashboard.areas track by area| filter: $select.search">' +
                '<span ng-bind-html="area"></span>' +
              '</ui-select-choices>' +
              '<ui-select-no-choice>' +
                'No Areas found' +
              '</ui-select-no-choice>' +
            '</ui-select>' +
          '</div>' +  

          '<button class="btn btn-danger pull-right"  style="margin-right: 20px" ng-click="dashboard.clear()"> <i class="fa fa-times-circle fa-6"></i> Clear filters </button>' +

          '<button class="col-md-1 btn btn-primary pull-right" style="margin-right: 20px" ng-click="dashboard.filter()"> <i class="fa fa-sliders fa-6"></i> Filter</button>' +
          

        
        '</div>' +
        '<div id="gridsterContainer" gridster="dashboard.gridsterOptions">' +
          '<ul id="ul">' +
            '<li gridster-item="widget"  ng-repeat="widget in dashboard.widgets">' +
              '<div class="box">' +
                '<div class="box-content">' +
                  '<adf-widget definition="widget" start="dashboard.start" end="dashboard.end"></adf-widget>' +
                '</div>' +
              '</div>' +
            '</li>' +
          '</ul>' +
        '</div>' +
      '</div>';

    function dashboardController($scope, DashboardConfigurationInstance, AreasService){//DashboardConfigurationInstance
 
      var dashboard = this;


      $scope.$on("propertyChanged", function(){
        AreasService.getAllWithoutPagination().then(function(data){
          dashboard.areas = data.data.map(function(area){
            return area.name;
          }); 
        clear();
        filter();
        })
      });

      dashboard.changeConfigData = changeConfigData;
      dashboard.resetZoom        = resetZoom;
      dashboard.openPicker       = openPicker;
      dashboard.filter           = filter;
      dashboard.clear            = clear;

      dashboard.format = 'yyyy-MM-dd';
      
      dashboard.options = {
        showWeeks: false,
        appendToBody: true
      };

      dashboard.gridsterOptions = {
        margins: [10, 10],
        columns: 24,
        minSizeX: 3,
        minSizeY: 1,

        draggable: {
          handle: 'tspan'
        },
        resizable: {
          enabled: true,
          start : function(event, $element, widget) {},
          resize : function(event, $element,widget){
            if($element.find('#chartContainer').highcharts()){
              $element.find('#chartContainer').highcharts().setSize($element.width()-10, $element.height()-10)
            } else {
              $element.find('.panel').height($element.height()-10);
            } 
          },
          stop: function(event, $element, widget) {
            $timeout(function() {
              if($element.find('#chartContainer').highcharts()){
                $element.find('#chartContainer').highcharts().setSize($element.width()-10, $element.height()-10)
              } else {
                $element.find('.panel').height($element.height()-10);
              } 
              console.log('stop')
              $scope.$emit('resize');
            }, 400);
          }
        }
      }

      $timeout(function(){
        var elements = $( "li.ng-scope.gridster-item" ).get(  )
        if(elements.length){        
          updateWidgetsHeight(elements)
        } else {
          $timeout(function(){
            elements = $( "li.ng-scope.gridster-item" ).get(  )
            if(elements.length){        
              updateWidgetsHeight(elements)
            } 
          },300)
        }
      },600)

      function updateWidgetsHeight(elements){
        elements.forEach(function(element){
            if(!$(element).find('#chartContainer').highcharts()){
              $(element).find('.panel').height($(element).height()-10);
            }
          })
      }

      function openPicker(e,picker) {
        dashboard[picker] = true;
      }

      function filter(){
        DashboardConfigurationInstance.start_date = dashboard.start_date;
        DashboardConfigurationInstance.end_date   = dashboard.end_date;
        DashboardConfigurationInstance.area_name  = dashboard.areaselected;
        $rootScope.$broadcast('cDashboard-config-changed');
      }

      function clear(){
        dashboard.start_date    = undefined;
        dashboard.end_date      = undefined;
        dashboard.areaselected  = undefined;
        DashboardConfigurationInstance.start_date = undefined;
        DashboardConfigurationInstance.end_date   = undefined;
        DashboardConfigurationInstance.area_name  = undefined;
      }

      function resetZoom(){
        Highcharts.charts.forEach(function(chart){
          if (!!chart) chart.zoomOut()
        })
      }


      function changeConfigData(){
        DashboardConfigurationInstance.selected.zoomed = false;
        $rootScope.$broadcast('dashboard-config-changed')
      }

      $rootScope.$on('$translateChangeEnd', function(){
        resizeChartsNext()
      });

    }

    function cleanup(){
      angular.element($window).off('resize', resizeChartsNext);
    }

    function link($scope, $element, $attr) {
      resizeChartsNext();

      angular.element($window).on('resize', resizeChartsNext)
      $scope.$on('$destroy', cleanup);
    }

    return {
      replace: true,
      restrict: 'E',
      controller: dashboardController,
      controllerAs : 'dashboard',
      bindToController : true,
      link: link,
      scope: {
        widgets : '=',
        areas : '='
      },
      template: template 
    };
  }
})();
(function () {
  'use strict';

  angular.module('GoCloudCast.modules').directive('signalStrengthOverviewDashboard', signalStrengthOverviewDashboard);

  function signalStrengthOverviewDashboard() {
  	
  	return {
  	  restrict: 'E',
	    scope: {
	    	status: '=status'
	    },
	    controller: ['$scope',
        	function ($scope) {
        		$scope.signals = [
              {
                range       : "0 to -32 dBm",
                background  : "#33773e",
                color       : "#fff",
                quantity    : 22,
                description : "Maximum strength, potentially undesirable (one AP's power may be set too high, causing interface with  others)."
              },{
                range       : "-32 to -69 dBm",
                background  : "#99c95c",
                color       : "#fff",
                quantity    : 779,
                description : "Adequate strength for streaming video."
              },{
                range       : "0 to -32 dBm",
                background  : "#fbef67",
                color       : "#56554a",
                quantity    : 12,
                description : "Adequate strength for streaming video."
              },{
                range       : "0 to -32 dBm",
                background  : "#dd9752",
                color       : "#56554a",
                quantity    : 0,
                description : "Adequate strength for streaming video."
              },{
                range       : "0 to -32 dBm",
                background  : "#82252d",
                color       : "#fff",
                quantity    : 1,
                description : "Adequate strength for streaming video."
              }
            ];
          }
        ],
      templateUrl: 'app/modules/directives/signalStrengthOverview/signalStrengthOverviewDashboard.html'
    }
  }
 
 }());
(function () {
  'use strict';

  angular.module('GoCloudCast.modules').directive('sncStatusDashboard', sncStatusDashboard);

  function sncStatusDashboard() {
  	
  	return {
  	  restrict: 'E',
	  scope: {
	  	status: '=status'
	  },
	  controller: ['$scope',
      	function ($scope) {
      		$scope.posibleStatus = [
            {
              color       :"green",
              description :"Operational"
            },{
              color       :"yellow",
              description :"Notification"
            },{
              color       :"orange",
              description :"Warning"
            },{
              color       :"wine",
              description :"Critical"
            }
          ];
        }
      ],
  	  templateUrl: 'app/modules/directives/sncStatus/sncStatusDashboard.html'
  	};
  }
 
 }());
(function () {
  'use strict';

  angular.module('GoCloudCast.modules')
      .directive('uploadImage', uploadImage);

  function uploadImage($uibModal, $timeout) {
    return {
      restrict: 'E',
      templateUrl: 'app/modules/directives/uploadImage/uploadImage.html',
      transclude: true,
      scope: {
        id: '@',
        label: '@?',
        hoverText: '@?',
        model: '=',
        required: '=',
        resolutions: '=',
        url: '@',
        idModel: '=',
        imageUrl: '=',
        imageId:'@',
        noCrop:'=?',
        location: '@',
        withMessage: '=?',
        maxAllowedSize: '=?',
        availableImageTypes: '=?',
        onDeleteFn: '=?',
        onChangeFn: '=?',
        onUploadedFn: '=?',
        clearWhenFinishUpload: '=?',
        onChangeParam: '=?',
        uploadPermission: '@?',
        deletePermission: '@?',
        readOnly: '=?'
      },
      link: function(scope, element, attrs, controller) {
        scope.idform = controller[scope.id];
        scope.form = controller;
      },
      controller: function($scope, $element, $translate, $attrs, $parse, StorageService, ConfigurationVariablesService, ApiService, NotificationService){
        $scope.hasUploadPermission = 
          !$scope.uploadPermission || StorageService.getPermissions().contains($scope.uploadPermission);
        $scope.hasDeletePermission = 
          !$scope.deletePermission || StorageService.getPermissions().contains($scope.deletePermission);

        $scope.maxAllowedSize      = $element[0].attributes['max-allowed-size'] !== undefined ? $scope.maxAllowedSize : 0.5;
        $scope.availableImageTypes = $element[0].attributes['available-image-types'] !== undefined ? $scope.availableImageTypes : ".jpg, .jpeg, .png";
        $scope.withMessage         = $element[0].attributes['with-message'] !== undefined ? $scope.withMessage : false;
        $scope.label               = $element[0].attributes['label'] !== undefined ? $scope.label : $translate.instant('IMAGE.LABEL');
        $scope.hoverText           = $element[0].attributes['hover-text'] !== undefined ? $scope.hoverText : $translate.instant('IMAGE.HOVER_IMAGE');
        $scope.inLine              = $element[0].attributes['in-line'] !== undefined;
        $scope.onChangeParam       = $element[0].attributes['on-change-param'] !== undefined ? $scope.onChangeParam : $scope.model;
        $scope.readOnly            = $element[0].attributes['read-only'] !== undefined ? $scope.readOnly : false;
        $scope.clearWhenFinishUpload = $element[0].attributes['clear-when-finish-upload'] !== undefined ? $scope.clearWhenFinishUpload : false;
        $scope.accept              = $scope.availableImageTypes.replace(/\'/,'').replace(/\'/,'');

        $scope.isTheImageLarge = false;
        $scope.openModal       = openModal;
        $scope.clickOpenFile   = clickOpenFile;
        $scope.setFile         = setFile;

        var rawImage = {}; 

        init();

        function init() {
          $scope.imageBase64     = $scope.imageUrl ? $scope.imageUrl : "/assets/img/theme/no-image.png";
          $scope.isNoImage       = $scope.imageBase64.includes("no-image.png");
          $scope.resetImage      = resetImage;
        }

        function resetImage() {
            if($scope.idModel){
              ApiService.delete("/"+$scope.url+"/delete-image").then(function(data){
                $scope.model = null;
                $scope.isNoImage = true;
                $scope.imageBase64 = "/assets/img/theme/no-image.png";
                if($scope.onDeleteFn) { 
                  $scope.onDeleteFn($scope.idModel, $scope.imageBase64); 
                } 
                NotificationService.success('Image deleted', 'Success');
              }, function(error){
                NotificationService.error('Error cant delete image', 'Error');
              }); 
            } else {
              $scope.model = null;
              $scope.isNoImage   = true;
              $scope.imageBase64 = "/assets/img/theme/no-image.png";
            }
        }  

        function clickOpenFile(){
            if ($scope.hasUploadPermission && !$scope.readOnly) {
                var fileInput = document.getElementById($scope.imageId);
                fileInput.click();
            }
        }

        function setFile(element) {
            $scope.currentFile  = element.files[0];
            var reader          = new FileReader();
            
            reader.onload = function(event) {
                if (element.files && element.files[0]) {
                  if($scope.noCrop){
                    rawImage.image = reader.result;
                    rawImage.croppedImage = reader.result;
                    modalResultFn(rawImage);
                  }else{
                      $scope.openModal(element.files[0]);
                  }
                }
                element.value = "";
                $scope.$apply();
            }
            // when the file is read it triggers the onload event above.
            reader.readAsDataURL(element.files[0]);
        }

        function modalResultFn(data) {
          $scope.model       = data.image;
          $scope.imageBase64 = data.croppedImage;
          $scope.isNoImage   = false;
          if ($scope.onChangeFn) { 
            $scope.onChangeFn($scope.onChangeParam) 
          }

          if($scope.idModel){
              uploadImage({"image_base64": $scope.model, "id": $scope.idModel}).then(function(data){
              NotificationService.success('Image uploaded', 'Success');

              if ($scope.onUploadedFn) { 
                $scope.onUploadedFn(data); 
              }     

              if ($scope.clearWhenFinishUpload) { 
                init(); 
              }

            }, function(error){
              $scope.model = $scope.imageUrl;
              NotificationService.error('Error cant upload image', 'Error');
            });
          }
        }

        function openModal(image) {
            var modalInstance = $uibModal.open({
                animation: true,
                windowClass: 'modal',
                title: 'Edit Image',
        templateUrl: 'app/modules/templates/editImage.html',
        controller: 'EditImageController',
        //                templateUrl: 'app/modules/directives/uploadImage/modal/editImage.html',
        //        controller: 'EditImageController',
                controllerAs: 'vm',
                size: 'lg',
                backdrop: false,
                resolve: {
                    image: function(){
                        return image;
                    },
                    resolutions: function(){
                        return getResolutions();
                    },
                    aspectRatio: function(){
                        return getResolutions().ratio;
                    },
                    withMessage: function(){
                        return $scope.withMessage;
                    }
                }
            });
            modalInstance.result.then(function(data){
                if(data){
                  modalResultFn(data);
                }
            });
        }

        function getResolutions() {
          return $scope.resolutions;
        }

        function uploadImage(data){
          return ApiService.post("/" + $scope.url, data);
        }

      }
    };
  }

})();



(function() {

    'use strict';
  
    angular.module('GoCloudCast.modules.iptv.experiences').controller('ExperiencesController', ExperiencesController);
  
    function ExperiencesController($scope,$controller,StorageService) {
  
      var vm = this;

      var fields = ['name', 'date', 'area_name', 'media_type'];
  
      angular.extend(vm, $controller('abstractTable',{
        childProperties : {
          url            : 'experiences',
          staticFilters  : {'property_id': function(){
            return StorageService.getProperty().id;
          }},
          preProcessData  :  function(experiences) {
            experiences.forEach(function(experience) { 
              setAreaNames(experience);
            });
            return experiences;
          },
          fieldsToFilter : fields,
        },
        scope : $scope
      }));  
      vm.availableSearchParams = vm.generateParams(fields);

      $scope.$on("propertyChanged", function(){
        vm.table.reload();
      });

      function refreshTable(){            
        vm.table.reload();
      }

      function setAreaNames(experience) {
        experience.area_name = '';

        experience.areas.map(function(area) {
          if(experience.area_name === "") {
            experience.area_name  += area.name;
          }else {
            experience.area_name  +=  ", " + area.name;
          }
        });
      }
  
    
  }  
  })();            
(function(){
    'use strict';
    angular.module('GoCloudCast.modules').factory('ExperiencesService',ExperiencesService);
  
    function ExperiencesService(StorageService, ApiService,$q) {
     
      var instance = {};

      instance.getAll                  = getAll;
      instance.get                     = get;
      instance.save                    = save;
      instance.getEmptyExperience      = getEmptyExperience;
      instance.delete                  = deleteExperience;
      instance.getLanguages            = getLanguages;
      instance.updateExperienceDescriptions = updateExperienceDescriptions;
      instance.saveImage               = saveImage;
      instance.deleteExperience        = deleteExperience;
      instance.deleteExperienceImage   = deleteExperienceImage;
      instance.updateImage             = updateImage;
      instance.uploadExperienceVideo   = uploadExperienceVideo;
      instance.uploadExperienceAudio   = uploadExperienceAudio;
      instance.deleteExperienceAudio   = deleteExperienceAudio;
      //instance.getAllWithoutPagination = getAllWithoutPagination;
  
      function getAll(){
        return ApiService.get("/experiences");
      }
  
      function get(id){
        return ApiService.get("/experiences/"+id);
      }

      function getLanguages(){
        return ApiService.get("/languages");
      }
  
      function getEmptyExperience(){
       return {"data": {
                  "from": "",
                  "to": "",
                  "description": [],
                  "areas": [],
                  "all_areas": false,
                  "property_id":StorageService.getProperty().id,
                  "descriptions": [],
                  "images": [],
                }
              };
      }
  
   
  
      function save(experience){
        if (experience.id) {
          return ApiService.put('/experiences/'+experience.id, experience);
        } else {
          return ApiService.post('/experiences', experience);
        }
      }
  
      function deleteExperience(id){
        return ApiService.delete('/experiences/'+id);
      }

      function deleteExperienceImage(id){
        return ApiService.delete('/experience-images/'+id);
      }

      function updateExperienceDescriptions(descriptions) {
        return ApiService.put('/experiences/update-descriptions',{descriptions: descriptions})
      }

      function saveImage(experienceId,image_base64){
        var data = {
                    experience_id: experienceId,
                    image_base64: image_base64
        }
    
         return ApiService.post('/experience-image', data);
      }

      function updateImage(image) {
        console.log(image);
          return ApiService.put('/experience-images/'+image.id, image);
      }

      function uploadExperienceVideo(experienceId, file) {
        return ApiService.put('/experience-videos', {
          "video": file,
          "experience_id": experienceId,
          "property_id": StorageService.getProperty().id
        });
      }

      function uploadExperienceAudio(experienceId, file) {
        return ApiService.put('/experience-audios', {
          "audio": file,
          "experience_id": experienceId,
          "property_id": StorageService.getProperty().id
        });
      }

      function deleteExperienceAudio(experienceId) {
        return ApiService.delete('/experience-audios/'+experienceId);
      }
      
      return instance;
      
    }

  })();
(function () {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.experiences').controller('ExperiencesAddEditController', ExperiencesAddEditController);

  function ExperiencesAddEditController($scope, $interval, experience, ExperiencesService,
    $state, NotificationService, $controller, areas, AreasService, StorageService, NgTableParams, languages) {

    var vm = this;

    angular.extend(vm, $controller('abstractAddEdit', {
      childProperties: {
        stateUrl: 'iptv.experiences-list',
        formatData: function (data) {
          data.areas = data.areas.map(function (area) { return area.name });
          data.from = formatDate(vm.from_date);
          data.to = formatDate(vm.to_date);
       },
        postSave: function (data) {
          vm.experience = data.data;
          setAvailableAreas();
          initDescriptions();
        },
        noRedirect: true,
      },
      service: ExperiencesService,
      scope: $scope
    }));


    //forms
    vm.experienceVideoForm = {};
    vm.experienceDescriptionForm = {};

    //propiedades
    vm.experience = experience.data;
    vm.popover = {};
    vm.from_date_open = false;
    vm.to_date_open = false;
    vm.image_base64 = null;
    vm.experience.all_areas = (vm.experience.all_areas == 1);
    vm.experience.slide_delay = vm.experience.slide_delay || 3;
    vm.descriptions = {};
    vm.current_image = vm.experience.images.length > 0 ? vm.experience.images[0].image_url : null;
    vm.current_image_index = 0;

    vm.current_video = vm.experience.video_url ? vm.experience.video_url + "?t=" + new Date().getTime() : null;
    vm.current_audio = vm.experience.audio_url ? vm.experience.audio_url + "?t=" + new Date().getTime() : null;

    vm.from_date = new Date(vm.experience.from);
    vm.from_date.setHours(vm.from_date.getHours() - (new Date().getTimezoneOffset() / -60));

    vm.to_date = new Date(vm.experience.to);
    vm.to_date.setHours(vm.to_date.getHours() - (new Date().getTimezoneOffset() / -60));

    //funciones
    vm.updateExperienceImage = updateExperienceImage;
    vm.deleteImageSelected = deleteImageSelected;
    vm.deleteImage = deleteImage;
    vm.updateDescriptions = updateDescriptions;
    vm.onImageUploaded = onImageUploaded;
    vm.addArea = addArea;
    vm.deleteAreaSelected = deleteAreaSelected;
    vm.togglePopover = togglePopover;
    vm.enablePopover = enablePopover;
    vm.closePopover = closePopover;
    vm.openPicker = openPicker;
    vm.formatFontSelects = formatFontSelects;
    vm.deleteAudio = deleteAudio;
    vm.updateFontColor = updateFontColor;
    vm.setSlideDelay = setSlideDelay;

    //colecciones
    vm.allAreas = areas.data;
    vm.availableAreas = [];
    vm.languages = languages.data;
    vm.resolutions = { minWidth: 1280, minHeight: 720, maxWidth: 1920, maxHeight: 1080, ratio: 16/9 };
    vm.experienceDescriptionTypes = [ 'main_header', 'title', 'main_footer', 'footer_text1', 'footer_text2' ];

    vm.mediaTypes = [ 
      { code: 'image', name: 'Image and audio' },
      { code: 'video', name: 'Video' }
    ];

    vm.fontOptions = {
      family: [
        // Serif
        { name: 'Times New Roman', code: '"Times New Roman", serif' },
        { name: 'Georgia', code: '"Georgia", serif' },
        { name: 'Garamond', code: '"Garamond", serif' },
        // Sans-serif        
        { name: 'Arial', code: '"Arial", sans-serif' },
        { name: 'Verdana', code: '"Verdana", sans-serif' },
        { name: 'Helvetica', code: '"Helvetica", sans-serif' },
        // Monospace
        { name: 'Courier New', code: '"Courier New", monospace' },
        { name: 'Lucida Console', code: '"Lucida Console", monospace' },
        // Cursive
        { name: 'Brush Script MT', code: '"Brush Script MT", cursive' },
        // Custom
        { name: 'Sweet Sans Pro', code: '"Sweet Sans Pro", sans-serif' },
        { name: 'Hatton', code: '"Hatton", serif' },
        { name: 'Candlescript', code: '"Candlescript", cursive' },
        { name: 'Abhaya Libre', code: '"Abhaya Libre", serif' },
      ],
      size: [ 
        "8px", "10px", "12px", "14px", "16px", "18px", "20px", "24px", "28px", 
        "32px", "36px", "44px", "48px", "54px", "60px", "66px", "72px"
      ],
      weight: [ 'lighter', 'normal', 'bold', 'bolder' ],
      style: [ 'normal', 'italic', 'oblique' ]
    };


    setAvailableAreas();
    initDescriptions();
    setSlideDelay(vm.experience.auto_play);

    vm.areasTable = new NgTableParams({ count: vm.experience.areas.length}, { dataset: vm.experience.areas, counts: [] });
    vm.imagesTable = new NgTableParams({ count: vm.experience.images.length}, { dataset: vm.experience.images, counts: [] });

    function initDescriptions() {
      vm.experience.descriptions.forEach(function(description) {
        vm.descriptions[description.type] = angular.copy(description);

        var fontData = { family: { name: '', code: '' }, size: '', weight: '', style: '', color: {} };
        var languageData = {};

        if (description.font != undefined && description.font != "") {
          var font = description.font.split(' ');
          fontData.style = font[0];
          fontData.weight = font[1];
          fontData.size = font[2];

          var fontFamilyCode = font.slice(3).join(' ');

          var fontFamily = vm.fontOptions.family.find(function(fontFamily) {
            return fontFamily.code == fontFamilyCode;
          });

          if (fontFamily) {
            fontData.family = fontFamily;
          }
        }

        description.languages.forEach(function (language) {
            languageData[language.language_code] = language;
        });

        fontData.color = parseFontColor(vm.descriptions[description.type].font_color);
        fontData.minicolorsSettings = { opacity: true };
        
        vm.descriptions[description.type].fontData = fontData;
        vm.descriptions[description.type].languageData = languageData;

      });
    }

    function updateFontColor(description) {
      description.font_color =  formatFontColor(description.fontData.color.rgb, description.fontData.color.opacity); 
    }

    function formatFontSelects(description) {
      var fontData = description.fontData;
      description.font = fontData.style + ' ' + fontData.weight + ' ' + fontData.size + ' ' + fontData.family.code;
    }

    function openPicker(e, picker) {
      vm[picker] = true;
    };

    function formatDate(date) {
      var month = date.getMonth() + 1;
      month = (month < 10 ? '0' : '') + month;
      var day = date.getDate();
      day =  (day < 10 ? '0' : '') + day;
      return date.getFullYear() + '-' + month + '-' + day;
    }

    function addArea() {
      vm.experience.areas.push(vm.areaSelected);
      vm.areaSelected = undefined;
      setAvailableAreas();
    }

    function formatFontColor(hex, opacity) {
      if (!hex) return;
      opacity = opacity || 1;
      var c;
      if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
          c= hex.substring(1).split('');
          if(c.length== 3){
              c= [c[0], c[0], c[1], c[1], c[2], c[2]];
          }
          c= '0x'+c.join('');
          return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',' + opacity + ')';
      }
      throw new Error('Bad Hex');
    }

    function parseFontColor(rgba) {
      var result = { rgb: '#FFFFFF', opacity: 1 }; 
      if (rgba) {
        rgba = rgba.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?([\d\.]+)[\s+]?/i);
        if (rgba && rgba.length === 5) {
          result.rgb = "#" + 
             ("0" + parseInt(rgba[1],10).toString(16)).slice(-2) +
             ("0" + parseInt(rgba[2],10).toString(16)).slice(-2) +
             ("0" + parseInt(rgba[3],10).toString(16)).slice(-2);
           result.opacity = parseFloat(rgba[4]);
        }
      }

      return result;
    }

    function deleteAreaSelected(area) {
      vm.experience.areas = vm.experience.areas.filter(function (item) {
        return item.name !== area.name;
      })
      setAvailableAreas();
    }

    function setAvailableAreas() {
      var areaNamesSelected = vm.experience.areas.map(function(area) { return area.name; });
      vm.availableAreas = vm.allAreas.filter(function(area) {
        return !areaNamesSelected.includes(area.name);
      });
      vm.areasTable = new NgTableParams({ count: vm.experience.areas.length}, { dataset: vm.experience.areas, counts: [] });
    }

    function setSlideDelay(autoplay) {
      if (autoplay == true) return;
      vm.experience.slide_delay = 0;
    }

    function updateDescriptions(experienceDescriptionForm, descriptions) {
      var data = Object.values(angular.copy(descriptions));
      data.forEach(function(description) {
        description.languages = Object.values(description.languageData);
        delete description.languageData;
        delete description.fontData;
      })

      var promise = new Promise(function(resolve, reject) {
        ExperiencesService.updateExperienceDescriptions(data).then(function (data) {
          NotificationService.success('Experience description language update', 'Success');
          resolve('.');
        },function(error){
          NotificationService.error('Experience description language cannot be saved', 'Error');
          reject(new Error("error updating languages"));
        });
      });
      
      return promise;
    }  

    //TODO: Me falta hacer revision de todas estas funciones --!>

    function getBase64(file) {
      return new Promise(function(resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function() {
          var encoded = reader.result.toString().replace(/^data:(.*,)?/, '');
          if ((encoded.length % 4) > 0) {
            encoded += '='.repeat(4 - (encoded.length % 4));
          }
          resolve(encoded);
        };
        reader.onerror = function(error) {
          reject(error);
        }
      });
    }

     function deleteImage(image) { 
      var promise = new Promise(function(resolve, reject) {
        ExperiencesService.deleteExperienceImage(image.id).then(function (data) {
          NotificationService.success('Experience image delete', 'Success');
          vm.areasTable.reload();
          resolve('.');
        },function(error){
          NotificationService.error('Experience image cannot be delete', 'Error');
        });
      });
      return promise;
    }  

    function deleteAudio() {
      var promise = new Promise(function(resolve, reject) {
        ExperiencesService.deleteExperienceAudio(vm.experience.id).then(function (data) {
          NotificationService.success('Experience audio delete', 'Success');
          vm.experience.audio = null;
          vm.areasTable.reload();
          resolve('.');
        },function(error){
          NotificationService.error('Experience audio cannot be delete', 'Error');
        });
      });
      return promise;
    }

    $scope.uploadExperienceVideo = function (param) {
      var experienceId = vm.experience.id;
      var file = param.files[0];

      var promise = new Promise(function(resolve, reject) {

        getBase64(file).then(function (data) {
          var fileBase64 = data;
          ExperiencesService.uploadExperienceVideo(experienceId, fileBase64).then(function (data) {
            NotificationService.success('Experience video upload', 'Success');
            vm.experience.video = data.data.video;
            vm.current_video = data.data.video_url + "?t=" + new Date().getTime();
            resolve('.');
          },function(error){
            NotificationService.error('Experience video cannot be saved', 'Error');
            reject(new Error("error uploading video"));
          });
        });
      });
      return promise;
    }
    
    $scope.uploadExperienceAudio = function (param) {
      var experienceId = vm.experience.id;
      var file = param.files[0];

      var promise = new Promise(function(resolve, reject) {

        getBase64(file).then(function (data) {
          var fileBase64 = data;
          ExperiencesService.uploadExperienceAudio(experienceId, fileBase64).then(function (data) {
            NotificationService.success('Experience audio upload', 'Success');
            vm.experience.audio = true;
            vm.current_audio = data.data.audio_url + "?t=" + new Date().getTime();
            //document.getElementById('audioPlayer').play();
            resolve('.');
          },function(error){
            NotificationService.error('Experience audio cannot be saved', 'Error');
            reject(new Error("error uploading audio"));
          });
        });
      });
      return promise;
    }

    function onImageUploaded(data) {
      var experienceImage = data.data;
      experienceImage.position = experienceImage.position || 999;
      vm.experience.images.push(experienceImage);
      vm.image_base64 = null;
      vm.imagesTable = new NgTableParams({ count: vm.experience.images.length}, { dataset: vm.experience.images, counts: [] });
      vm.imagesTable.reload();
    }

    function deleteImageSelected(image) {
      vm.experience.images = vm.experience.images.filter(function (img) {
        return img.id != image.id;
      });
      vm.imagesTable = new NgTableParams({ count: vm.experience.images.length}, { dataset: vm.experience.images, counts: [] });
      vm.imagesTable.reload();
      deleteImage(image);
    }

    function updateExperienceImage(experienceImage) {
      var promise = new Promise(function(resolve, reject) {
        ExperiencesService.updateImage(experienceImage).then(function (data) {
          NotificationService.success('Experience image update', 'Success');
          vm.areasTable.reload();
          resolve('.');
        },function(error){
          NotificationService.error('Experience image cannot be update', 'Error');
        });
      });
 
      return promise;
    }

    //TODO: <!-- Hasta aca

    function togglePopover(type) {
      if (vm.popover.type) {
        if (vm.popover.type == type) {
          vm.popover.opened = !vm.popover.opened;
          if (!vm.popover.opened) {
            delete vm.popover.type;
          }
        } else {
          closePopover({'id': vm.popover.type});
          togglePopover(type);
        }
      } else {
        vm.popover.type = type;
        vm.popover.opened = true;
      }
    }

    function enablePopover(type){
      return vm.popover.type ? vm.popover.type == type : true;
    }

    function closePopover(type) {
      vm.popover.opened = false;
      delete vm.popover.type;
    }

    $interval(function() {
      if (vm.experience.images.length > 0) {
        if (vm.experience.images.length == vm.current_image_index + 1) {
          vm.current_image_index = 0;
        } else {
          vm.current_image_index++;
        }
        vm.current_image = vm.experience.images[vm.current_image_index].image_url;
      }
    }, vm.experience.slide_delay * 1000);
    
  }
})();

(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tlx').controller('TlxController', TlxController);
  
  function TlxController($controller,$scope, tvModels, NotificationService, NgTableParams, TlxService) {
    
    var vm = this;
    vm.tvModels               = tvModels.data;
    vm.data                   = {tvModels:[]}
    vm.addTvModel             = addTvModel;
    vm.deleteTvModelSelected  = deleteTvModelSelected;
    vm.addTlx                 = addTlx;
    vm.tlx                    = undefined;
    vm.tvModelSelected        = undefined;

    function addTvModel(){
      vm.data.tvModels.push(vm.tvModelSelected);
      vm.tvModels = vm.tvModels.filter(function(item) { //se quita del select el tvmodel seleccionado 
        return item.model !== vm.tvModelSelected.model;
      });
      vm.tvModelSelected = undefined;
      vm.table = new NgTableParams({}, {dataset: vm.data.tvModels});
    }

    function deleteTvModelSelected(tvModel){
      vm.data.tvModels = vm.data.tvModels.filter(function(item) { 
        return item.model !== tvModel.model;
      });
      vm.tvModels.push(tvModel); //se agrega al select el tvmodel borrado

      vm.table = new NgTableParams({}, {dataset: vm.data.tvModels});
      vm.table.reload();
    }

    function addTlx(form){
      if(form.$valid){
        var data = {}
        data.tv_models = vm.data.tvModels.map(function(data){
          return data.model
        })
        data.tlx = vm.tlx
        TlxService.addTlx(data).then(function(data){
          NotificationService.success('Tlx added', 'Success');
        },function(error){
          NotificationService.error('Tlx cannot be added', 'Error');
        });
      }
    }

    $scope.setFile = function(element) {
      $scope.currentFile = element.files[0];
      var reader         = new FileReader();
      
      reader.onloadend = function(e) {
        vm.tlx = e.target.result;
      }

      reader.readAsBinaryString($scope.currentFile);
    }
  }   
})();            
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('TlxService',TlxService);

  function TlxService(ApiService, StorageService,NotificationService) {

    var instance = {};

    instance.addTlx = addTlx;

    function addTlx(data){
      return ApiService.post('/tlx?property_id='+StorageService.getProperty().id, data)
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvApplicationVersions').controller('TvApplicationVersionAddEditController', TvApplicationVersionAddEditController);
  
  function TvApplicationVersionAddEditController($scope, $controller, $rootScope, StorageService, ApiService,
      NotificationService, TvApplicationVersionsService, FileUploader, application_resolve, tv_application_version, tv_models, application) {
    var vm = this;

    vm.availables_models = tv_models;

    vm.application     = application;
    vm.data            = tv_application_version;
    vm.data.timestamp  = moment().unix();
    vm.isEdition       = Number.isInteger(vm.data.id);
    vm.lengthTvModels  = lengthTvModels;
    vm.clearQueue      = clearQueue;
    vm.loadTags        = loadTags;
    vm.successFileUpload = vm.isEdition;
    vm.uploader        = new FileUploader(
      {
        url: ApiService.getApiUrl() + '/tv-application-versions/upload-file',
        queueLimit: 1,
        formData: {
          withFile: {
            timestamp: vm.data.timestamp,
            tv_application_version_id: vm.data.id
          }
        },
        headers: {
          Authorization : 'bearer ' + StorageService.getToken() 
        }
    });

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl     : 'iptv.tv-application-version-list',
        stateParams  :  { application_id: application_resolve.application_id, name: application_resolve.name },
        postSave: function(data){
          $rootScope.$broadcast("ipkSavedCallback");
        },
        formatData   : function(data){
          if(data.id){
            data['models'] = data.tv_application_version_models.map(function(item){
              var parseModel = { tv_model: item.text, tv_application_version_id: data.id }
              if(item.id){
                parseModel['id'] = item.id
              }
              return parseModel;
            })
          } else {
            if(data.tv_application_version_models){
              data['models'] = data.tv_application_version_models.map(function(item){
                return item.text;
              });
            }
          }
        }  
      }, service : TvApplicationVersionsService,
      scope: $scope
    }))

    vm.uploader.onAfterAddingFile = function(fileItem) {
      vm.data.filename = fileItem.file.name;
      vm.fileItem = fileItem;
      fileItem.upload();
    };

    vm.uploader.onBeforeUploadItem = function(item) {
      vm.successFileUpload = false;
    };

    vm.uploader.onCompleteItem = function(item) {
      if(item.isSuccess){
        vm.successFileUpload = true;
        NotificationService.success('File .ipk uploaded successfully', 'Success');

      }else{
        NotificationService.error('Error uploading .ipk file', 'Error');
      }
    };
    
    function lengthTvModels(){
      return vm.availables_models.length;
    }
    
    function clearQueue(){
      return vm.uploader.clearQueue();
    }

    function loadTags(query) {
      return vm.availables_models.filter(function(model){
        return model.text.toUpperCase().includes(query.toUpperCase());
      });
    };
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvApplicationVersions').controller('TvApplicationVersionsController', TvApplicationVersionsController);
  
  function TvApplicationVersionsController($controller,$scope, $rootScope, application_resolve, application) {
    var fieldsToFilter = ['filename','version'];
    var vm = this;
    vm.application_data = application_resolve;
    vm.showModels       = showModels;
    vm.application      = application;
    
    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'tv-application-versions',
        fieldsToFilter : fieldsToFilter,
        staticFilters  : {'tv_application_id': function(){
          return application_resolve.application_id;
        }}  
      }, scope : $scope
    }))
    
    vm.availableSearchParams = vm.generateParams(fieldsToFilter);

    $rootScope.$on('ipkSavedCallback', function () {
      vm.refreshTable()
    });

    function showModels(tv_application_version){
      var models = tv_application_version.tv_application_version_models.map(function(item){
        return item.tv_model;
      });

      return models.join(', ');
    }

  }
})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('TvApplicationVersionsService',TvApplicationVersionsService);

  function TvApplicationVersionsService(StorageService, ApiService) {

    var instance = {};

    instance.getEmptyTvApplicationVersion  = getEmptyTvApplicationVersion;
    instance.save                          = save;
    instance.get                           = get;
    instance.getAll                        = getAll;

    function getEmptyTvApplicationVersion(tv_application_id){
      return {
        "tv_application_id": tv_application_id
      };
    }

    function getAll(){
      return ApiService.get("/tv-application-versions");
    }

    function get(id){
      return ApiService.get("/tv-application-versions/"+id); 
    }

    function save(tvApplicationVersion){
      if (tvApplicationVersion.id) {
        return ApiService.put('/tv-application-versions/'+tvApplicationVersion.id, tvApplicationVersion);
      } else {
        return ApiService.post('/tv-application-versions', tvApplicationVersion);
      }
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvApplications').controller('TvApplicationsController', TvApplicationsController);
  
  function TvApplicationsController($rootScope,$translate,$controller,$scope, $location, brands, ConfigurationVariablesService, StorageService) {
    var vm = this;

    vm.brands           = brands;
    var suggestedValues = { brand : vm.brands};

    vm.generatedPathTvApplicationImage = generatedPathTvApplicationImage;
    
    function generatedPathTvApplicationImage(imageName){
      return ConfigurationVariablesService.getPathImage() +'application/files/'+ imageName;
    }

    var fieldsToFilter = ['name','app_id','brand'];
    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'tv-applications',
        fieldsToFilter : fieldsToFilter,
        preProcessData : function(data){
          data.map(function(tvApplication){
            tvApplication['imagePath'] = generatedPathTvApplicationImage(tvApplication.image) + '?random=' + Date.now();
          })
          return data;
        },  
      }, scope : $scope
    }))

    vm.availableSearchParams = vm.generateParams(fieldsToFilter, suggestedValues);

    function refreshTable(){
      vm.table.reload();
    }
  }

})();            
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('TvApplicationsService',TvApplicationsService);

  function TvApplicationsService(StorageService, ApiService) {

    var instance = {};

    instance.getAll                    = getAll;
    instance.get                       = get;
    instance.save                      = save;
    instance.delete                    = deleteTvApplication;
    instance.getEmptyTvApplication     = getEmptyTvApplication;
    instance.getLanguages              = getLanguages;
    instance.addTvApplicationLanguage  = addTvApplicationLanguage;
    instance.addTvApplicationLanguages = addTvApplicationLanguages;
    instance.uploadTvApplicationImage = uploadTvApplicationImage;

    function getAll(){
      return ApiService.get("/tv-applications?pagination=disabled");
    }

    function get(id){
      return ApiService.get("/tv-applications/"+id);
    }

    function save(tvApplication){
      if (tvApplication.id) {
        return ApiService.put('/tv-applications/'+tvApplication.id, tvApplication);
      } else {
        return ApiService.post('/tv-applications', tvApplication);
      }
    }

    function getLanguages() {
      return ApiService.get('/languages');
    }

    function deleteTvApplication(id){
      return ApiService.delete('/tv-applications/'+id);
    }

    function addTvApplicationLanguage(tvApplicationLenguages){
      return ApiService.put("/tv-application-languages/"+tvApplicationLenguages.id, tvApplicationLenguages);
    }

    function addTvApplicationLanguages(tvApplicationLenguages){
      return ApiService.put("/tv-application-languages", tvApplicationLenguages);
    }

    function getEmptyTvApplication(){
     return {"data": {
                "property_id":StorageService.getProperty().id,
                "image":"",
                "brand":"",
                "app_id":"",
                "preload": false
                }
              };
    }

    function uploadTvApplicationImage(data){
      return ApiService.post("/tv-applications/upload-tv-application-image", data);
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvApplications').controller('TvApplicationsAddEditController', TvApplicationsAddEditController);
  
  function TvApplicationsAddEditController($state, $scope, $controller, $location, $uibModal, brands, languages, tvApplication, ConfigurationVariablesService, NotificationService, TvApplicationsService, StorageService ) {
    var vm = this;
    
    vm.brands                          = brands;
    vm.data                            = tvApplication.data;
    vm.languages                       = languages.data;
    vm.tvApplicationNotCreate          = tvApplicationNotCreate;
    vm.updateLanguage                  = updateLanguage;
    vm.availableImageTypes             = '".png"';
    vm.uploadTvApplicationImage        = uploadTvApplicationImage;
    vm.isEdition                       = Number.isInteger(vm.data.id);
    vm.generatedPathTvApplicationImage = generatedPathTvApplicationImage;
    vm.getTvApplicationImage           = getTvApplicationImage;
    vm.saveApp                         = saveApp;
    vm.tvApplicationForm               = {}
    vm.tvApplicationImageBase64        = vm.isEdition ? vm.generatedPathTvApplicationImage() : "/assets/img/theme/no-image.png"; 

    vm.languageList = [];
    if(vm.data.id){
      vm.languageList = tvApplication.data.tv_application_languages
    }

		vm.options = {
			language: 'en',
			allowedContent: true,
			entities: false,
      extraPlugins: 'colorbutton, font, justify'
		};
    
    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl     : 'tv-applications-list',
        resolutions  : {
                minWidth: 100,
                minHeight: 100,
                maxWidth: 256,
                maxHeight: 256,
                ratio: 1,
        },
        promise : function(data){
          vm.tvApplicationImage       = data.image;
          vm.tvApplicationImageBase64 = data.croppedImage;
          if(vm.isEdition){
            uploadTvApplicationImage();
          }
        },
        onLoad : function(data, openModal){
          openModal();
        },
        formatData   : function(data){
          if(!data.id){
            data.image_base64 = vm.tvApplicationImage;
          }
        },
        postSave     : function(data){
          vm.data = data.data
          vm.languageList = data.data.tv_application_languages
        },
        noRedirect: true,  
      }, 
      service : TvApplicationsService,
      scope : $scope
    }));

    function generatedPathTvApplicationImage(){
      return ConfigurationVariablesService.getPathImage() + 'application/files/'+ vm.data.image;
    }

    function uploadTvApplicationImage(){
      TvApplicationsService.uploadTvApplicationImage({"tv_application_id":vm.data.id, "image_base64":vm.tvApplicationImage}).then(function(data){
          NotificationService.success('Image uploaded', 'Success');
        },function(error){
          vm.tvApplicationImageBase64 = vm.generatedPathTvApplicationImage();
          NotificationService.error('Error cant upload image', 'Error');
        });
    }

    function getTvApplicationImage(){
      return vm.tvApplicationImageBase64;
    }

    function tvApplicationNotCreate() {
      return !vm.data.id
    }

    function saveApp(){
      var promise = new Promise(function(resolve, reject) {
        vm.save(vm.tvApplicationForm,vm.data).then(function(data){
          resolve('.');
        },function(error){
          reject(new Error("error updating entity")); 
        })
      })

      return promise
    }
    
    function updateLanguage() {
      TvApplicationsService.addTvApplicationLanguages({'languages':vm.languageList}).then(function(data){
        NotificationService.success('Tv application language saved', 'Success');
        $state.go('iptv.tv-applications-list');
      },function(error){
        NotificationService.error('Tv application language cannot be saved', 'Error');
      });
    }
  }  
})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvApplicationsProperty').controller('AddTvAppVersionByTvAppPropertyController', AddTvAppVersionByTvAppPropertyController);
  
  function AddTvAppVersionByTvAppPropertyController($rootScope, $controller, $scope, $uibModalInstance, StorageService, callbackFn, tvApplication,
   NotificationService, tv_models, ApiService, FileUploader, tv_application_version, application_resolve, TvApplicationVersionsService) {
    var vm = this;

    vm.data              = tv_application_version;
    vm.data.timestamp    = moment().unix();
    vm.tvApplication     = tvApplication;
    vm.availables_models = tv_models;
    vm.cancelModal       = cancelModal;
    vm.tvAppVersion      = null;
    vm.loadTags          = loadTags;
    vm.clearQueue        = clearQueue;
    vm.callbackFn        = callbackFn;
    vm.uploader          = new FileUploader({
        url: ApiService.getApiUrl() + '/tv-application-versions/upload-file',
        queueLimit: 1,
        formData: {
          withFile: {
            timestamp: vm.data.timestamp,
            tv_application_version_id: vm.data.id
          }
        },
        headers: {
          Authorization : 'bearer ' + StorageService.getToken() 
        }
    });

    vm.uploader.onAfterAddingFile = function(fileItem) {
      vm.data.filename = fileItem.file.name;
      vm.fileItem = fileItem;
      fileItem.upload();
    };

    vm.uploader.onBeforeUploadItem = function(item) {
      vm.successFileUpload = false;
    };

    vm.uploader.onCompleteItem = function(item) {
      if(item.isSuccess){
        vm.successFileUpload = true;
        NotificationService.success('File .ipk uploaded successfully', 'Success');

      }else{
        NotificationService.error('Error uploading .ipk file', 'Error');
      }
    };

    function clearQueue(){
      return vm.uploader.clearQueue();
    }

    function cancelModal() {
      $uibModalInstance.close();
    }

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl     : 'iptv.tv-applications-property-list',
        stateParams  :  { application_id: application_resolve.application_id, name: application_resolve.name },
        postSave: function(data){
          $rootScope.$broadcast("ipkSavedCallback");
          vm.callbackFn(data.data,vm.tvApplication);
          $uibModalInstance.close();
        },
        formatData   : function(data){
          if(data.id){
            data['models'] = data.tv_application_version_models.map(function(item){
              var parseModel = { tv_model: item.text, tv_application_version_id: data.id }
              if(item.id){
                parseModel['id'] = item.id
              }
              return parseModel;
            })
          } else {
            if(data.tv_application_version_models){
              data['models'] = data.tv_application_version_models.map(function(item){
                return item.text;
              });
            }
          }
        }  
      }, service : TvApplicationVersionsService,
      scope: $scope
    }))

    function loadTags(query) {
      return vm.availables_models.filter(function(model){
        return model.text.toUpperCase().includes(query.toUpperCase());
      });
    };

    function lengthTvModels(){
      return vm.availables_models.length;
    }
  }

})();            
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvApplicationsProperty').controller('TvApplicationsPropertyController', TvApplicationsPropertyController);
  
  function TvApplicationsPropertyController($controller, $scope, $uibModal, brands, ConfigurationVariablesService, tvApplicationsProperty, tvApplications,
    NotificationService, TvApplicationsPropertyService, tvApplicationVersions, TvApplicationVersionsService, NgTableParams,$filter) {
    
    var vm = this;
    
    vm.brands                                  = brands;
    vm.tvAppProperty                           = tvApplicationsProperty.data.data;
    vm.tvApplications                          = tvApplications.data;
    vm.tvApplicationVersions                   = tvApplicationVersions.data.data;
    vm.openModal                               = openModal;
    vm.doYouHaveAVersion                       = doYouHaveAVersion;
    vm.tvApplicationDisensable                 = vm.tvApplicationDisensable;
    vm.add                                     = add;
    vm.remove                                  = remove;
    vm.addOrRemove                             = addOrRemove;
    vm.enabledApps = [];
    vm.disabledApps = [];
    vm.finishModal = finishModal;
    vm.updatePosition = updatePosition;

    function init() {
      console.log(vm.tvAppProperty);
      vm.tvApplications.map(function(tvApp){
       var propertyFound = vm.tvAppProperty.find(function(tvAppProperty){
            return tvAppProperty.tv_application_id == tvApp.id;
        });

        tvApp.enabled = !!propertyFound;
        tvApp.position = propertyFound ? propertyFound.position : 999 ;
        if (tvApp.enabled) {
          vm.enabledApps.push(tvApp);
        } else {
          vm.disabledApps.push(tvApp);
        }
      });
      console.log(vm.disabledApps, vm.enabledApps);
      vm.enabledApps = $filter('orderBy')(vm.enabledApps, 'position');

      vm.tableEnabledApps = new NgTableParams( 
        {
          count: vm.enabledApps.length,
          noPager: true
        },
        {
          dataset: vm.enabledApps, 
          counts: [],
        }
      );
      vm.tableDisabledApps = new NgTableParams( 
        {
          count: vm.disabledApps.length,
          noPager: true
        },
        {
          dataset: vm.disabledApps, 
          counts: []
        }
      );
    }
    init();
    
    vm.generatedPathTvApplicationPropertyImage = generatedPathTvApplicationPropertyImage;
    
    function generatedPathTvApplicationPropertyImage(imageName){
      return ConfigurationVariablesService.getPathImage() +'application/files/'+ imageName;
    }
    
    vm.createOrDestroy       = createOrDestroy;

    function openModal(model){
      var modalInstance = $uibModal.open({
        animation: true,
        windowClass: 'modal',
        title: 'Edit Tv App Version',
        templateUrl: 'app/modules/iptv/tvApplicationsProperty/addTvApplicationVersion.html',
        controller: 'AddTvAppVersionByTvAppPropertyController',
        controllerAs: 'vm',
        backdrop: false,
        resolve: {
          tv_application_version : function(TvApplicationVersionsService){
            return TvApplicationVersionsService.getEmptyTvApplicationVersion(model.id);
          },
          tv_models: function(TvModelsService){
            return TvModelsService.getAllWithoutPagination().then(function(callback){
              return callback.data.map(function(object) { 
                return {text: object.model} 
              });
            });
          },
          application_resolve : function($stateParams){
            return $stateParams;
          },
          tvApplication: function (){
            return model;
          },
          callbackFn: function(){
            return vm.finishModal;
          },
        }
      });
    }

    function finishModal(tvApplicationVersion,tvApplication) {
      TvApplicationsPropertyService.save(tvApplication).then(function(data){
            NotificationService.success('Tv applications property created', 'Success');
            vm.tvAppProperty.push(data.data);
            vm.tvApplicationVersions.push(tvApplicationVersion); 
            addOrRemove(tvApplication);
          },function(error){
            NotificationService.error('Tv applications property not created', 'Error');
      }); 
      init();
      
    }

    function doYouHaveAVersion(tvApplication){
      return vm.tvApplicationVersions.find(function(tvAppVersion) {
        return tvApplication.id == tvAppVersion.tv_application_id;
      });
    }

    function addOrRemove(tvApplication){
      if (tvApplication.enabled) {
        vm.remove(tvApplication);
      } else {
        vm.add(tvApplication);
      }
    }

    function add(tvApplication) {
   
      tvApplication.enabled = true;
      vm.tableDisabledApps.data.splice(vm.index,1);
      vm.tableEnabledApps.data.push(tvApplication);
      
      updateArrays();
    }

    function remove(tvApplication) {
      tvApplication.enabled = false;
      vm.tableEnabledApps.data.splice(vm.index,1);
      vm.tableDisabledApps.data.push(tvApplication);
      updateArrays();
    }

    function updateArrays(){
      vm.toAddList = vm.tableEnabledApps.data;
      vm.addedList = vm.tableDisabledApps.data;
    }
  
    function createOrDestroy(tvApplication, index){
      vm.index = index;
      var tvAppVersionFinded  = vm.doYouHaveAVersion(tvApplication)
      var tvAppPropertyFinded = vm.tvAppProperty.find(function(tvAppProperty){
        return tvAppProperty.tv_application_id == tvApplication.id;
      });
      if(tvAppVersionFinded){

        if(tvAppPropertyFinded){
          console.log(1);
          TvApplicationsPropertyService.destroy(tvAppPropertyFinded).then(function(data){
            NotificationService.success('Tv applications property deleted', 'Success');
            vm.tvAppProperty = vm.tvAppProperty.filter(function(tvAppProperty) {
              return tvAppPropertyFinded.id != tvAppProperty.id ;
            })
            addOrRemove(tvApplication);
          },function(error){
            NotificationService.error('Tv applications property not deleted', 'Error');
          })
        } else {
          console.log(2);
          TvApplicationsPropertyService.save(tvApplication).then(function(data){
            NotificationService.success('Tv applications property created', 'Success');
            vm.tvAppProperty.push(data.data);
            addOrRemove(tvApplication);
          },function(error){
            NotificationService.error('Tv applications property not created', 'Error');
          });
        }
      } else {
        vm.openModal(tvApplication);
        tvApplication.enabled = false;
      }
      
    }

    function updatePosition(tvApplication) {
      var tvAppPropertyFound = vm.tvAppProperty.find(function(tvAppProperty){
        return tvAppProperty.tv_application_id == tvApplication.id;
      });
      tvAppPropertyFound.position = tvApplication.position;
      TvApplicationsPropertyService.update(tvAppPropertyFound).then(function (data) {
        NotificationService.success('Tv applications property update', 'Success');
      },function(error){
        NotificationService.error('Tv applications property not update', 'Error');
      });
    }
    
  }   
})();            
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('TvApplicationsPropertyService',TvApplicationsPropertyService);

  function TvApplicationsPropertyService(StorageService, NotificationService, ApiService) {

    var instance = {};

    instance.getAllWithoutPagination = getAllWithoutPagination;
    instance.save                    = save;
    instance.destroy                 = destroy;
    instance.get                     = get;
    instance.getAll                  = getAll; 
    instance.update                  = update;
    
    function getAllWithoutPagination(){
      return ApiService.get("/tv-applications-property?pagination=disabled");
    }

    function get(tvApplicationProperty){
      return ApiService.get("/tv-applications-property/"+tvApplicationProperty); 
    }

    function getAll(){
      return ApiService.get("/tv-applications-property?property_id="+StorageService.getProperty().id);  
    }

    function save(tvApplication){

        return ApiService.post('/tv-applications-property', {
            "tv_application_id": tvApplication.id,
            "property_id": StorageService.getProperty().id,
            "visible": false
        });
    }

    function destroy(tvAppProperty){
      return ApiService.delete('/tv-applications-property/'+ tvAppProperty.id, tvAppProperty);
    }

    function update(tvAppProperty){
      return ApiService.put('/tv-applications-property/'+ tvAppProperty.id, tvAppProperty);
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvModels').controller('AddTlxByTvModelController', AddTlxByTvModelController);
  
  function AddTlxByTvModelController($rootScope,$controller,$scope, $uibModalInstance, $uibModal, tvModel, TlxService, StorageService,
   NotificationService) {
    var vm = this;

    vm.cancel  = cancel;
    vm.tlx     = null;
    vm.save    = save;


    $scope.setFile = function(element) {
      $scope.currentFile = element.files[0];
      var reader         = new FileReader();
      
      reader.onloadend = function(e) {
        vm.tlx = e.target.result;
        $scope.$apply()
        //send your binary data via $http or $resource or do anything else with it
      }

      if($scope.currentFile){
        reader.readAsBinaryString($scope.currentFile);
      } else {
        vm.tlx = null;
        $scope.$apply()
      }
    }

    function cancel() {
      $uibModalInstance.close();
    }

    function save(form){
      if(form.$valid){
        var data = {}
        data.tv_models = [tvModel]
        data.tlx = vm.tlx
        TlxService.addTlx(data).then(function(data){
          NotificationService.success('Tlx added', 'Success');
          $uibModalInstance.close();
        },function(error){
          NotificationService.error('Tlx cannot be added', 'Error');
        });
      }
    }


  }

})();            
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvModels').controller('TvModelsController', TvModelsController);
  
  function TvModelsController($rootScope,$controller,$scope, $uibModal, brands, resolutions, StorageService) {
    var vm = this;

    vm.brands           = brands;
    vm.resolutions      = resolutions;
    vm.openModal        = openModal;
    var fieldsToFilter  = ['model','brand','resolution'];
    var suggestedValues = { brand: vm.brands, resolution: vm.resolutions};
    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'tv-models',
        fieldsToFilter : fieldsToFilter  
      }, scope : $scope
    }))
    vm.availableSearchParams = vm.generateParams(fieldsToFilter, suggestedValues);



    function openModal(model){
      var modalInstance = $uibModal.open({
        animation: true,
        windowClass: 'modal',
        title: 'Edit Image',
        templateUrl: 'app/modules/iptv/tvModels/addTlx.html',
        controller: 'AddTlxByTvModelController',
        controllerAs: 'vm',
        resolve: {
          tvModel: function(){
            return model
          }
        }
      });

      modalInstance.result.then(function(data){
        vm.table.reload()
      });
    }


  
  }

})();            
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('TvModelsService',TvModelsService);

  function TvModelsService(StorageService, ApiService) {

    var instance = {};

    instance.getAllWithoutPagination = getAllWithoutPagination;
    instance.getEmptyTvModel        = getEmptyTvModel;
    instance.save                    = save;
    instance.get                     = get;


    function getAllWithoutPagination(){
      return ApiService.get("/tv-models?pagination=disabled");
    }

    function getEmptyTvModel(){
     return {"data": {
                "model":"",
                "brand":"",
                "version_number":""}
              };
    }

    function get(model){
      return ApiService.get("/tv-models/"+model); 
    }

    function save(tvModel){
      if (tvModel.id) {
        return ApiService.put('/tv-models/'+tvModel.id, tvModel);
      } else {
        return ApiService.post('/tv-models', tvModel);
      }
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvModels').controller('TvModelsAddEditController', TvModelsAddEditController);
  
  function TvModelsAddEditController($state, $scope, $controller, brands, resolutions, tvModel, TvModelsService ) {
    var vm = this;
    
    vm.data = tvModel.data;
    vm.brands = brands;
    vm.resolutions = resolutions;

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl            : 'iptv.tv-models-list',
        formatData     : function(data){      
          if($state.params.id){
            data.id = $state.params.id; // negrada por no tener id
          }
        } 
      }, service : TvModelsService,
      scope: $scope
    }))

  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvs').controller('TvsController', TvsController);
  
  function TvsController($rootScope,$controller,$scope, StorageService) {
    var vm = this;

    var fieldsToFilter = ['area_name','tv_model','serial_number','ip_address'];
    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'tvs',
        fieldsToFilter : fieldsToFilter  
      }, scope : $scope
    }))
    vm.availableSearchParams = vm.generateParams(fieldsToFilter);  
  }

})();            
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('TvsService',TvsService);

  function TvsService(StorageService, ApiService) {

    var instance = {};

    instance.get                     = get;
    instance.save                    = save;
    instance.getEmptyTv              = getEmptyTv;
    instance.getAllWithoutPagination = getAllWithoutPagination;

    function getAllWithoutPagination(){
      return ApiService.get("/tvs?property_id=" + StorageService.getProperty().id + '&pagination=disabled');
    }

    function get(id){
      return ApiService.get("/tvs/"+id);
    }

    function getEmptyTv(){
     return {"data": {
                "property_id":StorageService.getProperty().id,
                "name":"",
                "area_name":"", 
                "tv_model":"", 
                "serial_number":"",
                "ip_address":""}
              };
    }

    function save(tv){
      if (tv.id) {
        return ApiService.put('/tvs/'+tv.id, tv);
      } else {
        return ApiService.post('/tvs', tv);
      }
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.tvs').controller('TvsAddEditController', TvsAddEditController);
  
  function TvsAddEditController($state, $scope, $controller, $uibModal, tv, tvModels, areas, TvsService, AreasService, StorageService, NotificationService) {
    var vm = this;

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl : 'iptv.tvs-list',
        formatData   : function(data){        
          data.area_name = data.area_name.name.replace(/ /g,"_").toUpperCase();
        } 
      }, service : TvsService,
      scope: $scope
    }))

    vm.data                       = tv.data;
    vm.data.area_name             = {"name":vm.data.area_name};
    vm.tvModels                   = tvModels.data;
    vm.areas                      = areas.data;
    vm.refreshAreas               = refreshAreas;
    vm.areaExist                  = areaExist;
    vm.createArea                 = createArea;
    vm.shouldCreateAreaButton     = shouldCreateAreaButton;

    function shouldCreateAreaButton() {
      return vm.areaExist()||vm.data.area_name.name=="";
    }

    function createArea() {
      AreasService.save({
        "name":vm.data.area_name.name,
        "property_id":StorageService.getProperty().id}).then(function(data){
          vm.areas.push(data.data)
          vm.data.area_name.isFreeText = false;
          NotificationService.success('Area added', 'Success');
        },function(error){
          NotificationService.error('Area cannot be added', 'Error')
        })
    }

    function areaExist() {
      return vm.areas.some(function(area){return vm.data.area_name && area.name==vm.data.area_name.name.replace(/ /g,"_").toUpperCase()});
    }

    function refreshAreas() {
      AreasService.getAllWithoutPagination().then(function(data){
        vm.areas = data.data
      })
    }
  }

})();
(function () {
  'use strict';

  var translations = {
  	"PROPERTIES": {
  	  "NEW"                             : "Add Property",
  	  "ID"                              : "Id",
  	  "NAME"                            : "Name",
  	  "ACRONYM"                         : "Acronym",
  	  "GENERATE_TOKEN"                  : "Generate Token",
  	  "API_ENABLED"                     : "Api enabled",
  	  "TOKEN"                           : "Token",
  	  "INSTANCE_TOKEN"                  : "Instance token",
  	  "INSTANCE_URL"                    : "Instance url",
      "EDIT_TEMPLATE"                   : "Template",
      "COPY_PARAMETERS_TO"              : "Copy Template Values",
      "TEMPLATE"                        : "Template",
      "REPORTS"                         : "Reports",
      "COUNTRY"                         : "Country",
      "CITY"                            : "City",
      "CREATE_CITY"                     : "Create city",
      "CITY_NOT_EXIST"                  : "The city doesn't exist - you should create it!",
      "COUNTRY_NOT_EXIST"               : "The country doesn't exist.",
      "LAYOUT"                          : "Default {{tvOrReceiver}} layout",
      "COPY_LAYOUT_FROM_OTHER_PROPERTY" : "Copy layout from other property",
      "TEMPLATE_LAYOUT"                 : "Choose a Template from which a layout will be created",
      "LAYOUT_NAME"                     : "Write the name for the {{tvOrReceiver}} layout",
      "PROPERTIES"                      : "Choose a Property from which a layout will be copy",
      "LAYOUTS"                         : "Choose a Layout from which will be copy",
      "DEFAULT_LAYOUT"                  : "Default layout {{tvOrReceiver}} name",
      "MODIFY_DEFAULT_LAYOUT"           : "Modify default layout {{tvOrReceiver}}",
      "CHROMECAST_OWNER_ACCOUNT_EMAIL"  : "Chromecast owner account email",
      "CHROMECAST_OWNER_ACCOUNT_PASSWORD" : "Chomecast owner account generated app password"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.reports.general-use').controller('GeneralUseReportsController', GeneralUseReportsController);
  
  function GeneralUseReportsController($scope, $rootScope, $window, $timeout, start_date_resolve, end_date_resolve,
   ApiService, StorageService, ReceiversService, AreasService) {
    var vm = this;
    var tabDisable = false;
    var disableFilter = false;
    vm.activeTab = 0;
    vm.start_date = start_date_resolve;
    vm.end_date = end_date_resolve;
   
    vm.availableSearchParamsValidations = generateParams(["area_name","mac_address","ip_address"], {});

    vm.availableSearchParamsStates = generateParams(["area_name","app","receiver_name"], {});

    vm.availableSearchParamsSessions = generateParams(["area_name","receiver_name","duration_greater_than","duration_less_than"], {});

    vm.disableForRecentAction  = disableForRecentAction;
    vm.tabSelected             = tabSelected;
    vm.basicValidation         = basicValidation;
    vm.openPicker              = openPicker;
    vm.filter                  = filter;
    vm.exportToPdf             = exportToPdf;
    vm.clear                   = clear;
    //Valido por si se agregan otros filtros en la vista de reportes
    //vm.clear            = clear;
    vm.dateFormat = 'yyyy-MM-dd';
    vm.datepickerOptions = {
      showWeeks: false,
      appendToBody: true
    };

    function basicValidation(form, field) {
      return field.$invalid && (field.$dirty || form.$submitted)
    }

    function openPicker(e,picker) {
      vm[picker] = true;
    }

    function disableForRecentAction() {
      return disableFilter || tabDisable
    }

    $scope.$on("propertyChanged", function(){
      AreasService.getAllWithoutPagination().then(function(areas){
        vm.areas = areas.data;
      })
    });

    function downloadFile(data) {
      console.log(data.data.url)
      ApiService.getOutsideCastApi(data.data.url).then(function(awsdata){
          window.open(data.data.url)
        },function(error){
          $timeout(function(){
            window.open(data.data.url)
          },500)
        });
    }

    function clear(){
      vm.search = {}
      
      
      filter()
    }

    $scope.$on('filter_area_name', function(event, opt) {
        vm.search.area_name = opt.area_name
        filter()
    });

    $scope.$on('filter_app', function(event, opt) {
        vm.search.app = opt.app
        filter()
    });

    $scope.$on('filter_receiver_name', function(event, opt) {
        vm.search.receiver_name = opt.receiver_name
        filter()
    });

    function filter(){
      if(vm.activeTab==0){
        $rootScope.$broadcast('reports_date_changed', { 
          start_date: vm.start_date, 
          end_date: vm.end_date,
          ip_address: vm.search.ip_address,
          area_name: vm.search.area_name,
          mac_address: vm.search.mac_address
        });
      } else {
        if(vm.activeTab==1){
          $rootScope.$broadcast('reports_date_changed', { 
            start_date: vm.start_date, 
            end_date: vm.end_date,
            app: vm.search.app,
            area_name: vm.search.area_name,
            receiver_name: vm.search.receiver_name
          });
        } else {
          $rootScope.$broadcast('reports_date_changed', { 
            start_date: vm.start_date, 
            end_date: vm.end_date,
            receiver_name: vm.search.receiver_name,
            area_name: vm.search.area_name,
            duration_greater_than: vm.search.duration_greater_than,
            duration_less_than: vm.search.duration_less_than
          });
        }
      }

      disableFilter = true;
      $timeout(function(){
        disableFilter = false;
      },500)
    }

    function tabSelected(index){
      $rootScope.$broadcast('reports_tab_changed', {
        tab_index: index
      });

    tabDisable = true;
    $timeout(function(){
        tabDisable = false;
      },500)
    }

    function generateParams(fields, suggestedValues) {
      var arrayLength = fields.length;
      var result = [];
      for (var i = 0; i < arrayLength; i++) {
        var arrayIndex = fields[i];
        var obj = {key:arrayIndex, name: formatValuesForName(arrayIndex)};
        if ((typeof(suggestedValues) != "undefined") && !!suggestedValues[arrayIndex]){
          obj.suggestedValues = suggestedValues[arrayIndex];
        }
        result.push(obj);
      }
      return result;
    }

    function formatValuesForName(string) {
      var result = string;
      result = result.replace(/_/g, ' ');
      return capitalize(result);
    }

    function capitalize(name) {
      return name.charAt(0).toUpperCase() + name.slice(1);
    };

    function exportToPdf(){
      var date_format_resolve = 'YYYY-MM-DD HH:mm:ss';
      var formated_start_date = moment(vm.start_date);
      var formated_end_date = moment(vm.end_date);
      formated_start_date.set({hour:0,minute:0,second:0,millisecond:0});
      formated_end_date.set({hour:23,minute:59,second:59,millisecond:0});
      formated_start_date = formated_start_date.format(date_format_resolve);
      formated_end_date = formated_end_date.format(date_format_resolve);

      ApiService.get('/public/es/report?property_id=' + StorageService.getProperty().id + '&token=' + StorageService.getProperty().token + '&from=' + formated_start_date
        + '&to=' + formated_end_date + '&name=' + StorageService.getProperty().name
          + (vm.search.ip_address            ? ('&ip_address=' + vm.search.ip_address) : '')
          + (vm.search.area_name             ? ('&area_name=' + vm.search.area_name) : '')
          + (vm.search.mac_address           ? ('&mac_address=' + vm.search.mac_address) : '')
          + (vm.search.receiver_name         ? ('&receiver_name=' + vm.search.receiver_name) : '')
          + (vm.search.app                   ? ('&app=' + vm.search.app) : '')
          + (vm.search.duration_greater_than ? ('&duration_greater_than=' + vm.search.duration_greater_than) : '')
          + (vm.search.duration_less_than    ? ('&duration_less_than=' + vm.search.duration_less_than) : '')
        ).then(function(data){
          downloadFile(data);
        });
    }

    angular.element($window).bind('resize', function(){
      $rootScope.$broadcast('reports_resize_screen', {
        tab_index: vm.activeTab
      });
    });

    vm.tabs = [
      {
        title: 'Validations',
        route: 'validation@main',
        active: false
      },
      {
        title: 'States',
        route: 'state@main',
        active: true
      },
      {
        title: 'Sessions',
        route: 'section@main',
        active: false
      }
    ]
  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules.reports').factory('GeneralUseService', GeneralUseService);

  function GeneralUseService(StorageService, ApiService) {

    var instance = {};

    instance.getTopMacAddresses = getTopMacAddresses;

    function getTopMacAddresses(start, end, ip_address, mac_address, area_name){
      var property = StorageService.getProperty();
      var uri = "/public/es/sender-uptime/top-mac-address?property_id=" + property.id + 
                    '&from=' + start + 
                    (ip_address? ('&ip_address=' + ip_address) : '') + 
                    (area_name? ('&area_name=' + area_name) : '') + 
                    (mac_address? ('&mac_address=' + mac_address) : '') + '&to=' + end + '&token=' + property.token;
      return ApiService.get(uri);
    }

    return instance;
  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules.reports').factory('InfrastructureMonitorService', InfrastructureMonitorService);

  function InfrastructureMonitorService(StorageService, ApiService, DeviceService) {

    var instance = {};

    instance.getGraphData       = getGraphData;
    instance.getDataAndColumns  = getDataAndColumns;
    instance.groupAndFormatData = groupAndFormatData;
    instance.addDisconnectReceivers  = addDisconnectReceivers;

    function getGraphData(start, end, ssid){
      var property = StorageService.getProperty();
      var uri = "/public/es/infrastructure-monitor/graph-data?property_id=" + property.id + 
                    '&from=' + start + '&to=' + end + '&token=' + property.token;
      if (ssid) {
        uri = uri + "&ssid=" + ssid;
      }
      return ApiService.get(uri);
    }

    function groupAndFormatData(receivers, signal_data){
      var group_data = addDisconnectReceivers(receivers, signal_data);
      return getDataAndColumns(group_data);
    }

    function getDataAndColumns(signal_data){
      var formattedData = null;
      if(DeviceService.isLongDesktop())
        formattedData = threeAxysGetChartData(signal_data,'avg_signal',10)
      else if (DeviceService.isMediumDesktop()) 
        formattedData = threeAxysGetChartData(signal_data,'avg_signal',9)
      else if (DeviceService.isShortDesktop()) 
        formattedData = threeAxysGetChartData(signal_data,'avg_signal',7)
      else if (DeviceService.isTablet())
        formattedData = threeAxysGetChartData(signal_data,'avg_signal',4)
      else formattedData = threeAxysGetChartData(signal_data,'avg_signal',2)

      return formattedData;
    }

    function threeAxysGetChartData(array,toValue,columns){
      var currentX = 0;
      var currentY = 0;

      return array.map(function(row){
        var formated = {}
        if(row[toValue] == undefined) row.color = "#000000"
        Object.keys(row).forEach(function(key){
          if(toValue == key) formated.value = -row[key]
          else formated[key] = row[key]
        });

        formated.x = currentX;
        formated.y = currentY;

        if(currentX < columns-1) currentX++
        else { currentX=0; currentY++ } 

        return formated;
      });
    }

    function addDisconnectReceivers(receivers, data_resolve){
      var group_data = data_resolve;
      receivers.map(function(rec){
        var disconnect_receiver = group_data.filter(function(signal){
          return rec['ip_address'] == signal['ip_address']
        });
        if(disconnect_receiver == null || disconnect_receiver.length == 0){
          rec['receiver_name'] = rec['name'];
          group_data.push(rec);
        }
        return rec;
      });
      return group_data;
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.reports.infrastructure-monitor').controller('InfrastructureMonitorReportsController', InfrastructureMonitorReportsController);
  
  function InfrastructureMonitorReportsController($rootScope, $scope, $window, $timeout, StorageService, ReceiversService, chartHelperService, DeviceService, InfrastructureMonitorService,
    date_format_resolve, start_date_resolve, end_date_resolve, data_resolve, receivers_data, frecs_resolve) {

    var vm = this;
    vm.data = data_resolve.data;
    
    vm.start_date = start_date_resolve;
    vm.end_date = end_date_resolve;

    vm.basicValidation  = basicValidation;
    vm.openPicker       = openPicker;
    vm.filter           = filter;
    vm.clear            = clear;
    vm.dateFormat = 'yyyy-MM-dd';
    vm.datepickerOptions = {
      showWeeks: false,
      appendToBody: true
    };

    function setChartSize(){
      function resize(heigth) {
        var chart = vm.treemapConfig.getHighcharts();
        var elem = chart.container;
        var parent = $(elem).parent();
        chart.setSize(parent.width()+1, heigth);
      }

      var chartHeigth = chartHelperService.calculateChartHeight(data_resolve)
      resize(chartHeigth);
    }

    function basicValidation(form, field) {
      return field? (field.$invalid && (field.$dirty || form.$submitted)): false;
    }

    function openPicker(e,picker) {
      vm[picker] = true;
    }

    function clear(){
      vm.ssid           = undefined;
      vm.frec_band      = undefined;
    }

    function updateImages(){
        chartHelperService.updateChart(vm.treemapConfig.getHighcharts(), { data: vm.data });
      }

    function filter(){
      console.log(vm.treemapConfig.getHighcharts());
      //var format_start_date = moment(vm.start_date).format(date_format_resolve);
      //var format_end_date = moment(vm.end_date).format(date_format_resolve);
      //InfrastructureMonitorService.getGraphData(format_start_date, format_end_date, vm.ssid).then(function(data){
      //    data_resolve = data.data;
      //    if (!vm.ssid) {
      //      InfrastructureMonitorService.addDisconnectReceivers(receivers, data_resolve)
      //    }
      //    vm.data = InfrastructureMonitorService.getDataAndColumns(data_resolve);
      //    updateImages();
      //});
    }

    angular.element($window).on('orientationchange', function() {
      $timeout(function(){
        setChartSize()
      }, 200)
    });

    $timeout(function(){
      vm.treemapConfig = chartHelperService.simpleChart('treemap', {
        series: [{
            name: 'Signal strength',
            type: "treemap",
            color: '#A0A0A0',
            layoutStartingDirection: 'vertical',
            levels: [{
              level: 1,
              borderWidth: 9,
              borderColor: '#000',
              layoutAlgorithm: 'strip',
              layoutStartingDirection: 'horizontal',
              dataLabels: {
                enabled: true,
                style: {
                  fontSize: "25px"
                },
                formatter: function(){
                  var hasIdUndefined = function(element){
                    return element.children.length == 0
                  };

                  if(this.point.node.children.some(hasIdUndefined)){
                    this.point.update({ dataLabels: { verticalAlign: 'top', y: 4 } }, false);
                  }
                  return this.point.name;
                }
              }
            },{
              level: 2,
              borderWidth: 6,
              layoutAlgorithm: 'stripes',
              layoutStartingDirection: 'horizontal',
              dataLabels: {
                enabled: true,
                formatter: function(){
                  var hasIdUndefined = function(element){
                    return element.children.length == 0
                  };

                  if(this.point.node.children.some(hasIdUndefined)){
                    this.point.update({ dataLabels: { y: 22 } }, false);
                  }
                  return this.point.name
                }
              }
            },{
              level: 3,
              borderWidth: 4,
              layoutAlgorithm: 'stripes',
              dataLabels: {
                enabled: true,
                formatter: function(){
                  return this.point.name
                }
              }         
            },{
              level: 4,
              borderWidth: 1,
              layoutAlgorithm: 'squarified',
              layoutStartingDirection: 'horizontal',
              dataLabels: {
                enabled: true
              }            
            }],
            
            data: vm.data
          }]
      },{
        title : 'Infrastructure monitor',
        typeCallbackParameters: {
          colorAxis: {
            dataClasses: [{
              from: 0,
              to: 1,
              name: 'Disconnected device',
              color: '#E85656' //LIGHT RED
            },{
              from: 1,
              to: 2,
              name: 'Connected device',
              color: '#7CFF89' //LIGHT GREEN
            },{
              from: 2,
              to: 33,
              name: 'Maximum strength, potentially undesirable (one AP`s power may be set too high causing interface with others)',
              color: '#00C64F' //DARK GREEN
            },{
              from: 33,
              to: 70,
              name: 'Adecuate strength for streaming video',
              color: '#7CFF89' //GREEN
            },{
              from:  70,
              to:  73,
              name: 'Insufficient strength for streaming video',
              color:'#E1FF8E'  //YELLOW
            },{
              from: 73,
              to: 83,
              name: 'Strength sufficient for email and webbrowsing only',
              color:'#FCA15F'  //ORANGE
            },{
              from: 83,
              name: 'Low Strength, likely unusable for even basic functions',
              color:'#AD4057'  //DARK RED
            }]
          },
          legend: {
            y: 25,
            align: 'center',
            layout: 'horizontal',
            verticalAlign: 'top',
            labelFormatter: function() {
              var words = this.name.split(/[\s]+/);
              var numCharsPerLine = 25;
              var currentChars = 0;
              var str = [];

              for (var word in words) {
                if (currentChars + words[word].length > numCharsPerLine){
                  str.push('<br>');
                  currentChars = words[word].length;

                }else{
                  currentChars+=words[word].length
                }

                str.push(words[word]);
              }

              var label = str.join(' ');

              return label;
            }
          }
        }
      })();
    }, 500);

  }

})();
(function () {
  'use strict';

  var translations = {
    "REPORT": {
      "FILTER"          : "Filter",
      "EXPORTTOPDF"     : "Export to PDF",
      "EXPORTTOEXCEL"   : "Export to Excel"
    },
    "SECTION": {
      "FROM"            : "From",
      "TO"              : "To",
      "DURATION"        : "Duration",
      "AREA_NAME"       : "Area name", 
      "RECEIVER_NAME"   : "Receiver name"
    },
    "STATE": {
      "FROM"            : "From",
      "TO"              : "To",
      "DURATION"        : "Duration",
      "AREA_NAME"       : "Area name", 
      "RECEIVER_NAME"   : "Receiver name",
      "APPLICATION"     : "Application"
    },
  	"VALIDATION": {
      "FROM"            : "From",
      "TO"              : "To",
      "DURATION"        : "Duration",
      "AREA_NAME"       : "Area name", 
      "RECEIVER_NAME"   : "Receiver name",
      "CLIENT_IP"       : "Client Ip",
      "MAC_ADDRESS"     : "Mac Address",
      "COUNT"           : "Count"
    }

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
      
(function(){
  'use strict';
  angular.module('GoCloudCast.modules.reports').factory('SignalStrengthService', SignalStrengthService);

  function SignalStrengthService(StorageService, ApiService, DeviceService) {

    var instance = {};

    instance.getGraphData       = getGraphData;
    instance.getDataAndColumns  = getDataAndColumns;
    instance.groupAndFormatData = groupAndFormatData;
    instance.addDisconnectReceivers  = addDisconnectReceivers;

    function getGraphData(start, end, ssid){
      var property = StorageService.getProperty();
      var uri = "/public/es/signal-strength/graph-data?property_id=" + property.id + 
                    '&from=' + start + '&to=' + end + '&token=' + property.token;
      if (ssid) {
        uri = uri + "&ssid=" + ssid;
      }
      return ApiService.get(uri);
    }

    function groupAndFormatData(receivers, signal_data){
      var group_data = addDisconnectReceivers(receivers, signal_data);
      return getDataAndColumns(group_data);
    }

    function getDataAndColumns(signal_data){
      var formattedData = null;
      if(DeviceService.isLongDesktop())
        formattedData = threeAxysGetChartData(signal_data,'avg_signal',10)
      else if (DeviceService.isMediumDesktop()) 
        formattedData = threeAxysGetChartData(signal_data,'avg_signal',9)
      else if (DeviceService.isShortDesktop()) 
        formattedData = threeAxysGetChartData(signal_data,'avg_signal',7)
      else if (DeviceService.isTablet())
        formattedData = threeAxysGetChartData(signal_data,'avg_signal',4)
      else formattedData = threeAxysGetChartData(signal_data,'avg_signal',2)

      return formattedData;
    }

    function threeAxysGetChartData(array,toValue,columns){
      var currentX = 0;
      var currentY = 0;

      return array.map(function(row){
        var formated = {}
        if(row[toValue] == undefined) row.color = "#000000"
        Object.keys(row).forEach(function(key){
          if(toValue == key) formated.value = -row[key]
          else formated[key] = row[key]
        });

        formated.x = currentX;
        formated.y = currentY;

        if(currentX < columns-1) currentX++
        else { currentX=0; currentY++ } 

        return formated;
      });
    }

    function addDisconnectReceivers(receivers, data_resolve){
      var group_data = data_resolve;
      receivers.map(function(rec){
        var disconnect_receiver = group_data.filter(function(signal){
          return rec['ip_address'] == signal['ip_address']
        });
        if(disconnect_receiver == null || disconnect_receiver.length == 0){
          rec['receiver_name'] = rec['name'];
          group_data.push(rec);
        }
        return rec;
      });
      return group_data;
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.reports.signal-strength').controller('SignalStrengthReportsController', SignalStrengthReportsController);
  
  function SignalStrengthReportsController($rootScope, $scope, $window, $timeout, StorageService, ReceiversService, chartHelperService, DeviceService, SignalStrengthService,
    date_format_resolve, start_date_resolve, end_date_resolve, data_resolve, receivers_data, frecs_resolve) {

    var receivers = receivers_data.data;

    var vm = this;
    
    vm.data = data_resolve;
    
    vm.start_date = start_date_resolve;
    vm.end_date = end_date_resolve;

    vm.frecs = frecs_resolve;

    //Configuraciones esteticas para el muestreo en frontend
    vm.dBms_color = [
      { background_color: '#00C64F', color: 'white'}, //DARK GREEN
      { background_color: '#7CFF89', color: 'black'}, //GREEN
      { background_color: '#E1FF8E', color: 'black'}, //YELLOW
      { background_color: '#FCA15F', color: 'black'}, //ORANGE
      { background_color: '#AD4057', color: 'white'}, //DARK RED
      //{ background_color: '#79797a', color: 'white'}, 
      { background_color: '#000000', color: 'white'}  //BLACK
    ]

    //Implementacion actual de fast feedback de estado de areas
    vm.frecs_count = [
      { name: '0 to -32 dBm',        count: 0  },
      { name: '-33 to -69 dBm',      count: 99 },
      { name: '-70 to -72 dBm',      count: 0  },
      { name: '-73 to -82 dBm',      count: 0  },
      { name: '-83+ dBm',            count: 0  },
      //{ name: 'Wired',               count: 0  },
      { name: 'Offline/No Readings', count: 1  }
    ]

    //Muestreo final de estado de los dBms en fontend
    vm.dBms_status = vm.frecs_count.map(function(frec,index){
      return Object.assign(frec, vm.dBms_color[index] )
    })

    vm.basicValidation  = basicValidation;
    vm.openPicker       = openPicker;
    vm.filter           = filter;
    vm.clear            = clear;
    vm.dateFormat = 'yyyy-MM-dd';
    vm.datepickerOptions = {
      showWeeks: false,
      appendToBody: true
    };

    function setChartSize(){
      function resize(heigth) {
        var chart = vm.heatmapConfig.getHighcharts();
        var elem = chart.container;
        var parent = $(elem).parent();
        chart.setSize(parent.width()+1, heigth);
      }

      var chartHeigth = chartHelperService.calculateChartHeight(data_resolve);
      resize(chartHeigth);
    }

    function getTextColor(color){
      var config = vm.dBms_color.find(function(dBm_font_config){
        return dBm_font_config.background_color == color;
      })  

      return config? config.color: "white";
    }

    function formatAttributeText(att1){
      var text = (att1) ? att1 : ""
      return text + '<br>';
    }

    function formatSampleDateTime(attDateTime){
      var textDiv = "";
      if (attDateTime) {
        var dateTime = attDateTime.split(" ");
        textDiv = dateTime[0];// + '<br>' + dateTime[1];
      }
      return textDiv + '<br>';
    }

    function truncateString(str, length, ending){
        if (length == null) {
          length = 100;
        }
        if (ending == null) {
          ending = '...';
        }
        if (str.length > length) {
          return str.substring(0, length - ending.length) + ending;
        } else {
          return str;
        }
    }

    function datalabelSignalStreght(point){
      var str =  '<div style="display: flex; width: 80%; position: relative; top: 20px; left: 5px;">' 

      if(point.value != undefined) 
        str+= '<span p style="position: relative; top: 18px;">'
          + point.max_signal 
        + '</span>' 
        + '<h1>' 
          + '-' + Math.trunc(point.value)
        + '</h1>' 
        + '<span p style="position: relative; top: 18px;">' 
          + point.min_signal 
        + '</span>'
      else
        str+= '<h1>N/A</h1>'

      str+= '</div>'
      return str;
    }

    function tooltipSignalStreght(point){
      var str = ''

      if(point.value != undefined) 
        str+= '<span> Worst signal: ' + point.min_signal + '</span><br>'
            + '<span> Average signal: -' + Math.trunc(point.value) + '</span><br>'
            + '<span> Best signal: ' + point.max_signal + '</span><br>'
      else
        str+= '<span> Average signal: N/A</span><br>'

      return str;
    }

    function basicValidation(form, field) {
      return field.$invalid && (field.$dirty || form.$submitted)
    }

    function openPicker(e,picker) {
      vm[picker] = true;
    }

    function clear(){
      vm.ssid           = undefined;
      vm.frec_band      = undefined;
    }

    function updateImages(){
        chartHelperService.updateChart(vm.heatmapConfig.getHighcharts(), { data: vm.data });
      }

    function filter(){
      var format_start_date = moment(vm.start_date).format(date_format_resolve);
      var format_end_date = moment(vm.end_date).format(date_format_resolve);
      SignalStrengthService.getGraphData(format_start_date, format_end_date, vm.ssid).then(function(data){
          data_resolve = data.data;
          if (!vm.ssid) {
            SignalStrengthService.addDisconnectReceivers(receivers, data_resolve)
          }
          vm.data = SignalStrengthService.getDataAndColumns(data_resolve);
          updateImages();
      });
    }

    $scope.$on("propertyChanged", function(){
       ReceiversService.getAll(true).then(function(data){
          receivers = data.data        
          filter()
       });    
    });


    angular.element($window).on('orientationchange', function() {
      $timeout(function(){
        setChartSize()
      }, 200)
    });

    $timeout(function(){
      vm.heatmapConfig = chartHelperService.simpleChart('heatmap', {
        data: vm.data,
        dataLabels: {
          enabled: true,
          style:{
            pointerEvents: 'none'
          },
          useHTML: true,
          formatter: function () {
            return '<div class="text-center" style="color: ' + getTextColor(this.point.color) + '">'
                      + '<h5>' + truncateString(this.point.area_name, 12) + '</h5>'
                      + this.point.receiver_name + '<br>'
                      + this.point.ip_address + '<br>'
                      + formatAttributeText(this.point.ap_bssid)
                      + formatSampleDateTime(this.point.sample_date)
                      + datalabelSignalStreght(this.point)
                    +'</div>'
          }
        }
      }, {
        title : null,
        typeCallbackParameters: {
          tooltip: {
            borderWidth: 0,
            shadow: false,
            backgroundColor: "rgba(255,255,255,0)",
            useHTML: true,
            formatter: function () {
              return '<div class="text-center heatmap-tooltip" style="border: 3px solid ' + this.point.color + ';">'
                        + '<b>' + this.point.area_name + '</b><br>'
                        + tooltipSignalStreght(this.point)
                        //+ '<span> Standard deviation: ' + this.point.standard_deviation + '</span><br>'
                        + '<span> # of samples: ' + this.point.samples_count + '</span><br>'
                        //+ '<span> # of APs: ' + this.point.number_of_aps + '</span><br>'
                      +'</div>'
                      +'<div class="triangle-down" style="border-top: 15px solid ' + this.point.color + ';"></div>'
            }
          },
          colorAxis: {
            dataClasses: [{
              from: 0,
              to: 33,
              name: 'Maximum strength, potentially undesirable (one AP`s power may be set too high causing interface with others)',
              color: '#00C64F' //DARK GREEN
            },{
              from: 33,
              to: 70,
              name: 'Adecuate strength for streaming video',
              color: '#7CFF89' //GREEN
            },{
              from:  70,
              to:  73,
              name: 'Insufficient strength for streaming video',
              color:'#E1FF8E'  //YELLOW
            },{
              from: 73,
              to: 83,
              name: 'Strength sufficient for email and webbrowsing only',
              color:'#FCA15F'  //ORANGE
            },{
              from: 83,
              name: 'Low Strength, likely unusable for even basic functions',
              color:'#AD4057'  //DARK RED
            }]
          },
          legend: {
            align: 'center',
            layout: 'horizontal',
            verticalAlign: 'top',
            labelFormatter: function() {
              var words = this.name.split(/[\s]+/);
              var numCharsPerLine = 25;
              var currentChars = 0;
              var str = [];

              for (var word in words) {
                if (currentChars + words[word].length > numCharsPerLine){
                  str.push('<br>');
                  currentChars = words[word].length;

                }else{
                  currentChars+=words[word].length
                }

                str.push(words[word]);
              }

              var label = str.join(' ');

              return label;
            }
          }
        }
      })()

    }, 500);

  }

})();
(function () {
  'use strict';

  var translations = {
  	"SERVICES": {
  	  "SERVICE"  : "Service",
  	  "STATUS"   : "Status"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"TEMPLATE": {
  	  "CROP_IMAGE"       			        : "Edit Image",
  	  "IMAGE_DIMENSIONS" 			        : "Dimensions: {{width}}X{{height}}",
  	  "IMAGE_DIMENSIONS_ACCEPTED"	    : "Dimensions accepted: min({{minWidth}}x{{minHeight}})",
      "IMAGE_DIMENSIONS_ACCEPTED_MAX" : "max({{maxWidth}}x{{maxHeight}})"
    }
  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"USERS": {
  	  "NEW"                : "Add User",
      "ID"                 : "Id",
  	  "FIRST_NAME"         : "First Name",
      "LAST_NAME"          : "Last Name",
      "USERNAME"           : "Username",
      "EMAIL"              : "Emails",
      "PASSWORD"           : "Password",
      "PASSWORD_CONFIRM"   : "Password Confirm",
      "ALL_PROPERTIES"     : "All Properties",
      "ROLE"               : "Role",
      "NOTIFICATIONS"      : "Notifications"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = $scope.data;
    };

  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = $scope.data[0];
      $scope.data[1] = $scope.data[1];
    };

  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .controller('DashboardInfoAverageCtrl', DashboardInfoAverageCtrl);

  /** @ngInject */
  function DashboardInfoAverageCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.pieColor = pieColor;
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .directive('dashboardInfoAverage', dashboardInfoAverage);

  /** @ngInject */
  function dashboardInfoAverage() {
    return {
      restrict: 'E',
      controller: 'DashboardInfoAverageCtrl',
      scope: {
        averageCharts: '=averageCharts'
      },
      templateUrl: 'app/pages/dashboard/dashboardInfoAverage/dashboardInfoAverage.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'App1',
              'App2',
              'App3',
              'App4',
              'App5',
              'App6'
          ],
          datasets: [
              {
                  data: [45, 29, 20, 17, 15, 10],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var n = 0; n < mapData.length; n++) {
      var dataItem = mapData[i];
      var value2 = dataItem.value;
      // calculate size of a bubble
      var square = (value2 - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value2
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {


  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('GoCloudCast.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('GoCloudCast.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($rootScope, $state, $scope, baSidebarService, toastr, StorageService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $rootScope.$on('appVariablesSetted', function () {
      $scope.menuItems = baSidebarService.getMenuItems();
    });

    $rootScope.$on('finishUpdateProperties', function () {
      checkDisabled()
    });

    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    function checkDisabled(){
      for (var i = 0; i < $scope.menuItems.length; i++){
        $scope.menuItems[i].disabled = !StorageService.hasProperty();
      } 
    }

    $scope.changeState = function(stateRef,disabled,message) {
      if(!disabled)
        $state.transitionTo(stateRef);
      else
        if(message)
          toastr.warning(message, 'Warning!');
        else
          toastr.warning('The section is disabled for some reason', 'Warning!');
    };

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.isAnySection = function(item){
      var subSections = baSidebarService.getSubSections(item.name);

      return $state.includes(item.stateRef) || subSections.some(function(section){return $state.includes(section)});
    }

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];
    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes, StorageService) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });
          var subItems = states.filter(function(subItem) {
            return subItem.level == 1;
          })

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              subItems.forEach(function(subitem) {
                var subChildren = states.filter(function(subChild){
                  return subChild.level == 2 && subChild.name.indexOf(subitem.name) === 0;
                })
                subitem.subMenu = subChildren.length ? subChildren : null;
              })  
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });
          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function arrayIntersecion(array1, array2) {
          return array1.filter(function(n) {
            return array2.indexOf(n) !== -1;
          })
        }

        function filterForbiddenMenues(customer_permissions, sidebarMeta) {
          var required_permissions = typeof sidebarMeta.permissions === 'string'
                                    ? [sidebarMeta.permissions]
                                    : sidebarMeta.permissions;
          var permissions_needed = sidebarMeta.all_permissions ? required_permissions.length : 1;
          return arrayIntersecion(customer_permissions, required_permissions).length >= permissions_needed;
        }


        function defineMenuItemStates() {
          var customer_permissions = StorageService.getPermissions();
          return $state.get()
              .filter(function(s) {
                var show = true;
                if (s.sidebarMeta && s.sidebarMeta.permissions) {
                  show = show && filterForbiddenMenues(customer_permissions, s.sidebarMeta);
                  return show;
                } 
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                
                return {
                  name: s.name,
                  disabled: meta.disabledWithoutProperty? !StorageService.hasProperty(): false,
                  message: meta.propertyErrorMessage,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });

        }

        this.getSubSections = function(sectionName){
          var sections = $state.get()
                          .filter(function(s) {
                            return s.contentTopParent == sectionName;
                          }).map(function(s) {
                            return s.name
                          });
          return sections;

        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }

        this.addStaticItem = function(item) {
          staticMenuItems.push(item);
        }

      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current) || menuItem.subMenu.some(function(submenu){
        return submenu.name == $state.current.contentTopParent;
      })) {
        $element.addClass('ba-sidebar-item-expanded');
      } else {
        $element.removeClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        var checkLevels = toState.contentTopParent ? _isSecondOrThirdLevel(toState) : !_isSecondOrThirdLevel(toState) 
        if (checkLevels && !_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
        }
      });
    }

    function _isSecondOrThirdLevel(toState){
      return toState.contentTopParent == $state.current.name && toState.contentTopParent == $state.current.contentTopParent;
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {

        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('GoCloudCast.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('GoCloudCast.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      updateTabNum(0)
      calcProgress()
    };

    $scope.$watch(angular.bind(vm, function () {
      return vm.tabNum;}), calcProgress);

    function updateTabNum(tabNum){
      vm.tabNum = tabNum;
      vm.tabs.forEach(function (t, tIndex) {
        tIndex == vm.tabNum ? t.select(true) : t.select(false);
      });
    }

    vm.selectTab = function(tab){
      if(vm.tabs[vm.tabNum].isComplete()){
        if (vm.tabs[tab].isAvailiable()) {
          updateTabNum(tab)
          $scope.$apply()
        }
      }
    }

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.tabs[vm.tabNum].submit().then(function(data){
        if (!vm.isLastTab())  {
          var currentTab = vm.tabs[vm.tabNum + 1];
          if (currentTab && currentTab.isAvailiable()) {
            updateTabNum(vm.tabNum + 1);
            $scope.$apply();
          }
        }
      }, function(error){
        console.log(error)
      })
    };

    vm.previousTab = function () {
      updateTabNum(vm.tabNum - 1)
    };

    vm.saveFinalStep = function() {
      return vm.tabs.length > vm.tabNum && vm.tabs[vm.tabNum].isComplete()
    }

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('GoCloudCast.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '=',
        submitFunction: '&submitFunction'
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;
        //if($scope.form && $scope.form.$valid ){  
          //$scope.submitFunction = $scope.submitFunction(); 
        //}

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          var prom = new Promise(function(resolve, reject) {
            if($scope.form && $scope.form.$valid){
              if($scope.submitFunction && !$scope.form.$submitted){
                $scope.submitFunction().then(
                  function(data){
                    $scope.form.$setSubmitted(true)
                    resolve()                  
                  },
                  function(error){
                    reject(new Error("error submiting"));
                  })
              } else {
                resolve();
              }
            } else {
              resolve();
            }
          }) 
          return prom 
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    function controller(){
      
      var contentTop = this;

    }

    function getTitle(currentState){
      return (typeof currentState.title === 'function') ? currentState.title() : currentState.title;
    }

    function link($scope, element, attr, contentTop){
      $scope.$watch(function () {
        contentTop.activePageTitle = getTitle($state.current);
        if (!!$state.current.contentTopParent){
          contentTop.activeHasParent = true;
          contentTop.activeParent = $state.get($state.current.contentTopParent);
        } else {
          contentTop.activeHasParent = false;
          contentTop.activeParent = undefined;
        }
      });
    }

    return {
       restrict: 'E',
        templateUrl: 'app/theme/components/contentTop/contentTop.html',
        link: link,
        controller : controller,
        controllerAs : 'contentTop'
    };
  }

})();
(function () {
  'use strict';

  var translations = {
  	"BUTTONS": {
  	  "CANCEL"     : "Cancel",
          "SAVE"       : "Save",
  	  "CONTINUE"   : "Continue",
          "SAVE_IMAGE" : "Save Image",
          "ASSIGN"     : "Assign",
	  "ADD"        : "Add"	
  	},
  	"ALERTS": {
  	  "CONFIRM"    : "Confirm the Operation",
  	  "DELETE"     : "Are you sure you want to delete the item?",
      "SUCCESFULL" : "The operation was completed successfully",
      "ERROR"      : "An error has occurred"
  	},
    "VALIDATIONS": {
      "REQUIRED"       : "This field is required",
      "EMAIL"          : "Please enter a valid email",
      "NUMBER"         : "Please enter a number",
      "NAME_USED"      : "Name Used",
      "MIN_LENGTH"     : "The value does not meet the minimum long",
      "MAX_LENGTH"     : "The value exceeds the maximum number of characters",
      "PASSWORD_MATCH" : "Password not match",
      "IP_ADDRESS"     : "Invalid Ip",
      "URL"            : "This Field must be a valid URL",
      "MAC_ADDRESS"    : "Invalid format (FF:FF:FF:FF:FF:FF)",
      "DATE"           : "The value isn't date. Correct format is YYYY-MM-DD"
    },
    "TABLES": {
      "EDIT"     : "Edit",
      "DELETE"   : "Delete",
      "RESTART"  : "Restart",
      "REBOOT"   : "Reboot",
      "ADD"      : "Add",
      "CHANNELS" : "Channels"

    },
    "DASHBOARD": {
      "TITLE" : "Title",
      "TOTAL_ROOMS" : "Total Rooms",
      "USES" : "Uses",
      "GUEST_STREAMED" : "Guest Streamed",
      "DURATION_ONE_USE" : "Duration One Use",
      "TOTAL_DURATION" : "Total Duration",
      "USERS_PER_STAY" : "Users Per Stay"
    },
    "ERRORS": {
      "LOADSECTION" : "La seccion no ha podido cargarse, intente mas tarde",
      "400"         : "Bad Request",
      "401"         : "El token expiro",
      "503"         : "Failed to connect with the Property local server",
      "GRAPH"       : "The chart",
      "TRY_AGAIN"   : "could not be loaded, try again later"
    }

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop(StorageService,PropertiesService,SessionService) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html',
      controllerAs: 'vm',
      controller: function($rootScope,$scope,$attrs){
        var vm = this;

        vm.propertySelected = "";

        vm.logout = function logout(){
          SessionService.logout();
        }

        vm.refreshProperties = function() {
          vm.properties = StorageService.getProperties();
          vm.propertySelected = vm.properties ? vm.properties[0] : "";

          if(vm.propertySelected != "" && !StorageService.getProperty()){
            StorageService.setActualProperty(vm.propertySelected);
          
          } else {

            if (StorageService.hasProperty() && (StorageService.getProperty().id !=vm.propertySelected.id)){
              vm.propertySelected = vm.properties[vm.properties.findIndex(
                function(prop){
                  return prop.id==StorageService.getProperty().id
                }
              )]
            }
          }
        };

        vm.refreshProperties();

        $rootScope.$on("propertiesUpdated", function(){
          console.log("--refresh");

          PropertiesService.getAllWithoutPagination().then(function(data){
            StorageService.removeProperties();

            var properties = data.data;

            StorageService.setProperties(properties);
            vm.refreshProperties();
            $rootScope.$broadcast("finishUpdateProperties");
          });
        });



        vm.changeProperty = function() {
          if (StorageService.hasToken()){
            StorageService.setActualProperty(vm.propertySelected);
            $rootScope.$broadcast("propertyChanged");
          }
        };
      }
    };
  }



})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('GoCloudCast.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .directive('selectOrCreate', selectOrCreate);

  function selectOrCreate() {
    return {
      restrict: 'E',
      require: '^form',
      scope: {
        id: '@',
        label: '@',
        placeholder: '@',
        model: '=',
        modelProperty: '@',
        items: '=',
        onClickFn: '=',
        buttonText: '@',
        labelNotExist: '@',
        ifCondition: '='
      },
      templateUrl: 'app/theme/components/selectOrCreate/selectOrCreate.html',
      link: function(scope, element, attrs, controller) {
        scope.idform = controller[scope.id];
        scope.form   = controller;
        scope.onSelected = onSelected;
        scope.disable = true;    

        function onSelected(selected) {
          var found = scope.items.some(function(item){
            return item.name == selected.name;
          });
          scope.disable = found;
          if (found && selected.isFreeText) {
            scope.model[scope.modelProperty] = scope.items.find(function(item){
              return item.name == selected.name;
            });
          }
        }
      }
    }
  };
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.components')
      .directive('themewidgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher(StorageService) {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '=',
        switcherDisabled: '=',
        switcherOn: '@',
        switcherOff: '@',
        switcherClick: '&',
        permission: '@?'
      },
      link: function(scope, element, attrs, controller) {
        scope.hasPermission = !scope.permission || StorageService.getPermissions().includes(scope.permission);
      }
    };
  }

})();

(function () {
  'use strict';

  var translations = {
  	"AREAS": {
  	  "NEW"                : "Add Area",
  	  "NAME"               : "Name",
      "CODE"               : "Current Code",
      "RECEIVERS_QUANTITY" : "Receiver Quantity",
      "AREA_TYPE"          : "Type"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"AREA_TYPES": {
  	  "NEW"                : "Add Area Type",
  	  "LAYOUT"             : "Layout {{tvOrReceiver}}"
   	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"NEWS": {
  	  "CATEGORY"         : "Category",
  	  "TITLE"            : "Title",
      "ALL_AREAS"        : "All areas",
      "EXPIRATION_DATE"  : "Expiration Date",
      "PUBLICATION_DATE" : "Publication Date",
      "AREAS"            : "Areas",
      "NEW"              : "Add News"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.cast.notifications.notificationEmails').controller('NotificationEmailsController', NotificationEmailsController);
  
  function NotificationEmailsController($rootScope,$controller,$scope, StorageService, NotificationEmailsService, NotificationService) {
    var vm = this;

    var fields = ['name', 'email'];
    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'notification-emails',
        fieldsToFilter : fields
      }, scope : $scope
    }))

    $scope.$on("propertyChanged", function(){
      vm.table.reload();
    });
    vm.changeActiveState     = changeActiveState;
    vm.availableSearchParams = vm.generateParams(fields);

    function changeActiveState(notificationEmail){
      NotificationEmailsService.save(notificationEmail).then(function(data){
        NotificationService.success('Notification email active state changed', 'Success');
        vm.refreshTable();
      },function(error){
        NotificationService.error('Notification email active state not changed', 'Error');
      });
    }
  }

  function refreshTable(){            
      vm.table.reload();
    }

})();            
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.cast.notifications.notificationEmails').controller('NotificationEmailsAddEditController', NotificationEmailsAddEditController);
  
  function NotificationEmailsAddEditController($state, $scope, $controller, notificationEmail, NotificationEmailsService ) {
    var vm = this;
    
    vm.data = notificationEmail.data;

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl            : 'cast.notifications.notification-emails-list' 
      }, service : NotificationEmailsService,
      scope: $scope
    }))

  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules.cast.notifications').factory('NotificationEmailsService',NotificationEmailsService);

  function NotificationEmailsService(StorageService, ApiService) {

    var instance = {};

    instance.getAll                    = getAll;
    instance.get                       = get;
    instance.save                      = save;
    instance.getEmptyNotificationEmail = getEmptyNotificationEmail;
    instance.delete                    = deleteNotificationEmail;

    function getAll(){
      return ApiService.get("/notification-emails?property_id=" + StorageService.getProperty().id);
    }

    function get(id){
      return ApiService.get("/notification-emails/"+id);
    }

    function getEmptyNotificationEmail(){
     return {"data": {
                "name":"",
                "email":"",
                "active":false
                }
              };
    }

    function save(notificationEmails){
      if (notificationEmails.id) {
        return ApiService.put('/notification-emails/'+notificationEmails.id, notificationEmails);
      } else {
        return ApiService.post('/notification-emails', notificationEmails);
      }
    }

    function deleteNotificationEmail(id){
      return ApiService.delete('/notification-emails/'+id);
    }

    return instance;
  }

})();
(function () {
  'use strict';

  var translations = {
  	"RECEIVERS": {
  	  "NEW"                 : "Add Receiver",
  	  "NAME"                : "Name",
      "AREA_NAME"           : "Area Name",
      "AREA"                : "Area",
      "TYPE"                : "Type",
      "AREA_TYPE"           : "Area Type",
      "UUID"                : "uuid",
      "IP_ADDRESS"          : "IP Address",
      "SMART_TV_IP_ADDRESS" : "Smart TV IP Address",
      "MAC_ADDRESS"          : "Mac Address",
      "SMART_TV_MAC_ADDRESS" : "Smart TV Mac Address",
      "CHROMECAST_INPUT"    : "Chromecast Input",
      "CREATE_AREA"         : "Create Area",
      "CREATE_AREA_TYPE"    : "Create Area Type",
      "DISCOVERY_WARNING"   : "Discovery list is loading",
      "AREA_NOT_EXIST"      : "Area not exist, you should create it",
      "AREA_TYPE_NOT_EXIST" : "Area Type not exist, you should create it",
      "LAST_APP_DATE"       : "Last Activity Date",
      "REFRESH_TOKENS"      : "Refresh tokens"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"SENDERS": {
  	  "ID"            : "Id",
  	  "IP_ADDRESS"    : "Ip Address",
      "MAC_ADDRESS"   : "Mac Address",
      "AREA_NAME"     : "Area Name",
      "NAME"          : "Name",
      "PLATFORM"      : "Platform",
      "BROWSER"       : "Browser",
      "MANUALASSIGN"  : "Manual Assignment",
      "REVOKE"        : "Revoke",
      "MDNS"          : "Enable MDNS",
      "DATE"          : "Verification Date"
    }

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"IMAGE": {
      "IMAGE_FORMAT_ACCEPTED"         : "Please choose an accepted format: {{availableImageTypes}}.",
      "THE_IMAGE_IS_BIG"              : "Please choose a smaller image. Less than {{maxAllowedSize}}MB.", 
      "CROP_IMAGE"                    : "Edit Image",
      "IMAGE_DIMENSIONS"              : "Dimensions: {{width}}X{{height}}",
      "IMAGE_DIMENSIONS_ACCEPTED"     : "Dimensions accepted: min({{minWidth}}x{{minHeight}})",
      "IMAGE_DIMENSIONS_ACCEPTED_MAX" : "max({{maxWidth}}x{{maxHeight}})",
      "MESSAGE"                       : "The image will be displayed better in the application if it has a 16/9 aspect ratio",
      "HOVER_IMAGE"                   : "Change Image",
      "LABEL"                         : "Add Image" 
    }
  }
  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();

(function() {

  'use strict';
/*
  angular.module('GoCloudCast.modules').controller('EditImageController', EditImageController);
  
  function EditImageController($scope, $timeout, $uibModalInstance, $stateParams, $state, image, resolutions, aspectRatio, withMessage, Cropper) {
    var vm = this;

    vm.save      = save;
    vm.cancel    = cancel;
    vm.saveImage = true;

    // Crop config
    vm.minWidth    = resolutions.minWidth;
    vm.minHeight   = resolutions.minHeight;
    vm.maxWidth    = resolutions.maxWidth;
    vm.maxHeight   = resolutions.maxHeight;
    vm.aspectRatio = aspectRatio;
    vm.withMessage = withMessage;
    

    $scope.supportedDimensions = {
      minWidth: vm.minWidth,
      minHeight: vm.minHeight,
      maxWidth: vm.maxWidth,
      maxHeight: vm.maxHeight,      
    };

    var file, data, croppedImage;

    $scope.image = image;

    $scope.onFile = function(blob) {
      Cropper.encode((file = blob)).then(function(dataUrl) {
        $scope.image = dataUrl;
        $timeout(showCropper);  // wait for $digest to set image's src
      });
    };

    $scope.onFile(image);
    //Cropper.background(false)

    $scope.cropper = {};
    $scope.cropperProxy = 'cropper.first';

    $scope.preview = function() {
      return Cropper.crop(file, data).then(Cropper.encode).then(function(dataUrl) {
        croppedImage = dataUrl;
        //($scope.preview || ($scope.preview = {})).dataUrl = dataUrl;
      });
    };

    $scope.options = {
      aspectRatio: vm.aspectRatio,
      crop: function(dataNew) {
        vm.saveImage = verifyCrop(dataNew);
        $scope.dimensions = {
          width: Math.trunc(dataNew.width),
          height: Math.trunc(dataNew.height),
        };
        data = dataNew;
        $scope.$apply();
      }
    };

    $scope.showEvent = 'show';
    $scope.hideEvent = 'hide';

    function verifyCrop(imageCrop){
      if (!vm.maxHeight && !vm.maxWidth) {
        return verifyMinCrop(imageCrop);  
      }
      else if (!vm.minHeight && !vm.minWidth) {
        return verifyMaxCrop(imageCrop);  
      }
      else {
        return verifyMinCrop(imageCrop) && verifyMaxCrop(imageCrop);
      }
    }

    function verifyMinCrop(imageCrop){
      return imageCrop.width >= vm.minWidth && imageCrop.height >= vm.minHeight;
    }

    function verifyMaxCrop(imageCrop){
      return imageCrop.width <= vm.maxWidth && imageCrop.height <= vm.maxHeight;
    }

    function showCropper() { $scope.$broadcast($scope.showEvent); }

    function save(){
      $scope.preview().then(function (argument) {
        //var image  = croppedImage.slice(croppedImage.lastIndexOf("base64,") + 7) //croppedImage es un string croppedImage:image/jpeg;base64,/etc.. a mi lo que me interesa es lo que esta despues de base64,
        var image = croppedImage
        $uibModalInstance.close({image: image, croppedImage: croppedImage});
      })
    }

    function cancel() {
      $uibModalInstance.close();
    }
    
  }
*/
})();

(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('ChannelListsService',ChannelListsService);

  function ChannelListsService(StorageService, ApiService) {

    var instance = {};
 
    instance.getAll             = getAll;
    instance.get                = get;
    instance.save               = save;
    instance.getEmptyChannel    = getEmptyChannel;
    instance.delete             = deleteChannels;
    instance.getTypes           = getTypes;
    instance.getStates          = getStates;
    instance.uploadChannelImage = uploadChannelImage;
    instance.getLanguages       = getLanguages;
    instance.addChannelLanguages = addChannelLanguages; 
    instance.uploadChannelVideo = uploadChannelVideo;

    function getAll(){
      return ApiService.get("/channels?property_id=" + StorageService.getProperty().id);
    }

    function get(id){
      return ApiService.get("/channels/"+id);
    }

    function getEmptyChannel(){
     return {"data": {
                "property_id":StorageService.getProperty().id,
                "number":"",
                "image":"",
                "name":"",
                "type":"",
                "frequency":0, //deberia ser empty
                "url":"", //deberia ser empty
                "state":"disabled",
                "channel_types": [],
                "channel_languages":[
                  {
                    "channel_id":"",
                    "language_code":"es",
                    "name":"",
                    "description":"",
                    "property_id":StorageService.getProperty().id
                  },
                  {
                    "channel_id":"",
                    "language_code":"en",
                    "name":"",
                    "description":"",
                    "property_id":StorageService.getProperty().id
                  },
                  {
                    "channel_id":"",
                    "language_code":"pt",
                    "name":"",
                    "description":"",
                    "property_id":StorageService.getProperty().id
                  },
                  {
                    "channel_id":"",
                    "language_code":"fr",
                    "name":"",
                    "description":"",
                    "property_id":StorageService.getProperty().id
                  }
                 ]
                }
              };
    }

    function getTypes(){
      return ApiService.get("/channels/types");
    }

    function getStates(){
      return ApiService.get("/channels/states");
    }

    function save(channels){
      if (channels.id) {
        return ApiService.put('/channels/'+channels.id, channels);
      } else {
        return ApiService.post('/channels', channels);
      }
    }

    function deleteChannels(id){
      return ApiService.delete('/channels/'+id);
    }

    function uploadChannelImage(data){
      return ApiService.post("/channels/upload-channel-image", data);
    }

    function getLanguages() {
      return ApiService.get('/languages');
    }

    function addChannelLanguages(channelLanguages){
      return ApiService.put("/channel-languages", channelLanguages);
    }

    function uploadChannelVideo(data){
      return ApiService.post("/channels/upload-channel-video", data);
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.channels.lists').controller('ChannelListsController', ChannelListsController);

  function ChannelListsController($rootScope, $controller, $scope, $location, ConfigurationVariablesService, types, states, StorageService, ChannelListsService, NotificationService) {

    var vm = this;

    vm.types = types.data;
    vm.states = states.data;
    vm.generatedPathChannelImage = generatedPathChannelImage;
    vm.savePosition = savePosition;
    vm.getChannelTypes = getChannelTypes;
    
    var fields = ['number', 'name', 'type', 'state'];
    var suggestedValues = { type: vm.types, state: vm.states};

    function generatedPathChannelImage(imageName){
      var property = StorageService.getProperty();
      return ConfigurationVariablesService.getPathImage() + property.acronym +'/channel/'+ imageName;
    }

    function getChannelTypes(channel) {
      if (!channel.channel_types || !channel.channel_types.length) return '';
      var channelTypes = [];
      channel.channel_types.forEach(function(channelType) {
        channelTypes.push(channelType.channel_type_languages[0].name);
      });
      return channelTypes.join(", ");
    }

    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'channels',
        fieldsToFilter : fields,
        staticFilters  : {'property_id': function(){
          return StorageService.getProperty().id;
        }},
        sorting: {
          position: 'asc'
        },
        preProcessData : function(data){
          data.map(function(channel){
            channel['imagePath'] = generatedPathChannelImage(channel.image) + '?random='+Date.now();
            channel['stateBoolean'] = channel['state'] == "enabled" ? true : false;
          })
          return data;
        },  
      }, scope : $scope
    }))

    $scope.$on("propertyChanged", function(){
      vm.table.reload();
    });
    vm.getRfOrIptvValue      = getRfOrIptvValue;
    vm.enabledOrDisabled     = enabledOrDisabled;
    vm.availableSearchParams = vm.generateParams(fields, suggestedValues);


    function enabledOrDisabled(channel){
      channel.state        = channel.state == "enabled" ? "disabled" : "enabled";
      channel.stateBoolean = channel.state == "enabled" ? false : true;
      
      if(channel.type == "IPTV"){
        delete channel.frequency;
      }
      if(channel.type == "RF"){
        delete channel.url;
      }

      ChannelListsService.save(channel).then(function(data){
        NotificationService.success('Channel state successfully changed', 'Success');
        vm.refreshTable();
      },function(error){
        NotificationService.error('Channel state not changed', 'Error');
      });
    }


  function getRfOrIptvValue(channel){
  	if(channel.type=="IPTV"){
  		return channel.url
  	} else {
  		return channel.frequency
  	}
  }

  function refreshTable(){            
      vm.table.reload();
  }

   function savePosition(channel){

      if(channel.type == "IPTV"){
        delete channel.frequency;
      } 
      
      if(channel.type == "RF"){
        delete channel.url;
      }
      
      ChannelListsService.save(channel).then(function(data){
        NotificationService.success('Channel state successfully changed', 'Success');
        vm.refreshTable();
      },function(error){
        NotificationService.error('Channel state not changed', 'Error');
      });
   }
 }

})();            
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.channels.lists').controller('ChannelListsAddEditController', ChannelListsAddEditController);
  
  function ChannelListsAddEditController($state, $controller, $uibModal, $location, $scope, $translate, types, states, channel, StorageService, ConfigurationVariablesService, ChannelListsService, NotificationService,languages,channelTypes,NgTableParams) {
    var vm = this;

    var language = $translate.use();

    vm.types                     = types.data;
    vm.states                    = states.data;
    vm.data                      = channel.data;
    vm.availableImageTypes       = '".png"';
    vm.uploadChannelImage        = uploadChannelImage;
    vm.isEdition                 = Number.isInteger(vm.data.id);
    vm.check                     = check;
    vm.state                     = vm.data.state == 'enabled' ? true : false;
    vm.generatedPathChannelImage = generatedPathChannelImage;
    vm.getChannelImage           = getChannelImage;
    vm.channelImageBase64        = vm.isEdition ? vm.generatedPathChannelImage() : "/assets/img/theme/no-image.png";
    vm.languages                 = languages.data;
    vm.updateLanguages           = updateLanguages;
    vm.channelLanguagesForm      = {};
    vm.channelNoCreado           = channelNoCreado;
    vm.addChannelTypes           = addChannelTypes;
    vm.allChannelTypes           = channelTypes.data;
    vm.deleteChannelTypesSelected = deleteChannelTypesSelected;
    vm.channelTypeSelected       = {};

		vm.options = {
			language: 'en',
			allowedContent: true,
			entities: false,
      extraPlugins: 'colorbutton, font, justify'
		};
    
    vm.languageList = [];
    if(vm.data.id){
      vm.languageList = channel.data.channel_languages;
    } else {
      for (var lang in languages.data){
        vm.languageList.push({language_code: vm.languages[lang].code, channel_id: vm.data.id, description: ""});
      }
    }

    $scope.$watch('vm.channelForm', function(form) {
      if(form) {
        if(!vm.data.id){
          vm.channelForm.$valid   = false;
          vm.channelForm.$invalid = true;
        }
      }
    });

    vm.allChannelTypes = vm.allChannelTypes.map(function(channelType) {
      var channelTypeLanguageSelected = channelType.channel_type_languages.filter(
        function(channelTypeLanguage) {
          return channelTypeLanguage.language_code == language.toLowerCase()
        }
      )[0]
      channelType.name = channelTypeLanguageSelected.name != '' && channelTypeLanguageSelected.name != null ? channelTypeLanguageSelected.name : 'Not found';
      return channelType;
    })

    setNameToChannelTypes(vm.allChannelTypes);
    setNameToChannelTypes(vm.data.channel_types);
    setAvailableChannelTypes();

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl     : 'iptv.channels.lists-list',
        resolutions  : {
                minWidth: 100,
                minHeight: 100,
                maxWidth: 256,
                maxHeight: 256,
                ratio: 1,
        },
        onError : function(error,form) {
          if (error.data.data.errors.hasOwnProperty('name')) {
            vm.formValidates.alreadyExist(form, 'name', true);
          }
        },
        promise : function(data){
          vm.channelImage = data.croppedImage;
          vm.channelImageBase64 = data.croppedImage;
          vm.channelForm.$invalid   = false;
          vm.channelForm.$valid     = true;
          vm.channelForm.$submitted = false;
          if(vm.isEdition){
            uploadChannelImage();
          }
        },
         onLoad : function(data){
        },
        formatData   : function(data){
          if(data.type == "IPTV"){
            delete data.frequency;
          }
          if(data.type == "RF"){
            delete data.url;
          }
          if(!data.id){
            data.image_base64 = vm.channelImage;
          }
        },
        postSave     : function(data){
          vm.data = data.data
          vm.languageList = data.data.channel_languages
        }, 
        noRedirect: true,
      },
      service : ChannelListsService,
      scope : $scope
    }));

/*
    function channelSave(form, data) {
      // Remove dummy values.
      // Hard-coded, but it can't be done in the backend without setting these to Nullables. Pick your poison.
      switch (data.type) {
        case 'IPTV':
          delete data.video_port;
          delete data.video_name;
          delete data.frequency;
          break;
        case 'RF':
          delete data.video_port;
          delete data.video_name;
          delete data.url;
          break;
        case 'VIDEO':
          delete data.frequency;
          delete data.url;
          break;
      }

      vm.save(form, data)
    }
*/
    function generatedPathChannelImage(){
      var property = StorageService.getProperty();
      return ConfigurationVariablesService.getPathImage() + property.acronym + '/channel/'+ vm.data.image;
    }
    
    function uploadChannelImage(){
      ChannelListsService.uploadChannelImage({"channel_id":vm.data.id, "image_base64":vm.channelImage}).then(function(data){
          NotificationService.success('Image uploaded', 'Success');
          vm.languageList = data.data.channel_languages;
        },function(error){
          vm.channelImageBase64 = vm.generatedPathChannelImage();
          NotificationService.error('Error cant upload image', 'Error');
        });
    }

    function check(){
      vm.data.state = vm.state ? 'enabled' : 'disabled';
    }

    function getChannelImage(){
      return vm.channelImageBase64;
    }

    function updateLanguages() {
      ChannelListsService.addChannelLanguages({'languages':vm.languageList}).then(function(data){
        NotificationService.success('Channel language saved', 'Success');
        $state.go('iptv.channels.lists-list');
      },function(error){
        NotificationService.error('Channel language cannot be saved', 'Error');
      });
    }

    function channelNoCreado() {
      return !vm.data.id
    }

    function addChannelTypes() {
        vm.data.channel_types.push(vm.channelTypeSelected);
        vm.channelTypeSelected = undefined;
        setAvailableChannelTypes();
    }

    function deleteChannelTypesSelected(channelTypeDeleted) {
      vm.data.channel_types = vm.data.channel_types.filter(function (channelType) {
        return channelTypeDeleted.id != channelType.id;
      })
      setAvailableChannelTypes();
    }

    function setAvailableChannelTypes() {
      var channelTypeIdsSelected = vm.data.channel_types.map(function(channelType) { console.log(channelType); return channelType.id; });
      vm.availableChannelTypes = vm.allChannelTypes.filter(function(channelType) {
        return !channelTypeIdsSelected.includes(channelType.id);
      });
      vm.table = new NgTableParams({ count: vm.data.channel_types.length}, { dataset: vm.data.channel_types, counts: [] });
    }

    function setNameToChannelTypes(channelTypeList) {
      channelTypeList = channelTypeList.map(function(channelType) {
        var channelTypeLanguageSelected = channelType.channel_type_languages.filter(
          function(channelTypeLanguage) {
            return channelTypeLanguage.language_code == language.toLowerCase()
          }
        )[0]
        channelType.name = channelTypeLanguageSelected.name != '' && channelTypeLanguageSelected.name != null ? channelTypeLanguageSelected.name : 'Not found';
        return channelType;
      });
    }

  }

})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('ChannelTypesService',ChannelTypesService);

  function ChannelTypesService(StorageService, ApiService) {

    var instance = {};
 
    instance.getAll                   = getAll;
    instance.getAllWithoutPagination  = getAllWithoutPagination;
    instance.get                      = get;
    instance.save                     = save;
    instance.getEmptyChannelTypes     = getEmptyChannelTypes;
    instance.delete                   = deleteChannelTypes;
    instance.getLanguages             = getLanguages;
    instance.addChannelTypeslanguage  = addChannelTypeslanguage;
    instance.addChannelTypeslanguages = addChannelTypeslanguages;           

    function getAll(){
      return ApiService.get("/channel-types?property_id=" + StorageService.getProperty().id);
    }

    function getAllWithoutPagination(){
      return ApiService.get("/channel-types?pagination=disabled&property_id=" + StorageService.getProperty().id);
    }

    function get(id){
      return ApiService.get("/channel-types/"+id);
    }

    function getEmptyChannelTypes(){
     return {"data": {
                "property_id":StorageService.getProperty().id,
                "channel_types_languages":[
                  {
                    "channel_type_id": 0,
                    "language_code":"es",
                    "name":"",
                    "property_id":StorageService.getProperty().id
                  },
                  {
                    "channel_type_id": 0,
                    "language_code":"en",
                    "name":"",
                    "property_id":StorageService.getProperty().id
                  },
                  {
                    "channel_type_id": 0,
                    "language_code":"pt",
                    "name":"",
                    "property_id":StorageService.getProperty().id
                  },
                  {
                    "channel_type_id": 0,
                    "language_code":"fr",
                    "name":"",
                    "property_id":StorageService.getProperty().id
                  }
                 ] 
                }
              };
    }

    function save(channelTypes){
      if (channelTypes.id) {
        return ApiService.put('/channel-types/'+channelTypes.id, channelTypes);
      } else {
        return ApiService.post('/channel-types', channelTypes);
      }
    }

    function deleteChannelTypes(id){
      return ApiService.delete('/channel-types/'+id);
    }

    function getLanguages() {
      return ApiService.get('/languages');
    }

    function addChannelTypeslanguage(channelTypeslanguage){
      return ApiService.put("/channel-type-languages/"+channelTypeslanguage.id, channelTypeslanguage);
    }

    function addChannelTypeslanguages(channelTypeslanguages){
      return ApiService.put("/channel-type-languages", channelTypeslanguages);
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.channels.types').controller('ChannelTypesController', ChannelTypesController);

  function ChannelTypesController($rootScope, $controller, $scope, $location, $translate, ConfigurationVariablesService, StorageService, ChannelTypesService, NotificationService) {

    var vm = this;
    
    vm.saveChannelType = saveChannelType;

    var language = $translate.use();
    
    var fields = [];

    vm.getNameFromChild = getNameFromChild;

    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'channel-types',
        fieldsToFilter : fields,
        staticFilters  : {'property_id': function(){
          return StorageService.getProperty().id;
        }},
        preProcessData : function(data){
          return data;
        },  
      }, scope : $scope
    }))

    $scope.$on("propertyChanged", function(){
      vm.table.reload();
    });


    function saveChannelType(channelType){
      var promise = new Promise(function(resolve, reject) {
        ChannelTypesService.save(channelType).then(function(data){
          NotificationService.success('Channel Type successfully changed', 'Success');
          vm.refreshTable();
        },function(error){
          NotificationService.error('Channel Type not changed', 'Error');
        });
      });
    }  
  
    function refreshTable(){            
      vm.table.reload();
    }

    function getNameFromChild(channelType) {
      var channelTypeLanguageSelected = channelType.channel_type_languages.filter(
        function(channelTypeLanguage) {
          return channelTypeLanguage.language_code == language.toLowerCase()
        }
      )[0]
      var hil = channelTypeLanguageSelected.name != '' && channelTypeLanguageSelected.name != null ? channelTypeLanguageSelected.name : 'Not found'
      return (hil);
    }

  }  

})();            
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.channels.types').controller('ChannelTypesAddEditController', ChannelTypesAddEditController);
  
  function ChannelTypesAddEditController($state, $controller, $uibModal, $location, $scope, channelType, StorageService, ConfigurationVariablesService, ChannelTypesService, NotificationService,languages) {
    var vm = this;

    vm.data                      = channelType.data;
    vm.channelTypesNoCreado      = channelTypesNoCreado;
    vm.updateLanguages           = updateLanguages;
    vm.languages                 = languages.data;
    vm.channelTypeLanguagesForm  = {};
    vm.channelTypesForm          = {};
 
    vm.languageList = [];
    if(vm.data.id){
      vm.languageList = channelType.data.channel_type_languages
    } else {
      for (var lang in languages.data){
        vm.languageList.push({lang: vm.languages[lang].code, name: ""});
      }
    }
    
    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl     : 'iptv.channels.types-list',
        postSave :  function(data){
          vm.data = data.data;
          vm.languageList = data.data.channel_type_languages;
        },
        noRedirect: true
      },
      service : ChannelTypesService,
      scope : $scope
    }));

    
    function channelTypesNoCreado() {
      return !vm.data.id;
    }

    function updateLanguages(form) {

     var promise = new Promise(function(resolve, reject) {
       if (form.$valid) {
          ChannelTypesService.addChannelTypeslanguages({'languages':vm.languageList}).then(function(data){
            NotificationService.success('Channel Type language saved', 'Success');
            $state.go('iptv.channels.types-list');
            resolve('.');
          },function(error){
            NotificationService.error('Channel Type language cannot be saved', 'Error');
            reject(new Error("error updating entity")); 
          });
       } else {
         resolve('.');
       }   
    });
    return promise
  }


  }

})();
(function () {
  'use strict';

  var translations = {
  	"EXPERIENCES": {
  	  "ADD"                   : "Add Experience",
      "IMAGE"                 : "Image",
      "FROM"                  : "From",
      "TO"                    : "To",
      "POSITION"              : "position",
      "NOTFOUND"              : "Not Found",
      "BACKGROUND"            : "Background Image",
      "EXPERIENCE_IMAGE"      : "Choose image",
      "IMAGE_FORMAT_ACCEPTED" : "Please choose an accepted format: {{availableImageTypes}}.",
      "UPLOAD_IMAGE"          : "Upload image",
      "THE_IMAGE_IS_BIG"      : "Please choose a smaller image. Less than {{maxAllowedSize}}MB.", 
      "AREA"                  : "Area",
      "ALL_AREAS"             : "All Area",
      "SELECT_AREAS"          : "Select Experience Areas",
      "MEDIA_TYPE"            : "Media Type",
      "NAME"                  : "Name",
      "MAIN_HEADER"           : "Main Header",
      "TITLE"                 : "Title",
      "MAIN_FOOTER"           : "Main Footer",
      "FOOTER_TEXT1"          : "Footer Text 1",
      "FOOTER_TEXT2"          : "Footer Text 2",
      "VIDEO"                 : "Video",
      "SLIDE_DELAY"           : "Slide Delay",
      "AUDIO"                 : "Audio",
      "AREAS"                 : "Areas",
      "ON_START_APP"          : "On start app",
      "AUTO_PLAY"             : "Autoplay"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.hotelInfos.categories').controller('HotelInfoCategoriesController', HotelInfoCategoriesController);
  
  function HotelInfoCategoriesController($rootScope,$translate,$location,$controller,$scope, StorageService,HotelInfoCategoriesService,NotificationService) {
    var vm = this;
    var fields = ['name'];

    vm.savePosition = savePosition;
    
    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'hotel-info-categories',
        fieldsToFilter : fields,
        staticFilters  : {'property_id': function(){
          return StorageService.getProperty().id;
        }},
        sorting: {
          position: 'asc'
        },
         service: HotelInfoCategoriesService,
      }, scope : $scope
    }))

    $scope.$on("propertyChanged", function(){
      vm.table.reload();
    });
    vm.availableSearchParams = vm.generateParams(fields);

    function refreshTable(){            
        vm.table.reload();
    }

    function savePosition(hotelInfoCategories) {
      HotelInfoCategoriesService.save(hotelInfoCategories).then(function (data) {
        NotificationService.success('HotelInfoCategories update', 'Success');
      },function(error){
        NotificationService.error('HotelInfoCategories cannot be update', 'Error');
        vm.table.reload();
      });
    }

  }
})();            
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.hotelInfos.categories').controller('HotelInfoCategoriesAddEditController', HotelInfoCategoriesAddEditController);
  
  function HotelInfoCategoriesAddEditController($state, $controller, $uibModal, $location, $scope, hotelInfoCategory, StorageService, HotelInfoCategoriesService, NotificationService) {
    var vm = this;

    vm.data                      = hotelInfoCategory.data;

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl : 'iptv.hotel-infos.categories-list',
      }, service : HotelInfoCategoriesService,
      scope: $scope
    }))
  }
})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('HotelInfoCategoriesService',HotelInfoCategoriesService);

  function HotelInfoCategoriesService(StorageService, ApiService, NotificationService) {

    var instance = {};

    instance.getAll                    = getAll;
    instance.get                       = get;
    instance.save                      = save;
    instance.delete                    = deleteHotelInfoCategory;
    instance.getEmptyHotelInfoCategory = getEmptyHotelInfoCategory;
    instance.getAllWithoutPagination   = getAllWithoutPagination;

    function getAll(){
      return ApiService.get("/hotel-info-categories?property_id=" + StorageService.getProperty().id);
    }

    function getAllWithoutPagination(){
      return ApiService.get("/hotel-info-categories?pagination=disabled&property_id=" + StorageService.getProperty().id);
    }

    function get(id){
      return ApiService.get("/hotel-info-categories/"+id);
    }

    function save(hotelInfoCategories){
      console.log(hotelInfoCategories);
      if (hotelInfoCategories.id) {
        return ApiService.put('/hotel-info-categories/'+hotelInfoCategories.id, hotelInfoCategories);
      } else {
        return ApiService.post('/hotel-info-categories', hotelInfoCategories);
      }
    }

    function deleteHotelInfoCategory(id){
      return ApiService.delete('/hotel-info-categories/'+id);
    }

    function getEmptyHotelInfoCategory(){
     return {"data": {
                "property_id":StorageService.getProperty().id,
                "name":""
                }
            };
    }

    return instance;
  }
})();
(function(){
  'use strict';
  angular.module('GoCloudCast.modules').factory('HotelInfoListsService',HotelInfoListsService);

  function HotelInfoListsService(StorageService, ApiService, NotificationService) {

    var instance = {};

    instance.getAll                  = getAll;
    instance.get                     = get;
    instance.save                    = save;
    instance.delete                  = deleteHotelInfo;
    instance.getEmptyHotelInfo       = getEmptyHotelInfo;
    instance.getLanguages            = getLanguages;
    instance.addHotelInfoLanguage    = addHotelInfoLanguage;
    instance.uploadHotelInfoImage    = uploadHotelInfoImage;
    instance.addHotelInfoLanguages   = addHotelInfoLanguages;
    instance.getAllWithoutPagination = getAllWithoutPagination;

    function getAllWithoutPagination(){
      return ApiService.get("/hotel-infos?pagination=disabled&property_id=" + StorageService.getProperty().id);
    }

    function getAll(){
      return ApiService.get("/hotel-infos?property_id=" + StorageService.getProperty().id);
    }

    function get(id){
      return ApiService.get("/hotel-infos/"+id);
    }

    function save(hotelinfos){
      if (hotelinfos.id) {
        return ApiService.put('/hotel-infos/'+hotelinfos.id, hotelinfos);
      } else {
        return ApiService.post('/hotel-infos', hotelinfos);
      }
    }

    function getLanguages() {
      return ApiService.get('/languages');
    }

    function deleteHotelInfo(id){
      return ApiService.delete('/hotel-infos/'+id);
    }

    function addHotelInfoLanguage(hotelinfolanguage){
      return ApiService.put("/hotel-info-languages/"+hotelinfolanguage.id, hotelinfolanguage);
    }

    function addHotelInfoLanguages(hotelinfolanguages){
      return ApiService.put("/hotel-info-languages", hotelinfolanguages);
    }

    function getEmptyHotelInfo(){
     return {"data": {
                "property_id":StorageService.getProperty().id,
                "image":"",
                "id":"",
                "hotel_info_category_id":"",
                "hotel_info_languages":[
                  {
                    "hotel_info_id":"",
                    "language_code":"es",
                    "name":"",
                    "description":"",
                    "property_id":StorageService.getProperty().id
                  },
                  {
                    "hotel_info_id":"",
                    "language_code":"en",
                    "name":"",
                    "description":"",
                    "property_id":StorageService.getProperty().id
                  },
                  {
                    "hotel_info_id":"",
                    "language_code":"pt",
                    "name":"",
                    "description":"",
                    "property_id":StorageService.getProperty().id
                  },
                  {
                    "hotel_info_id":"",
                    "language_code":"fr",
                    "name":"",
                    "description":"",
                    "property_id":StorageService.getProperty().id
                  }
                 ]
                }
              };
    }

    function uploadHotelInfoImage(data){
      return ApiService.post("/hotel-infos/upload-hotel-infos-image", data).then(function(data){
          NotificationService.success('Image uploaded', 'Success');
        },function(error){
          NotificationService.error('Error cant upload image', 'Error');
        });
    }

    return instance;
  }

})();
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.hotelInfos').controller('HotelInfoListsController', HotelInfoListsController);
  
  function HotelInfoListsController($rootScope,$translate,$location,$controller,$scope, ConfigurationVariablesService, StorageService,HotelInfoListsService,NotificationService) {
    var vm = this;
    var fields = ['name'];
    var language = $translate.use();

    vm.savePosition = savePosition;

    angular.extend(vm, $controller('abstractTable',{
      childProperties : {
        url            : 'hotel-infos',
        fieldsToFilter : fields,
        staticFilters  : {'property_id': function(){
          return StorageService.getProperty().id;
        }},
        sorting: {
          position: 'asc'
        },
        preProcessData : function(data){
          data.map(function(hotelInfo){
            hotelInfo['imagePath'] = generatedPathImage(hotelInfo.image) + '?random='+Date.now();
          })
          return data;
        },
         service : HotelInfoListsService,
      }, scope : $scope
    }))

    function generatedPathImage(imageName){
      var property = StorageService.getProperty();
      return ConfigurationVariablesService.getPathImage() + property.acronym + '/hotel-info/'+ imageName;
    }

    $scope.$on("propertyChanged", function(){
      vm.table.reload();
    });
    vm.availableSearchParams = vm.generateParams(fields);
    vm.getNameFromChild      = getNameFromChild;

    function getNameFromChild(hotelInfo) {
      var hotelInfoLanguageSelected = hotelInfo.hotel_info_languages.filter(
        function(hotelInfoLanguage) {
          return hotelInfoLanguage.language_code == language.toLowerCase()
        }
      )[0]
      var hil = hotelInfoLanguageSelected.name != '' && hotelInfoLanguageSelected.name != null ? hotelInfoLanguageSelected.name : 'Not found'
      return (hil);
    }

    function refreshTable(){            
        vm.table.reload();
    }

    function savePosition(hotelInfo) {
      console.log(hotelInfo);
      HotelInfoListsService.save(hotelInfo).then(function (data) {
        NotificationService.success('hotelInfo update', 'Success');
      },function(error){
        NotificationService.error('hotelInfo cannot be update', 'Error');
        vm.table.reload();
      });
    }
  }


})();            
(function() {

  'use strict';

  angular.module('GoCloudCast.modules.iptv.hotelInfos.lists').controller('HotelInfoListsAddEditController', HotelInfoListsAddEditController);
  
  function HotelInfoListsAddEditController($state, $location, $controller,$scope, $sce, $uibModal,NotificationService,StorageService, hotelInfo, 
    languages, hotelInfosMenu, HotelInfoCategoriesService, ConfigurationVariablesService, hotelInfoCategories, HotelInfoListsService) {
    var vm = this;

    vm.data                      = hotelInfo.data;
    vm.hotelInfosMenu            = hotelInfosMenu.data;
    vm.areThereAnyHotelsMenu     = areThereAnyHotelsMenu;
    vm.languages                 = languages.data;
    vm.hotelInfoNoCreado         = hotelInfoNoCreado;
    vm.updateLanguage            = updateLanguage;
    vm.hotelInfoCategories       = hotelInfoCategories.data;
    vm.flagHotelInfoImage        = true;
    vm.isTheImageLarge           = false;
    vm.maxAllowedSize            = 0.5; //500kb
    vm.uploadHotelInfoImage      = uploadHotelInfoImage;
    vm.availableImageTypes       = '".jpg, .jpeg, .png"';
    vm.hotelInfoForm             = {};
    vm.hotelInfoLanguageForm     = {};
    vm.isMenu                    = vm.data.menu_id ? false : true;
    vm.createHotelInfoCategory   = createHotelInfoCategory;
    vm.generatedPathImage        = generatedPathImage;
    vm.hotelInfoImageBase64      = vm.data.id ? vm.generatedPathImage():"/assets/img/theme/no-image.png" ;
    vm.getNameOnlyMenu           = getNameOnlyMenu;
    vm.selectedMenu              = null;
    vm.sce = $sce;


		vm.options = {
			language: 'en',
			allowedContent: true,
			entities: false,
      extraPlugins: 'colorbutton, font, justify'
		};

    if (vm.data.image) {
      vm.data.imagePath = generatedPathImage(vm.data.image) + '?random='+Date.now();
    }
    
    vm.languageList = [];
    if(vm.data.id){
      vm.languageList = hotelInfo.data.hotel_info_languages
    } else {
      for (var lang in languages.data){
        vm.languageList.push({lang: vm.languages[lang].code, name: "", description: ""});
      }
    }

    $scope.$watch('vm.hotelInfoForm', function(form) {
      if(form) {
        if(!vm.data.id){
          vm.hotelInfoForm.$valid   = false;
          vm.hotelInfoForm.$invalid = true;
        }
      }
    });

    angular.extend(vm, $controller('abstractAddEdit',{
      childProperties : {
        stateUrl     : 'hotel-infos.lists-list',
        resolutions  : {
                minWidth: 340,
                minHeight: 120,
                maxWidth: 1280,
                maxHeight: 720,
                ratio: 16/9,
        },
        promise : function(data){
          vm.data.image_base64        = data.image;
          vm.hotelInfoImageBase64     = data.croppedImage;
          vm.flagHotelInfoImage       = false;
          vm.hotelInfoForm.$invalid   = false;
          vm.hotelInfoForm.$valid     = true;
          vm.hotelInfoForm.$submitted = false;
        },
        onLoad : function(data, openModal){
          var maxSize = vm.maxAllowedSize * 1024 * 1024;
            if (data.size > maxSize) {
              vm.isTheImageLarge = true;
              vm.flagSplashImage = true;
            } else{
              vm.isTheImageLarge = false;
              vm.flagSplashImage = false;
              openModal();
            }
        },
        formatData   : function(data){
          data.image_base64 = vm.data.image_base64
        },
        postSave     : function(data){
          vm.data = data.data
          vm.languageList = data.data.hotel_info_languages
        },
        noRedirect: true,  
      }, 
      service : HotelInfoListsService,
      scope : $scope
    }));

    function areThereAnyHotelsMenu(){
      vm.menus = vm.hotelInfosMenu.filter(function(data){
        return data.menu_id == null;
      })
      var yourself = vm.menus.some(function(data){
        return data.id == vm.data.id;
      })
      return vm.hotelInfosMenu.length == 0 || vm.hotelInfosMenu.length != 0 && vm.menus.length != 0 && yourself || vm.data.menu_id;
    }

    function getNameOnlyMenu(menu){
      return menu.hotel_info_languages[0].name ? menu.hotel_info_languages[0].name : "None";
    }

    function generatedPathImage(){
      var property = StorageService.getProperty();
      return ConfigurationVariablesService.getPathImage() + property.acronym + '/hotel-info/'+ vm.data.image;
    }

    function hotelInfoNoCreado() {
      return !vm.data.id
    }

    function updateLanguage() {
      HotelInfoListsService.addHotelInfoLanguages({'languages':vm.languageList}).then(function(data){
        NotificationService.success('Hotel info language saved', 'Success');
        $state.go('iptv.hotel-infos.lists-list');
      },function(error){
        NotificationService.error('Hotel info language cannot be saved', 'Error');
      });
    }

    function createHotelInfoCategory() {
     HotelInfoCategoriesService.save({"name":vm.data.hotel_info_category.name,"property_id":StorageService.getProperty().id}).then(function(data){
         vm.hotelInfoCategories.push(data.data)
         vm.data.hotel_info_category.isFreeText = false;
         vm.data.hotel_info_category.name       = vm.data.hotel_info_category.name;
         vm.data.hotel_info_category.id         = data.data.id;
         NotificationService.success('Hotel Info Category added', 'Success');
       },function(error){
         NotificationService.error('Hotel Info Category cannot be added', 'Error')
       })
    }

    function uploadHotelInfoImage(){   
      var promise = new Promise(function(resolve, reject) {
      vm.data.hotel_info_category_id = vm.data.hotel_info_category ? vm.data.hotel_info_category.id : null;
      HotelInfoListsService.save(vm.data).then(function(data){
          NotificationService.success('Hotel info saved', 'Success');
          vm.data = data.data
          vm.languageList = data.data.hotel_info_languages;
          resolve('.'); // ignored
        },function(error){
          vm.hotelInfoImageBase64 = vm.generatedPathImage();
          NotificationService.error('Hotel info cannot be saved', 'Error');
          reject(new Error("error updating hotel info")); 
        });
      });
      return promise;
    }
  }    
  
})();
(function () {
  'use strict';

  var translations = {
  	"TV_APPLICATION_VERSIONS": {
  	  "NEW"                     : "Add Version",
      "VERSION"                 : "Version",
      "FILENAME"                : "Filename",
      "TVMODELS"                : "TV Models",
      "ADD_TV_MODELS"           : "Add Tv Models"
  	}
  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"TV_APPLICATIONS": {
  	  "NEW"                   : "Add Application",
      "NAME"                  : "Name",
      "APP_ID"                : "App ID",
      "BRAND"                 : "Brand",
      "VERSIONS"              : "Versions",
      "IMAGE"                 : "Image",
      "PRELOAD"               : "Preloaded",
      "APP_IMAGE"             : "Application Image: ",
      "IMAGE_FORMAT_ACCEPTED" : "Please choose an accepted format: {{availableImageTypes}}.",
      "CHANGE_APP_IMAGE"      : "Change Application Image"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"TV_APPLICATIONS_PROPERTY": {
      "NAME"                : "Name",
      "BRAND"               : "Brand",
      "ENABLED"             : "Enabled",
      "DISABLED"            : "Disabled",
      "IMAGE"               : "Image",
      "POSITION"            : "Position",
      "ADD_TV_APP_VERSION"  : "Add Tv Application Version"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"TV_MODELS": {
  	  "NEW"                 : "Add Tv Model",
      "MODEL"               : "Model",
      "BRAND"               : "Brand",
      "RESOLUTION"          : "Resolution",
      "ADD_TLX"             : "Add Tlx",
      "VERSION_NUMBER"      : "Version Number"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"TVS": {
      "NEW"                 : "Add Tv",
      "AREA_NAME"           : "Area",
      "TV_MODEL"            : "Tv Model",
      "SERIAL_NUMBER"       : "Serial Number",
      "IP_ADDRESS"          : "IP Address",
      "MAC_ADDRESS"          : "Mac Address",
      "CREATE_AREA"         : "Create Area",
  	}
  }
  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function() {

	'use strict';

	angular.module('GoCloudCast.modules.reports').controller('SectionReportsController', SectionReportsController);

	function SectionReportsController($scope, $controller, ApiService, StorageService,
		date_format_resolve ,start_date_resolve , end_date_resolve) {

	    var vm = this;
	    formatDates(start_date_resolve,end_date_resolve);

	    var data_url = 'public/es/receiver-uptime/filter-by-date';
	    var currentProp = StorageService.getProperty();
		var tableFields = ['duration','area_name','from','to','receiver_name'];

	    angular.extend(vm, $controller('abstractTable',{
	      childProperties : {
	        url           : data_url,
	        fieldsToFilter : tableFields,
	        staticFilters  : {
	        	'token': function(){
	          		return currentProp.token;
		        },
	        	'from': function(){
	          		return vm.start_date;
		        },
	        	'to': function(){
	          		return vm.end_date;
		        },
		        'name': function(){
		        	return vm.receiver_name
		        },
		        'area_name': function(){
		        	return vm.area_name
		        },
		        'duration_greater_than': function(){
		        	return vm.duration_greater_than
		        },
		        'duration_less_than': function(){
		        	return vm.duration_less_than
		        }
		    }
	      }, 
	      scope : $scope 
	    }));
	    vm.availableSearchParams = vm.generateParams(tableFields);

	    function formatDates(start_date, end_date){
	    	vm.start_date = moment(start_date);
	    	vm.end_date = moment(end_date);
      		vm.start_date.set({hour:0,minute:0,second:0,millisecond:0});
      		vm.end_date.set({hour:23,minute:59,second:59,millisecond:0});
      		vm.start_date = vm.start_date.format(date_format_resolve);
      		vm.end_date = vm.end_date.format(date_format_resolve);
	    }

		function updateData(){
			vm.refreshTable();
	    }

	    $scope.$on("propertyChanged", function(){
			currentProp = StorageService.getProperty();
			updateData();
		});

	    $scope.$on('reports_date_changed', function(event, opt) {
	    	vm.receiver_name = opt.receiver_name
	    	vm.duration_less_than = opt.duration_less_than
	    	vm.duration_greater_than = opt.duration_greater_than
	    	vm.area_name = opt.area_name
	    	formatDates(opt.start_date,opt.end_date);
	    	updateData();
		});
	}

})();
(function() {

	'use strict';

	angular.module('GoCloudCast.modules.reports').controller('StateReportsController', StateReportsController);

	function StateReportsController($scope, $rootScope, $controller, $timeout, ApiService, chartHelperService, StorageService,
		date_format_resolve ,start_date_resolve , end_date_resolve) {

	    var vm = this;
	    formatDates(start_date_resolve,end_date_resolve);

	    var tab_index = 1
	    var data_url = 'public/es/receiver-state/statistics';
	    var currentProp = StorageService.getProperty();
		var tableFields = ['duration','area_name','receiver_name','app'];

	    angular.extend(vm, $controller('abstractTable',{
	      childProperties : {
	        url           : data_url,
	        preProcessData: function(data){
	        	formatData(data);
			    return data.states.data;				//SIN paginacion
			    //return vm.data.states.data;		//CON paginacion
	        },
	        fieldsToFilter : tableFields,
	        staticFilters  : {
	        	'token': function(){
	          		return currentProp.token;
		        },
	        	'from': function(){
	          		return vm.start_date;
		        },
	        	'to': function(){
	          		return vm.end_date;
		        },
		        'app': function(){
		        	return vm.app
		        },
		        'area_name': function(){
		        	return vm.area_name
		        },
		        'receiver_name': function(){
		        	return vm.receiver_name
		        }
		    },
	  		dataRoot  : ['data','states']
	      }, 
	      scope : $scope 
	    }));

	    vm.data = {"receiver_names_count":[],"apps_count":[],"hours_count":[]};

	    vm.availableSearchParams = vm.generateParams(tableFields);

	    function formatDates(start_date, end_date){
	    	vm.start_date = moment(start_date);
	    	vm.end_date = moment(end_date);
      		vm.start_date.set({hour:0,minute:0,second:0,millisecond:0});
      		vm.end_date.set({hour:23,minute:59,second:59,millisecond:0});
      		vm.start_date = vm.start_date.format(date_format_resolve);
      		vm.end_date = vm.end_date.format(date_format_resolve);
	    }

		function formatData(data){
			data.receiver_names_count = chartHelperService.getChartData(data.receiver_names_count,'doc_count');
			data.receiver_names_count = addName(data.receiver_names_count);
			data.apps_count = chartHelperService.getChartData(data.apps_count,'doc_count');
			data.apps_count = addName(data.apps_count);
			data.hours_count = formatAppHourData(data);

			vm.data = data;

			if(vm.pieConfig&&vm.columnConfig&&vm.splitLinesConfig){
				updateImages();
			} else {
				createChartsConfigs();
			}

		}

		function addName(array){
			return  array.map(function(field) {
			   field.name = field.key;
			   return field;
			});
		}

	    function formatAppHourData(data){
			var appHourData = []
			if(data.hours_count.length > 0){
			    var app_hours = [];
			    var new_hour   = [{}];
			    data.hours_count.forEach(function(app_data, index){
			    	var index_color = index >= 10 ? index % 10 : index 
				    new_hour = {name: app_data.name, data: [], color: Highcharts.getOptions().colors[index_color]};
			    	Array.from(Array(24).keys()).forEach(function(hour){
				    	var activity = app_data.data.find(function hasActivity(activity){ return activity.key == hour });
				    	app_hours   = activity == undefined? [hour,0]: [hour,activity.doc_count];
				    	new_hour['data'].push(app_hours);
				    });
					appHourData.push(new_hour);
			    });
			}

		    return appHourData;
		}

		function hideLabels(){
			var labels = [vm.minLabel,vm.avgLabel,vm.maxLabel]

			if(vm.minLabel != undefined){	//Si No existe ningun label, se toma uno como parametro para muchos.
				labels.forEach(function(label){
		    		label.fadeOut();
		    	})
			}
		}

		function setTimeLabels(chart){
			if(vm.data.hours_count.length > 0){
				var heightPadding = 40 
				var widthPadding = 100 

				var attr = {
					fill: Highcharts.getOptions().colors[0],
                    padding: 10,
                    r: 5,
                    zIndex: 8
				}

				var css = {
                    color: '#FFFFFF'
                }

				vm.minLabel = chartHelperService.generateInfoLabel(
					chart,attr,css,'Duration minimum: ' + vm.data.duration_stats.min_as_string,widthPadding,chart.chartHeight - heightPadding
				)

				vm.avgLabel = chartHelperService.generateInfoLabel(
					chart,attr,css,'Duration average: ' + vm.data.duration_stats.avg_as_string,(chart.chartWidth - widthPadding)/2,chart.chartHeight - heightPadding
				)

				vm.maxLabel = chartHelperService.generateInfoLabel(
					chart,attr,css,'Duration maximum: ' + vm.data.duration_stats.max_as_string,chart.chartWidth - (widthPadding*2),chart.chartHeight - heightPadding
				)
			}
		}

	    // ####################################################################################################### //
	    // ########################################## Chart Declarations ######################################### //
	    // ####################################################################################################### //
	    


		function createChartsConfigs(){
			createReceiversNameCountChart();
			createAppsCountChart();
			createQuatityPerHourChart();
		}

		function createQuatityPerHourChart(){
			$timeout(function(){
				vm.splitLinesConfig = chartHelperService.simpleChart('splitLines', {
					data: vm.data.hours_count,
					events: {
						afterAnimate: function(){
							hideLabels();
							setTimeLabels(this.chart);
						}
	      			}
				}, {
			      	title : "Quantity per hour and app",
			      	typeCallbackParameters: {
			      		legend: { enabled: false },
			      		chart: { 
							spacingBottom: 60,
						},
			      	}
			    })();
		    }, 200);
		}

		function createReceiversNameCountChart(){
			$timeout(function(){
				vm.pieConfig = chartHelperService.simpleChart('pie', {
						data: vm.data.receiver_names_count,
						events: {
							click: function(event){
								$rootScope.$broadcast('filter_receiver_name', { 
	        					  receiver_name: event.point.name
	        					});
							}
						}

					}, {
				      	title : "Receivers name count"	
				    })();
			}, 200);
		}

		function createAppsCountChart(){
			$timeout(function(){
				vm.columnConfig = chartHelperService.simpleChart('column', {
							data: vm.data.apps_count,
	                    	events: {
	                    	        click: function(event){
	                    	                console.log(event)
	                    	                $rootScope.$broadcast('filter_app', { 
	                    	          			app: event.point.name
	                    	       			});
	                    	        }
	                    	}        
						},{
				      	title : "Apps count",
				      	typeCallbackParameters: {
				      		yAxis: { title: { text: 'Cant' } },
				      		xAxis: { 
								labels: {
									rotation: -45,
									formatter: function () {

										return vm.data.apps_count[this.value]
										? vm.data.apps_count[this.value].key
										: 'No data';
									}
								}
							}
				      	}
				    })();
			}, 200);
		}


		function resizeCharts(tabIndex){
			if(tab_index == tabIndex) chartHelperService.resizeCharts([
				vm.pieConfig.getHighcharts(),
				vm.columnConfig.getHighcharts(),
				vm.splitLinesConfig.getHighcharts()
			])
		}

	    function updateImages(){
	    	chartHelperService.updateChart(vm.pieConfig.getHighcharts(), { data: vm.data.receiver_names_count });
	    	chartHelperService.updateChart(vm.columnConfig.getHighcharts(), { data: vm.data.apps_count });
	    	$timeout(function(){
	    		vm.splitLinesConfig = createQuatityPerHourChart();
	    	}, 200);
	    }

	    function updateData(){
			vm.refreshTable();
	    }

		$scope.$on('reports_resize_screen', function(event, opt) {
			resizeCharts(opt.tab_index)

			$timeout(function(){
				hideLabels();
				setTimeLabels(vm.splitLinesConfig.getHighcharts());
			}, 500);
		});

		$scope.$on('reports_tab_changed', function(event, opt) {
			resizeCharts(opt.tab_index)

			$timeout(function(){
				hideLabels();
				setTimeLabels(vm.splitLinesConfig.getHighcharts());
			}, 500);
		});

	    $scope.$on("propertyChanged", function(){
			currentProp = StorageService.getProperty();
			updateData();
		});

	    $scope.$on('reports_date_changed', function(event, opt) {
	    	vm.app = opt.app
	    	vm.area_name = opt.area_name
	    	vm.receiver_name = opt.receiver_name
	    	formatDates(opt.start_date,opt.end_date);
	    	updateData();
		});
	}

})();

(function() {

	'use strict';

	angular.module('GoCloudCast.modules.reports').controller('ValidationReportsController', ValidationReportsController);

	function ValidationReportsController($scope, $rootScope, $controller, $timeout, ApiService, chartHelperService, StorageService, GeneralUseService,
		top_macs, date_format_resolve ,start_date_resolve , end_date_resolve) {
		
	    var vm = this;

	    vm.top_macs = top_macs.data;
	    formatDates(start_date_resolve,end_date_resolve);

	    var tab_index = 0
	    var data_url = 'public/es/sender-uptime/statistics';
	    var currentProp = StorageService.getProperty();
		var tableFields = ['duration','area_name','name','app'];
	    vm.data = {"areas_count":[],"hours_count":[]}

	    angular.extend(vm, $controller('abstractTable',{
	      childProperties : {
	        url           : data_url,
	        preProcessData: function(data){
	        	formatData(data);
			    return data.uptimes.data;			//SIN paginacion
			    //return vm.data.uptimes.data;	//CON paginacion
	        },
	        fieldsToFilter : tableFields,
	        staticFilters  : {
	        	'token': function(){
	          		return currentProp.token;
		        },
	        	'from': function(){
	          		return vm.start_date;
		        },
	        	'to': function(){
	          		return vm.end_date;
		        },
		        'ip_address': function(){
		        	return vm.ip_address
		        },
		        'mac_address': function(){
		        	return vm.mac_address
		        },
		        'area_name': function(){
		        	return vm.area_name
		        }
		    },
	        dataRoot  : ['data','uptimes']
	      }, 
	      scope : $scope 
	    }));
	    vm.availableSearchParams = vm.generateParams(tableFields);

	    function formatDates(start_date, end_date){
	    	vm.start_date = moment(start_date);
	    	vm.end_date = moment(end_date);
      		vm.start_date.set({hour:0,minute:0,second:0,millisecond:0});
      		vm.end_date.set({hour:23,minute:59,second:59,millisecond:0});
      		vm.start_date = vm.start_date.format(date_format_resolve);
      		vm.end_date = vm.end_date.format(date_format_resolve);
	    }

		function formatData(data){
			data.areas_count = chartHelperService.getChartData(data.areas_count,'doc_count');
			data.areas_count = data.areas_count.map(function(field) {
			   field.name = field.key;
			   return field;
			});
			data.hours_count = formatAreaHourData(data);

			vm.data = data;

			if(vm.pieConfig&&vm.splitLinesConfig){
				updateImages();
			} else {
				charts();
			}	
		}

		function formatAreaHourData(data){
			var areaHourData = []
			if(data.hours_count.length > 0){
			    var area_hours = [];
			    var new_hour   = [{}];
			    data.hours_count.forEach(function(area_data, index){
			    	var index_color = index >= 10 ? index % 10 : index 
				    new_hour = {name: area_data.name, data: [], color: Highcharts.getOptions().colors[index_color]};
			    	Array.from(Array(24).keys()).forEach(function(hour){
				    	var activity = area_data.data.find(function hasActivity(activity){ return activity.key == hour });
				    	area_hours   = activity == undefined? [hour,0]: [hour,activity.doc_count];
				    	new_hour['data'].push(area_hours);
				    });
					areaHourData.push(new_hour);
			    });
			}

		    return areaHourData;
		}

		function hideLabels(){
			var labels = [vm.minLabel,vm.avgLabel,vm.maxLabel]

			if(vm.minLabel != undefined){	//Si No existe ningun label, se toma uno como parametro para muchos.
				labels.forEach(function(label){
		    		label.fadeOut();
		    	})
			}
		}

		function setTimeLabels(chart){
			if(vm.data.hours_count.length > 0){
				var heightPadding = 40 
				var widthPadding = 100 

				var attr = {
					fill: Highcharts.getOptions().colors[0],
                    padding: 10,
                    r: 5,
                    zIndex: 8
				}

				var css = {
                    color: '#FFFFFF'
                }

				vm.minLabel = chartHelperService.generateInfoLabel(
					chart,attr,css,'Duration minimum: ' + vm.data.duration_stats.min_as_string,widthPadding,chart.chartHeight - heightPadding
				)

				vm.avgLabel = chartHelperService.generateInfoLabel(
					chart,attr,css,'Duration average: ' + vm.data.duration_stats.avg_as_string,(chart.chartWidth - widthPadding)/2,chart.chartHeight - heightPadding
				)

				vm.maxLabel = chartHelperService.generateInfoLabel(
					chart,attr,css,'Duration maximum: ' + vm.data.duration_stats.max_as_string,chart.chartWidth - (widthPadding*2),chart.chartHeight - heightPadding
				)
			}
		}

	    // ####################################################################################################### //
	    // ########################################## Chart Declarations ######################################### //
	    // ####################################################################################################### //

	    function charts(){
			createAreasCountChart();
			createQuantityPerHourChart();
		}

		function createAreasCountChart(){
			$timeout(function(){
			vm.pieConfig = chartHelperService.simpleChart('pie', {
					data: vm.data.areas_count,
					events: {
						click: function(event){
							$rootScope.$broadcast('filter_area_name', { 
        					  area_name: event.point.name
        					});
						}
					}

				}, {
			      	title : "Areas count"
			    })();
			}, 200);
		}

		function createQuantityPerHourChart(){
			$timeout(function(){
			vm.splitLinesConfig = chartHelperService.simpleChart('splitLines', {
					data: vm.data.hours_count,
					events: {
						afterAnimate: function(){
							hideLabels();
							setTimeLabels(this.chart);
						}
	      			}
				}, {
			      	title : "Quantity per hour and area",
			      	typeCallbackParameters: {
			      		legend: { enabled: false },
			      		chart: {
							spacingBottom: 60,
						},
			      	}
			    })();
			}, 200);
		}

		function resizeCharts(tabIndex){
			if(tab_index == tabIndex) chartHelperService.resizeCharts([
				vm.pieConfig.getHighcharts(),
				vm.splitLinesConfig.getHighcharts()
			])
		}

	    function updateImages(){
	    	chartHelperService.updateChart(vm.pieConfig.getHighcharts(), { data: vm.data.areas_count });
	    	$timeout(function(){
	    		vm.splitLinesConfig = createQuantityPerHourChart();
	    	},200);
	    }

	    function updateData(){
			vm.refreshTable();

			GeneralUseService.getTopMacAddresses(vm.start_date, vm.end_date, vm.ip_address, vm.mac_address, vm.area_name).then(function(top_macs){
				vm.top_macs = top_macs.data;
			});
	    }

		$scope.$on('reports_resize_screen', function(event, opt) {
			resizeCharts(opt.tab_index);

			$timeout(function(){
				hideLabels();
				setTimeLabels(vm.splitLinesConfig.getHighcharts());
			}, 500);
		});

		$scope.$on('reports_tab_changed', function(event, opt) {
			resizeCharts(opt.tab_index)

			$timeout(function(){
				hideLabels();
				setTimeLabels(vm.splitLinesConfig.getHighcharts());
			}, 500);
		});

	    $scope.$on("propertyChanged", function(){
			currentProp = StorageService.getProperty();
			updateData();
		});

	    $scope.$on('reports_date_changed', function(event, opt) {
	    	vm.mac_address = opt.mac_address
	    	vm.area_name = opt.area_name
	    	vm.ip_address = opt.ip_address
	    	formatDates(opt.start_date,opt.end_date);
	    	updateData();
		});
	}

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {

  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {

  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();
/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();
/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('GoCloudCast.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
  'use strict';

  var translations = {
  	"NOTIFICATION_EMAILS": {
  	  "NEW"                 : "Add a Notification Email",
      "NAME"                : "Name",
      "EMAIL"               : "Email",
      "ACTIVE"              : "Active"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"CHANNELS": {
  	  "NEW"                   : "Add Channel",
  	  "NUMBER"                : "Number",
      "IMAGE"                 : "Image",
      "NAME"                  : "Name",
      "TYPE"                  : "Type",
      "FREQ_URL"              : "Frequency/URL",
      "FREQUENCY"             : "Frequency",
      "URL"                   : "URL",
      "CHANNEL_IMAGE"         : "Channel Image: ",
      "IMAGE_FORMAT_ACCEPTED" : "Please choose an accepted format: {{availableImageTypes}}.",
      "CHANGE_CHANNEL_IMAGE"  : "Change Channel Image",
      "ENABLED"               : "Enabled",
      "STATE"                 : "State",
      "POSITION"              : "position",
      "CHANNEL_TYPES"         : "Channel Types",
      "VIDEO"                 : "Video",
      "PORT"                  : "Port",
      "CURRENTLY_UPLOADED"    : "Currently uploaded:"
    } 

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"CHANNEL_TYPES": {
  	  "NEW"                   : "Add ChannelTypes",
      "NAME"                  : "Name",
      "POSITION"              : "Position"
    } 

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"HOTEL_INFO_CATEGORY": {
  	  "NEW"                   : "Add Hotel Info Category",
      "NAME"                  : "Name",
      "POSITION"              : "position",
      "CREATE"                : "Create Hotel Info Category",
      "NOT_EXIST"    : "The category does not exist. Please create it"
  	}
  }
  
  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
(function () {
  'use strict';

  var translations = {
  	"HOTEL_INFO": {
  	  "NEW"                   : "Add Hotel Info",
      "IMAGE"                 : "Image",
      "NAME"                  : "Name",
      "NOTFOUND"              : "Not Found",
      "BACKGROUND"            : "Background Image",
      "HOTEL_INFO_IMAGE"      : "Choose image",
      "IMAGE_FORMAT_ACCEPTED" : "Please choose an accepted format: {{availableImageTypes}}.",
      "UPLOAD_IMAGE"          : "Upload image",
      "THE_IMAGE_IS_BIG"      : "Please choose a smaller image. Less than {{maxAllowedSize}}MB.", 
      "MENU_OR_ITEM"          : "Is a menu",
      "SELECT_CATEGORY"       : "Select Hotel Info Category",
      "SELECT_MENU"           : "Select Menu",
      "CATEGORY"              : "Category",
      "CHOOSE_MENU"           : "Choose menu",
      "POSITION"              : "Position"
  	}

  }

  angular.module('GoCloudCast.modules').config(function (translatePluggableLoaderProvider){
    translatePluggableLoaderProvider.translations('EN', translations)
  })

})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('GoCloudCast.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('GoCloudCast.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('GoCloudCast.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();
/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('GoCloudCast.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
angular.module('GoCloudCast').run(['$templateCache', function($templateCache) {$templateCache.put('app/core/main.core.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/modules/cities/cities.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="cities--store" class="btn btn-primary pull-right" ui-sref="cities-new"><i class="fa fa-institution fa-6"></i> {{\'CITIES.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="city in $data"><td title="\'CITIES.NAME\' | translate" ng-attr-title="" align="center" sortable="\'name\'">{{city.name}}</td><td title="\'CITIES.COUNTRY\' | translate" ng-attr-title="" align="center" sortable="\'country_row.name\'">{{city.country_row.name}}</td><td title="\'CITIES.TIMEZONE\' | translate" ng-attr-title="" align="center" sortable="\'timezone_code\'">{{city.timezone_code}}</td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="cities--update" ui-sref="cities-edit({ id : city.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="cities--destroy" href="" ng-really-click="vm.deleteRow(city.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/cities/citiesAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="citiesForm" novalidate="" ng-submit="vm.save(citiesForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(citiesForm, citiesForm.name,\'name\')}"><label for="name">{{\'CITIES.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" ng-change="vm.cleanSvError(\'name\')" id="name" name="name" placeholder="Name" ng-model="vm.data.name" required=""><div ng-messages="citiesForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'name\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'name\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(citiesForm, citiesForm.name)}"><label for="country">{{\'CITIES.COUNTRY\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><div class="col"><ui-select ng-model="vm.data.country" name="country" ui-select-free-text="" value-prop="name" style="padding-left: 0px" ng-disabled="false" search-enabled="true" append-to-body="true" required=""><ui-select-match placeholder="Select a Country"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="country.code as country in vm.countries | filter: $select.search"><span ng-bind-html="country.name"></span></ui-select-choices></ui-select></div></div><div ng-messages="citiesForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-if="vm.data.country.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'CITIES.COUNTRY_NOT_EXIST\' | translate}}</label></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(citiesForm, citiesForm.name)}"><label for="timezone_code">{{\'CITIES.TIMEZONE\' | translate}}</label><div class="form-control btn-group bootstrap-select row"><div class="col"><ui-select ng-model="vm.data.timezone_code" name="timezone_code" ui-select-free-text="" value-prop="code" style="padding-left: 0px" ng-disabled="false" search-enabled="true" append-to-body="true"><ui-select-match placeholder="Select a Timezone"><span>{{$select.selected.code}}</span></ui-select-match><ui-select-choices repeat="timezone.code as timezone in vm.timezones | filter: $select.search"><span ng-bind-html="timezone.code"></span></ui-select-choices></ui-select></div></div><div ng-messages="citiesForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-if="vm.data.timezone_code.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'CITIES.TIMEZONE_NOT_EXIST\' | translate}}</label></div></div><div class="form-group"><button class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="citiesForm.$invalid || (!vm.data.all_properties && vm.data.properties.length == 0)" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/configs/configs.html','<div class="row"><div class="col-md-offset-2 col-md-8"><form name="configsForm" novalidate="" ng-submit="vm.save(configsForm,vm.data)"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><uib-tabset active="active"><uib-tab index="0"><uib-tab-heading>Interfaces</uib-tab-heading><div style="margin-top: 10px;margin-bottom:20px"><div style="margin-top: 6px;">Cast Interface</div></div><div class="row"><div class="form-group has-feedback col-md-4" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.cast_interface)}"><label for="app_gocloudcast">{{\'CONFIGS.GENERAL_CAST_INTERFACE\' | translate}}</label><ui-select ng-model="vm.data.general.CAST_INTERFACE" name="cast_interface" id="cast_interface" placeholder="Cast Interface" class="btn-group bootstrap-select form-control" search-enabled="false" ng-required="false"><ui-select-match placeholder="Cast Interface"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="interface.name as interface in vm.getInterfaces(vm.data.general.CAST_INTERFACE) | filter: $select.search"><span ng-bind-html="interface.name"></span></ui-select-choices></ui-select><div ng-messages="configsForm.cast_interface.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback col-md-4" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.cast_ssid)}"><label for="cast_ssid">{{\'CONFIGS.GENERAL_CAST_SSID\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" required="" class="form-control" id="cast_ssid" name="cast_ssid" placeholder="Cast ssid" ng-model="vm.data.general.CAST_SSID"><div ng-messages="configsForm.cast_ssid.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div><hr><div class="row" style="margin-top: 10px;margin-bottom:10px"><div class="col-md-8" style="margin-top: 6px;">Guest Interface</div><div class="col-md-4"><button type="button" class="btn btn-primary pull-right" ng-click="vm.addGuestInterface()">Add guest interface</button></div></div><div class="row"><div class="col-md-3"><label for="cast_ssid">{{\'CONFIGS.GENERAL_CAST_INTERFACE\' | translate}}</label></div><div class="col-md-3"><label for="cast_ssid">{{\'CONFIGS.GENERAL_CAST_IP_ADDRESS\' | translate}}</label></div><div class="col-md-3"><label for="cast_ssid">{{\'CONFIGS.GENERAL_CAST_NETMASK\' | translate}}</label></div></div><div class="row" ng-repeat="guestInterface in vm.guestInterfaces track by $index"><div class="form-group has-feedback col-md-3" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.guest_interface_name+$index)}"><ui-select ng-model="guestInterface.name" name="guest_interface_name{{$index}}" id="guest_interface_name{{$index}}" placeholder="Name" ng-change="vm.updateGuestInterface(guestInterface)" class="btn-group bootstrap-select form-control" search-enabled="false" required=""><ui-select-match placeholder="Cast Interface"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="interface.name as interface in vm.getInterfaces(guestInterface.name) | filter: $select.search"><span ng-bind-html="interface.name"></span></ui-select-choices></ui-select><div ng-messages="vm.getErrorMessages(configsForm,\'guest_interface_name\',$index)" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback col-md-3"><input type="text" style="background-color:#e2e2e2;" disabled="" class="form-control" placeholder="Ip Address" id="guest_interface_ip_address{{$index}}" name="guest_interface_ip_address{{$index}}" ng-model="guestInterface.ip_address"></div><div class="form-group has-feedback col-md-3"><input type="text" style="background-color:#e2e2e2;" disabled="" class="form-control" placeholder="Netmask" id="guest_interface_netmask{{$index}}" name="guest_interface_netmask{{$index}}" ng-model="guestInterface.netmask"></div><div class="col-md-3"><button type="button" class="btn btn-danger pull-right" ng-click="vm.removeGuestInterface($index)">Remove</button></div></div><div class="form-group" style="margin-top: 5px"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="configsForm.$invalid && configsForm.$submitted" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></uib-tab><uib-tab index="1"><uib-tab-heading>Launcher</uib-tab-heading><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.app_gocloudcast)}"><label for="app_gocloudcast">{{\'CONFIGS.LAUNCHER_APP_GOCLOUDCAST\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.launcher.APP_GOCLOUDCAST" name="app_gocloudcast" id="app_gocloudcast" placeholder="App Gocloudcast" class="btn-group bootstrap-select form-control" search-enabled="false" required=""><ui-select-match placeholder="App Gocloudcast"><span>{{$select.selected.description}}</span></ui-select-match><ui-select-choices repeat="splashpage.code as splashpage in vm.splashPages | filter: $select.search"><span ng-bind-html="splashpage.description"></span></ui-select-choices></ui-select><div ng-messages="configsForm.app_gocloudcast.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(configsForm, configsForm.load_url,\'launcher.LOAD_URL\')}"><label for="load_url">{{\'CONFIGS.LAUNCHER_LOAD_URL\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.launcher.LOAD_URL" name="load_url" id="load_url" placeholder="Load url" ng-change="vm.cleanSvError(\'launcher.load_url\')" class="btn-group bootstrap-select form-control" search-enabled="false" required=""><ui-select-match placeholder="Load url"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="ipAddress in vm.interfacesIpAddresses| filter: $select.search"><span ng-bind-html="ipAddress"></span></ui-select-choices></ui-select><div ng-messages="configsForm.load_url.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-messages="configsForm.load_url.$error" class="help-block error-block basic-block"><span ng-message="url">{{\'VALIDATIONS.URL\' | translate}}</span></div><div ng-show="vm.haveServerError(\'launcher.LOAD_URL\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'launcher.LOAD_URL\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.cast_api_token)}"><label for="cast_api_token">{{\'CONFIGS.LAUNCHER_CAST_API_TOKEN\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" required="" class="form-control" id="cast_api_token" name="cast_api_token" placeholder="Cast api token" ng-model="vm.data.launcher.CAST_API_TOKEN"><div ng-messages="configsForm.cast_api_token.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(configsForm, configsForm.cast_api_url,\'launcher.CAST_API_URL\')}"><label for="cast_api_url">{{\'CONFIGS.LAUNCHER_CAST_API_URL\' | translate}} <span style="color:#209e91">*</span></label> <input type="url" required="" class="form-control" id="cast_api_url" ng-change="vm.cleanSvError(\'launcher.cast_api_url\')" name="cast_api_url" placeholder="Cast api url" ng-model="vm.data.launcher.CAST_API_URL"><div ng-messages="configsForm.cast_api_url.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-messages="configsForm.cast_api_url.$error" class="help-block error-block basic-block"><span ng-message="url">{{\'VALIDATIONS.URL\' | translate}}</span></div><div ng-show="vm.haveServerError(\'launcher.CAST_API_URL\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'launcher.CAST_API_URL\')}}</span></div></div><div class="form-group" style="margin-top: 5px"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="configsForm.$invalid && configsForm.$submitted" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></uib-tab><uib-tab index="2"><uib-tab-heading>Web</uib-tab-heading><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.guest_router_type)}"><label for="guest_router_type">{{\'CONFIGS.WEB_GUEST_ROUTER_TYPE\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.web.GUEST_ROUTER_TYPE" name="guest_router_type" id="guest_router_type" class="btn-group bootstrap-select form-control" search-enabled="false" required=""><ui-select-match placeholder="Guest router type"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in vm.guestRouterTypes track by type| filter: $select.search"><span ng-bind-html="type"></span></ui-select-choices></ui-select><div ng-messages="configsForm.guest_router_type.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.guest_router_host)}"><label for="guest_router_host">{{\'CONFIGS.WEB_GUEST_ROUTER_HOST\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" required="" class="form-control" id="guest_router_host" name="guest_router_host" placeholder="Guest router host" ip-address-format="" ng-model="vm.data.web.GUEST_ROUTER_HOST"><div ng-messages="configsForm.guest_router_host.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="ipAddress">{{\'VALIDATIONS.IP_ADDRESS\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.indications_template)}"><label for="indications_template">{{\'CONFIGS.WEB_INDICATIONS_TEMPLATE\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.web.INDICATIONS_TEMPLATE" name="indications_template" id="indications_template" class="btn-group bootstrap-select form-control" search-enabled="false" required=""><ui-select-match placeholder="Indications template"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="template in vm.templates track by template| filter: $select.search"><span ng-bind-html="template"></span></ui-select-choices></ui-select><div ng-messages="configsForm.indications_template.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.code_expiration_time)}"><label for="code_expiration_time">{{\'CONFIGS.WEB_CODE_EXPIRATION_TIME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" required="" class="form-control" id="code_expiration_time" name="code_expiration_time" placeholder="Code expiration time" ng-model="vm.data.web.CODE_EXPIRATION_TIME"><div ng-messages="configsForm.code_expiration_time.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="configsForm.$invalid && configsForm.$submitted" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></uib-tab><uib-tab index="3"><uib-tab-heading>General</uib-tab-heading><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.mikrotik_host)}"><label for="mikrotik_host">{{\'CONFIGS.GENERAL_MIKROTIK_HOST\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" required="" class="form-control" id="mikrotik_host" name="mikrotik_host" placeholder="Mikrotik host" ip-address-format="" ng-model="vm.data.general.MIKROTIK_HOSTNAME"><div ng-messages="configsForm.mikrotik_host.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="ipAddress">{{\'VALIDATIONS.IP_ADDRESS\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.mikrotik_type)}"><label for="mikrotik_type">{{\'CONFIGS.GENERAL_MIKROTIK_TYPE\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.general.MIKROTIK_TYPE" name="mikrotik_type" id="mikrotik_type" class="btn-group bootstrap-select form-control" search-enabled="false" required=""><ui-select-match placeholder="Mikrotik type"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in vm.castRouterTypes track by type| filter: $select.search"><span ng-bind-html="type"></span></ui-select-choices></ui-select><div ng-messages="configsForm.mikrotik_type.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.mikrotik_username)}"><label for="mikrotik_username">{{\'CONFIGS.GENERAL_MIKROTIK_USERNAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" required="" class="form-control" id="mikrotik_username" name="mikrotik_username" placeholder="Mikrotik username" ng-model="vm.data.general.MIKROTIK_USERNAME"><div ng-messages="configsForm.mikrotik_username.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.mikrotik_password)}"><label for="mikrotik_password">{{\'CONFIGS.GENERAL_MIKROTIK_PASSWORD\' | translate}} <span style="color:#209e91">*</span></label> <input type="password" required="" class="form-control" id="mikrotik_password" name="mikrotik_password" placeholder="Mikrotik password" ng-model="vm.data.general.MIKROTIK_PASSWORD"><div ng-messages="configsForm.mikrotik_password.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="configsForm.$invalid && configsForm.$submitted" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></uib-tab><uib-tab index="4"><uib-tab-heading>Transport Email</uib-tab-heading><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(configsForm, configsForm.transport_email,\'web.TRANSPORT_EMAIL\')}"><label for="transport_email">{{\'CONFIGS.WEB_TRANSPORT_EMAIL\' | translate}} <span style="color:#209e91">*</span></label> <input type="email" class="form-control" id="transport_email" name="transport_email" placeholder="Transport Email" ng-change="vm.cleanSvError(\'web.transport_email\')" ng-model="vm.data.web.TRANSPORT_EMAIL" required=""><div ng-messages="configsForm.transport_email.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="email">{{\'VALIDATIONS.EMAIL\' | translate}}</span></div><div ng-show="vm.haveServerError(\'web.TRANSPORT_EMAIL\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'web.TRANSPORT_EMAIL\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(configsForm, configsForm.username,\'web.TRANSPORT_EMAIL_USERNAME\')}"><label for="username">{{\'CONFIGS.WEB_TRANSPORT_EMAIL_USERNAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="username" name="username" placeholder="Username" ng-change="vm.cleanSvError(\'web.username\')" ng-model="vm.data.web.TRANSPORT_EMAIL_USERNAME" required=""><div ng-messages="configsForm.username.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'web.TRANSPORT_EMAIL_USERNAME\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'web.TRANSPORT_EMAIL_USERNAME\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(configsForm, configsForm.password,\'web.TRANSPORT_EMAIL_PASSWORD\')}"><label for="password">{{\'CONFIGS.WEB_TRANSPORT_EMAIL_PASSWORD\' | translate}} <span style="color:#209e91">*</span></label> <input type="password" class="form-control" id="password" name="password" placeholder="Password" ng-change="vm.cleanSvError(\'web.password\')" ng-model="vm.data.web.TRANSPORT_EMAIL_PASSWORD" required=""><div ng-messages="configsForm.password.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'web.TRANSPORT_EMAIL_PASSWORD\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'web.TRANSPORT_EMAIL_PASSWORD\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(configsForm, configsForm.domain,\'web.TRANSPORT_EMAIL_DOMAIN\')}"><label for="domain">{{\'CONFIGS.WEB_TRANSPORT_EMAIL_DOMAIN\' | translate}} <span style="color:#209e91">*</span></label> <input type="url" class="form-control" id="domain" name="domain" placeholder="Domain" ng-change="vm.cleanSvError(\'web.domain\')" ng-model="vm.data.web.TRANSPORT_EMAIL_DOMAIN" required=""><div ng-messages="configsForm.domain.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-messages="configsForm.domain.$error" class="help-block error-block basic-block"><span ng-message="url">{{\'VALIDATIONS.URL\' | translate}}</span></div><div ng-show="vm.haveServerError(\'web.TRANSPORT_EMAIL_DOMAIN\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'web.TRANSPORT_EMAIL_DOMAIN\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.protocol)}"><label for="protocol">{{\'CONFIGS.WEB_TRANSPORT_EMAIL_PROTOCOL\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.web.TRANSPORT_EMAIL_PROTOCOL" name="protocol" id="protocol" class="btn-group bootstrap-select form-control" search-enabled="false" required=""><ui-select-match placeholder="Protocol"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="protocol in vm.protocolTypes track by protocol | filter: $select.search"><span ng-bind-html="protocol"></span></ui-select-choices></ui-select><div ng-messages="configsForm.protocol.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(configsForm, configsForm.port,\'web.TRANSPORT_EMAIL_PORT\')}"><label for="port">{{\'CONFIGS.WEB_TRANSPORT_EMAIL_PORT\' | translate}} <span style="color:#209e91">*</span></label> <input type="number" class="form-control" id="port" name="port" placeholder="Port" ng-change="vm.cleanSvError(\'web.port\')" ng-model="vm.data.web.TRANSPORT_EMAIL_PORT" string-to-number="" required=""><div ng-messages="configsForm.port.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'web.TRANSPORT_EMAIL_PORT\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'web.TRANSPORT_EMAIL_PORT\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.security)}"><label for="security">{{\'CONFIGS.WEB_TRANSPORT_EMAIL_SECURITY\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.web.TRANSPORT_EMAIL_SECURITY" name="security" id="security" class="btn-group bootstrap-select form-control" search-enabled="false" required=""><ui-select-match placeholder="Security"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="security in vm.securityLevels track by security | filter: $select.search"><span ng-bind-html="security"></span></ui-select-choices></ui-select><div ng-messages="configsForm.security.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="configsForm.$invalid && configsForm.$submitted" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></uib-tab><uib-tab index="5"><uib-tab-heading>IPTV</uib-tab-heading><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(configsForm, configsForm.image)}"><div class="form-group row clearfix"><label class="col-sm-3 control-label">{{\'CONFIGS.SPLASH_IMAGE\' | translate}}</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ vm.getSplashImage() }}" ng-click="vm.clickOpenFile()"></div><a href="" class="change-userpic" ng-click="vm.clickOpenFile()">{{\'CONFIGS.CHANGE_SPLASH_IMAGE\' | translate}}</a> <input onchange="angular.element(this).scope().setFile(this)" type="file" ng-show="false" id="image" name="image" accept=".jpg, .jpeg" ng-model="vm.data.image"><div style="margin-top: 4px"><label style="color: gray; margin-left: 5px;margin-top: 2px">{{\'CONFIGS.IMAGE_FORMAT_ACCEPTED\' | translate:\'{ availableImageTypes: \'+vm.availableImageTypes+\'}\'}}</label></div><div ng-if="vm.isTheImageLarge"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'CONFIGS.THE_IMAGE_IS_BIG\' | translate:\'{ maxAllowedSize:\'+vm.maxAllowedSize+\' }\'}}</label></div></div></div></div></div></uib-tab></uib-tabset></div></form></div></div>');
$templateCache.put('app/modules/directives/advancedSearchBox.html','<div class="advancedSearchBox" ng-class="{active:focus}" ng-init="focus = false" ng-click="!focus ? setSearchFocus = true : null"><span ng-show="searchParams.length < 1 && searchQuery.length === 0" class="search-icon glyphicon glyphicon-search"></span> <a ng-href="" ng-show="searchParams.length > 0 || searchQuery.length > 0" ng-click="removeAll()" role="button"><span class="remove-all-icon glyphicon glyphicon-trash"></span></a><div><input name="searchbox" class="search-parameter-input" type="text" trinomio-auto-size-input="" trinomio-set-focus="setSearchFocus" placeholder="{{placeholder}}" ng-focus="focus = true" ng-blur="focus = false" ng-change="searchQueryChanged(searchQuery)" ng-model="searchQuery"></div></div>');
$templateCache.put('app/modules/errors/errorTemplate.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div style="height: 350px; position: relative;"><div class="centered-element"><i class="fa fa-exclamation-triangle fa-5x" style="margin-bottom: 10px"></i><h2>{{\'ERRORS.LOADSECTION\' | translate}}</h2><h5 ng-if="vm.status">{{\'ERRORS.\' + vm.status | translate}}</h5></div></div></div></div>');
$templateCache.put('app/modules/properties/properties.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="properties--store" class="btn btn-primary pull-right" ui-sref="properties-new"><i class="fa fa-building fa-6"></i> {{\'PROPERTIES.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="property in $data"><td title="\'PROPERTIES.ID\' | translate" ng-attr-title="" align="center" sortable="\'id\'">{{property.id}}</td><td title="\'PROPERTIES.NAME\' | translate" ng-attr-title="" align="center" sortable="\'name\'">{{property.name}}</td><td title="\'PROPERTIES.ACRONYM\' | translate" ng-attr-title="" align="center" sortable="\'acronym\'">{{property.acronym}}</td><td title="\'PROPERTIES.TOKEN\' | translate" ng-attr-title="" align="center" sortable="\'token\'">{{property.token | limitTo:20}}</td><td title="\'PROPERTIES.INSTANCE_TOKEN\' | translate" ng-attr-title="" align="center" sortable="\'instance_token\'">{{property.instance_token | limitTo:15}}</td><td title="\'PROPERTIES.INSTANCE_URL\' | translate" ng-attr-title="" align="center" sortable="\'instance_url\'">{{property.instance_url}}</td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="properties--update" ui-sref="properties-edit({ id : property.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="properties--destroy" href="" ng-really-click="vm.deleteRow(property.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/properties/propertiesAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="propertyForm" novalidate="" ng-submit="vm.save(propertyForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(propertyForm, propertyForm.name)}"><label for="name">{{\'PROPERTIES.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="name" name="name" placeholder="Name" ng-model="vm.data.name" required=""><div ng-messages="propertyForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(propertyForm, propertyForm.acronym,\'acronym\')}"><label for="acronym">{{\'PROPERTIES.ACRONYM\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" ng-change="vm.cleanSvError(\'acronym\')" id="acronym" name="acronym" placeholder="Acronym" ng-model="vm.data.acronym" required=""><div ng-messages="propertyForm.acronym.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'acronym\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'acronym\')}}</span></div></div><div class="form-group has-feedback" ng-show="vm.data.id"><div ng-class="{\'has-error\': vm.basicValidation(propertyForm, propertyForm.token)}"><label for="token">{{\'PROPERTIES.TOKEN\' | translate}}</label> <input type="text" class="form-control" id="token" name="token" ng-minlength="30" placeholder="Token" ng-model="vm.data.token" readonly="" disabled=""></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(propertyForm, propertyForm.instance_token, \'instance_token\')}"><label for="instance_token">{{\'PROPERTIES.INSTANCE_TOKEN\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" ng-change="vm.cleanSvError(\'instance_token\')" id="instance_token" name="instance_token" placeholder="Instance Token" ng-model="vm.data.instance_token" required=""><div ng-messages="propertyForm.instance_token.$error" class="help-block error-block basic-block"><span ng-message="minlength">{{\'VALIDATIONS.MIN_LENGTH\' | translate}}</span> <span ng-message="maxlength">{{\'VALIDATIONS.MAX_LENGTH\' | translate}}</span></div><div ng-show="vm.haveServerError(\'instance_token\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'instance_token\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(propertyForm, propertyForm.instance_url, \'instance_url\')}"><label for="instance_url">{{\'PROPERTIES.INSTANCE_URL\' | translate}} <span style="color:#209e91">*</span></label> <input type="url" class="form-control" id="instance_url" name="instance_url" placeholder="Instance url" ng-change="vm.cleanSvError(\'instance_url\')" ng-model="vm.data.instance_url" required=""><div ng-messages="propertyForm.instance_url.$error" class="help-block error-block basic-block"><span ng-message="url">{{\'VALIDATIONS.URL\' | translate}}</span></div><div ng-show="vm.haveServerError(\'instance_url\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'instance_url\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(propertyForm, propertyForm.name)}"><label for="country">{{\'PROPERTIES.COUNTRY\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><div class="col"><ui-select ng-model="vm.data.country" name="country" ui-select-free-text="" value-prop="name" style="padding-left: 0px" ng-disabled="false" search-enabled="true" append-to-body="true" on-select="vm.onSelected($item)" ng-change="vm.data.city = null" required=""><ui-select-match placeholder="Select a Country"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="country.code as country in vm.countries | filter: $select.search"><span ng-bind-html="country.name"></span></ui-select-choices></ui-select></div></div><div ng-messages="propertyForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-if="vm.data.country.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'PROPERTIES.COUNTRY_NOT_EXIST\' | translate}}</label></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(propertyForm, propertyForm.name)}"><label for="city">{{\'PROPERTIES.CITY\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><div class="col col-md-10"><ui-select ng-model="vm.data.city" name="city" ui-select-free-text="" value-prop="name" style="padding-left: 0px" ng-disabled="vm.countryNotSelected" search-enabled="true" append-to-body="true" required=""><ui-select-match placeholder="Select a City"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="city as city in vm.cities"><span ng-bind-html="city.name"></span></ui-select-choices></ui-select></div><div class="col col-md-2"><button type="button" ng-disabled="vm.countryNotSelected" class="btn btn-primary pull-right" style="border-top-left-radius:5px;border-bottom-left-radius:5px;" ng-click="vm.createCity()">{{\'PROPERTIES.CREATE_CITY\' | translate}}</button></div></div><div ng-messages="propertyForm.city.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-if="vm.data.city.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'PROPERTIES.CITY_NOT_EXIST\' | translate}}</label></div></div><hr><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(propertyForm, propertyForm.chromecast_owner_account_email, \'chromecast_owner_account_email\')}"><label for="chromecast_owner_account_email">{{\'PROPERTIES.CHROMECAST_OWNER_ACCOUNT_EMAIL\' | translate}}</label> <input type="email" class="form-control" id="chromecast_owner_account_email" name="chromecast_owner_account_email" placeholder="Enter the chromecast owner account email" ng-change="vm.cleanSvError(\'chromecast_owner_account_email\')" ng-model="vm.data.config.chromecast_owner_account_email"><div ng-messages="propertyForm.chromecast_owner_account_email.$error" class="help-block error-block basic-block"><span ng-message="email">{{\'VALIDATIONS.EMAIL\' | translate}}</span></div><div ng-show="vm.haveServerError(\'chromecast_owner_account_email\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'chromecast_owner_account_email\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(propertyForm, propertyForm.chromecast_owner_account_password, \'chromecast_owner_account_password\')}"><label for="chromecast_owner_account_password">{{\'PROPERTIES.CHROMECAST_OWNER_ACCOUNT_PASSWORD\' | translate}}</label> <input type="password" class="form-control" id="chromecast_owner_account_password" name="chromecast_owner_account_password" placeholder="Enter the chromecast owner account password" ng-model="vm.data.config.chromecast_owner_account_password"><div class="help-block">remember this password must be generated at <a href="https://myaccount.google.com/apppasswords" target="__blank">https://myaccount.google.com/apppasswords</a></div><div ng-show="vm.haveServerError(\'chromecast_owner_account_password\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'chromecast_owner_account_password\')}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="propertyForm.$invalid" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/services/services.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshServices()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="service in $data"><td title="\'SERVICES.SERVICE\' | translate" ng-attr-title="" align="center" style="text-align: left;">{{service.service}}</td><td title="\'SERVICES.STATUS\' | translate" ng-attr-title="" align="center"><span ng-class="vm.getClass(service)" style="width:100%">{{vm.getStatus(service)}}</span></td><td title="\'TABLES.RESTART\' | translate" ng-attr-title="" align="center"><a permission-hide="services--restart" href="" ng-really-click="vm.restart(service)" ng-really-message="Are you sure you want to restart this service?"><i class="fa fa-repeat"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/templates/editImage.html','<div class="modal-content"><div class="modal-header"><h5 class="modal-title"><i class="fa fa-image fa-lg"></i> {{\'TEMPLATE.CROP_IMAGE\' | translate}}</h5></div><div class="modal-body img-container"><div class="pull-right img-dimensions"><span>{{\'TEMPLATE.IMAGE_DIMENSIONS\' | translate:dimensions }}</span></div><img ng-src="{{image}}" ng-cropper="" ng-cropper-proxy="cropperProxy" ng-cropper-show="showEvent" ng-cropper-hide="hideEvent" ng-cropper-options="options"></div><div class="img-dimensions-error"><span ng-hide="vm.saveImage"><span>{{\'TEMPLATE.IMAGE_DIMENSIONS_ACCEPTED\' | translate:supportedDimensions}}</span> <span ng-if="vm.maxHeight" style="margin:0">- {{\'TEMPLATE.IMAGE_DIMENSIONS_ACCEPTED_MAX\' | translate:supportedDimensions}}</span></span></div><div class="modal-footer"><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="!vm.saveImage" ng-click="vm.save()" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE_IMAGE\' | translate}}</button></div></div></div>');
$templateCache.put('app/modules/templates/templatesEdit.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll"><form class="form-inline"><div class="form-group col-sm-3 col-xs-6"><ui-select ng-model="vm.currentParameter" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" ng-change="vm.changeType()" required=""><ui-select-match placeholder="Select Type"><span>{{$select.selected.parameter}}</span></ui-select-match><ui-select-choices repeat="parameter in vm.template.parameters | filter: $select.search"><span ng-bind-html="parameter.parameter"></span></ui-select-choices></ui-select></div><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" colorpicker="" ng-model="vm.currentParameter.value" ng-if="vm.currentParameter.type == \'Color\'"> <input type="file" class="form-control" onchange="angular.element(this).scope().setFile(this)" accept="image/png" ng-if="vm.currentParameter.type == \'Image\'"></div><button type="submit" class="btn btn-primary pull-right" ng-click="vm.save(vm.template.parameters)">Save</button></form></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="Preview"><template-preview template="vm.template"></template-preview></div></div></div></div>');
$templateCache.put('app/modules/users/users.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="customers--store" class="btn btn-primary pull-right" ui-sref="users-new"><i class="fa fa-user fa-6"></i> {{\'USERS.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="user in $data"><td title="\'USERS.ID\' | translate" ng-attr-title="" align="center" sortable="\'id\'">{{user.id}}</td><td title="\'USERS.FIRST_NAME\' | translate" ng-attr-title="" align="center" sortable="\'first_name\'">{{user.first_name}}</td><td title="\'USERS.LAST_NAME\' | translate" ng-attr-title="" align="center" sortable="\'last_name\'">{{user.last_name}}</td><td title="\'USERS.USERNAME\' | translate" ng-attr-title="" align="center" sortable="\'username\'">{{user.username}}</td><td title="\'USERS.EMAIL\' | translate" ng-attr-title="" align="center" sortable="\'email\'">{{user.email}}</td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="customers--update" ui-sref="users-edit({ id : user.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="customers--destroy" href="" ng-really-click="vm.deleteRow(user.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/users/usersAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="usersForm" novalidate="" ng-submit="vm.save(usersForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(usersForm, usersForm.first_name)}"><label for="first_name">{{\'USERS.FIRST_NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="first_name" name="first_name" placeholder="First Name" ng-model="vm.data.first_name" required=""><div ng-messages="usersForm.first_name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(usersForm, usersForm.last_name)}"><label for="last_name">{{\'USERS.LAST_NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="last_name" name="last_name" placeholder="Last Name" ng-model="vm.data.last_name" required=""><div ng-messages="usersForm.last_name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(usersForm, usersForm.email)}"><label for="email">{{\'USERS.EMAIL\' | translate}} <span style="color:#209e91">*</span></label> <input type="email" class="form-control" id="email" name="email" placeholder="Email" ng-model="vm.data.email" required=""><div ng-messages="usersForm.email.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="email">{{\'VALIDATIONS.EMAIL\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(usersForm, usersForm.username,\'username\')}"><label for="name">{{\'USERS.USERNAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" ng-change="vm.cleanSvError(\'username\')" id="username" name="username" placeholder="Username" ng-model="vm.data.username" required=""><div ng-messages="usersForm.username.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'username\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'username\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(usersForm, usersForm.password)}"><label for="name">{{\'USERS.PASSWORD\' | translate}} <span style="color:#209e91" ng-show="!vm.data.id">*</span></label> <input type="password" class="form-control" id="password" name="password" placeholder="Password" ng-model="vm.data.password" ng-required="!vm.data.id" ng-minlength="8"><div ng-messages="usersForm.password.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="minlength">{{\'VALIDATIONS.MIN_LENGTH\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(usersForm, usersForm.confirmpassword)}"><label for="confirmpassword">{{\'USERS.PASSWORD_CONFIRM\' | translate}} <span style="color:#209e91" ng-show="vm.data.password">*</span></label> <input match-password="password" type="password" class="form-control" id="confirmpassword" name="confirmpassword" placeholder="Password" ng-model="vm.passwordConfirm" ng-required="vm.data.password"><div ng-messages="usersForm.confirmpassword.$error" class="help-block error-block basic-block"><span ng-message="passwordMatch">{{\'VALIDATIONS.PASSWORD_MATCH\' | translate}}</span></div></div><div class="form-group has-feedback"><label for="role_id">{{\'USERS.ROLE\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.role_id" name="role_id" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" required=""><ui-select-match placeholder="Select Role"><span>{{$select.selected.display_name}}</span></ui-select-match><ui-select-choices repeat="role.id as role in vm.roles | filter: $select.search"><span ng-bind-html="role.display_name"></span></ui-select-choices></ui-select><div ng-messages="receiversForm.role_id.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" ng-change="vm.updatePropertiesList()" ng-model="vm.data.all_properties"> <span>{{\'USERS.ALL_PROPERTIES\' | translate}}</span></label></div><div ng-if="!vm.data.all_properties"><div class="form-group has-feedback"><label for="name">Properties <span style="color:#209e91">*</span></label><ui-select ng-model="vm.propertySelected" name="area_name" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-change="vm.addProperty()"><ui-select-match placeholder="Select Property"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="property in vm.properties | filter: $select.search"><span ng-bind-html="property.name"></span></ui-select-choices></ui-select></div><div ng-if="vm.data.properties.length > 0"><table ng-table="vm.table" style="margin-bottom:10px;" class="table table-striped"><tr ng-repeat="row in $data"><td data-title="\'Properties\'">{{row.name}}</td><td><a href="" ng-if="!vm.data.all_properties" ng-click="vm.deletePropertySelected(row)" uib-tooltip="\'delete\'"><i class="fa fa-times"></i></a></td></tr></table></div></div><div class="form-group row"><label class="col-sm-4 control-label">{{\'USERS.NOTIFICATIONS\' | translate}}</label> <label style="margin-left: 26px"><ba-switcher switcher-style="primary" switcher-value="vm.data.notifications_activated" switcher-on="Yes" switcher-off="No" permission="customers--update" class="col-sm-8"></ba-switcher></label></div><div class="form-group"><button class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="usersForm.$invalid || (!vm.data.all_properties && vm.data.properties.length == 0)" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard widgets="vm.widgets" areas="vm.areas"></dashboard>');
$templateCache.put('app/pages/maps/maps.html','<div class="widgets"><div class="row"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="progress-info">Your profile is 70% Complete</div><div class="progress"><div class="progress-bar progress-bar-primary progress-bar-striped active" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 70%"></div></div><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">First Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" value="Anastasiya"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Last Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Department</label><div class="col-sm-9"><select class="form-control" selectpicker=""><option>Web Development</option><option>System Development</option><option>Sales</option><option>Human Resources</option></select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Occupation</label><div class="col-sm-9"><input type="text" class="form-control" id="inputOccupation" placeholder="" value="Front End Web Developer"></div></div></div></div><h3 class="with-line">Change Password</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" value="12345678"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder=""></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" id="inputEmail3" placeholder="" value="contact@akveo.com"></div></div><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" value="+1 (23) 456 7890"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Office Location</label><div class="col-sm-9"><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class="form-group row clearfix"><label for="inputRoom" class="col-sm-3 control-label">Room</label><div class="col-sm-9"><input type="text" class="form-control" id="inputRoom" placeholder="" value="303"></div></div></div></div><h3 class="with-line">Social Profiles</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4" ng-repeat="item in socialProfiles"><a class="sn-link" href="" ng-click="showModal(item)" ng-if="!item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span></a> <a class="sn-link connected" href="{{ item.href }}" target="_blank" ng-if="item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span> <em class="ion-ios-close-empty sn-link-close" ng-mousedown="unconnect(item)"></em></a></div></div><h3 class="with-line">Send Email Notifications</h3><div class="notification row clearfix"><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When I receive a message</label><div class="col-xs-4"><switch color="primary" ng-model="switches[0]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When Someone sends me an invitation</label><div class="col-xs-4"><switch color="primary" ng-model="switches[1]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When profile information changes</label><div class="col-xs-4"><switch color="primary" ng-model="switches[2]"></switch></div></div></div><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When anyone logs into your account from a new device or browser</label><div class="col-xs-4"><switch color="primary" ng-model="switches[3]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Weekly Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[4]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Daily Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[5]"></switch></div></div></div></div><button type="button" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/modules/areas/area-lists/areaLists.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="areas--store" class="btn btn-primary pull-right" ui-sref="areas.area-lists-new"><i class="fa fa-bed fa-6"></i> {{\'AREAS.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-6" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><div class="col-md-4" style="padding-top: 8px"><span>Verification Code Expiration Time</span><timer countdown="vm.expirationTime" interval="1000" finish-callback="vm.refreshCode()"><div class="progress progress-striped active {{displayProgressActive}}" style="height: 20px;"><div class="progress-bar" style="background-color: #209e91; min-width: 2em;width: {{100-progressBar}}%;">{{countdown}} seconds</div></div></timer></div><div class="col-md-2" style="padding-top: 26px"><label class="custom-checkbox"><input type="checkbox" ng-change="vm.autoRefresh()" ng-model="vm.autoRefreshCodes"> <span>Auto-refresh Codes</span></label></div><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="area in $data"><td title="\'AREAS.NAME\' | translate" ng-attr-title="" align="center" sortable="\'name\'">{{area.name}}</td><td title="\'AREAS.AREA_TYPE\' | translate" ng-attr-title="" align="center">{{area.area_type.name}}</td><td title="\'AREAS.RECEIVERS_QUANTITY\' | translate" ng-attr-title="" align="center">{{area.receivers_quantity}}</td><td title="\'AREAS.CODE\' | translate" ng-attr-title="" align="center"><span class="badge badge-dark">{{area.code}}</span></td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="areas--update" ui-sref="areas.area-lists-edit({ id : area.name})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="areas--destroy" href="" ng-really-click="vm.deleteRow(area.name)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/areas/area-lists/areaListsAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="areaForm" novalidate="" ng-submit="vm.save(areaForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(areaForm, areaForm.name,\'name\')}"><label for="name">{{\'AREAS.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'name\')" class="form-control" id="name" name="name" placeholder="Name" ng-model="vm.data.name" required=""><div><label style="color: darkgray; margin-left: 20px">The name will be saved in upper case and whitespaces will be replaced by underscores</label></div><div ng-messages="areaForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'name\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'name\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(areaForm, areaForm.area_type_id)}"><label for="area_type_id">{{\'AREAS.AREA_TYPE\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><div class="col-md-9"><ui-select ng-model="vm.data.area_type" name="area_type_id" ui-select-free-text="" value-prop="name" style="padding-left: 0px" ng-disabled="false" search-enabled="true" append-to-body="true" required=""><ui-select-match placeholder="Select Area Type"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="areaType in vm.areaTypes | filter: $select.search"><span ng-bind-html="areaType.name"></span></ui-select-choices></ui-select></div><button type="button" permission-hide="area-types--store" ng-disabled="vm.shouldCreateAreaTypeButton()" class="btn btn-primary pull-right" style="border-top-left-radius:5px;border-bottom-left-radius:5px;" ng-click="vm.createAreaType()">{{\'RECEIVERS.CREATE_AREA_TYPE\' | translate}}</button></div><div ng-messages="areaForm.area_type_id.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-if="vm.data.area_type.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'RECEIVERS.AREA_TYPE_NOT_EXIST\' | translate}}</label></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="areaForm.$invalid" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/areas/area-types/areaTypes.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="area-types--store" class="btn btn-primary pull-right" ui-sref="areas.area-types-new"><i class="fa fa-bed fa-6"></i> {{\'AREA_TYPES.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="areaType in $data"><td title="\'AREAS.NAME\' | translate" ng-attr-title="" sortable="\'name\'">{{areaType.name}}</td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a ui-sref="areas.area-types-edit({ id : areaType.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a href="" ng-really-click="vm.deleteRow(areaType.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/areas/area-types/areaTypesAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="areaForm" novalidate="" ng-submit="vm.save(areaForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(areaForm, areaForm.name,\'name\')}"><label for="name">{{\'AREAS.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'name\')" class="form-control" id="name" name="name" placeholder="Name" ng-model="vm.data.name" required=""><div><label style="color: darkgray; margin-left: 20px">The name will be saved in upper case and whitespaces will be replaced by underscores</label></div><div ng-messages="areaForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'name\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'name\')}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="areaForm.$invalid" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/auth/login/login.html','<main class="auth-main"><div class="auth-block"><h1>Sign in to Gocloud Cast</h1><form class="form-horizontal" ng-submit="vm.login()"><div class="form-group" ng-class="{\'has-error\': vm.errorMessage}"><label for="inputUsername" class="col-sm-2 control-label">Username</label><div class="col-sm-10"><input type="text" ng-change="vm.cleanErrorMessage()" class="form-control" id="inputUsername" placeholder="Username" ng-model="vm.credentials.username" required=""></div></div><div class="form-group" ng-class="{\'has-error\': vm.errorMessage}"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" ng-change="vm.cleanErrorMessage()" class="form-control" id="inputPassword3" placeholder="Password" ng-model="vm.credentials.password" required=""></div></div><div ng-if="vm.errorMessage" class="login-error-message">{{vm.errorMessage}}</div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-default btn-auth">Sign in</button></div></div></form></div></main>');
$templateCache.put('app/modules/cast/news/news.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="news--store" class="btn btn-primary pull-right" ui-sref="cast.news-new"><i class="fa fa-newspaper-o fa-6"></i> {{\'NEWS.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="news in $data"><td title="\'NEWS.TITLE\' | translate" ng-attr-title="" align="center" sortable="\'title\'">{{news.title}}</td><td title="\'NEWS.CATEGORY\' | translate" ng-attr-title="" align="center">{{news.category.name}}</td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="news--update" ui-sref="cast.news-edit({ id : news.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="news--destroy" href="" ng-really-click="vm.deleteRow(news.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/cast/news/newsAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="newsForm" novalidate="" ng-submit="vm.save(newsForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(newsForm, newsForm.title,\'title\')}"><label for="title">{{\'NEWS.TITLE\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'title\')" class="form-control" id="title" name="title" placeholder="Title" ng-model="vm.data.title" required=""><div ng-messages="newsForm.title.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'title\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'title\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(newsForm, newsForm.publication_date,\'publication_date\')}"><label for="publication_date">{{\'NEWS.PUBLICATION_DATE\' | translate}} <span style="color:#209e91">*</span></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" datepicker-options="vm.options" ng-model="vm.publication_date" id="publication_date" name="publication_date" is-open="vm.publication_date_open" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'publication_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span></p><div ng-messages="newsForm.publication_date.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(newsForm, newsForm.expiration_date,\'expiration_date\')}"><label for="expiration_date">{{\'NEWS.EXPIRATION_DATE\' | translate}} <span style="color:#209e91">*</span></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" datepicker-options="vm.options" ng-model="vm.expiration_date" id="expiration_date" name="expiration_date" is-open="vm.expiration_date_open" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'expiration_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span></p><div ng-messages="newsForm.expiration_date.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback"><label for="category_id">{{\'NEWS.CATEGORY\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.category_id" name="category_id" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" required=""><ui-select-match placeholder="Select Category"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="category.id as category in vm.categories | filter: $select.search"><span ng-bind-html="category.name"></span></ui-select-choices></ui-select><div ng-messages="receiversForm.category_id.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group row"><label class="col-sm-4 control-label">{{\'NEWS.ALL_AREAS\' | translate}}</label> <label style="margin-left: 26px"><ba-switcher switcher-style="primary" switcher-value="vm.data.all_areas" switcher-on="Yes" switcher-off="No" permission="news--update" class="col-sm-8"></ba-switcher></label></div><div ng-if="!vm.data.all_areas"><div class="form-group has-feedback"><label for="name">{{\'NEWS.AREAS\' | translate}}</label><ui-select ng-model="vm.areaSelected" name="area_name" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-change="vm.addArea()"><ui-select-match placeholder="Select Area"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in vm.areas | filter: $select.search"><span ng-bind-html="area.name"></span></ui-select-choices></ui-select></div><div ng-if="vm.data.areas.length > 0"><table ng-table="vm.table" style="margin-bottom:10px;" class="table table-striped"><tr ng-repeat="row in $data"><td data-title="\'Areas\'">{{row.name}}</td><td><a href="" ng-if="!vm.data.all_areas" ng-click="vm.deleteAreaSelected(row)" uib-tooltip="\'delete\'"><i class="fa fa-times"></i></a></td></tr></table></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="newsForm.$invalid || (!vm.data.all_areas && vm.data.areas.length == 0)" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/cast/receivers/addReceiverModal.html','<form name="addReceiverForm" novalidate="" ng-submit="vm.assign(addReceiverForm)"><div class="modal-content"><div class="modal-header"><h5 class="modal-title"><i class="fa fa-television fa-lg"></i> {{\'RECEIVERS.NEW\' | translate}}</h5></div><div class="modal-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(addReceiverForm, addReceiverForm.ip_address, \'ip_address\')}"><label for="ip_address_label">{{\'RECEIVERS.IP_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" ng-change="vm.cleanSvError(\'ip_address\')" id="ip_address" name="ip_address" placeholder="Ip Address" ng-model="vm.receiver.ip_address" ip-address-format="" required=""><div ng-messages="addReceiverForm.ip_address.$error || addReceiverForm.ip_address.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="ipAddress">{{\'VALIDATIONS.IP_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'ip_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'ip_address\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(addReceiverForm, addReceiverForm.mac_address, \'mac_address\')}"><label for="mac_address_label">{{\'RECEIVERS.MAC_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-pattern="/^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/" class="form-control" id="mac_address" name="mac_address" ng-change="vm.cleanSvError(\'mac_address\')" placeholder="Mac Address" ng-model="vm.receiver.mac_address" required=""><div ng-messages="addReceiverForm.mac_address.$error || addReceiverForm.mac_address.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="pattern">{{\'VALIDATIONS.MAC_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'mac_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'mac_address\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(addReceiverForm, addReceiverForm.name)}"><label for="ip_address_label">{{\'RECEIVERS.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="name" name="name" placeholder="Name" ng-model="vm.receiver.name" required=""><div ng-messages="addReceiverForm.name.$error || addReceiverForm.name.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(addReceiverForm, addReceiverForm.uuid, \'uuid\')}"><label for="ip_address_label">{{\'RECEIVERS.UUID\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" ng-change="vm.cleanSvError(\'uuid\')" id="uuid" name="uuid" placeholder="uuid" ng-model="vm.receiver.uuid" required=""><div ng-messages="addReceiverForm.uuid.$error || addReceiverForm.uuid.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'uuid\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'uuid\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(addReceiverForm, addReceiverForm.area_name)}"><label for="area_name_label">{{\'RECEIVERS.AREA_NAME\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><ui-select ng-model="vm.receiver.area_name" name="area_name" class="col-md-9" ui-select-free-text="" value-prop="name" style="padding-left: 0px" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Select Area"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in vm.areas | filter: $select.search"><span ng-bind-html="area.name"></span></ui-select-choices></ui-select><button type="button" ng-disabled="vm.areaExist()||vm.receiver.area_name==undefined||!vm.receiver.area_type.id" class="btn btn-primary pull-right" style="border-top-left-radius:5px;border-bottom-left-radius:5px;" ng-click="vm.createArea()">{{\'RECEIVERS.CREATE_AREA\' | translate}}</button></div><div ng-if="vm.receiver.area_name.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'RECEIVERS.AREA_NOT_EXIST\' | translate}}</label></div><div ng-messages="addReceiverForm.area_name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-if="!vm.areaExist()" ng-class="{\'has-error\': vm.basicValidation(addReceiverForm, addReceiverForm.area_type)}"><label for="area_type">{{\'RECEIVERS.AREA_TYPE\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><ui-select ng-model="vm.receiver.area_type" name="area_type" class="col-md-9" ui-select-free-text="" value-prop="name" style="padding-left: 0px" ng-disabled="false" ng-change="vm.areaTypeChanged($select.selected)" search-enabled="true" required=""><ui-select-match placeholder="Select Area Type"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in vm.areaTypes | filter: $select.search"><span ng-bind-html="area.name"></span></ui-select-choices></ui-select><button type="button" ng-disabled="vm.shouldCreateAreaTypeButton()" class="btn btn-primary pull-right" style="border-top-left-radius:5px;border-bottom-left-radius:5px;" ng-click="vm.createAreaType()">{{\'RECEIVERS.CREATE_AREA_TYPE\' | translate}}</button></div><div ng-if="vm.receiver.area_type.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'RECEIVERS.AREA_NOT_EXIST\' | translate}}</label></div><div ng-messages="addReceiverForm.area_type.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(addReceiverForm, addReceiverForm.type)}"><label for="type_label">{{\'RECEIVERS.TYPE\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.receiver.type" name="type" id="type" class="btn-group bootstrap-select form-control" search-enabled="false" on-select="vm.changeType()" required=""><ui-select-match placeholder="Select Type"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in vm.types track by type| filter: $select.search"><span ng-bind-html="type"></span></ui-select-choices></ui-select><div ng-messages="addReceiverForm.type.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(addReceiverForm, addReceiverForm.chromecast_input)}" ng-show="vm.isChromecastInputRequired()"><label for="chromecast_input_label">{{\'RECEIVERS.CHROMECAST_INPUT\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.receiver.chromecast_input" name="chromecast_input" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false" ng-required="vm.isChromecastInputRequired()"><ui-select-match placeholder="Select Chromecast input"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="input in vm.inputs | filter: $select.search"><span ng-bind-html="input"></span></ui-select-choices></ui-select><div ng-messages="addReceiverForm.chromecast_input.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(addReceiverForm, addReceiverForm.smart_tv_ip_address)}" ng-show="vm.isSmartTVIPAddressRequired()"><label for="smart_tv_ip_address">{{\'RECEIVERS.SMART_TV_IP_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="smart_tv_ip_address" name="smart_tv_ip_address" ip-address-format="" placeholder="Smart TV IP Address" ng-model="vm.receiver.smart_tv_ip_address" ng-required="vm.isSmartTVIPAddressRequired()"><div ng-messages="addReceiverForm.smart_tv_ip_address.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="ipAddress">{{\'VALIDATIONS.IP_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'smart_tv_ip_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'smart_tv_ip_address\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(addReceiverForm, addReceiverForm.smart_tv_mac_address, \'smart_tv_mac_address\')}" ng-show="vm.isSmartTVIPAddressRequired()"><label for="smart_tv_mac_address_label">{{\'RECEIVERS.SMART_TV_MAC_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-pattern="/^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/" class="form-control" id="smart_tv_mac_address" name="smart_tv_mac_address" ng-change="vm.cleanSvError(\'smart_tv_mac_address\')" placeholder="Smart Tv Mac Address" ng-model="vm.receiver.smart_tv_mac_address" ng-required="vm.isSmartTVIPAddressRequired()"><div ng-messages="addReceiverForm.smart_tv_mac_address.$error || addReceiverForm.smart_tv_mac_address.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="pattern">{{\'VALIDATIONS.MAC_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'smart_tv_mac_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'smart_tv_mac_address\')}}</span></div></div></div><div class="modal-footer"><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="addReceiverForm.$invalid || vm.receiver.area_name.isFreeText" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.ADD\' | translate}}</button></div></div></div></form>');
$templateCache.put('app/modules/cast/receivers/receivers.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button class="btn btn-primary pull-right" ui-sref="cast.receivers-new" permission-hide="receivers--store"><i class="fa fa-television fa-6"></i> {{\'RECEIVERS.NEW\' | translate}}</button> <button class="btn btn-default pull-right" ng-click="vm.refreshTokens()" permission-hide="receivers--token-refresh" style="margin-right: 15px;"><i class="fa fa-key" aria-hidden="true"></i> {{\'RECEIVERS.REFRESH_TOKENS\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><uib-tabset active="active"><uib-tab index="0"><uib-tab-heading><i class="fa fa-list-ul"></i> List</uib-tab-heading><nit-advanced-searchbox ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped"><tr ng-repeat="receiver in $data"><td title="\'RECEIVERS.NAME\' | translate" align="center" ng-attr-title="" style="width:7%" sortable="\'name\'">{{receiver.name}}</td><td title="\'RECEIVERS.AREA_NAME\' | translate" align="center" ng-attr-title="" style="width:7%" sortable="\'area_name\'">{{receiver.area_name}}</td><td title="\'RECEIVERS.TYPE\' | translate" align="center" ng-attr-title="" style="width:15%" sortable="\'type\'">{{receiver.type }}</td><td title="\'RECEIVERS.IP_ADDRESS\' | translate" align="center" ng-attr-title="" style="width:10%" sortable="\'ip_address\'"><div ng-bind="receiver.ip_address"></div><div ng-bind="receiver.smart_tv_ip_address"></div></td><td title="\'RECEIVERS.MAC_ADDRESS\' | translate" align="center" ng-attr-title="" style="width:10%" sortable="\'ip_address\'"><div ng-bind="receiver.mac_address"></div><div ng-bind="receiver.smart_tv_mac_address"></div></td><td title="\'RECEIVERS.UUID\' | translate" align="center" ng-attr-title="" style="width:23%" sortable="\'uuid\'"><a class="text-link" href="" ng-click="vm.goToIndications(receiver.uuid)">{{receiver.uuid}}</a></td><td title="\'RECEIVERS.LAST_APP_DATE\' | translate" align="center" ng-attr-title="" style="width:10%">{{receiver.last_date}}</td><td title="\'TABLES.RESTART\' | translate" ng-attr-title="" style="width:3%" align="center"><a href="" ng-really-click="vm.restart(receiver)" ng-really-message="Are you sure you want to restart the receiver?"><i class="fa fa-repeat"></i></a></td><td title="\'TABLES.REBOOT\' | translate" ng-attr-title="" style="width:3%" align="center"><a href="" ng-really-click="vm.reboot(receiver)" ng-really-message="Are you sure you want to reboot the receiver?"><i class="fa fa-power-off"></i></a></td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" style="width:3%" align="center"><a permission-hide="receivers--update" ui-sref="cast.receivers-edit({ id : receiver.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" style="width:3%" align="center"><a permission-hide="receivers--destroy" href="" ng-really-click="vm.deleteRow(receiver.id)"><i class="fa fa-trash"></i></a></td><td><span ng-if="receiver.isOn" class="badge badge-success" style="width:100%">{{receiver.state}}</span> <span ng-if="!receiver.isOn" class="badge badge-danger" style="width:100%">{{receiver.state ? receiver.state : "Loading"}}</span></td></tr></table></uib-tab><uib-tab disable="vm.discoveryDisable" index="1" style="width: 135px"><uib-tab-heading><div class="row" style="margin-left: 0px"><div class="col-md-2 pull-right"><div ng-if="vm.discoveryDisable" class="loadersmall"></div></div><div><i class="fa fa-search"></i> Discovery</div></div></uib-tab-heading><table ng-table="vm.discoveryTable" class="table table-hover table-condensed table-striped"><tr ng-repeat="receiver in vm.discoveryReceivers"><td title="\'RECEIVERS.NAME\' | translate" ng-attr-title="" style="width:15%" sortable="\'name\'">{{receiver.name}}</td><td title="\'RECEIVERS.TYPE\' | translate" ng-attr-title="" style="width:15%" sortable="\'type\'">{{receiver.type | limitTo:12 }}</td><td title="\'RECEIVERS.IP_ADDRESS\' | translate" ng-attr-title="" style="width:24%" sortable="\'ip_address\'">{{receiver.ip_address}}</td><td title="\'RECEIVERS.UUID\' | translate" ng-attr-title="" style="width:36%" sortable="\'uuid\'">{{receiver.uuid}}</td><td title="\'TABLES.ADD\' | translate" ng-attr-title="" style="width:3%" align="center"><a permission-hide="receivers--store" href="" ng-click="vm.add(receiver)"><i class="fa fa-plus"></i></a></td></tr></table></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/modules/cast/receivers/receiversAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="receiversForm" novalidate="" ng-submit="vm.save(receiversForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(receiversForm, receiversForm.name)}"><label for="name">{{\'RECEIVERS.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="name" name="name" placeholder="Name" ng-model="vm.data.name" required=""><div ng-messages="receiversForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback"><label for="name">{{\'RECEIVERS.AREA\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><ui-select ng-model="vm.data.area_name" name="area_name" class="col-md-9" ui-select-free-text="" value-prop="name" style="padding-left: 0px" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Select Area"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in vm.areas | filter: $select.search"><span ng-bind-html="area.name"></span></ui-select-choices></ui-select><button type="button" ng-disabled="vm.shouldCreateAreaButton()" class="btn btn-primary pull-right" style="border-top-left-radius:5px;border-bottom-left-radius:5px;" ng-click="vm.createArea()">{{\'RECEIVERS.CREATE_AREA\' | translate}}</button></div><div ng-messages="receiversForm.area_name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-if="vm.data.area_name.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'RECEIVERS.AREA_NOT_EXIST\' | translate}}</label></div></div><div class="form-group has-feedback" ng-if="!vm.areaExist()"><label for="area_type">{{\'RECEIVERS.AREA_TYPE\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><ui-select ng-model="vm.data.area_type" name="area_type" class="col-md-9" ui-select-free-text="" value-prop="name" style="padding-left: 0px" ng-disabled="false" ng-change="vm.areaTypeChanged($select.selected)" search-enabled="true" required=""><ui-select-match placeholder="Select Area Type"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="areaType in vm.areaTypes | filter: $select.search"><span ng-bind-html="areaType.name"></span></ui-select-choices></ui-select><button type="button" ng-disabled="vm.shouldCreateAreaTypeButton()" class="btn btn-primary pull-right" style="border-top-left-radius:5px;border-bottom-left-radius:5px;" ng-click="vm.createAreaType()">{{\'RECEIVERS.CREATE_AREA_TYPE\' | translate}}</button></div><div ng-messages="receiversForm.area_type.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-if="vm.data.area_type.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'RECEIVERS.AREA_TYPE_NOT_EXIST\' | translate}}</label></div></div><div class="form-group has-feedback"><label for="name">{{\'RECEIVERS.TYPE\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.type" name="type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" on-select="vm.changeType()" required=""><ui-select-match placeholder="Select Type"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in vm.types | filter: $select.search"><span ng-bind-html="type"></span></ui-select-choices></ui-select><div ng-messages="receiversForm.type.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(receiversForm, receiversForm.ip_address, \'ip_address\')}"><label for="ip_address_label">{{\'RECEIVERS.IP_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="ip_address" name="ip_address" ng-change="vm.cleanSvError(\'ip_address\')" placeholder="Ip Address" ng-model="vm.data.ip_address" ip-address-format="" required=""><div ng-messages="receiversForm.ip_address.$error || receiversForm.ip_address.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="ipAddress">{{\'VALIDATIONS.IP_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'ip_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'ip_address\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(receiversForm, receiversForm.mac_address, \'mac_address\')}"><label for="mac_address_label">{{\'RECEIVERS.MAC_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-pattern="/^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/" class="form-control" id="mac_address" name="mac_address" ng-change="vm.cleanSvError(\'mac_address\')" placeholder="Mac Address" ng-model="vm.data.mac_address" required=""><div ng-messages="receiversForm.mac_address.$error || receiversForm.mac_address.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="pattern">{{\'VALIDATIONS.MAC_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'mac_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'mac_address\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(receiversForm, receiversForm.uuid,\'uuid\')}"><label for="uuid">{{\'RECEIVERS.UUID\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="uuid" name="uuid" ng-change="vm.cleanSvError(\'uuid\')" placeholder="UUID" ng-model="vm.data.uuid" required=""><div ng-messages="receiversForm.uuid.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'uuid\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'uuid\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(receiversForm, receiversForm.chromecast_input)}" ng-show="vm.isTVType()"><label for="ip_address_label">{{\'RECEIVERS.CHROMECAST_INPUT\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.chromecast_input" name="chromecast_input" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" ng-required="vm.isTVType()"><ui-select-match placeholder="Select Chromecast input"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="input in vm.inputs | filter: $select.search"><span ng-bind-html="input"></span></ui-select-choices></ui-select><div ng-messages="receiversForm.chromecast_input.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(receiversForm, receiversForm.smart_tv_ip_address)}" ng-show="vm.isTVType()"><label for="smart_tv_ip_address">{{\'RECEIVERS.SMART_TV_IP_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="smart_tv_ip_address" name="smart_tv_ip_address" ip-address-format="" placeholder="Smart TV IP Address" ng-model="vm.data.smart_tv_ip_address" ng-required="vm.isTVType()"><div ng-messages="receiversForm.smart_tv_ip_address.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="ipAddress">{{\'VALIDATIONS.IP_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'smart_tv_ip_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'smart_tv_ip_address\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(receiversForm, receiversForm.smart_tv_mac_address, \'smart_tv_mac_address\')}" ng-show="vm.isTVType()"><label for="smart_tv_mac_address_label">{{\'RECEIVERS.SMART_TV_MAC_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-pattern="/^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/" class="form-control" id="smart_tv_mac_address" name="smart_tv_mac_address" ng-change="vm.cleanSvError(\'smart_tv_mac_address\')" placeholder="Smart Tv Mac Address" ng-model="vm.data.smart_tv_mac_address" ng-required="vm.isTVType()"><div ng-messages="receiversForm.smart_tv_mac_address.$error || receiversForm.smart_tv_mac_address.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="pattern">{{\'VALIDATIONS.MAC_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'smart_tv_mac_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'smart_tv_mac_address\')}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="receiversForm.$invalid||!vm.areaExist()" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/cast/senders/senders.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="senders--manual-assignment" class="btn btn-primary pull-right" ng-click="vm.openModal()"><i class="fa fa-television fa-6"></i> {{\'SENDERS.MANUALASSIGN\' | translate}} <span style="color:#209e91">*</span></button><div class="col-md-4 pull-right"><ui-select ng-model="vm.areaselected" name="type" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false" ng-change="vm.changeArea()" required=""><ui-select-match allow-clear="true" placeholder="Select Area"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="area in vm.areas track by area| filter: $select.search"><span ng-bind-html="area"></span></ui-select-choices><ui-select-no-choice>No Areas found</ui-select-no-choice></ui-select></div></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="sender in $data"><td title="\'SENDERS.ID\' | translate" ng-attr-title="" align="center" sortable="\'id\'">{{sender.id}}</td><td title="\'SENDERS.DATE\' | translate" ng-attr-title="" align="center" sortable="\'created_at\'">{{sender.created_at}}</td><td title="\'SENDERS.IP_ADDRESS\' | translate" ng-attr-title="" align="center" sortable="\'ip_address\'">{{sender.ip_address}}</td><td title="\'SENDERS.MAC_ADDRESS\' | translate" ng-attr-title="" align="center" sortable="\'mac_address\'">{{sender.mac_address}}</td><td title="\'SENDERS.AREA_NAME\' | translate" ng-attr-title="" align="center" sortable="\'area_name\'">{{sender.area_name}}</td><td ng-if="!vm.isUnmanaged()" title="\'SENDERS.NAME\' | translate" ng-attr-title="" align="center" sortable="\'name\'">{{sender.name}}</td><td title="\'SENDERS.PLATFORM\' | translate" ng-attr-title="" sortable="\'platform\'" align="center"><i class="fa {{vm.getPlatformIcon(sender.platform.toLowerCase())}}"></i></td><td title="\'SENDERS.BROWSER\' | translate" ng-attr-title="" sortable="\'browser\'" align="center"><i class="fa {{vm.getBrowserIcon(sender.browser.toLowerCase())}}"></i></td><td title="\'SENDERS.REVOKE\' | translate" ng-attr-title="" align="center"><a permission-hide="senders--manual-revoke" href="" ng-really-click="vm.revoke(sender.id)" ng-really-message="Are you sure you want to revoke sender {{sender.name}}?" ng-class="{\'disabled\': vm.revokePressed}" uib-tooltip="revoke"><i class="fa fa-eye-slash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/cast/senders/sendersManualAssignment.html','<form name="sendersForm" novalidate="" ng-submit="vm.assign(sendersForm)"><div class="modal-content"><div class="modal-header"><h5 class="modal-title"><i class="fa fa-bookmark fa-lg"></i> {{\'SENDERS.MANUALASSIGN\' | translate}}</h5></div><div class="modal-body"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(sendersForm, sendersForm.ip_address)}"><label for="ip_address_label">{{\'SENDERS.IP_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="ip_address" name="ip_address" placeholder="Ip Address" ng-model="vm.assignmentData.ip_address" ip-address-format="" required=""><div ng-messages="sendersForm.ip_address.$error || sendersForm.ip_address.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="ipAddress">{{\'VALIDATIONS.IP_ADDRESS\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(sendersForm, sendersForm.platform)}"><label for="name">{{\'SENDERS.PLATFORM\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.assignmentData.platform" name="platform" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false" required=""><ui-select-match placeholder="Select Platform"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="platform in vm.platforms | filter: $select.search"><span ng-bind-html="platform"></span></ui-select-choices></ui-select><div ng-messages="sendersForm.platform.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(sendersForm, sendersForm.area_name)}"><label for="area_name_label">{{\'SENDERS.AREA_NAME\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.assignmentData.area_name" name="area_name" id="area_name" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false" required=""><ui-select-match placeholder="Select Area"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="area in vm.areas track by area| filter: $select.search"><span ng-bind-html="area"></span></ui-select-choices></ui-select><div ng-messages="sendersForm.area_name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div><div class="modal-footer"><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="false" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.ASSIGN\' | translate}}</button></div></div></div></form>');
$templateCache.put('app/modules/directives/basicFileInput/basicFileInput.html','<div class="form-group" ng-class="{ \'has-error\': idform.$invalid }"><label for="{{fileId}}">{{label}}</label> <input class="form-control input-file" type="file" style="{{widthInput}}" id="{{fileId}}" name="{{fileId}}" accept="{{accept}}" ng-model="$parent.model" ng-disabled="{{disabled}}" onchange="angular.element(this).scope().add(this)"><div class="help-block"><span ng-show="idform.$error.wrongExtension">{{\'VALIDATIONS.ALLOWED_FILE_EXTENSIONS\' | translate}} {{extensions}}</span><ng-transclude></ng-transclude></div><div ng-if="maxFile" style="margin-top: -10px"><i class="fa fa-info"></i> <label style="color: gray; margin-left: 5px;margin-top: 2px">{{\'VALIDATIONS.MAX_SIZE\' | translate}} {{maxFile}}</label></div></div>');
$templateCache.put('app/modules/directives/signalStrengthOverview/signalStrengthOverviewDashboard.html','<div ba-panel="" ba-panel-class="col-eq-height" ba-panel-title="Signal Strength Overview"><div ng-repeat="signal in signals"><div class="col-md-12"><div class="col-md-4"><div class="col-md-12"><small>{{signal.range}}</small></div><div class="col-md-12" style="background: {{signal.background}}; color: {{signal.color}};">{{::signal.quantity}}</div></div><div class="col-md-8"><small>{{::signal.description}}</small></div></div></div><div class="col-md-12"><div class="col-md-6"><small>Wired</small></div><div class="col-md-6"><small>Offline / No Reading</small></div><div class="col-md-6" style="background: #626262; color: #fff;">0</div><div class="col-md-6" style="background: #000; color: #fff;">0</div></div></div>');
$templateCache.put('app/modules/directives/sncStatus/sncStatusDashboard.html','<div ba-panel="" ba-panel-title="SNC Status Dashboard"><div class="col-md-12" style="padding: 30px"><div ng-repeat="status in status"><figure class="color-box {{ ::status.color }}" style="width: 100%;"><h5 style="text-align: center;">{{ ::status.name }}</h5></figure></div></div><div ng-repeat="state in posibleStatus"><div class="col-md-6"><div class="color-box {{ ::state.color }}"></div>{{ ::state.description }}</div></div></div>');
$templateCache.put('app/modules/directives/uploadImage/uploadImage.html','<div class="form-group row"><label class="col-sm-3">{{label}} <span style="color: #209e91" ng-if="required">*</span></label><div ng-class="inLine ? \'col-sm-3\' : \'col-sm-9\'"><div class="userpic" ng-style="{\'margin-bottom\': inLine ? \'10px\' : \'40px\'}"><a ng-if="hasDeletePermission && !readOnly" href="" ng-show="!isNoImage" ng-click="resetImage()"><i class="fa fa-trash-o"></i></a><div class="userpic-wrapper"><img ng-src="{{imageBase64}}" onerror="this.src=\'/assets/img/theme/no-image.png\';" ng-click="clickOpenFile()"></div><a ng-if="hasUploadPermission && !readOnly" href="" class="change-userpic" ng-click="clickOpenFile()">{{hoverText}}</a> <input ng-required="required" ng-model="model" onchange="angular.element(this).scope().setFile(this)" type="file" ng-show="false" id="{{imageId}}" name="{{imageId}}" accept="{{accept}}" readonly=""><div ng-if="!inLine"><div style="margin-top: 4px"><label style="color: gray; margin-left: 5px;margin-top: 2px">{{\'IMAGE.IMAGE_FORMAT_ACCEPTED\' | translate: "{ availableImageTypes: \'"+availableImageTypes+"\' }"}}</label></div><div ng-if="isTheImageLarge"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'IMAGE.THE_IMAGE_IS_BIG\' | translate: \'{ maxAllowedSize: \'+maxAllowedSize+\' }\'}}</label></div></div></div></div><div class="col-sm-6" ng-if="inLine"><div><label style="color: gray; margin-left: 5px;margin-top: 2px">{{\'IMAGE.IMAGE_FORMAT_ACCEPTED\' | translate: "{ availableImageTypes: \'"+availableImageTypes+"\' }"}}</label></div><div ng-if="isTheImageLarge"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'IMAGE.THE_IMAGE_IS_BIG\' | translate: \'{ maxAllowedSize: \'+maxAllowedSize+\' }\'}}</label></div></div></div>');
$templateCache.put('app/modules/iptv/experiences/experiences.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button class="btn btn-primary pull-right" ui-sref="iptv.experiences-add"><i class="fa fa-th-large fa-6"></i> {{\'EXPERIENCES.ADD\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="experience in $data"><td title="\'EXPERIENCES.NAME\' | translate" ng-attr-title="">{{experience.name}}</td><td title="\'EXPERIENCES.MEDIA_TYPE\' | translate" ng-attr-title="" align="center">{{experience.media_type}}</td><td title="\'EXPERIENCES.FROM\' | translate" ng-attr-title="" align="center">{{experience.from}}</td><td title="\'EXPERIENCES.TO\' | translate" ng-attr-title="" align="center">{{experience.to}}</td><td title="\'EXPERIENCES.AREA\' | translate" ng-attr-title="" align="center"><span ng-show="experience.all_areas">{{\'EXPERIENCES.ALL_AREAS\' | translate}}</span> <span ng-show="!experience.all_areas">{{experience.area_name}}</span></td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a ui-sref="iptv.experiences-edit({ id : experience.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a href="" ng-really-click="vm.deleteRow(experience.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/experiences/experiencesAddEdit.html','<div class="widgets"><div class="row"><div class="col-12"><div ba-panel="" ba-panel-class="panel-experiences-editor"><ba-wizard><ba-wizard-step title="Experience" form="vm.experienceForm" submit-function="vm.save(vm.experienceForm,vm.experience)"><div class="row"><div class="col-md-6"><form name="vm.experienceForm" novalidate=""><div class="form-group"><label for="name">{{\'EXPERIENCES.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" placeholder="Experience name" class="form-control" id="name" name="name" ng-model="vm.experience.name" ng-required="true"></div><div class="form-group"><label for="name">{{\'EXPERIENCES.MEDIA_TYPE\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.experience.media_type" name="type" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-required="true"><ui-select-match placeholder="Media type"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="mediaType.code as mediaType in vm.mediaTypes"><div ng-bind="mediaType.name"></div></ui-select-choices></ui-select></div><div class="form-group"><div ng-if="vm.experience.media_type == \'image\'"><label for="slide_delay">{{\'EXPERIENCES.SLIDE_DELAY\' | translate}} <span style="color:#209e91">*</span></label> <input type="number" min="{{ vm.experience.auto_play ? 1 : 0}}" placeholder="Slide delay" class="form-control" id="slide_delay" name="slide_delay" ng-model="vm.experience.slide_delay" ng-required="true" ng-disabled="!vm.experience.auto_play"></div></div><div class="form-group row"><label class="col-sm-4 control-label">{{\'EXPERIENCES.ON_START_APP\' | translate}}</label> <label style="margin-left: 26px"><ba-switcher switcher-style="primary" switcher-value="vm.experience.on_start_app" switcher-on="Yes" switcher-off="No" class="col-sm-8"></ba-switcher></label></div><div class="form-group row" ng-if="vm.experience.media_type == \'image\'"><label class="col-sm-4 control-label">{{\'EXPERIENCES.AUTO_PLAY\' | translate}}</label> <label style="margin-left: 26px"><ba-switcher switcher-style="primary" switcher-value="vm.experience.auto_play" switcher-on="Yes" switcher-off="No" ng-click="vm.setSlideDelay(vm.experience.auto_play)" class="col-sm-8"></ba-switcher></label></div><div class="form-group" ng-controller="datepickerpopupCtrl"><label for="from">{{\'EXPERIENCES.FROM\' | translate}} <span style="color:#209e91">*</span></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{\'yyyy-MM-dd\'}}" datepicker-options="{maxDate: vm.to_date}" is-open="vm.from_date_open" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" id="from" name="from" placeholder="From" ng-model="vm.from_date" required="" readonly="" ng-click="vm.openPicker($event,\'from_date_open\')"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'from_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="form-group" ng-controller="datepickerpopupCtrl"><label for="to">{{\'EXPERIENCES.TO\' | translate}}<span style="color:#209e91">*</span></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{\'yyyy-MM-dd\'}}" datepicker-options="{minDate: vm.from_date}" is-open="vm.to_date_open" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false" id="to" name="to" placeholder="To" ng-model="vm.to_date" required="" readonly="" ng-click="vm.openPicker($event,\'to_date_open\')"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'to_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="form-group row"><label class="col-sm-4 control-label">{{\'EXPERIENCES.ALL_AREAS\' | translate}}</label> <label style="margin-left: 26px"><ba-switcher switcher-style="primary" switcher-value="vm.experience.all_areas" switcher-on="Yes" switcher-off="No" class="col-sm-8"></ba-switcher></label></div><div ng-if="!vm.experience.all_areas"><div class="form-group"><label for="name">{{\'EXPERIENCES.AREAS\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.areaSelected" name="all_areas" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-change="vm.addArea()"><ui-select-match placeholder="Select Area"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in vm.availableAreas | filter: $select.search"><span ng-bind-html="area.name | highlight: $select.search"></span></ui-select-choices><ui-select-no-choice><span style="color: #777; padding-left: 20px;">No results</span></ui-select-no-choice></ui-select></div><div ng-if="!vm.experience.all_areas && vm.experience.areas.length > 0"><table ng-table="vm.areasTable" style="margin-bottom:10px;" class="table table-striped"><tr ng-repeat="area in $data"><td data-title="\'Areas\'">{{area.name}}</td><td><a href="" ng-click="vm.deleteAreaSelected(area)" uib-tooltip="\'delete\'"><i class="fa fa-times"></i></a></td></tr></table></div></div></form></div><div class="col-md-6"><ng-include src="\'app/modules/iptv/experiences/preview/experiencesPreview.html\'"></ng-include></div></div></ba-wizard-step><ba-wizard-step title="{{\'Languages\' | translate}}" form="vm.experienceDescriptionForm" submit-function="vm.updateDescriptions(vm.experienceDescriptionForm, vm.descriptions)"><div class="row"><div class="col-md-6"><form name="vm.experienceDescriptionForm" novalidate=""><uib-tabset active="vm.active"><uib-tab index="language" data-ng-repeat="language in vm.languages"><uib-tab-heading>{{language.name}}</uib-tab-heading><div class="form-group" ng-repeat="type in vm.experienceDescriptionTypes"><label for="main_header_type">{{\'EXPERIENCES.\' + type.toUpperCase() | translate}}</label><div class="input-group"><input type="text" class="form-control" ng-model="vm.descriptions[type].languageData[language.code].description" id="main_header_type" name="main_header_type" placeholder="{{type}}"> <span class="input-group-btn"><button type="button" class="btn btn-default" uib-popover-template="\'app/modules/iptv/experiences/templates/popover.html\'" popover-placement="left" popover-animation="false" popover-trigger="click" popover-class="popover-experiences-editor" ng-click="vm.togglePopover(type)" popover-enable="vm.enablePopover(type)" popover-is-open="vm.popover.type == type"><i class="glyphicon glyphicon-font"></i></button></span></div></div></uib-tab></uib-tabset></form></div><div class="col-md-6"><ng-include src="\'app/modules/iptv/experiences/preview/experiencesPreview.html\'" style="overflow-x:hidden;" mute=""></ng-include></div></div></ba-wizard-step><ba-wizard-step title="{{\'Media\' | translate}}" form="vm.experienceVideoForm" submit-function="vm.cancel()"><form name="vm.experienceVideoForm" novalidate="" editable-form=""><div class="row"><div class="col-md-6" ng-if="vm.experience.media_type == \'video\'"><div class="row form-group"><div class="col-md-3"><label for="video">{{\'EXPERIENCES.VIDEO\' | translate}}</label></div><div class="col-md-6"><input ng-model="vm.experience.video" onchange="angular.element(this).scope().uploadExperienceVideo(this)" type="file" id="video" name="video" accept=".mp4"></div></div></div><div class="col-md-6" ng-if="vm.experience.media_type == \'image\'"><upload-image image-id="image_base64" model="vm.image_base64" resolutions="vm.resolutions" url="experience-images" id-model="vm.experience.id" max-allowed-size="0.4" with-message="true" on-uploaded-fn="vm.onImageUploaded" clear-when-finish-upload="true" ng-accept="image/jpeg"></upload-image><div class="row"><div class="col-sm-12"><div ng-if="vm.experience.images.length > 0"><table ng-table="vm.imagesTable" style="margin-bottom:10px;" class="table table-striped"><tr ng-repeat="row in $data"><td data-title="\'Images\'"><img ng-src="{{row.image_url}}" width="86" height="55"></td><td style="max-width: 150px;"><a href="" ng-click="vm.deleteImageSelected(row)" uib-tooltip="\'delete\'"><i class="fa fa-times"></i></a></td></tr></table></div></div></div><hr><div class="row form-group"><div class="col-md-3"><label>{{\'EXPERIENCES.AUDIO\' | translate}}</label></div><div class="col-md-6"><input ng-model="vm.experience.audio" onchange="angular.element(this).scope().uploadExperienceAudio(this)" type="file" id="audio" name="audio" accept=".mp3"><br><div ng-if="vm.experience.audio"><audio autoplay="" loop="" controls="" ng-src="{{vm.current_audio}}" id="audioPlayer"></audio><button type="button" class="btn btn-default" ng-click="vm.deleteAudio()" uib-tooltip="\'delete\'" style="position: absolute; top: 50%; margin-left: 30px"><i class="fa fa-times"></i></button></div></div></div></div><div class="col-md-6"><ng-include src="\'app/modules/iptv/experiences/preview/experiencesPreview.html\'" mute=""></ng-include></div></div></form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/modules/iptv/tlx/tlx.html','<div class="row"><form name="tlxForm" novalidate="" ng-submit="vm.addTlx(tlxForm)"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><div class="col-md-12"><div class="form-group has-feedback"><label for="name">Tlx <span style="color:#209e91">*</span></label> <input required="" ng-model="vm.tlx" onchange="angular.element(this).scope().setFile(this)" type="file" id="tlx" name="tlx" accept=".tlx"></div><div class="form-group has-feedback"><label for="name">Tv model <span style="color:#209e91">*</span></label><ui-select ng-model="vm.tvModelSelected" name="area_name" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-change="vm.addTvModel()"><ui-select-match placeholder="Select Property"><span>{{$select.selected.model}}</span></ui-select-match><ui-select-choices repeat="tvModel in vm.tvModels | filter: $select.search"><span ng-bind-html="tvModel.model"></span></ui-select-choices></ui-select></div><div ng-if="vm.data.tvModels.length > 0"><div class="row"><div class="col-md-10 col-md-offset-1"><table ng-table="vm.table" style="margin-bottom:10px;" class="table table-striped"><tr ng-repeat="row in $data"><td data-title="\'Tv Models\'">{{row.model}}</td><td><a href="" ng-click="vm.deleteTvModelSelected(row)" uib-tooltip="\'delete\'"><i class="fa fa-times"></i></a></td></tr></table></div></div></div></div><div class="form-group col-md-12" style="margin-top: 15px"><button permission-hide="tlx--add-tlx" type="submit" ng-disabled="tlxForm.$invalid || vm.data.tvModels.length == 0" style="margin-right:10px;" class="btn btn-primary pull-right">Add Tlx</button></div></div></form></div>');
$templateCache.put('app/modules/iptv/tvApplicationVersions/tvApplicationVersionAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="tvApplicationVersionForm" novalidate="" ng-submit="vm.save(tvApplicationVersionForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(tvApplicationVersionForm, tvApplicationVersionForm.version,\'version\')}"><label for="version">{{\'TV_APPLICATION_VERSIONS.VERSION\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'version\')" class="form-control" id="version" name="version" placeholder="Version" ng-model="vm.data.version" required=""><div ng-messages="tvApplicationVersionForm.version.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'version\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'version\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(tvApplicationVersionForm, tvApplicationVersionForm.filename,\'filename\')}" ng-show="!vm.application.preload"><label>{{\'TV_APPLICATION_VERSIONS.FILENAME\' | translate}} <span style="color:#209e91" ng-show="!vm.isEdition">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'filename\')" class="form-control" id="filename" name="filename" placeholder="Filename" ng-model="vm.data.filename" ng-required="!vm.application.preload && !vm.isEdition" disabled=""> <input ng-click="vm.clearQueue()" class="btn" type="file" nv-file-select="" uploader="vm.uploader" accept=".ipk"><div ng-messages="tvApplicationVersionForm.filename.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'filename\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'filename\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(tvApplicationVersionForm, tvApplicationVersionForm.models,\'tv_application_version_models\')}"><label for="tv_application_version_models">{{\'TV_APPLICATION_VERSIONS.TVMODELS\' | translate}} <span style="color:#209e91">*</span></label><tags-input id="tvAppVersionModels" ng-model="vm.data.tv_application_version_models" add-from-autocomplete-only="true" tag-class="{trinomio_tag: true, trinomio_label: true, trinomio_label_primary: true}" placeholder="{{\'TV_APPLICATION_VERSIONS.ADD_TV_MODELS\' | translate}}" ng-invalid="false" required=""><auto-complete id="tvAppVersionModelsList" source="vm.loadTags($query)" min-length="1" max-results-to-show="{{vm.lengthTvModels()}}" load-on-empty="true" load-on-focus="true"></auto-complete></tags-input><div ng-messages="tvApplicationVersionForm.tv_application_version_models.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'tv_application_version_models\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'tv_application_version_models\')}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="(!vm.application.preload && vm.successFileUpload != undefined && !vm.successFileUpload) || tvApplicationVersionForm.$invalid" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/iptv/tvApplicationVersions/tvApplicationVersions.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="tv-application-version--store" class="btn btn-primary pull-right" ui-sref="iptv.tv-application-version-new({ application_id : vm.application_data.application_id, name: vm.application_data.name})"><i class="fa fa-file fa-6"></i> {{\'TV_APPLICATION_VERSIONS.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="tvApplicationVersion in $data"><td title="\'TV_APPLICATION_VERSIONS.VERSION\' | translate" ng-attr-title="" sortable="\'version\'" align="center">{{tvApplicationVersion.version}}</td><td ng-if="!vm.application.preload" title="\'TV_APPLICATION_VERSIONS.FILENAME\' | translate" ng-attr-title="" sortable="\'filename\'" align="center">{{tvApplicationVersion.filename}}</td><td title="\'TV_APPLICATION_VERSIONS.TVMODELS\' | translate" ng-attr-title="" align="center" sortable="\'tv_models\'">{{vm.showModels(tvApplicationVersion)}}</td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="tv-application-version--update" ui-sref="iptv.tv-application-version-edit({ application_id : vm.application_data.application_id, name: vm.application_data.name, id : tvApplicationVersion.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="tv-application-version--destroy" href="" ng-really-click="vm.deleteRow(tvApplicationVersion.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/tvApplications/tvApplications.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="tv-applications--store" class="btn btn-primary pull-right" ui-sref="iptv.tv-applications-new"><i class="fa fa-television fa-6"></i> {{\'TV_APPLICATIONS.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="tvApplication in $data"><td title="\'TV_APPLICATIONS.IMAGE\' | translate" ng-attr-title="" align="center"><img ng-src="{{tvApplication.imagePath}}" width="35" height="35"></td><td title="\'TV_APPLICATIONS.NAME\' | translate" ng-attr-title="" sortable="\'name\'" align="center">{{tvApplication.name}}</td><td title="\'TV_APPLICATIONS.APP_ID\' | translate" ng-attr-title="" align="center" sortable="\'app_id\'">{{tvApplication.app_id}}</td><td title="\'TV_APPLICATIONS.BRAND\' | translate" ng-attr-title="" align="center" sortable="\'brand\'">{{tvApplication.brand}}</td><td title="\'TV_APPLICATIONS.VERSIONS\' | translate" ng-attr-title="" align="center"><a permission-hide="tv-application-version--index" ui-sref="iptv.tv-application-version-list({ application_id : tvApplication.id, name: tvApplication.name})"><i class="fa fa-folder-open"></i></a></td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="tv-applications--update" ui-sref="iptv.tv-applications-edit({ id : tvApplication.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="tv-applications--destroy" href="" ng-really-click="vm.deleteRow(tvApplication.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/tvApplications/tvApplicationsAddEdit.html','<div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Tv Application" form="vm.tvApplicationForm" submit-function="vm.saveApp()"><form name="vm.tvApplicationForm" novalidate=""><div class="row" style="margin:15px"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(vm.tvApplicationForm, vm.tvApplicationForm.name,\'name\')}"><label for="name">{{\'TV_APPLICATIONS.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'name\')" class="form-control" id="name" name="name" placeholder="Name" ng-model="vm.data.name" required=""><div><label style="color: darkgray; margin-left: 20px">The model will be saved in upper case and whitespaces will be replaced by underscores</label></div><div ng-messages="vm.tvApplicationForm.model.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'name\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'name\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(vm.tvApplicationForm, vm.tvApplicationForm.app_id)}"><label for="app_id">{{\'TV_APPLICATIONS.APP_ID\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="app_id" name="app_id" placeholder="App ID" ng-model="vm.data.app_id" required=""><div ng-messages="vm.tvApplicationForm.app_id.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(vm.tvApplicationForm, vm.tvApplicationForm.brand)}"><label for="brand">{{\'TV_MODELS.BRAND\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><ui-select ng-model="vm.data.brand" name="brand" id="brand" search-enabled="false" required=""><ui-select-match placeholder="Select Brand"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="brand in vm.brands | filter: $select.search"><span ng-bind-html="brand"></span></ui-select-choices></ui-select></div><div ng-messages="vm.tvApplicationForm.brand.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">{{\'TV_APPLICATIONS.APP_IMAGE\' | translate}} <span style="color:#209e91" ng-show="!vm.data.id">*</span></label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ vm.getTvApplicationImage() }}" ng-click="vm.clickOpenFile()"></div><a href="" class="change-userpic" ng-click="vm.clickOpenFile()">{{\'TV_APPLICATIONS.CHANGE_APP_IMAGE\' | translate}}</a> <input ng-required="!vm.data.id" ng-model="vm.tvApplicationImage" onchange="angular.element(this).scope().setFile(this)" type="file" ng-show="false" id="image" name="image" accept=".png"><div style="margin-top: 4px"><label style="color: gray; margin-left: 5px;margin-top: 2px">{{\'TV_APPLICATIONS.IMAGE_FORMAT_ACCEPTED\' | translate:\'{ availableImageTypes: \'+vm.availableImageTypes+\'}\'}}</label></div></div></div></div><div class="form-group row"><label class="col-sm-4 control-label">{{\'TV_APPLICATIONS.PRELOAD\' | translate}}</label> <label style="margin-left: 26px"><ba-switcher switcher-style="primary" switcher-value="vm.data.preload" switcher-on="Yes" switcher-off="No" permission="tv-applications--update" class="col-sm-8"></ba-switcher></label></div></div></form></ba-wizard-step><ba-wizard-step title="Languages" form="vm.tvApplicationLanguageForm" submit-function="vm.updateLanguage()"><form name="vm.tvApplicationLanguageForm" novalidate=""><div><label>Translation</label><uib-tabset active="vm.active"><uib-tab index="language" data-ng-repeat="language in vm.languages"><uib-tab-heading>{{language.name}}</uib-tab-heading><div class="row" style="margin-top: 10px;margin-bottom:10px"><div class="col-md-12" style="margin-top: 6px;"><label>Description</label> <span style="color:#209e91">*</span></div></div><div class="row" style="margin-top: 10px;margin-bottom:10px"><div class="form-group has-feedback col-md-12" ng-class="{\'has-error\': vm.basicValidation(vm.tvApplicationLanguageForm, vm.tvApplicationLanguageForm[\'tv_application_language_description_\'+language.code])}"><div ckeditor="vm.options" ng-model="vm.languageList[$index].description" ready="onReady()" id="tv_application_language_description_{{language.code}}" name="tv_application_language_description_{{language.code}}" ng-disabled="vm.tvApplicationNotCreate() || vm.tvApplicationLanguageForm.$invalid"></div><div ng-messages="vm.tvApplicationLanguageForm[\'tv_application_language_description_\'+language.code].$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div></uib-tab></uib-tabset></div></form></ba-wizard-step></ba-wizard></div></div></div>');
$templateCache.put('app/modules/iptv/tvApplicationsProperty/addTvApplicationVersion.html','<div class="modal-content"><form name="tvAppVersionForm" novalidate="" ng-submit="vm.save(tvAppVersionForm, vm.data)"><div class="modal-header"><h5 class="modal-title"><i class="fa fa-folder-open"></i> {{\'TV_APPLICATIONS_PROPERTY.ADD_TV_APP_VERSION\' | translate}}</h5></div><div class="modal-body img-container"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(tvAppVersionForm, tvAppVersionForm.version,\'version\')}"><label for="version">{{\'TV_APPLICATION_VERSIONS.VERSION\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'version\')" class="form-control" id="version" name="version" placeholder="Version" ng-model="vm.data.version" required=""><div ng-messages="tvAppVersionForm.version.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'version\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'version\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(tvAppVersionForm, tvAppVersionForm.filename,\'filename\')}"><label>{{\'TV_APPLICATION_VERSIONS.FILENAME\' | translate}}</label> <input type="text" ng-change="vm.cleanSvError(\'filename\')" class="form-control" id="filename" name="filename" placeholder="Filename" ng-model="vm.data.filename" disabled=""> <input ng-click="vm.clearQueue()" class="btn" type="file" nv-file-select="" uploader="vm.uploader" accept=".ipk"><div ng-messages="tvAppVersionForm.filename.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'filename\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'filename\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(tvAppVersionForm, tvAppVersionForm.models,\'tv_application_version_models\')}" required=""><label for="tv_application_version_models">{{\'TV_APPLICATION_VERSIONS.TVMODELS\' | translate}} <span style="color:#209e91">*</span></label><tags-input id="tvAppVersionModels" ng-model="vm.data.tv_application_version_models" add-from-autocomplete-only="true" tag-class="{trinomio_tag: true, trinomio_label: true, trinomio_label_primary: true}" required=""><auto-complete id="tvAppVersionModelsList" source="vm.loadTags($query)" min-length="1" max-results-to-show="{{vm.lengthTvModels()}}" load-on-empty="true" load-on-focus="true"></auto-complete></tags-input><div ng-messages="tvAppVersionForm.tv_application_version_models.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'tv_application_version_models\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'tv_application_version_models\')}}</span></div></div><div class="modal-footer"><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancelModal()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button permission-hide="tv-application-version--store" type="submit" ng-disabled="(vm.successFileUpload != undefined && !vm.successFileUpload) || tvAppVersionForm.$invalid" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></div></div></form></div>');
$templateCache.put('app/modules/iptv/tvApplicationsProperty/tvApplicationsProperty.html','<div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll"><table ng-table="vm.tableDisabledApps" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="tvApplication in $data"><td title="\'TV_APPLICATIONS_PROPERTY.IMAGE\' | translate" ng-attr-title="" align="center"><img ng-src="{{vm.generatedPathTvApplicationPropertyImage(tvApplication.image)}}" width="35" height="35"></td><td title="\'TV_APPLICATIONS_PROPERTY.NAME\' | translate" ng-attr-title="" sortable="\'name\'" align="center">{{tvApplication.name}}</td><td title="\'TV_APPLICATIONS_PROPERTY.BRAND\' | translate" ng-attr-title="" align="center" sortable="\'brand\'">{{tvApplication.brand}}</td><td class="row-switcher-custom" title="\'TV_APPLICATIONS_PROPERTY.DISABLED\' | translate" ng-attr-title="" align="center"><button class="btn btn-primary" ng-click="vm.createOrDestroy(tvApplication, $index)">+</button></td></tr></table></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="ENABLED" ba-panel-class="with-scroll"><table ng-table="vm.tableEnabledApps" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="tvApplication in $data"><td title="\'TV_APPLICATIONS_PROPERTY.IMAGE\' | translate" ng-attr-title="" align="center"><img ng-src="{{vm.generatedPathTvApplicationPropertyImage(tvApplication.image)}}" width="35" height="35"></td><td title="\'TV_APPLICATIONS_PROPERTY.NAME\' | translate" ng-attr-title="" sortable="\'name\'" align="center">{{tvApplication.name}}</td><td title="\'TV_APPLICATIONS_PROPERTY.BRAND\' | translate" ng-attr-title="" align="center" sortable="\'brand\'">{{tvApplication.brand}}</td><td class="row-switcher-custom" title="\'TV_APPLICATIONS_PROPERTY.ENABLED\' | translate" ng-attr-title="" align="center"><label class="label-switcher-custom" align="center"><ba-switcher switcher-style="primary" switcher-value="tvApplication.enabled" switcher-click="vm.createOrDestroy(tvApplication)" switcher-on="Yes" switcher-off="No" permission="tv-applications-properties--update" class="col-sm-8"></ba-switcher></label></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/tvModels/addTlx.html','<div class="modal-content"><form name="tlxForm" novalidate="" ng-submit="vm.save(tlxForm)"><div class="modal-header"><h5 class="modal-title"><i class="fa fa-th-large"></i> {{\'TV_MODELS.ADD_TLX\' | translate}}</h5></div><div class="modal-body img-container"><input required="" ng-model="vm.tlx" onchange="angular.element(this).scope().setFile(this)" type="file" id="tlx" name="tlx" accept=".tlx"></div><div class="modal-footer"><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="tlxForm.$invalid" class="btn btn-primary pull-right">{{\'TV_MODELS.ADD_TLX\' | translate}}</button></div></div></form></div>');
$templateCache.put('app/modules/iptv/tvModels/tvModels.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button class="btn btn-primary pull-right" ui-sref="iptv.tv-models-new"><i class="fa fa-television fa-6"></i> {{\'TV_MODELS.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="tvModel in $data"><td title="\'TV_MODELS.MODEL\' | translate" ng-attr-title="" sortable="\'model\'">{{tvModel.model}}</td><td title="\'TV_MODELS.BRAND\' | translate" ng-attr-title="" align="center" sortable="\'brand\'">{{tvModel.brand}}</td><td title="\'TV_MODELS.RESOLUTION\' | translate" ng-attr-title="" align="center" sortable="\'resolution\'">{{tvModel.resolution}}</td><td title="\'TABLES.CHANNELS\' | translate" ng-attr-title="" align="center"><a href="" ng-click="vm.openModal(tvModel.model)"><i class="fa fa-th-large"></i></a></td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a ui-sref="iptv.tv-models-edit({ id : tvModel.model})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a href="" ng-really-click="vm.deleteRow(tvModel.model)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/tvModels/tvModelsAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="tvModelForm" novalidate="" ng-submit="vm.save(tvModelForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(tvModelForm, tvModelForm.model,\'model\')}"><label for="model">{{\'TV_MODELS.MODEL\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'model\')" class="form-control" id="model" name="model" placeholder="Model" ng-model="vm.data.model" required=""><div><label style="color: darkgray; margin-left: 20px">The model will be saved in upper case and whitespaces will be replaced by underscores</label></div><div ng-messages="tvModelForm.model.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'model\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'model\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(tvModelForm, tvModelForm.brand)}"><label for="brand">{{\'TV_MODELS.BRAND\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><ui-select ng-model="vm.data.brand" name="brand" class="col-md-12" style="padding-left: 0px" search-enabled="false" required=""><ui-select-match placeholder="Select Brand"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="brand in vm.brands | filter: $select.search"><span ng-bind-html="brand"></span></ui-select-choices></ui-select></div><div ng-messages="tvModelForm.brand.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(tvModelForm, tvModelForm.resolution)}"><label for="resolution">{{\'TV_MODELS.RESOLUTION\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><ui-select ng-model="vm.data.resolution" name="resolution" class="col-md-12" style="padding-left: 0px" search-enabled="false" required=""><ui-select-match placeholder="Select Resolution"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="resolution in vm.resolutions | filter: $select.search"><span ng-bind-html="resolution"></span></ui-select-choices></ui-select></div><div ng-messages="tvModelForm.resolution.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="tvModelForm.$invalid" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/iptv/tvs/tvs.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="tvs--store" class="btn btn-primary pull-right" ui-sref="iptv.tvs-new"><i class="fa fa-television fa-6"></i> {{\'TVS.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="tv in $data"><td title="\'TVS.AREA_NAME\' | translate" ng-attr-title="" align="center" sortable="\'area_name\'">{{tv.area_name}}</td><td title="\'TVS.TV_MODEL\' | translate" ng-attr-title="" align="center" sortable="\'tv_model\'">{{tv.tv_model}}</td><td title="\'TVS.SERIAL_NUMBER\' | translate" ng-attr-title="" align="center" sortable="\'serial_number\'">{{tv.serial_number}}</td><td title="\'TVS.IP_ADDRESS\' | translate" ng-attr-title="" align="center" sortable="\'ip_address\'">{{tv.ip_address}}</td><td title="\'TVS.MAC_ADDRESS\' | translate" ng-attr-title="" align="center" sortable="\'mac_address\'">{{tv.mac_address}}</td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="tvs--update" ui-sref="iptv.tvs-edit({ id : tv.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="tvs--destroy" href="" ng-really-click="vm.deleteRow(tv.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/tvs/tvsAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="tvsForm" novalidate="" ng-submit="vm.save(tvsForm,vm.data)"><div class="form-group has-feedback"><label for="name">{{\'TVS.AREA_NAME\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><ui-select ng-model="vm.data.area_name" name="area_name" class="col-md-9" ui-select-free-text="" value-prop="name" style="padding-left: 0px" ng-disabled="false" search-enabled="true" required=""><ui-select-match placeholder="Select Area"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="area in vm.areas | filter: $select.search"><span ng-bind-html="area.name"></span></ui-select-choices></ui-select><button type="button" ng-disabled="vm.shouldCreateAreaButton()" class="btn btn-primary pull-right" style="border-top-left-radius:5px;border-bottom-left-radius:5px;" ng-click="vm.createArea()">{{\'TVS.CREATE_AREA\' | translate}}</button></div><div ng-messages="tvsForm.area_name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-if="vm.data.area_name.isFreeText"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'RECEIVERS.AREA_NOT_EXIST\' | translate}}</label></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(tvsForm, tvsForm.tv_model,\'tv_model\')}"><label for="tv_model">{{\'TVS.TV_MODEL\' | translate}} <span style="color:#209e91">*</span></label><div class="form-control btn-group bootstrap-select row"><ui-select ng-model="vm.data.tv_model" name="tv_model" class="col-md-14" value-prop="name" style="padding-left: 0px" required=""><ui-select-match placeholder="Select Tv Model"><span>{{$select.selected.model}}</span></ui-select-match><ui-select-choices repeat="tv_model.model as tv_model in vm.tvModels | filter: $select.search"><span ng-bind-html="tv_model.model"></span></ui-select-choices></ui-select></div><div ng-messages="tvsForm.tv_model.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(tvsForm, tvsForm.ip_address, \'ip_address\')}"><label for="ip_address_label">{{\'TVS.IP_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" class="form-control" id="ip_address" name="ip_address" ng-change="vm.cleanSvError(\'ip_address\')" placeholder="Ip Address" ng-model="vm.data.ip_address" ip-address-format="" required=""><div ng-messages="tvsForm.ip_address.$error || tvsForm.ip_address.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="ipAddress">{{\'VALIDATIONS.IP_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'ip_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'ip_address\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(tvsForm, tvsForm.serial_number,\'serial_number\')}"><label for="serial_number">{{\'TVS.SERIAL_NUMBER\' | translate}}</label> <input type="text" class="form-control" id="serial_number" name="serial_number" ng-change="vm.cleanSvError(\'serial_number\')" placeholder="Serial Number" ng-model="vm.data.serial_number"></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(tvsForm, tvsForm.mac_address, \'mac_address\')}"><label for="ip_address_label">{{\'TVS.MAC_ADDRESS\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-pattern="/^([0-9A-Fa-f]{2}[:]){5}([0-9A-Fa-f]{2})$/" class="form-control" id="mac_address" name="mac_address" ng-change="vm.cleanSvError(\'mac_address\')" placeholder="Mac Address" ng-model="vm.data.mac_address" required=""><div ng-messages="tvsForm.mac_address.$error || tvsForm.mac_address.$invalid" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="pattern">{{\'VALIDATIONS.MAC_ADDRESS\' | translate}}</span></div><div ng-show="vm.haveServerError(\'mac_address\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'mac_address\')}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="tvsForm.$invalid||!vm.areaExist()" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/reports/general-use/general-use-reports.html','<form name="filtersForm" novalidate=""><div class="row" style="margin-left: 5px; margin-bottom: 15px"><div class="col-md-2 form-group"><div class="input-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.start_date)}"><input type="text" class="form-control" uib-datepicker-popup="{{vm.dateFormat}}" datepicker-options="vm.datepickerOptions" ng-model="vm.start_date" id="start_date" name="start_date" is-open="vm.start_date_open" close-text="Close" ng-required="true" placeholder="Start Date Filter" alt-input-formats="altInputFormats" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'start_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span><div ng-messages="filtersForm.start_date.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div><div class="col-md-2 form-group"><div class="input-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.end_date)}"><input type="text" class="form-control" popup-placement="bottom" uib-datepicker-popup="{{vm.dateFormat}}" datepicker-options="vm.datepickerOptions" ng-model="vm.end_date" id="end_date" name="end_date" is-open="vm.end_date_open" close-text="Close" ng-required="true" placeholder="End Date Filter" alt-input-formats="altInputFormats" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'end_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span><div ng-messages="filtersForm.end_date.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div><div class="col-md-5 form-group" ng-if="vm.activeTab==0"><nit-advanced-searchbox style="margin-top:0px;margin-bottom:0px" ng-if="vm.activeTab==0" ng-model="vm.search" parameters="vm.availableSearchParamsValidations"></nit-advanced-searchbox></div><div class="col-md-5 form-group" ng-if="vm.activeTab==1"><nit-advanced-searchbox style="margin-top:0px;margin-bottom:0px" ng-if="vm.activeTab==1" ng-model="vm.search" parameters="vm.availableSearchParamsStates"></nit-advanced-searchbox></div><div class="col-md-5 form-group" ng-if="vm.activeTab==2"><nit-advanced-searchbox style="margin-top:0px;margin-bottom:0px" ng-if="vm.activeTab==2" ng-model="vm.search" parameters="vm.availableSearchParamsSessions"></nit-advanced-searchbox></div><div class="pull-right"><button type="button" class="btn pull-right" style="margin-right: 20px; position: relative;" ng-click="vm.exportToPdf()"><i class="fa ion-android-download fa-6"></i> {{\'REPORT.EXPORTTOEXCEL\' | translate}}</button> <button type="button" class="btn btn-danger pull-right" style="margin-right: 10px; position: relative;" ng-click="vm.clear()"><i class="fa fa-times-circle fa-6" style="margin-right: 5px"></i>Clear</button> <button type="button" ng-click="vm.filter()" ng-disabled="filtersForm.$invalid || vm.disableForRecentAction()" class="btn btn-primary pull-right" style="margin-right: 10px;position: relative;"><i class="fa fa-sliders fa-6"></i> {{\'REPORT.FILTER\' | translate}}</button></div></div></form><div class="row"><div ba-panel=""><uib-tabset active="vm.activeTab"><uib-tab ng-repeat="tab in vm.tabs" heading="{{tab.title}}" active="tab.active" select="vm.tabSelected($index)" disable="vm.disableForRecentAction()"><div ui-view="{{tab.route}}"></div></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/modules/reports/infrastructure-monitor/infrastructure-monitor-reports.html','<div class="row"><form name="filtersForm" novalidate="" ng-submit="vm.filter()"><div class="form-group"><div class="form-inline"><div class="col-md-9"><div class="form-group col-md-4 has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.ssid)}"><input type="text" class="form-control" id="ssid" name="ssid" ng-model="vm.ssid" placeholder="SSID"><div ng-messages="filtersForm.ssid.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group col-md-2 has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.frec_band)}"><ui-select ng-model="vm.frec_band" name="frec_band" id="frec_band" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false"><ui-select-match placeholder="Frec"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="frec_band in vm.frecs track by frec_band| filter: $select.search"><span ng-bind-html="frec_band"></span></ui-select-choices></ui-select><div ng-messages="filtersForm.frec_band.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="col-md-3 form-group"><div class="input-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.start_date)}"><input type="text" class="form-control" uib-datepicker-popup="{{vm.dateFormat}}" datepicker-options="vm.datepickerOptions" ng-model="vm.start_date" id="start_date" name="start_date" is-open="vm.start_date_open" close-text="Close" ng-required="true" placeholder="Start Date Filter" alt-input-formats="altInputFormats" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'start_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span><div ng-messages="filtersForm.start_date.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div><div class="col-md-3 form-group"><div class="input-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.end_date)}"><input type="text" class="form-control" popup-placement="bottom" uib-datepicker-popup="{{vm.dateFormat}}" datepicker-options="vm.datepickerOptions" ng-model="vm.end_date" id="end_date" name="end_date" is-open="vm.end_date_open" close-text="Close" ng-required="true" placeholder="End Date Filter" alt-input-formats="altInputFormats" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'end_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span><div ng-messages="filtersForm.end_date.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div></div><div class="col-md-3"><div class="pull-right"><button type="submit" ng-disabled="filtersForm.$invalid || vm.disableForRecentAction()" class="btn btn-primary"><i class="fa fa-sliders fa-6"></i> {{\'REPORT.FILTER\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-times-circle fa-6"></i>Clear</button></div></div></div></div></form></div><div class="row"><div ba-panel=""><highchart id="infrastructure-monitor-treemap-chart" config="vm.treemapConfig"></highchart></div></div>');
$templateCache.put('app/modules/reports/signal-strength/signal-strength-reports.html','<div class="row"><form name="filtersForm" novalidate="" ng-submit="vm.filter()"><div class="form-group"><div class="form-inline"><div class="col-md-9"><div class="form-group col-md-4 has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.ssid)}"><input type="text" class="form-control" id="ssid" name="ssid" ng-model="vm.ssid" placeholder="SSID"><div ng-messages="filtersForm.ssid.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="form-group col-md-2 has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.frec_band)}"><ui-select ng-model="vm.frec_band" name="frec_band" id="frec_band" class="btn-group bootstrap-select form-control" ng-disabled="false" search-enabled="false"><ui-select-match placeholder="Frec"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="frec_band in vm.frecs track by frec_band| filter: $select.search"><span ng-bind-html="frec_band"></span></ui-select-choices></ui-select><div ng-messages="filtersForm.frec_band.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div class="col-md-3 form-group"><div class="input-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.start_date)}"><input type="text" class="form-control" uib-datepicker-popup="{{vm.dateFormat}}" datepicker-options="vm.datepickerOptions" ng-model="vm.start_date" id="start_date" name="start_date" is-open="vm.start_date_open" close-text="Close" ng-required="true" placeholder="Start Date Filter" alt-input-formats="altInputFormats" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'start_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span><div ng-messages="filtersForm.start_date.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div><div class="col-md-3 form-group"><div class="input-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(filtersForm, filtersForm.end_date)}"><input type="text" class="form-control" popup-placement="bottom" uib-datepicker-popup="{{vm.dateFormat}}" datepicker-options="vm.datepickerOptions" ng-model="vm.end_date" id="end_date" name="end_date" is-open="vm.end_date_open" close-text="Close" ng-required="true" placeholder="End Date Filter" alt-input-formats="altInputFormats" show-button-bar="false" required=""> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openPicker($event,\'end_date_open\')"><i class="glyphicon glyphicon-calendar"></i></button></span><div ng-messages="filtersForm.end_date.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div></div><div class="col-md-3"><div class="pull-right"><button type="submit" ng-disabled="filtersForm.$invalid || vm.disableForRecentAction()" class="btn btn-primary"><i class="fa fa-sliders fa-6"></i> {{\'REPORT.FILTER\' | translate}}</button> <button type="button" class="btn btn-danger" ng-click="vm.clear()"><i class="fa fa-times-circle fa-6"></i>Clear</button></div></div></div></div></form></div><div class="row"><div ba-panel=""><div class="row six-cols"><div ng-repeat="dbm in vm.dBms_status" class="col-lg-1 col-md-3 col-sm-4 col-xs-6 gray-border" style="background-color: {{dbm.background_color}}; color: {{dbm.color}};"><div class="staff-name text-center" style="height: 40px"><div class="row"><div class="staff-first-name">{{dbm.name}}</div></div></div></div></div><highchart id="signal-strength-heatmap-chart" config="vm.heatmapConfig"></highchart></div></div>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-primary" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-primary" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-primary" ng-click="expand()">Expand All</button></div><div><button class="btn btn-primary" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardInfoAverage/dashboardInfoAverage.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in averageCharts"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i style="color:{{pieColor}}" class="chart-icon fa fa-{{ ::chart.icon }} fa-5x"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">136 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/dashboard/widgets/chart.html','<highchart id="chartContainer" config="chartConfig" ng-if="data!=undefined" style="height:100%;width:100%"></highchart><div class="row" ng-if="data==undefined"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div style="height: 90px; position: relative;"><div class="centered-element"><i class="fa fa-exclamation-triangle fa-3x" style="margin-bottom: 2px"></i><h4>{{\'ERRORS.GRAPH\' | translate}} {{ ::chartConfig.title.text }} {{\'ERRORS.TRY_AGAIN\' | translate}}</h4></div></div></div></div>');
$templateCache.put('app/pages/dashboard/widgets/usage.html','<div class="row pie-charts" ng-if="info.stats!=undefined"><div class="pie-chart-item-container" style="width: 100%"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div>{{ ::info.description }}</div><div class="description-stats">{{ ::info.stats }}</div></div><i style="color:{{pieColor}}" class="chart-icon fa fa-{{ ::info.icon }} fa-5x"></i></div></div></div></div><div class="row" ng-if="info.stats==undefined"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><div style="height: 90px; position: relative;"><div class="centered-element"><i class="fa fa-exclamation-triangle fa-3x" style="margin-bottom: 2px"></i><h4>{{\'ERRORS.GRAPH\' | translate}} {{ ::info.description }} {{\'ERRORS.TRY_AGAIN\' | translate}}</h4></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/maps/google-maps/google-maps.html','<div ba-panel="" ba-panel-title="Google Maps" class="viewport100"><div id="google-maps"></div></div>');
$templateCache.put('app/pages/maps/leaflet/leaflet.html','<div ba-panel="" ba-panel-title="Leaflet" class="viewport100"><div id="leaflet-map"></div></div>');
$templateCache.put('app/pages/maps/map-bubbles/map-bubbles.html','<div ba-panel="" ba-panel-title="Map with Bubbles" class="viewport100"><div id="map-bubbles"></div></div>');
$templateCache.put('app/pages/maps/map-lines/map-lines.html','<div ba-panel="" ba-panel-title="Line Map" class="viewport100"><div id="map-lines"></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="{\'selected\': isAnySection(item), \'disabled\': item.disabled }" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ng-click="changeState(item.stateRef,item.disabled,item.message)" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="{\'with-sub-menu\': subitem.subMenu, \'selected\': isAnySection(subitem), \'disabled\': subitem.disabled }" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ng-class="::{\'with-sub-menu\': subSubitem.subitem.subMenu, \'selected\': isAnySection(subSubitem), \'disabled\': subSubitem.disabled }"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next" ng-if="!$baWizardController.isLastTab()"><button ng-disabled="$baWizardController.isLastTab()||!$baWizardController.saveFinalStep()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li><button style="float:right" ng-if="$baWizardController.isLastTab()" ng-disabled="!$baWizardController.saveFinalStep()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">save</button></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ contentTop.activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li ng-if="contentTop.activeHasParent"><a ui-sref="{{contentTop.activeParent.name}}">{{ contentTop.activeParent.title }}</a></li><li>{{ contentTop.activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><img src="assets/img/logo-cast.png" alt="" class="guest-img"></a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><i class="fa fa-user fa-3x" aria-hidden="true"></i></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a href="" class="signout" ng-click="vm.logout()"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></div><div class="propertySelected" scroll-position="scrolled" ng-class="{\'scrolled\': scrolled}"><ui-select ng-model="vm.propertySelected" ng-change="vm.changeProperty()" class="bootstrap-select btn-group" title="Choose a property"><ui-select-match placeholder="Select or search a property">{{$select.selected.name | limitTo:20}}</ui-select-match><ui-select-choices repeat="property in vm.properties | filter: $select.search"><span ng-bind-html="property.name | highlight: $select.search" class="overflow-ellipsis"></span> <small ng-bind-html="property.acronym | highlight: $select.search"></small></ui-select-choices></ui-select></div></div><div id="loading-bar-container"></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/selectOrCreate/selectOrCreate.html','<div class="form-group has-feedback" ng-class="{\'has-error\': idform.$invalid && form.$submitted}"><label for="{{name}}">{{label}}</label><div class="form-control btn-group bootstrap-select row"><div class="col-md-9" style="padding-left: 0;"><ui-select ng-required="!model.id" ng-model="model[modelProperty]" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ui-select-free-text="" value-prop="name" on-select="onSelected($item)"><ui-select-match placeholder="{{placeholder}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="item in items | filter: { name: $select.search }"><span ng-bind-html="item.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><button type="button" ng-disabled="disable" class="btn btn-primary pull-right" style="border-top-left-radius:5px;border-bottom-left-radius:5px;" ng-click="onClickFn()">{{buttonText}}</button></div><div ng-if="ifCondition"><label style="color: red; margin-left: 5px;margin-top: 2px">{{labelNotExist}}</label></div></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input ng-disabled="!hasPermission || switcherDisabled" type="checkbox" ng-model="switcherValue" ng-click="switcherClick()"> {{console.log(!hasPermission);}}<div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">{{switcherOn}}</span> <span class="handle"></span> <span class="handle handle-off">{{switcherOff}}</span></div></div></label>');
$templateCache.put('app/modules/cast/notifications/notificationEmails/notificationEmails.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="notification-emails--store" class="btn btn-primary pull-right" ui-sref="cast.notifications.notification-emails-new"><i class="fa fa-envelope fa-6"></i> {{\'NOTIFICATION_EMAILS.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="notificationEmail in $data"><td title="\'NOTIFICATION_EMAILS.NAME\' | translate" ng-attr-title="" sortable="\'name\'">{{notificationEmail.name}}</td><td title="\'NOTIFICATION_EMAILS.EMAIL\' | translate" ng-attr-title="" align="center" sortable="\'email\'">{{notificationEmail.email}}</td><td class="row-switcher-custom" title="\'NOTIFICATION_EMAILS.ACTIVE\' | translate" ng-attr-title="" align="center" sortable="\'active\'"><label class="label-switcher-custom" align="center"><ba-switcher switcher-style="primary" switcher-value="notificationEmail.active" switcher-click="vm.changeActiveState(notificationEmail)" switcher-on="Yes" switcher-off="No" permission="notification-emails--update" class="col-sm-8"></ba-switcher></label></td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="notification-emails--update" ui-sref="cast.notifications.notification-emails-edit({ id : notificationEmail.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="notification-emails--destroy" href="" ng-really-click="vm.deleteRow(notificationEmail.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/cast/notifications/notificationEmails/notificationEmailsAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="notificationEmailForm" novalidate="" ng-submit="vm.save(notificationEmailForm,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(notificationEmailForm, notificationEmailForm.name,\'name\')}"><label for="name">{{\'NOTIFICATION_EMAILS.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'name\')" class="form-control" id="name" name="name" placeholder="Name" ng-model="vm.data.name" required=""><div ng-messages="notificationEmailForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'name\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'name\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(notificationEmailForm, notificationEmailForm.email)}"><label for="email">{{\'NOTIFICATION_EMAILS.EMAIL\' | translate}} <span style="color:#209e91">*</span></label> <input type="email" class="form-control" id="email" name="email" placeholder="Email" ng-model="vm.data.email" required=""><div ng-messages="notificationEmailForm.email.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="email">{{\'VALIDATIONS.EMAIL\' | translate}}</span></div></div><div class="form-group row"><label class="col-sm-4 control-label">{{\'NOTIFICATION_EMAILS.ACTIVE\' | translate}}</label> <label style="margin-left: 26px"><ba-switcher switcher-style="primary" switcher-value="vm.data.active" switcher-on="Yes" switcher-off="No" permission="notification-emails--update" class="col-sm-8"></ba-switcher></label></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="notificationEmailForm.$invalid" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/directives/uploadImage/modal/editImage.html','<style type="text/css">\n  .modal-body {\n    max-height: 600px; \n    overflow-y: auto;\n  }\n  .modal-content {\n    top: 50px;\n  }\n</style><div class="ng-scope"><div class="modal-header"><h5 class="modal-title"><i class="fa fa-image fa-lg"></i> {{\'IMAGE.CROP_IMAGE\' | translate}}</h5></div><div class="modal-body img-container"><div class="col-md-8"><span ng-show="vm.withMessage">{{\'IMAGE.MESSAGE\' | translate}}</span></div><div class="img-dimensions col-md-4"><span class="pull-right">{{\'IMAGE.IMAGE_DIMENSIONS\' | translate:dimensions }}</span></div><img ng-src="{{image}}" ng-cropper="" ng-cropper-proxy="cropperProxy" ng-cropper-show="showEvent" ng-cropper-hide="hideEvent" ng-cropper-options="options"></div><div class="img-dimensions-error"><span ng-hide="vm.saveImage"><span>{{\'IMAGE.IMAGE_DIMENSIONS_ACCEPTED\' | translate:supportedDimensions}}</span> <span ng-if="vm.maxHeight" style="margin:0">- {{\'IMAGE.IMAGE_DIMENSIONS_ACCEPTED_MAX\' | translate:supportedDimensions}}</span></span></div><div class="modal-footer"><div class="form-group"><button type="button" class="btn btn-light" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="!vm.saveImage" ng-click="vm.save()" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></div></div>');
$templateCache.put('app/modules/iptv/channels/lists/lists.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="channels--store" class="btn btn-primary pull-right" ui-sref="iptv.channels.lists-new"><i class="fa fa-th-large fa-6"></i> {{\'CHANNELS.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="channel in $data"><td title="\'CHANNELS.IMAGE\' | translate" ng-attr-title="" align="center"><img ng-src="{{channel.imagePath}}" width="35" height="35"></td><td title="\'CHANNELS.NAME\' | translate" ng-attr-title="" align="center">{{channel.name}}</td><td title="\'CHANNELS.NUMBER\' | translate" ng-attr-title="" sortable="\'number\'" align="center">{{channel.number}}</td><td title="\'CHANNELS.TYPE\' | translate" ng-attr-title="" align="center">{{channel.type}}</td><td title="\'CHANNELS.FREQ_URL\' | translate" ng-attr-title="" align="center">{{vm.getRfOrIptvValue(channel)}}</td><td data-title="\'Position\'" align="center" sortable="\'position\'"><span editable-number="channel.position" onaftersave="vm.savePosition(channel)">{{channel.position}} <i class="fa fa-sort"></i></span></td><td class="row-switcher-custom" title="\'CHANNELS.STATE\' | translate" ng-attr-title="" align="center"><label class="label-switcher-custom" align="center"><ba-switcher switcher-style="primary" switcher-value="channel.stateBoolean" switcher-click="vm.enabledOrDisabled(channel)" switcher-on="Yes" switcher-off="No" permission="channels--update" class="col-sm-8"></ba-switcher></label></td><td title="\'CHANNELS.CHANNEL_TYPES\' | translate" ng-attr-title="" align="center">{{ vm.getChannelTypes(channel) }}</td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="channels--update" ui-sref="iptv.channels.lists-edit({ id : channel.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="channels--destroy" href="" ng-really-click="vm.deleteRow(channel.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/channels/lists/listsAddEdit.html','<div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><ba-wizard senable-tabs="vm.data.hasOwnProperty(\'id\')" return-state="channel.list"><ba-wizard-step title="Channel" form="vm.channelForm" submit-function="vm.save(vm.channelForm,vm.data)"><form name="vm.channelForm" novalidate=""><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(channelForm, channelForm.name,\'name\')}"><label for="name">{{\'CHANNELS.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'name\')" class="form-control" id="name" name="name" placeholder="Name" ng-model="vm.data.name" required=""><div ng-messages="channelForm.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'name\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'name\')}}</span></div></div><div class="form-group row clearfix"><label class="col-sm-3 control-label">{{\'CHANNELS.CHANNEL_IMAGE\' | translate}} <span style="color:#209e91" ng-show="!vn.data.id">*</span></label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ vm.getChannelImage() }}" ng-click="vm.clickOpenFile()"></div><a href="" class="change-userpic" ng-click="vm.clickOpenFile()">{{\'CHANNELS.CHANGE_CHANNEL_IMAGE\' | translate}}</a> <input ng-required="!vm.data.id" ng-model="vm.channelImage" onchange="angular.element(this).scope().setFile(this)" type="file" ng-show="false" id="image" name="image" accept=".png"><div style="margin-top: 4px"><label style="color: gray; margin-left: 5px;margin-top: 2px">{{\'CHANNELS.IMAGE_FORMAT_ACCEPTED\' | translate:\'{ availableImageTypes: \'+vm.availableImageTypes+\'}\'}}</label></div></div></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(channelForm, channelForm.number,\'number\')}"><label for="number">{{\'CHANNELS.NUMBER\' | translate}} <span style="color:#209e91">*</span></label> <input type="number" ng-change="vm.cleanSvError(\'number\')" class="form-control" id="number" name="number" placeholder="Number" ng-model="vm.data.number" required=""><div ng-messages="channelForm.number.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'number\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'number\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(channelForm, channelForm.position,\'position\')}"><label for="position">{{\'CHANNELS.POSITION\' | translate}} <span style="color:#209e91">*</span></label> <input type="number" ng-change="vm.cleanSvError(\'position\')" e-min="1" e-max="999" class="form-control" id="position" name="position" placeholder="position" ng-model="vm.data.position" required=""><div ng-messages="channelForm.position.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'position\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'position\')}}</span></div></div><div class="form-group has-feedback"><label for="type">{{\'CHANNELS.TYPE\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.data.type" name="type" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" required=""><ui-select-match placeholder="Select Type"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="type in vm.types | filter: $select.search"><span ng-bind-html="type"></span></ui-select-choices></ui-select><div ng-messages="receiversForm.type.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div><div ng-if="vm.data.type == \'IPTV\'"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(channelForm, channelForm.url,\'url\')}"><label for="url">{{\'CHANNELS.URL\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'url\')" class="form-control" id="url" name="url" placeholder="URL" ng-model="vm.data.url" required=""><div ng-messages="channelForm.url.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span> <span ng-message="url">{{\'VALIDATIONS.URL\' | translate}}</span></div><div ng-show="vm.haveServerError(\'url\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'url\')}}</span></div></div></div><div ng-if="vm.data.type == \'RF\'"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(Channels, channelForm.frequency,\'frequency\')}"><label for="frequency">{{\'CHANNELS.FREQUENCY\' | translate}} <span style="color:#209e91">*</span></label> <input type="number" step="any" ng-change="vm.cleanSvError(\'frequency\')" class="form-control" id="frequency" name="frequency" placeholder="Frequency" ng-model="vm.data.frequency" required=""><div ng-messages="channelForm.frequency.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'frequency\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'frequency\')}}</span></div></div></div><div ng-if="vm.data.type == \'VIDEO\'"><label for="video">{{\'CHANNELS.VIDEO\' | translate}}</label> <input ng-model="vm.data.video_name" onchange="angular.element(this).scope().uploadChannelVideo(this)" type="file" id="video" name="video" accept=".mp4"><div ng-if="vm.data.video_name"><label for="video" style="font-weight: 400;">{{\'CHANNELS.CURRENTLY_UPLOADED\' | translate}} {{ vm.data.video_name }}</label></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(channelForm, channelForm.video_port,\'video_port\')}"><label for="video_port">{{\'CHANNELS.PORT\' | translate}} <span style="color:#209e91">*</span></label> <input type="number" ng-change="vm.cleanSvError(\'video_port\')" class="form-control" id="video_port" name="video_port" placeholder="Video port" ng-min="0" ng-max="65535" ng-model="vm.data.video_port" required=""><div ng-messages="channelForm.video_port.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'video_port\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'video_port\')}}</span></div></div></div><div class="form-group row"><label class="col-sm-4 control-label">{{\'CHANNELS.ENABLED\' | translate}}</label> <label style="margin-left: 26px"><ba-switcher switcher-style="primary" switcher-value="vm.state" switcher-click="vm.check()" switcher-on="Yes" switcher-off="No" permission="channels--update" class="col-sm-8"></ba-switcher></label></div><div><div class="form-group"><label for="name">{{\'CHANNELS.CHANNEL_TYPES\' | translate}} <span style="color:#209e91">*</span></label><ui-select ng-model="vm.channelTypeSelected" name="channelTypes" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="true" ng-change="vm.addChannelTypes()"><ui-select-match placeholder="Select Channel Types"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="channelType in vm.availableChannelTypes | filter: $select.search"><span ng-bind-html="channelType.name | highlight: $select.search"></span></ui-select-choices><ui-select-no-choice><span style="color: #777; padding-left: 20px;">No results</span></ui-select-no-choice></ui-select></div><div ng-if="vm.data.channel_types.length > 0"><table ng-table="vm.table" style="margin-bottom:10px;" class="table table-striped"><tr ng-repeat="channelType in $data"><td>{{channelType.name}}</td><td><a href="" ng-click="vm.deleteChannelTypesSelected(channelType)" uib-tooltip="\'delete\'"><i class="fa fa-times"></i></a></td></tr></table></div></div></form></ba-wizard-step><ba-wizard-step title="Languages" form="vm.channelLanguagesForm" submit-function="vm.updateLanguages()"><form name="vm.channelLanguagesForm" novalidate=""><uib-tabset active="vm.active"><uib-tab index="language" data-ng-repeat="language in vm.languages"><uib-tab-heading>{{language.name}}</uib-tab-heading><div class="row"><div class="row" style="margin-top: 10px;margin-bottom:10px"><div class="col-md-12" style="margin-top: 6px;">Description</div></div><div class="row" style="margin-top: 10px;margin-bottom:10px"><div class="form-group has-feedback col-md-12" ng-class="{\'has-error\': vm.basicValidation(vm.channelLanguagesForm, vm.channelLanguagesForm[\'channe_language_description_\'+language.code])}"><div ckeditor="vm.options" ng-model="vm.languageList[$index].description" ready="onReady()" id="channel_language_description_{{language.code}}" name="channel_language_description_{{language.code}}" ng-disabled="vm.channelNoCreado()" ng-maxlength="512"></div><div ng-messages="vm.channelLanguagesForm[\'channel_language_description_\'+language.code].$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div></div></uib-tab></uib-tabset></form></ba-wizard-step></ba-wizard></div></div></div>');
$templateCache.put('app/modules/iptv/channels/types/types.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button class="btn btn-primary pull-right" ui-sref="iptv.channels.types-new"><i class="fa fa-th-large fa-6"></i> {{\'CHANNEL_TYPES.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="channelType in $data"><td title="\'CHANNEL_TYPES.NAME\' | translate" ng-attr-title="" align="center">{{vm.getNameFromChild(channelType)}}</td><td title="\'CHANNEL_TYPES.POSITION\' | translate" ng-attr-title="" sortable="\'position\'" align="center"><span editable-number="channelType.position" onaftersave="vm.saveChannelType(channelType)" e-min="1" e-max="999">{{channelType.position}} <i class="fa fa-sort"></i></span></td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a ui-sref="iptv.channels.types-edit({ id : channelType.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a href="" ng-really-click="vm.deleteRow(channelType.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/channels/types/typesAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Channel Types" form="vm.channelTypesForm" submit-function="vm.save(vm.channelTypesForm,vm.data)"><form name="vm.channelTypesForm" novalidate=""><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(vm.channelTypesForm, vm.channelTypesForm.position,\'position\')}"><label for="name">{{\'CHANNEL_TYPES.POSITION\' | translate}} <span style="color:#209e91">*</span></label> <input type="number" ng-change="vm.cleanSvError(\'position\')" class="form-control" id="position" name="position" placeholder="Position" ng-model="vm.data.position" min="1" required=""><div ng-messages="channelForm.position.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'position\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'position\')}}</span></div></div></form></ba-wizard-step><ba-wizard-step title="Languages" form="vm.channelTypesLanguagesForm" submit-function="vm.updateLanguages(vm.channelTypesLanguagesForm)"><form name="vm.channelTypesLanguagesForm" novalidate=""><uib-tabset active="vm.active"><uib-tab index="language" data-ng-repeat="language in vm.languages"><uib-tab-heading>{{language.name}}</uib-tab-heading><div class="row"><div class="form-group has-feedback col-md-12" ng-class="{\'has-error\': vm.basicValidation(vm.channelTypesLanguagesForm, vm.channelTypesLanguagesForm[\'channel_type_language_\'+language.code])}"><label for="name">{{\'CHANNEL_TYPES.NAME\' | translate}}</label> <input type="name" class="form-control" id="channel_type_language_-{{language.code}}" name="channel_type_language_{{language.code}}" placeholder="Name of the channel types (in {{language.name}})" ng-model="vm.languageList[$index].name"><div ng-messages="vm.channelTypesLanguagesForm[\'channel_type_language_\'+language.code].$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div></uib-tab></uib-tabset></form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/modules/iptv/experiences/preview/experiencesPreview.html','<style>\n\t/* Setup para fuentes */\n\n\t@font-face {\n\t\tfont-family: \'Sweet Sans Pro\';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tsrc: url(\'assets/fonts/SweetSansProRegular.otf\');\n\t}\n\n\t@font-face {\n\t\tfont-family: \'Abhaya Libre\';\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tsrc: url(\'assets/fonts/AbhayaLibre-Medium.ttf\');\n\t}\n\t\n\t@font-face {\n\t\tfont-family: \'Candlescript\';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tsrc: url(\'assets/fonts/Candlescript Demo Version.otf\');\n\t}\n\n\t@font-face {\n\t\tfont-family: \'Hatton\';\n\t\tfont-style: normal;\n\t\tfont-weight: 100;\n\t\tsrc: url(\'assets/fonts/Hatton-Ultralight.otf\');\n\t}\n\n\t@font-face {\n\t\tfont-family: \'Hatton\';\n\t\tfont-style: normal;\n\t\tfont-weight: 300;\n\t\tsrc: url(\'assets/fonts/Hatton-Regular.otf\');\n\t}\n\n\t@font-face {\n\t\tfont-family: \'Hatton\';\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tsrc: url(\'assets/fonts/Hatton-Medium.otf\');\n\t}\n\t\n\n\t/* Clases para fuentes */\n\t.ssp-font {\n\t\tfont-family: \'Sweet Sans Pro\', sans-serif; text-transform: uppercase; \n\t}\n\n\t.cds-font {\n\t\tfont-family: \'Candlescript Demo Version\', sans-serif;\n\t}\n\n\t.hat-font {\n\t\tfont-family: \'Hatton\', sans-serif;\n\t}\n\n\t/* Breakpoints responsivos */\n\n\t@media only screen and (min-width: 576px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.6;\n\t\t\ttransform: scale(0.6);\n\t\t\t-moz-transform: scale(0.4);\n\t\t}\n\t}\n\n\t@media only screen and (min-width: 768px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.8;\n\t\t\ttransform: scale(0.8);\n\t\t\t-moz-transform: scale(0.6);\n\t\t}\n\t}\n\t\n\t@media only screen and (min-width: 1000px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.5;\n\t\t\ttransform: scale(0.5);\n\t\t\t-moz-transform: scale(0.35);\n\t\t}\n\t}\n\n\t@media only screen and (min-width: 1200px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.6;\n\t\t\ttransform: scale(0.6);\n\t\t\t-moz-transform: scale(0.4);\n\t\t}\n\t}\n\n\t@media only screen and (min-width: 1550px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.7;\n\t\t\ttransform: scale(0.7);\n\t\t\t-moz-transform: scale(0.5);\n\t\t}\n\t}\n\n\t@media only screen and (min-width: 1800px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.8;\n\t\t\ttransform: scale(0.8);\n\t\t\t-moz-transform: scale(0.6);\n\t\t}\n\t}\n</style><div class="preview-window" style="transform-origin: top left; border: 1px solid #bbb; width: 1280px; height: 720px; color: white;"><div class="container" style="background: linear-gradient(rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.35) 20%, transparent 40%) repeat scroll 0% 0%, linear-gradient(to top, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.35) 20%, transparent 40%) repeat scroll 0% 0%, rgba(0, 0, 0, 0) no-repeat center center; width: 1280px; height: 720px; position: relative; background-size: cover; background-position: center center;"><div ng-if="vm.experience.media_type == \'image\'"><img ng-src="{{ vm.current_image }}" style="width: 1280px; height: 720px; position: absolute; top: 0; left: 0;"></div><div ng-if="vm.experience.media_type == \'video\'"><video autoplay="" muted="" loop="" id="myVideo" ng-src="{{ vm.current_video }}" style="width: 1280px; height: 720px; position: absolute; top: 0; left: 0;"></video></div><div class="row" style="width: 60%; color: white; position: absolute; width: 100%; height: 100px; padding: 30px 40px;"><img src="assets/img/logo-cloud1tv.png"></div><div class="row" style="position: absolute; right: 0px; text-align: right; width: 100%; height: 100px; padding: 36px 50px;"><h1 id="main_header" ng-style="{ font: vm.descriptions[\'main_header\'].font, color: vm.descriptions[\'main_header\'].font_color }">{{ vm.descriptions["main_header"]["languageData"][vm.active.code]["description"] }}</h1><h2 id="title" ng-style="{ font: vm.descriptions[\'title\'].font, color: vm.descriptions[\'title\'].font_color }">{{ vm.descriptions["title"]["languageData"][vm.active.code]["description"] }}</h2></div><div class="row" style="position: absolute; right: 0px; top: 50%; height: auto; padding: 0 40px;"><div id="replayButton" class="widget container button listitem active focus" style="border-radius: 150px; width: 150px; height: 150px; padding: 8px; margin: 8px auto 0 auto; background-color: rgba(138, 63, 46, 0.8); visibility: visible; opacity: 1;"><div id="replayImage" class="widget container image"><img id="replayImage_img" src="assets/img/replay.png" style="margin: 8px 12px; width: 80px"></div><center><span class="ssp-font" style="color: white; font-size: 10px; padding: 0;">Reproducir<br>nuevamente</span></center></div><div id="menuButton" class="widget container button listitem active focus" style="border-radius: 20px; width: 15vw; max-width: 600px; padding: 8px; margin: 8px auto 0 auto; background-color: rgba(0, 1, 2, 0.4); visibility: visible; opacity: 1;"><center><span class="ssp-font" style="color: white; font-size: 24px; padding: 8px;">Ir al men\xFA</span></center></div></div><div class="row" style="position: absolute; bottom: 0px; width: 100%; text-align: center; padding: 60px 0; text-transform: uppercase;"><h1 id="main_footer" ng-style="{ font: vm.descriptions[\'main_footer\'].font, color: vm.descriptions[\'main_footer\'].font_color }">{{ vm.descriptions["main_footer"]["languageData"][vm.active.code]["description"] }}</h1><h4 id="footer_text1" ng-style="{ font: vm.descriptions[\'footer_text1\'].font, color: vm.descriptions[\'footer_text1\'].font_color }">{{ vm.descriptions["footer_text1"]["languageData"][vm.active.code]["description"] }}</h4><h3 id="footer_text2" ng-style="{ font: vm.descriptions[\'footer_text2\'].font, color: vm.descriptions[\'footer_text2\'].font_color }">{{ vm.descriptions["footer_text2"]["languageData"][vm.active.code]["description"] }}</h3></div></div></div>');
$templateCache.put('app/modules/iptv/experiences/templates/popover.html','<div><div class="form-group"><label>Family <span style="color:#209e91">*</span></label><ui-select ng-model="vm.descriptions[type].fontData.family" name="type" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-change="vm.formatFontSelects(vm.descriptions[type])"><ui-select-match placeholder="Font family"><span>{{$select.selected.name}}</span></ui-select-match><ui-select-choices repeat="family in vm.fontOptions.family | filter: $select.search"><span ng-bind-html="family.name"></span></ui-select-choices></ui-select></div><div class="form-group"><label>Size <span style="color:#209e91">*</span></label><ui-select ng-model="vm.descriptions[type].fontData.size" name="type" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-change="vm.formatFontSelects(vm.descriptions[type])"><ui-select-match placeholder="Font size"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="size in vm.fontOptions.size | filter: $select.search"><span ng-bind-html="size"></span></ui-select-choices></ui-select></div><div class="form-group"><label>Weight <span style="color:#209e91">*</span></label><ui-select ng-model="vm.descriptions[type].fontData.weight" name="type" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-change="vm.formatFontSelects(vm.descriptions[type])"><ui-select-match placeholder="Font weight"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="weight in vm.fontOptions.weight | filter: $select.search"><span ng-bind-html="weight"></span></ui-select-choices></ui-select></div><div class="form-group"><label>Style <span style="color:#209e91">*</span></label><ui-select ng-model="vm.descriptions[type].fontData.style" name="type" class="btn-group bootstrap-select form-control" append-to-body="true" search-enabled="false" ng-change="vm.formatFontSelects(vm.descriptions[type])"><ui-select-match placeholder="Font style"><span>{{$select.selected}}</span></ui-select-match><ui-select-choices repeat="style in vm.fontOptions.style | filter: $select.search"><span ng-bind-html="style"></span></ui-select-choices></ui-select></div><div class="form-group" style="padding-bottom: 30px;"><label>Color</label> <input minicolors="vm.descriptions[type].fontData.minicolorsSettings" id="{{color}}_login" name="type" class="form-control" type="text" minicolors-rgba="vm.descriptions[type].fontData.color.rgb" minicolors-opacity="vm.descriptions[type].fontData.color.opacity" ng-model="vm.descriptions[type].fontData.color.rgb" ng-change="vm.updateFontColor(vm.descriptions[type])"></div></div>');
$templateCache.put('app/modules/iptv/hotelInfos/categories/categories.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="hotel-info-categories--store" class="btn btn-primary pull-right" ui-sref="iptv.hotel-infos.categories-new"><i class="fa fa-info-circle fa-6"></i> {{\'HOTEL_INFO_CATEGORY.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="hotelInfoCategory in $data"><td title="\'HOTEL_INFO_CATEGORY.NAME\' | translate" ng-attr-title="">{{hotelInfoCategory.name}}</td><td data-title="\'Position\'" align="center" sortable="\'position\'"><span editable-number="hotelInfoCategory.position" onaftersave="vm.savePosition(hotelInfoCategory)">{{hotelInfoCategory.position}} <i class="fa fa-sort"></i></span></td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="hotel-info-categories--update" ui-sref="iptv.hotel-infos.categories-edit({ id : hotelInfoCategory.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="hotel-info-categories--destroy" href="" ng-really-click="vm.deleteRow(hotelInfoCategory.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/hotelInfos/categories/categoriesAddEdit.html','<div class="widgets"><div class="row"><div class="col-md-offset-2 col-md-8"><div ba-panel="" ba-panel-class="with-scroll"><form name="hotelInfoCategory" novalidate="" ng-submit="vm.save(hotelInfoCategory,vm.data)"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(hotelInfoCategory, hotelInfoCategory.name,\'name\')}"><label for="name">{{\'HOTEL_INFO_CATEGORY.NAME\' | translate}} <span style="color:#209e91">*</span></label> <input type="text" ng-change="vm.cleanSvError(\'name\')" class="form-control" id="name" name="name" placeholder="Name" ng-model="vm.data.name" required=""><div ng-messages="hotelInfoCategory.name.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'name\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'name\')}}</span></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(hotelInfoCategory, hotelInfoCategory.position,\'position\')}"><label for="name">{{\'HOTEL_INFO_CATEGORY.POSITION\' | translate}} <span style="color:#209e91">*</span></label> <input type="number" ng-change="vm.cleanSvError(\'position\')" class="form-control" id="postion" name="postion" placeholder="Postion" ng-model="vm.data.position" required=""><div ng-messages="hotelInfoCategory.position.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'position\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'position\')}}</span></div></div><div class="form-group"><button type="button" class="btn pull-right" ng-click="vm.cancel()">{{\'BUTTONS.CANCEL\' | translate}}</button> <button type="submit" ng-disabled="hotelInfoCategory.$invalid || (!vm.data.all_areas && vm.data.areas.length == 0)" style="margin-right:10px;" class="btn btn-primary pull-right">{{\'BUTTONS.SAVE\' | translate}}</button></div></form></div></div></div></div>');
$templateCache.put('app/modules/iptv/hotelInfos/lists/lists.html','<div class="row"><div class="col-md-12" ba-panel="" ba-panel-class="with-scroll"><a href="" ng-click="vm.refreshTable()" class="btn btn-link btn-icon transparent-btn"><i class="ion-loop fa-2x"></i></a> <button permission-hide="hotel-info--store" class="btn btn-primary pull-right" ui-sref="iptv.hotel-infos.lists-new"><i class="fa fa-info-circle fa-6"></i> {{\'HOTEL_INFO.NEW\' | translate}}</button></div><div class="col-md-12"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><nit-advanced-searchbox class="col-md-12" ng-model="vm.search" parameters="vm.availableSearchParams"></nit-advanced-searchbox><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="hotelinfo in $data"><td title="\'HOTEL_INFO.IMAGE\' | translate" ng-attr-title="" align="center"><img ng-src="{{hotelinfo.imagePath}}" width="86" height="50"></td><td title="\'HOTEL_INFO.NAME\' | translate" ng-attr-title="" align="center">{{vm.getNameFromChild(hotelinfo)}}</td><td title="\'HOTEL_INFO.CATEGORY\' | translate" ng-attr-title="" align="center">{{hotelinfo.hotel_info_category.name}}</td><td data-title="\'Position\'" align="center" sortable="\'position\'"><span editable-number="hotelinfo.position" onaftersave="vm.savePosition(hotelinfo)">{{hotelinfo.position}} <i class="fa fa-sort"></i></span></td><td title="\'TABLES.EDIT\' | translate" ng-attr-title="" align="center"><a permission-hide="hotel-info--update" ui-sref="iptv.hotel-infos.lists-edit({ id : hotelinfo.id})"><i class="fa fa-pencil-square-o"></i></a></td><td title="\'TABLES.DELETE\' | translate" ng-attr-title="" align="center"><a permission-hide="hotel-info--destroy" href="" ng-really-click="vm.deleteRow(hotelinfo.id)"><i class="fa fa-trash"></i></a></td></tr></table></div></div></div>');
$templateCache.put('app/modules/iptv/hotelInfos/lists/listsAddEdit.html','<div class="row"><div class="col-12"><div ba-panel="" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Hotel Info" form="vm.hotelInfoForm" submit-function="vm.uploadHotelInfoImage()"><div class="row"><div class="col-md-6"><form name="vm.hotelInfoForm" novalidate=""><div class="form-group row"><label class="col-sm-4 control-label">{{\'HOTEL_INFO.MENU_OR_ITEM\' | translate}}</label> <label style="margin-left: 26px"><ba-switcher switcher-style="primary" switcher-disabled="vm.areThereAnyHotelsMenu()" switcher-value="vm.isMenu" switcher-on="Yes" switcher-off="No" class="col-sm-8"></ba-switcher></label></div><div class="form-group row"><label class="col-sm-3">{{\'HOTEL_INFO.HOTEL_INFO_IMAGE\' | translate}} <span style="color:#209e91" ng-show="!vm.data.id">*</span></label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ vm.hotelInfoImageBase64 }}" ng-click="vm.clickOpenFile()"></div><a href="" class="change-userpic" ng-click="vm.clickOpenFile()">{{\'CONFIGS.CHANGE_SPLASH_IMAGE\' | translate}}</a> <input ng-required="!vm.data.id" ng-model="vm.data.image_base64" onchange="angular.element(this).scope().setFile(this)" type="file" ng-show="false" id="image" name="image" accept=".jpg, .jpeg"><div style="margin-top: 4px"><label style="color: gray; margin-left: 5px;margin-top: 2px">{{\'HOTEL_INFO.IMAGE_FORMAT_ACCEPTED\' | translate:\'{ availableImageTypes: \'+vm.availableImageTypes+\'}\'}}</label></div><div ng-if="vm.isTheImageLarge"><label style="color: red; margin-left: 5px;margin-top: 2px">{{\'HOTEL_INFO.THE_IMAGE_IS_BIG\' | translate:\'{ maxAllowedSize:\'+vm.maxAllowedSize+\' }\'}}</label></div></div></div></div><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidationWithSvError(hotelInfo, vm.data.position,\'position\')}"><label for="name">{{\'HOTEL_INFO.POSITION\' | translate}} <span style="color:#209e91">*</span></label> <input type="number" ng-change="vm.cleanSvError(\'position\')" class="form-control" id="postion" name="postion" placeholder="Postion" ng-model="vm.data.position" required=""><div ng-messages="vm.data.position.$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div><div ng-show="vm.haveServerError(\'position\')" class="help-block error-block basic-block"><span>{{vm.showServerError(\'position\')}}</span></div></div><div ng-if="vm.isMenu"><label for="name">{{\'HOTEL_INFO.SELECT_CATEGORY\' | translate}} <span style="color:#209e91">*</span></label><select-or-create id="hotel_info_category" name="hotel_info_category" placeholder="Select Hotel Info Category" model="vm.data" model-property="hotel_info_category" items="vm.hotelInfoCategories" on-click-fn="vm.createHotelInfoCategory" button-text="{{\'HOTEL_INFO_CATEGORY.CREATE\' | translate}}" label-not-exist="{{\'HOTEL_INFO_CATEGORY.NOT_EXIST\' | translate}}" if-condition="vm.data.hotel_info_category.isFreeText"></select-or-create></div><div ng-if="!vm.isMenu"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.basicValidation(hotelInfoForm, hotelInfoForm.menu)}"><label for="name">{{\'HOTEL_INFO.CHOOSE_MENU\' | translate}}</label><div class="col-md-12" style="margin-bottom: 20px;"><table ng-required="!vm.data.id" ng-model="vm.data.menu_id" ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="menu in vm.menus"><td title="\'HOTEL_INFO.SELECT_MENU\' | translate" ng-attr-title="" sortable="\'enabled\'" align="center"><input name="parents" type="radio" ng-value="menu.id" value="menu.id" ng-model="vm.data.menu_id"></td><td title="\'HOTEL_INFO.NAME\' | translate" ng-attr-title="" align="center">{{vm.getNameOnlyMenu(menu)}}</td><td title="\'HOTEL_INFO.CATEGORY\' | translate" ng-attr-title="" sortable="\'name\'" align="center">{{menu.hotel_info_category.name}}</td></tr></table></div></div></div></form></div><div class="col-md-6 vcenter"><ng-include src="\'app/modules/iptv/hotelInfos/lists/preview/preview.html\'"></ng-include></div></div></ba-wizard-step><ba-wizard-step title="Languages" form="vm.hotelInfoLanguagesForm" submit-function="vm.updateLanguage()"><form name="vm.hotelInfoLanguagesForm" ng-submit="vm.uploadHotelInfoImage()" novalidate=""><div class="col-md-6 vcenter"><uib-tabset active="vm.active"><uib-tab index="$index" data-ng-repeat="language in vm.languages"><uib-tab-heading>{{language.name}}</uib-tab-heading><div class="row"><div class="form-group has-feedback col-md-12" ng-class="{\'has-error\': vm.basicValidation(vm.hotelInfoLanguagesForm, vm.hotelInfoLanguagesForm[\'hotel_info_language_\'+language.code])}"><label for="name">{{\'HOTEL_INFO.NAME\' | translate}}</label> <input type="name" class="form-control" ng-disabled="vm.hotelInfoNoCreado()" id="hotel_info_language_-{{language.code}}" name="hotel_info_language_{{language.code}}" placeholder="Name of the hotel (in {{language.name}})" ng-model="vm.languageList[$index].name"><div ng-messages="vm.hotelInfoLanguagesForm[\'hotel_info_language_\'+language.code].$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div><hr><div class="row" style="margin-top: 10px;margin-bottom:10px"><div class="col-md-12" style="margin-top: 6px;">Description</div></div><div class="row" style="margin-top: 10px;margin-bottom:10px"><div class="form-group has-feedback col-md-12" ng-class="{\'has-error\': vm.basicValidation(vm.hotelInfoLanguagesForm, vm.hotelInfoLanguagesForm[\'hotel_info_language_description_\'+language.code])}"><div ckeditor="vm.options" ng-model="vm.languageList[$index].description" ready="onReady()" id="hotel_info_language_description_{{language.code}}" name="hotel_info_language_description_{{language.code}}" ng-disabled="vm.hotelInfoNoCreado()"></div><div ng-messages="vm.hotelInfoLanguagesForm[\'hotel_info_language_description_\'+language.code].$error" class="help-block error-block basic-block"><span ng-message="required">{{\'VALIDATIONS.REQUIRED\' | translate}}</span></div></div></div></uib-tab></uib-tabset></div><div class="col-md-6 vcenter"><ng-include src="\'app/modules/iptv/hotelInfos/lists/preview/preview.html\'"></ng-include></div></form></ba-wizard-step></ba-wizard></div></div></div>');
$templateCache.put('app/modules/reports/general-use/sections/section-reports.html','<div class="row"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="row in $data"><td class="text-center" title="\'SECTION.FROM\' | translate" sortable="\'from\'" ng-attr-title="">{{row.from}}</td><td class="text-center" title="\'SECTION.TO\' | translate" sortable="\'to\'" ng-attr-title="">{{row.to}}</td><td class="text-center" title="\'SECTION.DURATION\' | translate" sortable="\'duration\'" ng-attr-title="">{{row.duration}}</td><td class="text-center" title="\'SECTION.AREA_NAME\' | translate" sortable="\'area_name\'" ng-attr-title="">{{row.area_name}}</td><td class="text-center" title="\'SECTION.RECEIVER_NAME\' | translate" sortable="\'name\'" ng-attr-title="">{{row.name}}</td></tr></table></div></div>');
$templateCache.put('app/modules/reports/general-use/states/state-reports.html','<div class="row"><div ba-panel="" class="col-sm-6" style="padding-left: 0px"><highchart id="state-pie-chart" config="vm.pieConfig"></highchart></div><div ba-panel="" class="col-sm-6" style="padding-right: 0px"><highchart id="state-column-chart" config="vm.columnConfig"></highchart></div></div><div ba-panel="" class="row"><highchart id="state-zoomtype-chart" config="vm.splitLinesConfig"></highchart></div><div class="row"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="row in $data"><td class="text-center" title="\'STATE.FROM\' | translate" sortable="\'from\'" ng-attr-title="">{{row.from}}</td><td class="text-center" title="\'STATE.TO\' | translate" sortable="\'to\'" ng-attr-title="">{{row.to}}</td><td class="text-center" title="\'STATE.DURATION\' | translate" sortable="\'duration\'" ng-attr-title="">{{row.duration}}</td><td class="text-center" title="\'STATE.AREA_NAME\' | translate" sortable="\'area_name\'" ng-attr-title="">{{row.area_name}}</td><td class="text-center" title="\'STATE.RECEIVER_NAME\'| translate" sortable="\'receiver_name\'" ng-attr-title="">{{row.receiver_name}}</td><td class="text-center" title="\'STATE.APPLICATION\' | translate" sortable="\'app\'" ng-attr-title="">{{row.app}}</td></tr></table></div></div>');
$templateCache.put('app/modules/reports/general-use/validations/validation-reports.html','<div class="row"><div ba-panel="" class="col-sm-8" style="padding-left: 0px"><highchart id="validation-pie-chart" config="vm.pieConfig"></highchart></div><div ba-panel="" class="col-sm-4" ba-panel-class="with-scroll table-panel" style="padding-left: 0px"><table class="table table-hover table-condensed table-striped"><thead><tr><th scope="col">{{\'VALIDATION.MAC_ADDRESS\' | translate}}</th><th scope="col">{{\'VALIDATION.COUNT\' | translate}}</th></tr></thead><tr ng-repeat="row in vm.top_macs"><td class="text-center">{{row.key}}</td><td class="text-center">{{row.doc_count}}</td></tr></table></div></div><div ba-panel="" class="row"><highchart id="validation-zoomtype-chart" config="vm.splitLinesConfig"></highchart></div><div class="row"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll"><table ng-table="vm.table" class="table table-hover table-condensed table-striped" show-filter="true"><tr ng-repeat="row in $data"><td class="text-center" title="\'VALIDATION.FROM\' | translate" sortable="\'from\'" ng-attr-title="">{{row.from}}</td><td class="text-center" title="\'VALIDATION.TO\' | translate" sortable="\'to\'" ng-attr-title="">{{row.to}}</td><td class="text-center" title="\'VALIDATION.DURATION\' | translate" sortable="\'duration\'" ng-attr-title="">{{row.duration}}</td><td class="text-center" title="\'VALIDATION.AREA_NAME\' | translate" sortable="\'area_name\'" ng-attr-title="">{{row.area_name}}</td><td class="text-center" title="\'VALIDATION.CLIENT_IP\' | translate" sortable="\'ip_address\'" ng-attr-title="">{{row.ip_address}}</td><td class="text-center" title="\'VALIDATION.MAC_ADDRESS\' | translate" sortable="\'mac_address\'" ng-attr-title="">{{row.mac_address}}</td></tr></table></div></div>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/dangerModal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-flame modal-icon"></i><span>Error</span></div><div class="modal-body text-center">Your information hasn\'t been saved!</div><div class="modal-footer"><button type="button" class="btn btn-danger" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/warningModal.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>Warning</span></div><div class="modal-body text-center">Your computer is about to explode!</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/modules/iptv/hotelInfos/lists/preview/preview.html','<link href="http://fonts.cdnfonts.com/css/sweet-sans-pro" rel="stylesheet"><style>\n\t@import url(\'http://fonts.cdnfonts.com/css/sweet-sans-pro\');\n\n\t.ssp-font {\n\t\tfont-family: \'Sweet Sans Pro\', sans-serif; text-transform: uppercase; \n\t}\n\n\t@media only screen and (min-width: 576px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.6;\n\t\t\ttransform: scale(0.6);\n\t\t\t-moz-transform: scale(0.4);\n\t\t}\n\t}\n\n\t@media only screen and (min-width: 768px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.8;\n\t\t\ttransform: scale(0.8);\n\t\t\t-moz-transform: scale(0.6);\n\t\t}\n\t}\n\t\n\t@media only screen and (min-width: 1000px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.5;\n\t\t\ttransform: scale(0.5);\n\t\t\t-moz-transform: scale(0.35);\n\t\t}\n\t}\n\n\t@media only screen and (min-width: 1200px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.6;\n\t\t\ttransform: scale(0.6);\n\t\t\t-moz-transform: scale(0.4);\n\t\t}\n\t}\n\n\t@media only screen and (min-width: 1550px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.7;\n\t\t\ttransform: scale(0.7);\n\t\t\t-moz-transform: scale(0.5);\n\t\t}\n\t}\n\n\t@media only screen and (min-width: 1800px) {\n\t\t.preview-window {\n\t\t\tzoom: 0.8;\n\t\t\ttransform: scale(0.8);\n\t\t\t-moz-transform: scale(0.6);\n\t\t}\n\t}\n</style><div class="preview-window" style="transform-origin: top left; border: 1px solid #bbb; width: 1280px; height: 720px;"><div class="container" style="background-image: url(\'{{ vm.hotelInfoImageBase64 }}\'); width: 1280px; height: 720px; position: relative; background-size: cover; background-position: center center;"><div class="row" style="width: 60%; color: white; padding-left: 40px; padding-top: 40px;"><div ng-bind-html="vm.sce.trustAsHtml(vm.languageList[vm.active].description)"></div></div><div class="row" style="position: absolute; bottom: 0px; width: 100%; height: 100px; background-color: rgba(0, 0, 0, 0.75); padding: 0 40px;"><div style="position: absolute; top: 45%; width: 100%"><div style="display: block; float: left; width: 50%;"><span class="ssp-font" style="font-size:30px; color: rgb(202, 186, 98);">{{ vm.languageList[vm.active].name }}</span></div><div style="display: block; float: right; width: 50%; text-align: right; padding-right: 7%"><span class="ssp-font" style="font-size:25px; color: rgb(224, 218, 211);">< ANTERIOR | PR\xD3XIMO ></span></div></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');}]);